export var symbolsPredefined = [
    {
        "aspectRatio": 0.9752321981424149,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.9752321981424149,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "4be5dcc0-7d4c-493c-b7dd-cf940cc49276",
            "ownerSide": null
        },
        "_id": "4be5dcc0-7d4c-493c-b7dd-cf940cc49276",
        "tripH": {
            "aspectRatio": 0.9752321981424149,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.9752321981424149,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.9752321981424149,
            "_p1": {
                "x": 240.1761403101,
                "y": 134.1784593
            },
            "_p2": {
                "x": 545.3294693145,
                "y": 134.1784593
            },
            "_p3": {
                "x": 545.3294693145,
                "y": 382.3012560025
            },
            "_p4": {
                "x": 240.1761403101,
                "y": 382.3012560025
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 250.1761403101,
                        "y": 258.23985765124996
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "e25e14e4-3caf-4d1c-be33-a8e8fa7f7791",
                    "ownerSide": 0
                },
                "_id": "e25e14e4-3caf-4d1c-be33-a8e8fa7f7791",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 250.1761403101,
                        "y": 372.3012560025
                    },
                    "_mouse": {
                        "x": 458,
                        "y": 363
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 250.1761403101,
                        "y": 144.1784593
                    },
                    "_mouse": {
                        "x": 260,
                        "y": 162
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.9752321981424149,
                    "_p1": {
                        "x": 233.8718257461,
                        "y": 217.7436802886
                    },
                    "_p2": {
                        "x": 233.8718257461,
                        "y": 251.6526657263
                    },
                    "_p3": {
                        "x": 243.8718257461,
                        "y": 251.6526657263
                    },
                    "_p4": {
                        "x": 243.8718257461,
                        "y": 217.7436802886
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 250.1761403101,
                    "y": 144.1784593
                },
                "_end": {
                    "x": 250.1761403101,
                    "y": 372.3012560025
                },
                "mid": {
                    "x": 250.1761403101,
                    "y": 258.23985765124996
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "fd27bc9a-302a-4242-92ac-5024b0c4f568",
                    "ownerId": "e25e14e4-3caf-4d1c-be33-a8e8fa7f7791",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 267,
                        "y": 164
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "abfd40dc-e5c1-46fa-885a-46d215b624d4",
                    "ownerId": "e25e14e4-3caf-4d1c-be33-a8e8fa7f7791",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 267,
                        "y": 181.4006685183
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "981860e8-cdcd-421e-a09d-45ce4f44305a",
                "saved": {
                    "0": 268,
                    "1": 164,
                    "2": 268,
                    "3": 181.40066528320312,
                    "4": 266,
                    "5": 181.40066528320312,
                    "6": 268,
                    "7": 164,
                    "8": 266,
                    "9": 181.40066528320312,
                    "10": 266,
                    "11": 164
                },
                "len": 228.1227967025
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "63bf090f-bb98-4286-8bfa-fbecfbd3afd9",
                    "ownerSide": 1
                },
                "_id": "63bf090f-bb98-4286-8bfa-fbecfbd3afd9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "_mouse": {
                        "x": 525,
                        "y": 255
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "_mouse": {
                        "x": 529,
                        "y": 98
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 535.3294693145,
                    "y": 258.2398576513
                },
                "_end": {
                    "x": 535.3294693145,
                    "y": 201.2091918504
                },
                "mid": {
                    "x": 535.3294693145,
                    "y": 229.72452475084998
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "63bf090f-bb98-4286-8bfa-fbecfbd3afd9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "c03461d0-6c80-443d-b5c4-418d81c91b93",
                    "ownerId": "63bf090f-bb98-4286-8bfa-fbecfbd3afd9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 201.2091918504
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "981860e8-cdcd-421e-a09d-45ce4f44305a",
                "saved": {
                    "0": 534.3294677734375,
                    "1": 258.2398681640625,
                    "2": 534.3294677734375,
                    "3": 201.20919799804688,
                    "4": 536.3294677734375,
                    "5": 201.20919799804688,
                    "6": 534.3294677734375,
                    "7": 258.2398681640625,
                    "8": 536.3294677734375,
                    "9": 201.20919799804688,
                    "10": 536.3294677734375,
                    "11": 258.2398681640625
                },
                "len": 57.03066580089998
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 535.3294693145,
                        "y": 286.75519055175
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "0cd87b1b-6eb1-4573-bac8-688c53c51843",
                    "ownerSide": 1
                },
                "_id": "0cd87b1b-6eb1-4573-bac8-688c53c51843",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 315.2705234522
                    },
                    "_mouse": {
                        "x": 508,
                        "y": 321
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "_mouse": {
                        "x": 529,
                        "y": 98
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 535.3294693145,
                    "y": 258.2398576513
                },
                "_end": {
                    "x": 535.3294693145,
                    "y": 315.2705234522
                },
                "mid": {
                    "x": 535.3294693145,
                    "y": 286.75519055175
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "0cd87b1b-6eb1-4573-bac8-688c53c51843",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 258.2398576513
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "aaff0a2e-fa8a-4ecd-ac9f-3a8829ae7648",
                    "ownerId": "0cd87b1b-6eb1-4573-bac8-688c53c51843",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 315.2705234522
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "981860e8-cdcd-421e-a09d-45ce4f44305a",
                "saved": {
                    "0": 536.3294677734375,
                    "1": 258.2398681640625,
                    "2": 536.3294677734375,
                    "3": 315.2705383300781,
                    "4": 534.3294677734375,
                    "5": 315.2705383300781,
                    "6": 536.3294677734375,
                    "7": 258.2398681640625,
                    "8": 534.3294677734375,
                    "9": 315.2705383300781,
                    "10": 534.3294677734375,
                    "11": 258.2398681640625
                },
                "len": 57.03066580090001
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 250.1761403101,
                        "y": 372.3012560025
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "a1a0e2cf-5721-4870-a87d-8749b33286bd",
                    "ownerSide": 1
                },
                "_id": "a1a0e2cf-5721-4870-a87d-8749b33286bd",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 250.1761403101,
                        "y": 372.3012560025
                    },
                    "_mouse": {
                        "x": 458,
                        "y": 363
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 315.2705234522
                    },
                    "_mouse": {
                        "x": 529,
                        "y": 98
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.9752321981424149,
                    "_p1": {
                        "x": 534.3488875352667,
                        "y": 310.367620294454
                    },
                    "_p2": {
                        "x": 249.19555853086672,
                        "y": 367.398352844754
                    },
                    "_p3": {
                        "x": 251.1567220893333,
                        "y": 377.204159160246
                    },
                    "_p4": {
                        "x": 536.3100510937333,
                        "y": 320.173426609946
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 535.3294693145,
                    "y": 315.2705234522
                },
                "_end": {
                    "x": 250.1761403101,
                    "y": 372.3012560025
                },
                "mid": {
                    "x": 392.7528048123,
                    "y": 343.78588972734997
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "a1a0e2cf-5721-4870-a87d-8749b33286bd",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 315.2705234522
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "abfd40dc-e5c1-46fa-885a-46d215b624d4",
                    "ownerId": "a1a0e2cf-5721-4870-a87d-8749b33286bd",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 250.1761403101,
                        "y": 372.3012560025
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "981860e8-cdcd-421e-a09d-45ce4f44305a",
                "saved": {
                    "0": 535.5255737304688,
                    "1": 316.2510986328125,
                    "2": 250.37225341796875,
                    "3": 373.2818298339844,
                    "4": 249.9800262451172,
                    "5": 371.3206787109375,
                    "6": 535.5255737304688,
                    "7": 316.2510986328125,
                    "8": 249.9800262451172,
                    "9": 371.3206787109375,
                    "10": 535.1333618164062,
                    "11": 314.2899475097656
                },
                "len": 290.80049088252144
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 250.1761403101,
                        "y": 144.1784593
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "e2d9dedb-d90a-4f8f-97db-01e1aaee78ee",
                    "ownerSide": 0
                },
                "_id": "e2d9dedb-d90a-4f8f-97db-01e1aaee78ee",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 201.2091918504
                    },
                    "_mouse": {
                        "x": 289,
                        "y": 209
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.3294693145,
                        "y": 201.2091918504
                    },
                    "_mouse": {
                        "x": 529,
                        "y": 98
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 535.3294693145,
                    "y": 201.2091918504
                },
                "_end": {
                    "x": 250.1761403101,
                    "y": 144.1784593
                },
                "mid": {
                    "x": 392.7528048123,
                    "y": 172.69382557519998
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "c03461d0-6c80-443d-b5c4-418d81c91b93",
                    "ownerId": "e2d9dedb-d90a-4f8f-97db-01e1aaee78ee",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.3294693145,
                        "y": 201.2091918504
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "fd27bc9a-302a-4242-92ac-5024b0c4f568",
                    "ownerId": "e2d9dedb-d90a-4f8f-97db-01e1aaee78ee",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 250.1761403101,
                        "y": 144.1784593
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "981860e8-cdcd-421e-a09d-45ce4f44305a",
                "saved": {
                    "0": 535.1333618164062,
                    "1": 202.1897735595703,
                    "2": 249.9800262451172,
                    "3": 145.15904235839844,
                    "4": 250.37225341796875,
                    "5": 143.1978759765625,
                    "6": 535.1333618164062,
                    "7": 202.1897735595703,
                    "8": 250.37225341796875,
                    "9": 143.1978759765625,
                    "10": 535.5255737304688,
                    "11": 200.22860717773438
                },
                "len": 290.80049088254106
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10301",
            "desc": "Переход симметричный",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 250.1761403101,
                    "y": 258.23985765124996
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 535.3294693145,
                    "y": 258.2398576513
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 251.1761474609375,
            "1": 144.178466796875,
            "2": 251.1761474609375,
            "3": 372.30126953125,
            "4": 249.1761474609375,
            "5": 372.30126953125,
            "6": 251.1761474609375,
            "7": 144.178466796875,
            "8": 249.1761474609375,
            "9": 372.30126953125,
            "10": 249.1761474609375,
            "11": 144.178466796875,
            "12": 534.3294677734375,
            "13": 258.2398681640625,
            "14": 534.3294677734375,
            "15": 201.20919799804688,
            "16": 536.3294677734375,
            "17": 201.20919799804688,
            "18": 534.3294677734375,
            "19": 258.2398681640625,
            "20": 536.3294677734375,
            "21": 201.20919799804688,
            "22": 536.3294677734375,
            "23": 258.2398681640625,
            "24": 536.3294677734375,
            "25": 258.2398681640625,
            "26": 536.3294677734375,
            "27": 315.2705383300781,
            "28": 534.3294677734375,
            "29": 315.2705383300781,
            "30": 536.3294677734375,
            "31": 258.2398681640625,
            "32": 534.3294677734375,
            "33": 315.2705383300781,
            "34": 534.3294677734375,
            "35": 258.2398681640625,
            "36": 535.5255737304688,
            "37": 316.2510986328125,
            "38": 250.37225341796875,
            "39": 373.2818298339844,
            "40": 249.9800262451172,
            "41": 371.3206787109375,
            "42": 535.5255737304688,
            "43": 316.2510986328125,
            "44": 249.9800262451172,
            "45": 371.3206787109375,
            "46": 535.1333618164062,
            "47": 314.2899475097656,
            "48": 535.1333618164062,
            "49": 202.1897735595703,
            "50": 249.9800262451172,
            "51": 145.15904235839844,
            "52": 250.37225341796875,
            "53": 143.1978759765625,
            "54": 535.1333618164062,
            "55": 202.1897735595703,
            "56": 250.37225341796875,
            "57": 143.1978759765625,
            "58": 535.5255737304688,
            "59": 200.22860717773438
        },
        "zlc": 0.28515332900441864,
        "id": "4be5dcc0-7d4c-493c-b7dd-cf940cc49276"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "d65dde56-11f2-41fc-b20a-c9aa7e385c1d",
            "ownerSide": null
        },
        "_id": "d65dde56-11f2-41fc-b20a-c9aa7e385c1d",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 526.9862775725,
                "y": 168.8123045796
            },
            "_p2": {
                "x": 703.9904763255,
                "y": 168.8123045796
            },
            "_p3": {
                "x": 703.9904763255,
                "y": 347.2383197161
            },
            "_p4": {
                "x": 526.9862775725,
                "y": 347.2383197161
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 536.9862775725,
                        "y": 258.02531214785
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "7beeb042-1634-49e6-b66c-92e9c798edda",
                    "ownerSide": 1
                },
                "_id": "7beeb042-1634-49e6-b66c-92e9c798edda",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 536.9862775725,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 596,
                        "y": 187
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 536.9862775725,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 544,
                        "y": 244
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 531.9862775725,
                        "y": 178.8123045796
                    },
                    "_p2": {
                        "x": 531.9862775725,
                        "y": 337.2383197161
                    },
                    "_p3": {
                        "x": 541.9862775725,
                        "y": 337.2383197161
                    },
                    "_p4": {
                        "x": 541.9862775725,
                        "y": 178.8123045796
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 536.9862775725,
                    "y": 178.8123045796
                },
                "_end": {
                    "x": 536.9862775725,
                    "y": 337.2383197161
                },
                "mid": {
                    "x": 536.9862775725,
                    "y": 258.02531214785
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "7beeb042-1634-49e6-b66c-92e9c798edda",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535,
                        "y": 146
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "7beeb042-1634-49e6-b66c-92e9c798edda",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535,
                        "y": 180.4781048041
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 536,
                    "1": 146,
                    "2": 536,
                    "3": 180.4781036376953,
                    "4": 534,
                    "5": 180.4781036376953,
                    "6": 536,
                    "7": 146,
                    "8": 534,
                    "9": 180.4781036376953,
                    "10": 534,
                    "11": 146
                },
                "len": 158.4260151365
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "5921c9d3-98c2-4c69-b97f-d06f0cb40516",
                    "ownerSide": 0
                },
                "_id": "5921c9d3-98c2-4c69-b97f-d06f0cb40516",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 596,
                        "y": 187
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 564,
                        "y": 218
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 556.789522597,
                    "y": 178.8123045796
                },
                "_end": {
                    "x": 556.789522597,
                    "y": 337.2383197161
                },
                "mid": {
                    "x": 556.789522597,
                    "y": 258.02531214785
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "782114f6-3b07-4892-afae-67630aedce50",
                    "ownerId": "5921c9d3-98c2-4c69-b97f-d06f0cb40516",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "2be2ebec-2d9d-4c7b-923d-d1b77c6a8b03",
                    "ownerId": "5921c9d3-98c2-4c69-b97f-d06f0cb40516",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 556.789522597,
                        "y": 337.2383197161
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "5becf743-1b11-42f1-b150-1aa4d88a50bb",
                "saved": {
                    "0": 557.78955078125,
                    "1": 178.8123016357422,
                    "2": 557.78955078125,
                    "3": 337.2383117675781,
                    "4": 555.78955078125,
                    "5": 337.2383117675781,
                    "6": 557.78955078125,
                    "7": 178.8123016357422,
                    "8": 555.78955078125,
                    "9": 337.2383117675781,
                    "10": 555.78955078125,
                    "11": 178.8123016357422
                },
                "len": 158.4260151365
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 693.9904763255,
                        "y": 258.0253121479
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ffdf0bc1-fbf4-4bc4-b0bb-8c2d2b97503e",
                    "ownerSide": 1
                },
                "_id": "ffdf0bc1-fbf4-4bc4-b0bb-8c2d2b97503e",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 693.9904763255,
                        "y": 258.0253121479
                    },
                    "_mouse": {
                        "x": 542,
                        "y": 249
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.789522597,
                        "y": 337.2383197161
                    },
                    "_mouse": {
                        "x": 564,
                        "y": 218
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 556.789522597,
                    "y": 337.2383197161
                },
                "_end": {
                    "x": 693.9904763255,
                    "y": 258.0253121479
                },
                "mid": {
                    "x": 625.38999946125,
                    "y": 297.631815932
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "2be2ebec-2d9d-4c7b-923d-d1b77c6a8b03",
                    "ownerId": "ffdf0bc1-fbf4-4bc4-b0bb-8c2d2b97503e",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 556.789522597,
                        "y": 337.2383197161
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "dd0be443-8369-4abb-ab49-a2342fa733c5",
                    "ownerId": "ffdf0bc1-fbf4-4bc4-b0bb-8c2d2b97503e",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 693.9904763255,
                        "y": 258.0253121479
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "5becf743-1b11-42f1-b150-1aa4d88a50bb",
                "saved": {
                    "0": 556.28955078125,
                    "1": 336.3722839355469,
                    "2": 693.490478515625,
                    "3": 257.1593017578125,
                    "4": 694.490478515625,
                    "5": 258.8913269042969,
                    "6": 556.28955078125,
                    "7": 336.3722839355469,
                    "8": 694.490478515625,
                    "9": 258.8913269042969,
                    "10": 557.28955078125,
                    "11": 338.1043395996094
                },
                "len": 158.42601513643433
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "acced4d3-33ea-46e8-ba0b-443c18cfbb86",
                    "ownerSide": 1
                },
                "_id": "acced4d3-33ea-46e8-ba0b-443c18cfbb86",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 596,
                        "y": 187
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "_mouse": {
                        "x": 564,
                        "y": 218
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 693.9904763255,
                    "y": 258.0253121479
                },
                "_end": {
                    "x": 556.789522597,
                    "y": 178.8123045796
                },
                "mid": {
                    "x": 625.38999946125,
                    "y": 218.41880836375003
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "dd0be443-8369-4abb-ab49-a2342fa733c5",
                    "ownerId": "acced4d3-33ea-46e8-ba0b-443c18cfbb86",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 693.9904763255,
                        "y": 258.0253121479
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "782114f6-3b07-4892-afae-67630aedce50",
                    "ownerId": "acced4d3-33ea-46e8-ba0b-443c18cfbb86",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 556.789522597,
                        "y": 178.8123045796
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "5becf743-1b11-42f1-b150-1aa4d88a50bb",
                "saved": {
                    "0": 693.490478515625,
                    "1": 258.8913269042969,
                    "2": 556.28955078125,
                    "3": 179.67832946777344,
                    "4": 557.28955078125,
                    "5": 177.94627380371094,
                    "6": 693.490478515625,
                    "7": 258.8913269042969,
                    "8": 557.28955078125,
                    "9": 177.94627380371094,
                    "10": 694.490478515625,
                    "11": 257.1593017578125
                },
                "len": 158.42601513648435
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10501",
            "desc": "Отверстие (решётка) для выпуска воздуха",
            "size": "",
            "kms": "4",
            "kvs": "",
            "flowDirections": {
                "start": "IN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": true,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 4,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 536.9862775725,
                    "y": 258.02531214785
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 537.9862670898438,
            "1": 178.8123016357422,
            "2": 537.9862670898438,
            "3": 337.2383117675781,
            "4": 535.9862670898438,
            "5": 337.2383117675781,
            "6": 537.9862670898438,
            "7": 178.8123016357422,
            "8": 535.9862670898438,
            "9": 337.2383117675781,
            "10": 535.9862670898438,
            "11": 178.8123016357422,
            "12": 557.78955078125,
            "13": 178.8123016357422,
            "14": 557.78955078125,
            "15": 337.2383117675781,
            "16": 555.78955078125,
            "17": 337.2383117675781,
            "18": 557.78955078125,
            "19": 178.8123016357422,
            "20": 555.78955078125,
            "21": 337.2383117675781,
            "22": 555.78955078125,
            "23": 178.8123016357422,
            "24": 556.28955078125,
            "25": 336.3722839355469,
            "26": 693.490478515625,
            "27": 257.1593017578125,
            "28": 694.490478515625,
            "29": 258.8913269042969,
            "30": 556.28955078125,
            "31": 336.3722839355469,
            "32": 694.490478515625,
            "33": 258.8913269042969,
            "34": 557.28955078125,
            "35": 338.1043395996094,
            "36": 693.490478515625,
            "37": 258.8913269042969,
            "38": 556.28955078125,
            "39": 179.67832946777344,
            "40": 557.28955078125,
            "41": 177.94627380371094,
            "42": 693.490478515625,
            "43": 258.8913269042969,
            "44": 557.28955078125,
            "45": 177.94627380371094,
            "46": 694.490478515625,
            "47": 257.1593017578125
        },
        "zlc": 0.1980324502446743,
        "id": "d65dde56-11f2-41fc-b20a-c9aa7e385c1d"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "14519fea-5131-4f22-a9e0-bf812effb458",
            "ownerSide": null
        },
        "_id": "14519fea-5131-4f22-a9e0-bf812effb458",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 506,
                "y": 148
            },
            "_p2": {
                "x": 683.0041511729,
                "y": 148
            },
            "_p3": {
                "x": 683.0041511729,
                "y": 326.4259601957
            },
            "_p4": {
                "x": 506,
                "y": 326.4259601957
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 516,
                        "y": 237.21298009785
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "9ed05563-da93-4d68-8478-377e1c373277",
                    "ownerSide": null
                },
                "_id": "9ed05563-da93-4d68-8478-377e1c373277",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 516,
                        "y": 158
                    },
                    "_mouse": {
                        "x": 564,
                        "y": 165
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 516,
                        "y": 158
                    },
                    "_mouse": {
                        "x": 526,
                        "y": 259
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 511,
                        "y": 158
                    },
                    "_p2": {
                        "x": 511,
                        "y": 316.4259601957
                    },
                    "_p3": {
                        "x": 521,
                        "y": 316.4259601957
                    },
                    "_p4": {
                        "x": 521,
                        "y": 158
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 516,
                    "y": 158
                },
                "_end": {
                    "x": 516,
                    "y": 316.4259601957
                },
                "mid": {
                    "x": 516,
                    "y": 237.21298009785
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "9ed05563-da93-4d68-8478-377e1c373277",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 516,
                        "y": 158
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "9ed05563-da93-4d68-8478-377e1c373277",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 516,
                        "y": 316.4259601957
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 517,
                    "1": 158,
                    "2": 517,
                    "3": 316.42596435546875,
                    "4": 515,
                    "5": 316.42596435546875,
                    "6": 517,
                    "7": 158,
                    "8": 515,
                    "9": 316.42596435546875,
                    "10": 515,
                    "11": 158
                },
                "len": 158.4259601957
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "1c2dc874-c919-4612-b197-fab6e208a398",
                    "ownerSide": 0
                },
                "_id": "1c2dc874-c919-4612-b197-fab6e208a398",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "_mouse": {
                        "x": 514,
                        "y": 234
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "_mouse": {
                        "x": 539,
                        "y": 227
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 535.8032450245,
                    "y": 237.2129800978
                },
                "_end": {
                    "x": 673.0041511729,
                    "y": 158
                },
                "mid": {
                    "x": 604.4036980987,
                    "y": 197.6064900489
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "b8a42a57-7c79-4720-8215-958c2851462f",
                    "ownerId": "1c2dc874-c919-4612-b197-fab6e208a398",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "a2abd478-faf1-4946-b0a4-c860a75dec34",
                    "ownerId": "1c2dc874-c919-4612-b197-fab6e208a398",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 673.0041511729,
                        "y": 158
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "e201c906-f046-4986-8724-4fcee45e0bf4",
                "saved": {
                    "0": 535.30322265625,
                    "1": 236.34695434570312,
                    "2": 672.504150390625,
                    "3": 157.13397216796875,
                    "4": 673.504150390625,
                    "5": 158.86602783203125,
                    "6": 535.30322265625,
                    "7": 236.34695434570312,
                    "8": 673.504150390625,
                    "9": 158.86602783203125,
                    "10": 536.30322265625,
                    "11": 238.07901000976562
                },
                "len": 158.42596019565897
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 673.0041511729,
                        "y": 316.4259601957
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "f6dc054f-5c77-4a76-b3b7-2650778b6ac8",
                    "ownerSide": 1
                },
                "_id": "f6dc054f-5c77-4a76-b3b7-2650778b6ac8",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 673.0041511729,
                        "y": 158
                    },
                    "_mouse": {
                        "x": 564,
                        "y": 165
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 673.0041511729,
                    "y": 158
                },
                "_end": {
                    "x": 673.0041511729,
                    "y": 316.4259601957
                },
                "mid": {
                    "x": 673.0041511729,
                    "y": 237.21298009785
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "a2abd478-faf1-4946-b0a4-c860a75dec34",
                    "ownerId": "f6dc054f-5c77-4a76-b3b7-2650778b6ac8",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 673.0041511729,
                        "y": 158
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "d90c1d76-cdff-40d9-8a3a-b97a42d60679",
                    "ownerId": "f6dc054f-5c77-4a76-b3b7-2650778b6ac8",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 673.0041511729,
                        "y": 316.4259601957
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "e201c906-f046-4986-8724-4fcee45e0bf4",
                "saved": {
                    "0": 674.004150390625,
                    "1": 158,
                    "2": 674.004150390625,
                    "3": 316.42596435546875,
                    "4": 672.004150390625,
                    "5": 316.42596435546875,
                    "6": 674.004150390625,
                    "7": 158,
                    "8": 672.004150390625,
                    "9": 316.42596435546875,
                    "10": 672.004150390625,
                    "11": 158
                },
                "len": 158.4259601957
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "965a5e33-6a4b-4348-aeed-970703c47505",
                    "ownerSide": 1
                },
                "_id": "965a5e33-6a4b-4348-aeed-970703c47505",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "_mouse": {
                        "x": 514,
                        "y": 234
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "_mouse": {
                        "x": 539,
                        "y": 227
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 675.5041511729015,
                        "y": 312.0958331767786
                    },
                    "_p2": {
                        "x": 538.3032450245015,
                        "y": 232.88285307887864
                    },
                    "_p3": {
                        "x": 533.3032450244986,
                        "y": 241.54310711672136
                    },
                    "_p4": {
                        "x": 670.5041511728986,
                        "y": 320.75608721462135
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 673.0041511729,
                    "y": 316.4259601957
                },
                "_end": {
                    "x": 535.8032450245,
                    "y": 237.2129800978
                },
                "mid": {
                    "x": 604.4036980987,
                    "y": 276.81947014675
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "d90c1d76-cdff-40d9-8a3a-b97a42d60679",
                    "ownerId": "965a5e33-6a4b-4348-aeed-970703c47505",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 673.0041511729,
                        "y": 316.4259601957
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "b8a42a57-7c79-4720-8215-958c2851462f",
                    "ownerId": "965a5e33-6a4b-4348-aeed-970703c47505",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 535.8032450245,
                        "y": 237.2129800978
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "e201c906-f046-4986-8724-4fcee45e0bf4",
                "saved": {
                    "0": 672.504150390625,
                    "1": 317.2919921875,
                    "2": 535.30322265625,
                    "3": 238.07901000976562,
                    "4": 536.30322265625,
                    "5": 236.34695434570312,
                    "6": 672.504150390625,
                    "7": 317.2919921875,
                    "8": 536.30322265625,
                    "9": 236.34695434570312,
                    "10": 673.504150390625,
                    "11": 315.5599365234375
                },
                "len": 158.42596019570897
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10502",
            "desc": "Отверстие (решётка) для забора воздуха",
            "size": "",
            "kms": "4",
            "kvs": "",
            "flowDirections": {
                "start": "OUT",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": true,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 4,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 516,
                    "y": 237.21298009785
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 517,
            "1": 158,
            "2": 517,
            "3": 316.42596435546875,
            "4": 515,
            "5": 316.42596435546875,
            "6": 517,
            "7": 158,
            "8": 515,
            "9": 316.42596435546875,
            "10": 515,
            "11": 158,
            "12": 535.30322265625,
            "13": 236.34695434570312,
            "14": 672.504150390625,
            "15": 157.13397216796875,
            "16": 673.504150390625,
            "17": 158.86602783203125,
            "18": 535.30322265625,
            "19": 236.34695434570312,
            "20": 673.504150390625,
            "21": 158.86602783203125,
            "22": 536.30322265625,
            "23": 238.07901000976562,
            "24": 674.004150390625,
            "25": 158,
            "26": 674.004150390625,
            "27": 316.42596435546875,
            "28": 672.004150390625,
            "29": 316.42596435546875,
            "30": 674.004150390625,
            "31": 158,
            "32": 672.004150390625,
            "33": 316.42596435546875,
            "34": 672.004150390625,
            "35": 158,
            "36": 672.504150390625,
            "37": 317.2919921875,
            "38": 535.30322265625,
            "39": 238.07901000976562,
            "40": 536.30322265625,
            "41": 236.34695434570312,
            "42": 672.504150390625,
            "43": 317.2919921875,
            "44": 536.30322265625,
            "45": 236.34695434570312,
            "46": 673.504150390625,
            "47": 315.5599365234375
        },
        "zlc": 0.1980324502446743,
        "id": "14519fea-5131-4f22-a9e0-bf812effb458"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "e0b0ef2c-a49a-4138-834e-378aaeaa3fdb",
            "ownerSide": null
        },
        "_id": "e0b0ef2c-a49a-4138-834e-378aaeaa3fdb",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 575.3680134133,
                "y": 135.3341064365
            },
            "_p2": {
                "x": 741.3995918619,
                "y": 135.3341064365
            },
            "_p3": {
                "x": 741.3995918619,
                "y": 341.3150474988
            },
            "_p4": {
                "x": 575.3680134133,
                "y": 341.3150474988
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 658.3838026376,
                        "y": 145.3341064365
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ed8406d4-fa09-496f-bf74-79ce5813791f",
                    "ownerSide": 1
                },
                "_id": "ed8406d4-fa09-496f-bf74-79ce5813791f",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 658.3838026376,
                        "y": 145.3341064365
                    },
                    "_mouse": {
                        "x": 685,
                        "y": 136
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 658.3838026376,
                        "y": 145.3341064365
                    },
                    "_mouse": {
                        "x": 668,
                        "y": 208
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 653.3838026376,
                        "y": 145.3341064365
                    },
                    "_p2": {
                        "x": 653.3838026376,
                        "y": 331.3150474988
                    },
                    "_p3": {
                        "x": 663.3838026376,
                        "y": 331.3150474988
                    },
                    "_p4": {
                        "x": 663.3838026376,
                        "y": 145.3341064365
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 658.3838026376,
                    "y": 145.3341064365
                },
                "_end": {
                    "x": 658.3838026376,
                    "y": 331.3150474988
                },
                "mid": {
                    "x": 658.3838026376,
                    "y": 238.32457696765002
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "a34cf25b-c400-4326-85c9-1176d40923e3",
                    "ownerId": "ed8406d4-fa09-496f-bf74-79ce5813791f",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 626,
                        "y": 172
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "7b8fbec1-4984-4928-9369-0e3782a9e6c6",
                    "ownerId": "ed8406d4-fa09-496f-bf74-79ce5813791f",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 626,
                        "y": 225.8720387564
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "b4cc759d-07cb-4689-876f-1f596b2b8574",
                "saved": {
                    "0": 627,
                    "1": 172,
                    "2": 627,
                    "3": 225.87203979492188,
                    "4": 625,
                    "5": 225.87203979492188,
                    "6": 627,
                    "7": 172,
                    "8": 625,
                    "9": 225.87203979492188,
                    "10": 625,
                    "11": 172
                },
                "len": 185.98094106230002
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 694.89169724975,
                        "y": 268.0815191532
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "9f19b730-f5e0-4b76-9ba9-d2fbdef6b0b9",
                    "ownerSide": 0
                },
                "_id": "9f19b730-f5e0-4b76-9ba9-d2fbdef6b0b9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 673,
                        "y": 212
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 728,
                        "y": 66
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 658.3838026376,
                    "y": 331.3150474988
                },
                "_end": {
                    "x": 731.3995918619,
                    "y": 204.8479908076
                },
                "mid": {
                    "x": 694.89169724975,
                    "y": 268.0815191532
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "9ae93b20-714a-4f90-a8fb-e5fa25c77f58",
                    "ownerId": "9f19b730-f5e0-4b76-9ba9-d2fbdef6b0b9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 658.3838026376,
                        "y": 331.3150474988
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "558c8e3e-9811-46cf-8351-56d69b74448d",
                    "ownerId": "9f19b730-f5e0-4b76-9ba9-d2fbdef6b0b9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "b4cc759d-07cb-4689-876f-1f596b2b8574",
                "saved": {
                    "0": 657.5177612304688,
                    "1": 330.8150329589844,
                    "2": 730.5335693359375,
                    "3": 204.34799194335938,
                    "4": 732.265625,
                    "5": 205.34799194335938,
                    "6": 657.5177612304688,
                    "7": 330.8150329589844,
                    "8": 732.265625,
                    "9": 205.34799194335938,
                    "10": 659.2498168945312,
                    "11": 331.8150329589844
                },
                "len": 146.03157844857603
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 658.3838026376,
                        "y": 204.8479908076
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "2b1b9035-5b59-446b-9527-1097bdf271ad",
                    "ownerSide": 1
                },
                "_id": "2b1b9035-5b59-446b-9527-1097bdf271ad",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 673,
                        "y": 212
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 728,
                        "y": 66
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 731.3995918619,
                    "y": 204.8479908076
                },
                "_end": {
                    "x": 658.3838026376,
                    "y": 204.8479908076
                },
                "mid": {
                    "x": 694.89169724975,
                    "y": 204.8479908076
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "558c8e3e-9811-46cf-8351-56d69b74448d",
                    "ownerId": "2b1b9035-5b59-446b-9527-1097bdf271ad",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 731.3995918619,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "746ce34b-8f0d-4c41-84d5-c19659ff79b8",
                    "ownerId": "2b1b9035-5b59-446b-9527-1097bdf271ad",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 658.3838026376,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "b4cc759d-07cb-4689-876f-1f596b2b8574",
                "saved": {
                    "0": 731.3995971679688,
                    "1": 205.84799194335938,
                    "2": 658.3837890625,
                    "3": 205.84799194335938,
                    "4": 658.3837890625,
                    "5": 203.84799194335938,
                    "6": 731.3995971679688,
                    "7": 205.84799194335938,
                    "8": 658.3837890625,
                    "9": 203.84799194335938,
                    "10": 731.3995971679688,
                    "11": 203.84799194335938
                },
                "len": 73.01578922430008
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 585.3680134133,
                        "y": 204.8479908076
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "0306e405-03e5-4d4e-a80a-d029d994ca0b",
                    "ownerSide": 1
                },
                "_id": "0306e405-03e5-4d4e-a80a-d029d994ca0b",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 585.3680134133,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 673,
                        "y": 212
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 658.3838026376,
                        "y": 331.3150474988
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 194
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 658.3838026376,
                    "y": 331.3150474988
                },
                "_end": {
                    "x": 585.3680134133,
                    "y": 204.8479908076
                },
                "mid": {
                    "x": 621.8759080254499,
                    "y": 268.0815191532
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "7b8fbec1-4984-4928-9369-0e3782a9e6c6",
                    "ownerId": "0306e405-03e5-4d4e-a80a-d029d994ca0b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 658.3838026376,
                        "y": 331.3150474988
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "d48cbe3b-d8fe-4a52-b127-48e1eae23029",
                    "ownerId": "0306e405-03e5-4d4e-a80a-d029d994ca0b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 585.3680134133,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "b4cc759d-07cb-4689-876f-1f596b2b8574",
                "saved": {
                    "0": 657.5177612304688,
                    "1": 331.8150329589844,
                    "2": 584.5020141601562,
                    "3": 205.34799194335938,
                    "4": 586.2340087890625,
                    "5": 204.34799194335938,
                    "6": 657.5177612304688,
                    "7": 331.8150329589844,
                    "8": 586.2340087890625,
                    "9": 204.34799194335938,
                    "10": 659.2498168945312,
                    "11": 330.8150329589844
                },
                "len": 146.03157844857597
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 658.3838026376,
                        "y": 204.8479908076
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "a522987d-36d4-4ec8-b603-c47e3eabb01a",
                    "ownerSide": 1
                },
                "_id": "a522987d-36d4-4ec8-b603-c47e3eabb01a",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 585.3680134133,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 673,
                        "y": 212
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 658.3838026376,
                        "y": 204.8479908076
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 194
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 585.3680134133,
                    "y": 204.8479908076
                },
                "_end": {
                    "x": 658.3838026376,
                    "y": 204.8479908076
                },
                "mid": {
                    "x": 621.8759080254499,
                    "y": 204.8479908076
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "d48cbe3b-d8fe-4a52-b127-48e1eae23029",
                    "ownerId": "a522987d-36d4-4ec8-b603-c47e3eabb01a",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 585.3680134133,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "746ce34b-8f0d-4c41-84d5-c19659ff79b8",
                    "ownerId": "a522987d-36d4-4ec8-b603-c47e3eabb01a",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 658.3838026376,
                        "y": 204.8479908076
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "b4cc759d-07cb-4689-876f-1f596b2b8574",
                "saved": {
                    "0": 585.3680419921875,
                    "1": 203.84799194335938,
                    "2": 658.3837890625,
                    "3": 203.84799194335938,
                    "4": 658.3837890625,
                    "5": 205.84799194335938,
                    "6": 585.3680419921875,
                    "7": 203.84799194335938,
                    "8": 658.3837890625,
                    "9": 205.84799194335938,
                    "10": 585.3680419921875,
                    "11": 205.84799194335938
                },
                "len": 73.01578922429997
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10503",
            "desc": "Воздухораспределитель приточный четырёхсторонний",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 658.3838026376,
                    "y": 145.3341064365
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 659.3837890625,
            "1": 145.3341064453125,
            "2": 659.3837890625,
            "3": 331.3150329589844,
            "4": 657.3837890625,
            "5": 331.3150329589844,
            "6": 659.3837890625,
            "7": 145.3341064453125,
            "8": 657.3837890625,
            "9": 331.3150329589844,
            "10": 657.3837890625,
            "11": 145.3341064453125,
            "12": 657.5177612304688,
            "13": 330.8150329589844,
            "14": 730.5335693359375,
            "15": 204.34799194335938,
            "16": 732.265625,
            "17": 205.34799194335938,
            "18": 657.5177612304688,
            "19": 330.8150329589844,
            "20": 732.265625,
            "21": 205.34799194335938,
            "22": 659.2498168945312,
            "23": 331.8150329589844,
            "24": 731.3995971679688,
            "25": 205.84799194335938,
            "26": 658.3837890625,
            "27": 205.84799194335938,
            "28": 658.3837890625,
            "29": 203.84799194335938,
            "30": 731.3995971679688,
            "31": 205.84799194335938,
            "32": 658.3837890625,
            "33": 203.84799194335938,
            "34": 731.3995971679688,
            "35": 203.84799194335938,
            "36": 657.5177612304688,
            "37": 331.8150329589844,
            "38": 584.5020141601562,
            "39": 205.34799194335938,
            "40": 586.2340087890625,
            "41": 204.34799194335938,
            "42": 657.5177612304688,
            "43": 331.8150329589844,
            "44": 586.2340087890625,
            "45": 204.34799194335938,
            "46": 659.2498168945312,
            "47": 330.8150329589844,
            "48": 585.3680419921875,
            "49": 203.84799194335938,
            "50": 658.3837890625,
            "51": 203.84799194335938,
            "52": 658.3837890625,
            "53": 205.84799194335938,
            "54": 585.3680419921875,
            "55": 203.84799194335938,
            "56": 658.3837890625,
            "57": 205.84799194335938,
            "58": 585.3680419921875,
            "59": 205.84799194335938
        },
        "zlc": 0.14878471092762904,
        "id": "e0b0ef2c-a49a-4138-834e-378aaeaa3fdb"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "1bd2b97a-9204-49db-a1af-92e4c2685462",
            "ownerSide": null
        },
        "_id": "1bd2b97a-9204-49db-a1af-92e4c2685462",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 507.38237354750004,
                "y": 116.8075901305
            },
            "_p2": {
                "x": 801.8136783942,
                "y": 116.8075901305
            },
            "_p3": {
                "x": 801.8136783942,
                "y": 486.3141343626
            },
            "_p4": {
                "x": 507.38237354750004,
                "y": 486.3141343626
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 791.8136783942,
                        "y": 476.3141343626
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "5494ac9a-89dd-4d2c-8a55-34abb5ab8bf5",
                    "ownerSide": 0
                },
                "_id": "5494ac9a-89dd-4d2c-8a55-34abb5ab8bf5",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "_mouse": {
                        "x": 740,
                        "y": 229
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 791.8136783942,
                        "y": 476.3141343626
                    },
                    "_mouse": {
                        "x": 784,
                        "y": 290
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 650.2678989518785,
                        "y": 241.1496527717011
                    },
                    "_p2": {
                        "x": 787.4835513752785,
                        "y": 478.81413436260107
                    },
                    "_p3": {
                        "x": 796.1438054131215,
                        "y": 473.8141343625989
                    },
                    "_p4": {
                        "x": 658.9281529897215,
                        "y": 236.1496527716989
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 654.5980259708,
                    "y": 238.6496527717
                },
                "_end": {
                    "x": 791.8136783942,
                    "y": 476.3141343626
                },
                "mid": {
                    "x": 723.2058521824999,
                    "y": 357.48189356715
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "d36e23b9-d655-4650-ba7f-f49201aedd15",
                    "ownerId": "5494ac9a-89dd-4d2c-8a55-34abb5ab8bf5",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "83fd87b1-3b77-42f0-9751-8b4735f901d3",
                    "ownerId": "5494ac9a-89dd-4d2c-8a55-34abb5ab8bf5",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 791.8136783942,
                        "y": 476.3141343626
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "f7077f51-4e11-4583-bd69-bf261217827b",
                "saved": {
                    "0": 655.4640502929688,
                    "1": 238.149658203125,
                    "2": 792.6796875,
                    "3": 475.81414794921875,
                    "4": 790.9476318359375,
                    "5": 476.81414794921875,
                    "6": 655.4640502929688,
                    "7": 238.149658203125,
                    "8": 790.9476318359375,
                    "9": 476.81414794921875,
                    "10": 653.7319946289062,
                    "11": 239.149658203125
                },
                "len": 274.4313048466784
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 517.3823735475,
                        "y": 476.3141343626
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "30eac210-92df-4412-be7f-5a913991639c",
                    "ownerSide": 1
                },
                "_id": "30eac210-92df-4412-be7f-5a913991639c",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 791.8136783942,
                        "y": 476.3141343626
                    },
                    "_mouse": {
                        "x": 784,
                        "y": 290
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 791.8136783942,
                    "y": 476.3141343626
                },
                "_end": {
                    "x": 517.3823735475,
                    "y": 476.3141343626
                },
                "mid": {
                    "x": 654.59802597085,
                    "y": 476.3141343626
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "83fd87b1-3b77-42f0-9751-8b4735f901d3",
                    "ownerId": "30eac210-92df-4412-be7f-5a913991639c",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 791.8136783942,
                        "y": 476.3141343626
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "51484230-90da-4837-91bc-3245dd29c34b",
                    "ownerId": "30eac210-92df-4412-be7f-5a913991639c",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 517.3823735475,
                        "y": 476.3141343626
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "f7077f51-4e11-4583-bd69-bf261217827b",
                "saved": {
                    "0": 791.8136596679688,
                    "1": 477.31414794921875,
                    "2": 517.3823852539062,
                    "3": 477.31414794921875,
                    "4": 517.3823852539062,
                    "5": 475.31414794921875,
                    "6": 791.8136596679688,
                    "7": 477.31414794921875,
                    "8": 517.3823852539062,
                    "9": 475.31414794921875,
                    "10": 791.8136596679688,
                    "11": 475.31414794921875
                },
                "len": 274.43130484669996
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ea34f4cb-aabc-4560-8477-21df289a547b",
                    "ownerSide": 1
                },
                "_id": "ea34f4cb-aabc-4560-8477-21df289a547b",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "_mouse": {
                        "x": 740,
                        "y": 229
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "_mouse": {
                        "x": 663,
                        "y": 134
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 517.3823735475,
                    "y": 476.3141343626
                },
                "_end": {
                    "x": 654.5980259708,
                    "y": 238.6496527717
                },
                "mid": {
                    "x": 585.9901997591501,
                    "y": 357.48189356715
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "51484230-90da-4837-91bc-3245dd29c34b",
                    "ownerId": "ea34f4cb-aabc-4560-8477-21df289a547b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 517.3823735475,
                        "y": 476.3141343626
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "d36e23b9-d655-4650-ba7f-f49201aedd15",
                    "ownerId": "ea34f4cb-aabc-4560-8477-21df289a547b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 654.5980259708,
                        "y": 238.6496527717
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "f7077f51-4e11-4583-bd69-bf261217827b",
                "saved": {
                    "0": 516.516357421875,
                    "1": 475.81414794921875,
                    "2": 653.7319946289062,
                    "3": 238.149658203125,
                    "4": 655.4640502929688,
                    "5": 239.149658203125,
                    "6": 516.516357421875,
                    "7": 475.81414794921875,
                    "8": 655.4640502929688,
                    "9": 239.149658203125,
                    "10": 518.2484130859375,
                    "11": 476.81414794921875
                },
                "len": 274.43130484662845
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 654.5980259709,
                        "y": 126.8075901305
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "4237addb-b860-473c-90cd-edeb936b63dd",
                    "ownerSide": 1
                },
                "_id": "4237addb-b860-473c-90cd-edeb936b63dd",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 654.5980259709,
                        "y": 126.8075901305
                    },
                    "_mouse": {
                        "x": 735,
                        "y": 122
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 654.5980259709,
                        "y": 126.8075901305
                    },
                    "_mouse": {
                        "x": 661,
                        "y": 137
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 654.5980259709,
                    "y": 126.8075901305
                },
                "_end": {
                    "x": 654.5980259709,
                    "y": 476.3141343626
                },
                "mid": {
                    "x": 654.5980259709,
                    "y": 301.56086224655
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "4237addb-b860-473c-90cd-edeb936b63dd",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 654.5980259709,
                        "y": 126.8075901305
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "4237addb-b860-473c-90cd-edeb936b63dd",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 654.5980259709,
                        "y": 476.3141343626
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 655.5980224609375,
                    "1": 126.80758666992188,
                    "2": 655.5980224609375,
                    "3": 476.31414794921875,
                    "4": 653.5980224609375,
                    "5": 476.31414794921875,
                    "6": 655.5980224609375,
                    "7": 126.80758666992188,
                    "8": 653.5980224609375,
                    "9": 476.31414794921875,
                    "10": 653.5980224609375,
                    "11": 126.80758666992188
                },
                "len": 349.5065442321
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10508",
            "desc": "Воздухораспределитель вытяжной четырёхсторонний",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 654.5980259709,
                    "y": 126.80759013049999
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 655.4640502929688,
            "1": 238.149658203125,
            "2": 792.6796875,
            "3": 475.81414794921875,
            "4": 790.9476318359375,
            "5": 476.81414794921875,
            "6": 655.4640502929688,
            "7": 238.149658203125,
            "8": 790.9476318359375,
            "9": 476.81414794921875,
            "10": 653.7319946289062,
            "11": 239.149658203125,
            "12": 791.8136596679688,
            "13": 477.31414794921875,
            "14": 517.3823852539062,
            "15": 477.31414794921875,
            "16": 517.3823852539062,
            "17": 475.31414794921875,
            "18": 791.8136596679688,
            "19": 477.31414794921875,
            "20": 517.3823852539062,
            "21": 475.31414794921875,
            "22": 791.8136596679688,
            "23": 475.31414794921875,
            "24": 516.516357421875,
            "25": 475.81414794921875,
            "26": 653.7319946289062,
            "27": 238.149658203125,
            "28": 655.4640502929688,
            "29": 239.149658203125,
            "30": 516.516357421875,
            "31": 475.81414794921875,
            "32": 655.4640502929688,
            "33": 239.149658203125,
            "34": 518.2484130859375,
            "35": 476.81414794921875,
            "36": 655.5980224609375,
            "37": 126.80758666992188,
            "38": 655.5980224609375,
            "39": 476.31414794921875,
            "40": 653.5980224609375,
            "41": 476.31414794921875,
            "42": 655.5980224609375,
            "43": 126.80758666992188,
            "44": 653.5980224609375,
            "45": 476.31414794921875,
            "46": 653.5980224609375,
            "47": 126.80758666992188
        },
        "zlc": 0.2796052411161902,
        "id": "1bd2b97a-9204-49db-a1af-92e4c2685462"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "6098a0ec-db98-4091-8f22-f596972fde7f",
            "ownerSide": null
        },
        "_id": "6098a0ec-db98-4091-8f22-f596972fde7f",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 546.3816171567,
                "y": 212.4496864057
            },
            "_p2": {
                "x": 758.7999128415,
                "y": 212.4496864057
            },
            "_p3": {
                "x": 758.7999128415,
                "y": 402.6658772195
            },
            "_p4": {
                "x": 546.3816171567,
                "y": 402.6658772195
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 652.5907649991,
                        "y": 392.6658772195
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "27261d4a-2c25-4918-85a8-c9d4e7018e27",
                    "ownerSide": 0
                },
                "_id": "27261d4a-2c25-4918-85a8-c9d4e7018e27",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 652.5907649991,
                        "y": 244.6517912768
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 254
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 652.5907649991,
                        "y": 244.6517912768
                    },
                    "_mouse": {
                        "x": 661,
                        "y": 381
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 654.1903160086,
                        "y": 205.9436571431
                    },
                    "_p2": {
                        "x": 654.1903160086,
                        "y": 431.5405198573
                    },
                    "_p3": {
                        "x": 664.1903160086,
                        "y": 431.5405198573
                    },
                    "_p4": {
                        "x": 664.1903160086,
                        "y": 205.9436571431
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 652.5907649991,
                    "y": 244.6517912768
                },
                "_end": {
                    "x": 652.5907649991,
                    "y": 392.6658772195
                },
                "mid": {
                    "x": 652.5907649991,
                    "y": 318.65883424815
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "d8dc8395-6e74-45a4-9cef-6e503a3474e6",
                    "ownerId": "27261d4a-2c25-4918-85a8-c9d4e7018e27",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 612,
                        "y": 203
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "27261d4a-2c25-4918-85a8-c9d4e7018e27",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 612,
                        "y": 246.0976310052
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "f9cc0581-cad7-4af3-b1bd-488dfc69360b",
                "saved": {
                    "0": 613,
                    "1": 203,
                    "2": 613,
                    "3": 246.09762573242188,
                    "4": 611,
                    "5": 246.09762573242188,
                    "6": 613,
                    "7": 203,
                    "8": 611,
                    "9": 246.09762573242188,
                    "10": 611,
                    "11": 203
                },
                "len": 156.2610036473055
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 748.7999128415,
                        "y": 318.6588342481
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ed625c88-7662-4420-9f76-a0056cddff4f",
                    "ownerSide": 0
                },
                "_id": "ed625c88-7662-4420-9f76-a0056cddff4f",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 748.7999128415,
                        "y": 318.6588342481
                    },
                    "_mouse": {
                        "x": 712,
                        "y": 316
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 748.7999128415,
                        "y": 318.6588342481
                    },
                    "_mouse": {
                        "x": 756,
                        "y": 122
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 655.6547821026672,
                        "y": 175.63967386613274
                    },
                    "_p2": {
                        "x": 802.2927306426673,
                        "y": 322.27762240613276
                    },
                    "_p3": {
                        "x": 809.3637984545328,
                        "y": 315.20655459426723
                    },
                    "_p4": {
                        "x": 662.7258499145328,
                        "y": 168.56860605426726
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 652.5907649991,
                    "y": 222.4496864057
                },
                "_end": {
                    "x": 748.7999128415,
                    "y": 318.6588342481
                },
                "mid": {
                    "x": 700.6953389203,
                    "y": 270.5542603269
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "67ea30a9-197c-4eb2-a2f0-7fa766d9d28d",
                    "ownerId": "ed625c88-7662-4420-9f76-a0056cddff4f",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 659.1903160086,
                        "y": 172.1041399602
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "ed625c88-7662-4420-9f76-a0056cddff4f",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 805.8282645486,
                        "y": 318.7420885002
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "01fc6625-b0a9-4f53-a7ed-8dc2d1df2d62",
                "saved": {
                    "0": 659.8973999023438,
                    "1": 171.39703369140625,
                    "2": 806.535400390625,
                    "3": 318.03497314453125,
                    "4": 805.1211547851562,
                    "5": 319.4491882324219,
                    "6": 659.8973999023438,
                    "7": 171.39703369140625,
                    "8": 805.1211547851562,
                    "9": 319.4491882324219,
                    "10": 658.4832153320312,
                    "11": 172.81124877929688
                },
                "len": 144.87256345835806
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 556.3816171567,
                        "y": 318.6588342481
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "97af75f8-3ae5-4ea8-bb63-9028dff575c5",
                    "ownerSide": 1
                },
                "_id": "97af75f8-3ae5-4ea8-bb63-9028dff575c5",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 556.3816171567,
                        "y": 318.6588342481
                    },
                    "_mouse": {
                        "x": 712,
                        "y": 316
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 652.5907649991,
                        "y": 222.4496864057
                    },
                    "_mouse": {
                        "x": 661,
                        "y": 381
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 652.5907649991,
                    "y": 222.4496864057
                },
                "_end": {
                    "x": 556.3816171567,
                    "y": 318.6588342481
                },
                "mid": {
                    "x": 604.4861910779,
                    "y": 270.5542603269
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "67ea30a9-197c-4eb2-a2f0-7fa766d9d28d",
                    "ownerId": "97af75f8-3ae5-4ea8-bb63-9028dff575c5",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 659.1903160086,
                        "y": 172.1041399602
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "97af75f8-3ae5-4ea8-bb63-9028dff575c5",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 512.5523674686,
                        "y": 318.7420885002
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "01fc6625-b0a9-4f53-a7ed-8dc2d1df2d62",
                "saved": {
                    "0": 659.8973999023438,
                    "1": 172.81124877929688,
                    "2": 513.2594604492188,
                    "3": 319.4491882324219,
                    "4": 511.84527587890625,
                    "5": 318.03497314453125,
                    "6": 659.8973999023438,
                    "7": 172.81124877929688,
                    "8": 511.84527587890625,
                    "9": 318.03497314453125,
                    "10": 658.4832153320312,
                    "11": 171.39703369140625
                },
                "len": 142.79307942704628
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10602",
            "desc": "Зонт",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 652.5907649991,
                    "y": 392.6658772195
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 653.5907592773438,
            "1": 244.65179443359375,
            "2": 653.5907592773438,
            "3": 392.6658630371094,
            "4": 651.5907592773438,
            "5": 392.6658630371094,
            "6": 653.5907592773438,
            "7": 244.65179443359375,
            "8": 651.5907592773438,
            "9": 392.6658630371094,
            "10": 651.5907592773438,
            "11": 244.65179443359375,
            "12": 653.2978515625,
            "13": 221.74258422851562,
            "14": 749.5070190429688,
            "15": 317.95172119140625,
            "16": 748.0928344726562,
            "17": 319.3659362792969,
            "18": 653.2978515625,
            "19": 221.74258422851562,
            "20": 748.0928344726562,
            "21": 319.3659362792969,
            "22": 651.8836669921875,
            "23": 223.15679931640625,
            "24": 653.2978515625,
            "25": 223.15679931640625,
            "26": 557.0887451171875,
            "27": 319.3659362792969,
            "28": 555.6744995117188,
            "29": 317.95172119140625,
            "30": 653.2978515625,
            "31": 223.15679931640625,
            "32": 555.6744995117188,
            "33": 317.95172119140625,
            "34": 651.8836669921875,
            "35": 221.74258422851562
        },
        "zlc": 0.14801404815814592,
        "id": "6098a0ec-db98-4091-8f22-f596972fde7f"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "3576801a-b201-4569-9ac0-1bfea881d8f8",
            "ownerSide": null
        },
        "_id": "3576801a-b201-4569-9ac0-1bfea881d8f8",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 655.1336251017,
                "y": 186.4029956971
            },
            "_p2": {
                "x": 810.3924883976,
                "y": 186.4029956971
            },
            "_p3": {
                "x": 810.3924883976,
                "y": 341.661858993
            },
            "_p4": {
                "x": 655.1336251017,
                "y": 341.661858993
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 732.76305674965,
                        "y": 264.03242734505
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "f7d41d23-286d-4228-a592-cd87ead6926b",
                    "ownerSide": null
                },
                "_id": "f7d41d23-286d-4228-a592-cd87ead6926b",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 665.1336251017,
                        "y": 196.4029956971
                    },
                    "_mouse": {
                        "x": 726,
                        "y": 206
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 800.3924883976,
                        "y": 331.661858993
                    },
                    "_mouse": {
                        "x": 804,
                        "y": 506
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 661.5980911957672,
                        "y": 199.93852960303275
                    },
                    "_p2": {
                        "x": 796.8569544916672,
                        "y": 335.1973928989328
                    },
                    "_p3": {
                        "x": 803.9280223035328,
                        "y": 328.12632508706724
                    },
                    "_p4": {
                        "x": 668.6691590076327,
                        "y": 192.86746179116727
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 665.1336251017,
                    "y": 196.4029956971
                },
                "_end": {
                    "x": 800.3924883976,
                    "y": 331.661858993
                },
                "mid": {
                    "x": 732.76305674965,
                    "y": 264.03242734505
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "f7d41d23-286d-4228-a592-cd87ead6926b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 665.1336251017,
                        "y": 196.4029956971
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "f7d41d23-286d-4228-a592-cd87ead6926b",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 800.3924883976,
                        "y": 331.661858993
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 665.8407592773438,
                    "1": 195.69589233398438,
                    "2": 801.099609375,
                    "3": 330.9547424316406,
                    "4": 799.6853637695312,
                    "5": 332.36895751953125,
                    "6": 665.8407592773438,
                    "7": 195.69589233398438,
                    "8": 799.6853637695312,
                    "9": 332.36895751953125,
                    "10": 664.426513671875,
                    "11": 197.110107421875
                },
                "len": 191.28491890423024
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 748.7306294045538,
                        "y": 264.03242734508063
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "8dfe9eb8-55c3-41ed-b23b-c2571244dec7",
                    "ownerSide": null
                },
                "_id": "8dfe9eb8-55c3-41ed-b23b-c2571244dec7",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 732.7630567496345,
                        "y": 264.03242734508063
                    },
                    "_mouse": {
                        "x": 724,
                        "y": 104
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 706.7954840947152,
                        "y": 285
                    },
                    "_p2": {
                        "x": 758.7306294045538,
                        "y": 285
                    },
                    "_p3": {
                        "x": 758.7306294045538,
                        "y": 243.06485469016127
                    },
                    "_p4": {
                        "x": 706.7954840947152,
                        "y": 243.06485469016127
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "circle",
                "_center": {
                    "x": 732.7630567496345,
                    "y": 264.03242734508063
                },
                "quad1": {
                    "x": 732.7630567496345,
                    "y": 280
                },
                "quad2": {
                    "x": 748.7306294045538,
                    "y": 264.03242734508063
                },
                "quad3": {
                    "x": 732.7630567496345,
                    "y": 248.06485469016127
                },
                "quad4": {
                    "x": 716.7954840947152,
                    "y": 264.03242734508063
                },
                "saved": {
                    "0": 749.7393188476562,
                    "1": 263.04119873046875,
                    "2": 749.7194213867188,
                    "3": 265.3197937011719,
                    "4": 747.719482421875,
                    "5": 265.3023376464844,
                    "6": 749.7393188476562,
                    "7": 263.04119873046875,
                    "8": 747.719482421875,
                    "9": 265.3023376464844,
                    "10": 747.7393798828125,
                    "11": 263.02374267578125,
                    "12": 749.7540283203125,
                    "13": 263.3376159667969,
                    "14": 749.6943969726562,
                    "15": 265.6155090332031,
                    "16": 747.695068359375,
                    "17": 265.56317138671875,
                    "18": 749.7540283203125,
                    "19": 263.3376159667969,
                    "20": 747.695068359375,
                    "21": 265.56317138671875,
                    "22": 747.7546997070312,
                    "23": 263.2852783203125,
                    "24": 749.7635498046875,
                    "25": 263.6342468261719,
                    "26": 749.6641845703125,
                    "27": 265.9107666015625,
                    "28": 747.6660766601562,
                    "29": 265.82354736328125,
                    "30": 749.7635498046875,
                    "31": 263.6342468261719,
                    "32": 747.6660766601562,
                    "33": 265.82354736328125,
                    "34": 747.7655029296875,
                    "35": 263.5470275878906,
                    "36": 749.7679443359375,
                    "37": 263.9310302734375,
                    "38": 749.6288452148438,
                    "39": 266.2054443359375,
                    "40": 747.632568359375,
                    "41": 266.0833435058594,
                    "42": 749.7679443359375,
                    "43": 263.9310302734375,
                    "44": 747.632568359375,
                    "45": 266.0833435058594,
                    "46": 747.7716674804688,
                    "47": 263.8089294433594,
                    "48": 749.76708984375,
                    "49": 264.2278137207031,
                    "50": 749.5883178710938,
                    "51": 266.4994812011719,
                    "52": 747.594482421875,
                    "53": 266.3425598144531,
                    "54": 749.76708984375,
                    "55": 264.2278137207031,
                    "56": 747.594482421875,
                    "57": 266.3425598144531,
                    "58": 747.7732543945312,
                    "59": 264.0708923339844,
                    "60": 749.7611083984375,
                    "61": 264.5245361328125,
                    "62": 749.542724609375,
                    "63": 266.792724609375,
                    "64": 747.5519409179688,
                    "65": 266.6010437011719,
                    "66": 749.7611083984375,
                    "67": 264.5245361328125,
                    "68": 747.5519409179688,
                    "69": 266.6010437011719,
                    "70": 747.7703247070312,
                    "71": 264.3328552246094,
                    "72": 749.7499389648438,
                    "73": 264.8211364746094,
                    "74": 749.4920043945312,
                    "75": 267.0851745605469,
                    "76": 747.5048217773438,
                    "77": 266.8587646484375,
                    "78": 749.7499389648438,
                    "79": 264.8211364746094,
                    "80": 747.5048217773438,
                    "81": 266.8587646484375,
                    "82": 747.7628173828125,
                    "83": 264.5947265625,
                    "84": 749.7335815429688,
                    "85": 265.1174621582031,
                    "86": 749.4361572265625,
                    "87": 267.37664794921875,
                    "88": 747.4532470703125,
                    "89": 267.1156005859375,
                    "90": 749.7335815429688,
                    "91": 265.1174621582031,
                    "92": 747.4532470703125,
                    "93": 267.1156005859375,
                    "94": 747.7506713867188,
                    "95": 264.8564147949219,
                    "96": 749.7120361328125,
                    "97": 265.4134826660156,
                    "98": 749.375244140625,
                    "99": 267.6671447753906,
                    "100": 747.397216796875,
                    "101": 267.37152099609375,
                    "102": 749.7120361328125,
                    "103": 265.4134826660156,
                    "104": 747.397216796875,
                    "105": 267.37152099609375,
                    "106": 747.7340087890625,
                    "107": 265.11785888671875,
                    "108": 749.6853637695312,
                    "109": 265.7090759277344,
                    "110": 749.3092651367188,
                    "111": 267.9565124511719,
                    "112": 747.3367309570312,
                    "113": 267.62640380859375,
                    "114": 749.6853637695312,
                    "115": 265.7090759277344,
                    "116": 747.3367309570312,
                    "117": 267.62640380859375,
                    "118": 747.7128295898438,
                    "119": 265.37896728515625,
                    "120": 749.653564453125,
                    "121": 266.004150390625,
                    "122": 749.23828125,
                    "123": 268.2446594238281,
                    "124": 747.2717895507812,
                    "125": 267.88018798828125,
                    "126": 749.653564453125,
                    "127": 266.004150390625,
                    "128": 747.2717895507812,
                    "129": 267.88018798828125,
                    "130": 747.68701171875,
                    "131": 265.6396789550781,
                    "132": 749.6165771484375,
                    "133": 266.2986145019531,
                    "134": 749.1622314453125,
                    "135": 268.53155517578125,
                    "136": 747.202392578125,
                    "137": 268.1328430175781,
                    "138": 749.6165771484375,
                    "139": 266.2986145019531,
                    "140": 747.202392578125,
                    "141": 268.1328430175781,
                    "142": 747.6566772460938,
                    "143": 265.89990234375,
                    "144": 749.574462890625,
                    "145": 266.5924072265625,
                    "146": 749.0812377929688,
                    "147": 268.81707763671875,
                    "148": 747.128662109375,
                    "149": 268.38421630859375,
                    "150": 749.574462890625,
                    "151": 266.5924072265625,
                    "152": 747.128662109375,
                    "153": 268.38421630859375,
                    "154": 747.621826171875,
                    "155": 266.1595458984375,
                    "156": 749.5272216796875,
                    "157": 266.88543701171875,
                    "158": 748.9952392578125,
                    "159": 269.10113525390625,
                    "160": 747.050537109375,
                    "161": 268.6342468261719,
                    "162": 749.5272216796875,
                    "163": 266.88543701171875,
                    "164": 747.050537109375,
                    "165": 268.6342468261719,
                    "166": 747.5824584960938,
                    "167": 266.4185485839844,
                    "168": 749.474853515625,
                    "169": 267.17755126953125,
                    "170": 748.904296875,
                    "171": 269.3836669921875,
                    "172": 746.968017578125,
                    "173": 268.8829040527344,
                    "174": 749.474853515625,
                    "175": 267.17755126953125,
                    "176": 746.968017578125,
                    "177": 268.8829040527344,
                    "178": 747.53857421875,
                    "179": 266.67681884765625,
                    "180": 749.4174194335938,
                    "181": 267.46875,
                    "182": 748.8084716796875,
                    "183": 269.66455078125,
                    "184": 746.8812255859375,
                    "185": 269.13006591796875,
                    "186": 749.4174194335938,
                    "187": 267.46875,
                    "188": 746.8812255859375,
                    "189": 269.13006591796875,
                    "190": 747.4901733398438,
                    "191": 266.93426513671875,
                    "192": 749.3549194335938,
                    "193": 267.7588806152344,
                    "194": 748.7077026367188,
                    "195": 269.9437255859375,
                    "196": 746.7901000976562,
                    "197": 269.3757019042969,
                    "198": 749.3549194335938,
                    "199": 267.7588806152344,
                    "200": 746.7901000976562,
                    "201": 269.3757019042969,
                    "202": 747.437255859375,
                    "203": 267.19085693359375,
                    "204": 749.287353515625,
                    "205": 268.0478820800781,
                    "206": 748.6021118164062,
                    "207": 270.2210998535156,
                    "208": 746.6947021484375,
                    "209": 269.61968994140625,
                    "210": 749.287353515625,
                    "211": 268.0478820800781,
                    "212": 746.6947021484375,
                    "213": 269.61968994140625,
                    "214": 747.3798828125,
                    "215": 267.44647216796875,
                    "216": 749.2147216796875,
                    "217": 268.3356628417969,
                    "218": 748.49169921875,
                    "219": 270.49658203125,
                    "220": 746.5950927734375,
                    "221": 269.8619689941406,
                    "222": 749.2147216796875,
                    "223": 268.3356628417969,
                    "224": 746.5950927734375,
                    "225": 269.8619689941406,
                    "226": 747.318115234375,
                    "227": 267.7010498046875,
                    "228": 749.1371459960938,
                    "229": 268.62213134765625,
                    "230": 748.3765258789062,
                    "231": 270.7701110839844,
                    "232": 746.4912109375,
                    "233": 270.1025085449219,
                    "234": 749.1371459960938,
                    "235": 268.62213134765625,
                    "236": 746.4912109375,
                    "237": 270.1025085449219,
                    "238": 747.2518310546875,
                    "239": 267.9544982910156,
                    "240": 749.0545654296875,
                    "241": 268.9071960449219,
                    "242": 748.2565307617188,
                    "243": 271.04156494140625,
                    "244": 746.3831787109375,
                    "245": 270.3411560058594,
                    "246": 749.0545654296875,
                    "247": 268.9071960449219,
                    "248": 746.3831787109375,
                    "249": 270.3411560058594,
                    "250": 747.1812133789062,
                    "251": 268.206787109375,
                    "252": 748.9669799804688,
                    "253": 269.1907653808594,
                    "254": 748.1318359375,
                    "255": 271.3109130859375,
                    "256": 746.27099609375,
                    "257": 270.5779113769531,
                    "258": 748.9669799804688,
                    "259": 269.1907653808594,
                    "260": 746.27099609375,
                    "261": 270.5779113769531,
                    "262": 747.1061401367188,
                    "263": 268.457763671875,
                    "264": 748.87451171875,
                    "265": 269.4727783203125,
                    "266": 748.0025024414062,
                    "267": 271.5780029296875,
                    "268": 746.1547241210938,
                    "269": 270.8126525878906,
                    "270": 748.87451171875,
                    "271": 269.4727783203125,
                    "272": 746.1547241210938,
                    "273": 270.8126525878906,
                    "274": 747.0267333984375,
                    "275": 268.7074279785156,
                    "276": 748.777099609375,
                    "277": 269.7531433105469,
                    "278": 747.8684692382812,
                    "279": 271.84283447265625,
                    "280": 746.0343627929688,
                    "281": 271.04534912109375,
                    "282": 748.777099609375,
                    "283": 269.7531433105469,
                    "284": 746.0343627929688,
                    "285": 271.04534912109375,
                    "286": 746.9429931640625,
                    "287": 268.9556579589844,
                    "288": 748.6748046875,
                    "289": 270.0317687988281,
                    "290": 747.7298583984375,
                    "291": 272.1052551269531,
                    "292": 745.909912109375,
                    "293": 271.27587890625,
                    "294": 748.6748046875,
                    "295": 270.0317687988281,
                    "296": 745.909912109375,
                    "297": 271.27587890625,
                    "298": 746.8549194335938,
                    "299": 269.2023620605469,
                    "300": 748.5676879882812,
                    "301": 270.30853271484375,
                    "302": 747.586669921875,
                    "303": 272.365234375,
                    "304": 745.781494140625,
                    "305": 271.50421142578125,
                    "306": 748.5676879882812,
                    "307": 270.30853271484375,
                    "308": 745.781494140625,
                    "309": 271.50421142578125,
                    "310": 746.7625122070312,
                    "311": 269.447509765625,
                    "312": 748.4557495117188,
                    "313": 270.5834045410156,
                    "314": 747.4390258789062,
                    "315": 272.6226806640625,
                    "316": 745.6491088867188,
                    "317": 271.73028564453125,
                    "318": 748.4557495117188,
                    "319": 270.5834045410156,
                    "320": 745.6491088867188,
                    "321": 271.73028564453125,
                    "322": 746.6658935546875,
                    "323": 269.6910095214844,
                    "324": 748.3390502929688,
                    "325": 270.8562927246094,
                    "326": 747.286865234375,
                    "327": 272.87750244140625,
                    "328": 745.5128173828125,
                    "329": 271.9540100097656,
                    "330": 748.3390502929688,
                    "331": 270.8562927246094,
                    "332": 745.5128173828125,
                    "333": 271.9540100097656,
                    "334": 746.5650024414062,
                    "335": 269.93280029296875,
                    "336": 748.2175903320312,
                    "337": 271.1270751953125,
                    "338": 747.1302490234375,
                    "339": 273.129638671875,
                    "340": 745.3726196289062,
                    "341": 272.1753234863281,
                    "342": 748.2175903320312,
                    "343": 271.1270751953125,
                    "344": 745.3726196289062,
                    "345": 272.1753234863281,
                    "346": 746.4598999023438,
                    "347": 270.1727600097656,
                    "348": 748.0913696289062,
                    "349": 271.3957214355469,
                    "350": 746.9692993164062,
                    "351": 273.3789978027344,
                    "352": 745.2285766601562,
                    "353": 272.3941345214844,
                    "354": 748.0913696289062,
                    "355": 271.3957214355469,
                    "356": 745.2285766601562,
                    "357": 272.3941345214844,
                    "358": 746.3507080078125,
                    "359": 270.410888671875,
                    "360": 747.9605712890625,
                    "361": 271.662109375,
                    "362": 746.8040161132812,
                    "363": 273.62548828125,
                    "364": 745.0807495117188,
                    "365": 272.61041259765625,
                    "366": 747.9605712890625,
                    "367": 271.662109375,
                    "368": 745.0807495117188,
                    "369": 272.61041259765625,
                    "370": 746.2373046875,
                    "371": 270.64703369140625,
                    "372": 747.8250732421875,
                    "373": 271.92620849609375,
                    "374": 746.6344604492188,
                    "375": 273.86907958984375,
                    "376": 744.92919921875,
                    "377": 272.8240966796875,
                    "378": 747.8250732421875,
                    "379": 271.92620849609375,
                    "380": 744.92919921875,
                    "381": 272.8240966796875,
                    "382": 746.1198120117188,
                    "383": 270.8811950683594,
                    "384": 747.6849975585938,
                    "385": 272.1878662109375,
                    "386": 746.460693359375,
                    "387": 274.10968017578125,
                    "388": 744.77392578125,
                    "389": 273.03509521484375,
                    "390": 747.6849975585938,
                    "391": 272.1878662109375,
                    "392": 744.77392578125,
                    "393": 273.03509521484375,
                    "394": 745.9982299804688,
                    "395": 271.1132507324219,
                    "396": 747.5404052734375,
                    "397": 272.4470520019531,
                    "398": 746.28271484375,
                    "399": 274.3471984863281,
                    "400": 744.6149291992188,
                    "401": 273.2433166503906,
                    "402": 747.5404052734375,
                    "403": 272.4470520019531,
                    "404": 744.6149291992188,
                    "405": 273.2433166503906,
                    "406": 745.8726196289062,
                    "407": 271.3431701660156,
                    "408": 747.3912963867188,
                    "409": 272.70367431640625,
                    "410": 746.1006469726562,
                    "411": 274.5815734863281,
                    "412": 744.452392578125,
                    "413": 273.4487609863281,
                    "414": 747.3912963867188,
                    "415": 272.70367431640625,
                    "416": 744.452392578125,
                    "417": 273.4487609863281,
                    "418": 745.7430419921875,
                    "419": 271.57086181640625,
                    "420": 747.2377319335938,
                    "421": 272.9576416015625,
                    "422": 745.9144897460938,
                    "423": 274.812744140625,
                    "424": 744.2862548828125,
                    "425": 273.6513366699219,
                    "426": 747.2377319335938,
                    "427": 272.9576416015625,
                    "428": 744.2862548828125,
                    "429": 273.6513366699219,
                    "430": 745.6094970703125,
                    "431": 271.7962341308594,
                    "432": 747.0797729492188,
                    "433": 273.2088928222656,
                    "434": 745.724365234375,
                    "435": 275.0406188964844,
                    "436": 744.1166381835938,
                    "437": 273.8509826660156,
                    "438": 747.0797729492188,
                    "439": 273.2088928222656,
                    "440": 744.1166381835938,
                    "441": 273.8509826660156,
                    "442": 745.4720458984375,
                    "443": 272.0192565917969,
                    "444": 746.9174194335938,
                    "445": 273.4573669433594,
                    "446": 745.5302734375,
                    "447": 275.2651672363281,
                    "448": 743.9435424804688,
                    "449": 274.0476379394531,
                    "450": 746.9174194335938,
                    "451": 273.4573669433594,
                    "452": 743.9435424804688,
                    "453": 274.0476379394531,
                    "454": 745.3307495117188,
                    "455": 272.2398376464844,
                    "456": 746.7507934570312,
                    "457": 273.70294189453125,
                    "458": 745.332275390625,
                    "459": 275.48626708984375,
                    "460": 743.76708984375,
                    "461": 274.2412414550781,
                    "462": 746.7507934570312,
                    "463": 273.70294189453125,
                    "464": 743.76708984375,
                    "465": 274.2412414550781,
                    "466": 745.1856079101562,
                    "467": 272.4579162597656,
                    "468": 746.5798950195312,
                    "469": 273.9455871582031,
                    "470": 745.1304931640625,
                    "471": 275.7038879394531,
                    "472": 743.5872192382812,
                    "473": 274.4317321777344,
                    "474": 746.5798950195312,
                    "475": 273.9455871582031,
                    "476": 743.5872192382812,
                    "477": 274.4317321777344,
                    "478": 745.03662109375,
                    "479": 272.6734313964844,
                    "480": 746.40478515625,
                    "481": 274.18524169921875,
                    "482": 744.9248657226562,
                    "483": 275.9179382324219,
                    "484": 743.404052734375,
                    "485": 274.6190490722656,
                    "486": 746.40478515625,
                    "487": 274.18524169921875,
                    "488": 743.404052734375,
                    "489": 274.6190490722656,
                    "490": 744.8839721679688,
                    "491": 272.8863220214844,
                    "492": 746.2255249023438,
                    "493": 274.4217529296875,
                    "494": 744.7156372070312,
                    "495": 276.1283874511719,
                    "496": 743.2177124023438,
                    "497": 274.80316162109375,
                    "498": 746.2255249023438,
                    "499": 274.4217529296875,
                    "500": 743.2177124023438,
                    "501": 274.80316162109375,
                    "502": 744.7276000976562,
                    "503": 273.0965270996094,
                    "504": 746.0421142578125,
                    "505": 274.6551208496094,
                    "506": 744.502685546875,
                    "507": 276.33514404296875,
                    "508": 743.0281372070312,
                    "509": 274.9839782714844,
                    "510": 746.0421142578125,
                    "511": 274.6551208496094,
                    "512": 743.0281372070312,
                    "513": 274.9839782714844,
                    "514": 744.5675659179688,
                    "515": 273.303955078125,
                    "516": 745.854736328125,
                    "517": 274.88525390625,
                    "518": 744.2861938476562,
                    "519": 276.5381774902344,
                    "520": 742.83544921875,
                    "521": 275.1614685058594,
                    "522": 745.854736328125,
                    "523": 274.88525390625,
                    "524": 742.83544921875,
                    "525": 275.1614685058594,
                    "526": 744.4039916992188,
                    "527": 273.508544921875,
                    "528": 745.663330078125,
                    "529": 275.1120910644531,
                    "530": 744.066162109375,
                    "531": 276.73736572265625,
                    "532": 742.6396484375,
                    "533": 275.3355407714844,
                    "534": 745.663330078125,
                    "535": 275.1120910644531,
                    "536": 742.6396484375,
                    "537": 275.3355407714844,
                    "538": 744.23681640625,
                    "539": 273.71026611328125,
                    "540": 745.468017578125,
                    "541": 275.3355407714844,
                    "542": 743.8427124023438,
                    "543": 276.9327087402344,
                    "544": 742.44091796875,
                    "545": 275.5061950683594,
                    "546": 745.468017578125,
                    "547": 275.3355407714844,
                    "548": 742.44091796875,
                    "549": 275.5061950683594,
                    "550": 744.066162109375,
                    "551": 273.9090576171875,
                    "552": 745.268798828125,
                    "553": 275.5555725097656,
                    "554": 743.6159057617188,
                    "555": 277.12408447265625,
                    "556": 742.2391967773438,
                    "557": 275.67333984375,
                    "558": 745.268798828125,
                    "559": 275.5555725097656,
                    "560": 742.2391967773438,
                    "561": 275.67333984375,
                    "562": 743.89208984375,
                    "563": 274.10479736328125,
                    "564": 745.0657958984375,
                    "565": 275.7720642089844,
                    "566": 743.3857421875,
                    "567": 277.3115234375,
                    "568": 742.0346069335938,
                    "569": 275.8369445800781,
                    "570": 745.0657958984375,
                    "571": 275.7720642089844,
                    "572": 742.0346069335938,
                    "573": 275.8369445800781,
                    "574": 743.714599609375,
                    "575": 274.2975158691406,
                    "576": 744.8590087890625,
                    "577": 275.9849853515625,
                    "578": 743.1524047851562,
                    "579": 277.494873046875,
                    "580": 741.8271484375,
                    "581": 275.9969787597656,
                    "582": 744.8590087890625,
                    "583": 275.9849853515625,
                    "584": 741.8271484375,
                    "585": 275.9969787597656,
                    "586": 743.5338134765625,
                    "587": 274.487060546875,
                    "588": 744.6485595703125,
                    "589": 276.19427490234375,
                    "590": 742.9158325195312,
                    "591": 277.6741638183594,
                    "592": 741.616943359375,
                    "593": 276.1533508300781,
                    "594": 744.6485595703125,
                    "595": 276.19427490234375,
                    "596": 741.616943359375,
                    "597": 276.1533508300781,
                    "598": 743.3496704101562,
                    "599": 274.6734619140625,
                    "600": 744.4345092773438,
                    "601": 276.39984130859375,
                    "602": 742.6762084960938,
                    "603": 277.8492736816406,
                    "604": 741.404052734375,
                    "605": 276.3060302734375,
                    "606": 744.4345092773438,
                    "607": 276.39984130859375,
                    "608": 741.404052734375,
                    "609": 276.3060302734375,
                    "610": 743.162353515625,
                    "611": 274.8565979003906,
                    "612": 744.2169189453125,
                    "613": 276.6016540527344,
                    "614": 742.43359375,
                    "615": 278.0201721191406,
                    "616": 741.1885375976562,
                    "617": 276.4549560546875,
                    "618": 744.2169189453125,
                    "619": 276.6016540527344,
                    "620": 741.1885375976562,
                    "621": 276.4549560546875,
                    "622": 742.9718627929688,
                    "623": 275.03643798828125,
                    "624": 743.9957885742188,
                    "625": 276.7996520996094,
                    "626": 742.18798828125,
                    "627": 278.1867980957031,
                    "628": 740.970458984375,
                    "629": 276.60009765625,
                    "630": 743.9957885742188,
                    "631": 276.7996520996094,
                    "632": 740.970458984375,
                    "633": 276.60009765625,
                    "634": 742.7782592773438,
                    "635": 275.2129211425781,
                    "636": 743.771240234375,
                    "637": 276.9937438964844,
                    "638": 741.9395141601562,
                    "639": 278.3491516113281,
                    "640": 740.7498779296875,
                    "641": 276.7414245605469,
                    "642": 743.771240234375,
                    "643": 276.9937438964844,
                    "644": 740.7498779296875,
                    "645": 276.7414245605469,
                    "646": 742.5816040039062,
                    "647": 275.3860168457031,
                    "648": 743.5433959960938,
                    "649": 277.1838684082031,
                    "650": 741.6882934570312,
                    "651": 278.5071105957031,
                    "652": 740.52685546875,
                    "653": 276.8788757324219,
                    "654": 743.5433959960938,
                    "655": 277.1838684082031,
                    "656": 740.52685546875,
                    "657": 276.8788757324219,
                    "658": 742.3819580078125,
                    "659": 275.5556335449219,
                    "660": 743.3121948242188,
                    "661": 277.3700256347656,
                    "662": 741.4342651367188,
                    "663": 278.6606750488281,
                    "664": 740.3014526367188,
                    "665": 277.0124206542969,
                    "666": 743.3121948242188,
                    "667": 277.3700256347656,
                    "668": 740.3014526367188,
                    "669": 277.0124206542969,
                    "670": 742.1793823242188,
                    "671": 275.7217712402344,
                    "672": 743.0778198242188,
                    "673": 277.5520935058594,
                    "674": 741.1776733398438,
                    "675": 278.8097839355469,
                    "676": 740.0737915039062,
                    "677": 277.1419982910156,
                    "678": 743.0778198242188,
                    "679": 277.5520935058594,
                    "680": 740.0737915039062,
                    "681": 277.1419982910156,
                    "682": 741.9739379882812,
                    "683": 275.8843078613281,
                    "684": 742.84033203125,
                    "685": 277.73004150390625,
                    "686": 740.9185180664062,
                    "687": 278.9543762207031,
                    "688": 739.8438720703125,
                    "689": 277.2676086425781,
                    "690": 742.84033203125,
                    "691": 277.73004150390625,
                    "692": 739.8438720703125,
                    "693": 277.2676086425781,
                    "694": 741.7656860351562,
                    "695": 276.04327392578125,
                    "696": 742.5997314453125,
                    "697": 277.9038391113281,
                    "698": 740.6567993164062,
                    "699": 279.0944519042969,
                    "700": 739.61181640625,
                    "701": 277.38916015625,
                    "702": 742.5997314453125,
                    "703": 277.9038391113281,
                    "704": 739.61181640625,
                    "705": 277.38916015625,
                    "706": 741.5547485351562,
                    "707": 276.19854736328125,
                    "708": 742.3561401367188,
                    "709": 278.0733947753906,
                    "710": 740.3927612304688,
                    "711": 279.22991943359375,
                    "712": 739.377685546875,
                    "713": 277.50665283203125,
                    "714": 742.3561401367188,
                    "715": 278.0733947753906,
                    "716": 739.377685546875,
                    "717": 277.50665283203125,
                    "718": 741.341064453125,
                    "719": 276.3501281738281,
                    "720": 742.109619140625,
                    "721": 278.2386779785156,
                    "722": 740.1263427734375,
                    "723": 279.3607482910156,
                    "724": 739.1415405273438,
                    "725": 277.62005615234375,
                    "726": 742.109619140625,
                    "727": 278.2386779785156,
                    "728": 739.1415405273438,
                    "729": 277.62005615234375,
                    "730": 741.124755859375,
                    "731": 276.49798583984375,
                    "732": 741.8602905273438,
                    "733": 278.3996276855469,
                    "734": 739.8577270507812,
                    "735": 279.4869384765625,
                    "736": 738.9033813476562,
                    "737": 277.72930908203125,
                    "738": 741.8602905273438,
                    "739": 278.3996276855469,
                    "740": 738.9033813476562,
                    "741": 277.72930908203125,
                    "742": 740.9059448242188,
                    "743": 276.6419982910156,
                    "744": 741.608154296875,
                    "745": 278.55621337890625,
                    "746": 739.5869140625,
                    "747": 279.6083984375,
                    "748": 738.6634521484375,
                    "749": 277.8343811035156,
                    "750": 741.608154296875,
                    "751": 278.55621337890625,
                    "752": 738.6634521484375,
                    "753": 277.8343811035156,
                    "754": 740.6846313476562,
                    "755": 276.7821960449219,
                    "756": 741.3533325195312,
                    "757": 278.7083740234375,
                    "758": 739.3140258789062,
                    "759": 279.7251281738281,
                    "760": 738.421630859375,
                    "761": 277.93524169921875,
                    "762": 741.3533325195312,
                    "763": 278.7083740234375,
                    "764": 738.421630859375,
                    "765": 277.93524169921875,
                    "766": 740.4609375,
                    "767": 276.91851806640625,
                    "768": 741.0958862304688,
                    "769": 278.8560485839844,
                    "770": 739.0391845703125,
                    "771": 279.8370666503906,
                    "772": 738.1781616210938,
                    "773": 278.0318908691406,
                    "774": 741.0958862304688,
                    "775": 278.8560485839844,
                    "776": 738.1781616210938,
                    "777": 278.0318908691406,
                    "778": 740.23486328125,
                    "779": 277.0509033203125,
                    "780": 740.8358764648438,
                    "781": 278.9992370605469,
                    "782": 738.7623901367188,
                    "783": 279.9441833496094,
                    "784": 737.9329833984375,
                    "785": 278.124267578125,
                    "786": 740.8358764648438,
                    "787": 278.9992370605469,
                    "788": 737.9329833984375,
                    "789": 278.124267578125,
                    "790": 740.0065307617188,
                    "791": 277.1793212890625,
                    "792": 740.573486328125,
                    "793": 279.1378479003906,
                    "794": 738.4837646484375,
                    "795": 280.0464782714844,
                    "796": 737.686279296875,
                    "797": 278.21234130859375,
                    "798": 740.573486328125,
                    "799": 279.1378479003906,
                    "800": 737.686279296875,
                    "801": 278.21234130859375,
                    "802": 739.7759399414062,
                    "803": 277.3037109375,
                    "804": 740.3086547851562,
                    "805": 279.2718505859375,
                    "806": 738.2034301757812,
                    "807": 280.14385986328125,
                    "808": 737.4380493164062,
                    "809": 278.2961120605469,
                    "810": 740.3086547851562,
                    "811": 279.2718505859375,
                    "812": 737.4380493164062,
                    "813": 278.2961120605469,
                    "814": 739.5432739257812,
                    "815": 277.4241027832031,
                    "816": 740.04150390625,
                    "817": 279.4012145996094,
                    "818": 737.92138671875,
                    "819": 280.2363586425781,
                    "820": 737.1884155273438,
                    "821": 278.3755187988281,
                    "822": 740.04150390625,
                    "823": 279.4012145996094,
                    "824": 737.1884155273438,
                    "825": 278.3755187988281,
                    "826": 739.3085327148438,
                    "827": 277.5403747558594,
                    "828": 739.772216796875,
                    "829": 279.5259094238281,
                    "830": 737.6378173828125,
                    "831": 280.32391357421875,
                    "832": 736.9374389648438,
                    "833": 278.4505615234375,
                    "834": 739.772216796875,
                    "835": 279.5259094238281,
                    "836": 736.9374389648438,
                    "837": 278.4505615234375,
                    "838": 739.07177734375,
                    "839": 277.6525573730469,
                    "840": 739.500732421875,
                    "841": 279.6458740234375,
                    "842": 737.352783203125,
                    "843": 280.4065246582031,
                    "844": 736.6851196289062,
                    "845": 278.521240234375,
                    "846": 739.500732421875,
                    "847": 279.6458740234375,
                    "848": 736.6851196289062,
                    "849": 278.521240234375,
                    "850": 738.8331298828125,
                    "851": 277.7605895996094,
                    "852": 739.2272338867188,
                    "853": 279.7610778808594,
                    "854": 737.0662841796875,
                    "855": 280.484130859375,
                    "856": 736.4317016601562,
                    "857": 278.58746337890625,
                    "858": 739.2272338867188,
                    "859": 279.7610778808594,
                    "860": 736.4317016601562,
                    "861": 278.58746337890625,
                    "862": 738.5925903320312,
                    "863": 277.86444091796875,
                    "864": 738.9517211914062,
                    "865": 279.8714904785156,
                    "866": 736.7785034179688,
                    "867": 280.55670166015625,
                    "868": 736.1771240234375,
                    "869": 278.6492919921875,
                    "870": 738.9517211914062,
                    "871": 279.8714904785156,
                    "872": 736.1771240234375,
                    "873": 278.6492919921875,
                    "874": 738.350341796875,
                    "875": 277.9640808105469,
                    "876": 738.6743774414062,
                    "877": 279.97711181640625,
                    "878": 736.489501953125,
                    "879": 280.624267578125,
                    "880": 735.9215087890625,
                    "881": 278.7066345214844,
                    "882": 738.6743774414062,
                    "883": 279.97711181640625,
                    "884": 735.9215087890625,
                    "885": 278.7066345214844,
                    "886": 738.1063232421875,
                    "887": 278.0594482421875,
                    "888": 738.3952026367188,
                    "889": 280.0778503417969,
                    "890": 736.1994018554688,
                    "891": 280.6867980957031,
                    "892": 735.6649169921875,
                    "893": 278.759521484375,
                    "894": 738.3952026367188,
                    "895": 280.0778503417969,
                    "896": 735.6649169921875,
                    "897": 278.759521484375,
                    "898": 737.8607177734375,
                    "899": 278.15057373046875,
                    "900": 738.1143188476562,
                    "901": 280.1736755371094,
                    "902": 735.908203125,
                    "903": 280.7442321777344,
                    "904": 735.4074096679688,
                    "905": 278.80792236328125,
                    "906": 738.1143188476562,
                    "907": 280.1736755371094,
                    "908": 735.4074096679688,
                    "909": 278.80792236328125,
                    "910": 737.613525390625,
                    "911": 278.2373962402344,
                    "912": 737.831787109375,
                    "913": 280.2646179199219,
                    "914": 735.6160278320312,
                    "915": 280.79656982421875,
                    "916": 735.149169921875,
                    "917": 278.8518371582031,
                    "918": 737.831787109375,
                    "919": 280.2646179199219,
                    "920": 735.149169921875,
                    "921": 278.8518371582031,
                    "922": 737.3648681640625,
                    "923": 278.31988525390625,
                    "924": 737.5477294921875,
                    "925": 280.3506164550781,
                    "926": 735.3230590820312,
                    "927": 280.84381103515625,
                    "928": 734.89013671875,
                    "929": 278.8912048339844,
                    "930": 737.5477294921875,
                    "931": 280.3506164550781,
                    "932": 734.89013671875,
                    "933": 278.8912048339844,
                    "934": 737.1148071289062,
                    "935": 278.39801025390625,
                    "936": 737.26220703125,
                    "937": 280.431640625,
                    "938": 735.0292358398438,
                    "939": 280.88592529296875,
                    "940": 734.6304931640625,
                    "941": 278.92608642578125,
                    "942": 737.26220703125,
                    "943": 280.431640625,
                    "944": 734.6304931640625,
                    "945": 278.92608642578125,
                    "946": 736.8634643554688,
                    "947": 278.4717712402344,
                    "948": 736.9752807617188,
                    "949": 280.5076599121094,
                    "950": 734.7348022460938,
                    "951": 280.92291259765625,
                    "952": 734.3703002929688,
                    "953": 278.9563903808594,
                    "954": 736.9752807617188,
                    "955": 280.5076599121094,
                    "956": 734.3703002929688,
                    "957": 278.9563903808594,
                    "958": 736.61083984375,
                    "959": 278.5411376953125,
                    "960": 736.6871337890625,
                    "961": 280.5786437988281,
                    "962": 734.439697265625,
                    "963": 280.9547424316406,
                    "964": 734.109619140625,
                    "965": 278.982177734375,
                    "966": 736.6871337890625,
                    "967": 280.5786437988281,
                    "968": 734.109619140625,
                    "969": 278.982177734375,
                    "970": 736.3570556640625,
                    "971": 278.6060791015625,
                    "972": 736.3977661132812,
                    "973": 280.6446228027344,
                    "974": 734.1441040039062,
                    "975": 280.9814147949219,
                    "976": 733.8485107421875,
                    "977": 279.0033874511719,
                    "978": 736.3977661132812,
                    "979": 280.6446228027344,
                    "980": 733.8485107421875,
                    "981": 279.0033874511719,
                    "982": 736.1021118164062,
                    "983": 278.6665954589844,
                    "984": 736.1072998046875,
                    "985": 280.7055358886719,
                    "986": 733.8480834960938,
                    "987": 281.0029602050781,
                    "988": 733.5870361328125,
                    "989": 279.0200500488281,
                    "990": 736.1072998046875,
                    "991": 280.7055358886719,
                    "992": 733.5870361328125,
                    "993": 279.0200500488281,
                    "994": 735.8462524414062,
                    "995": 278.7226257324219,
                    "996": 735.8157958984375,
                    "997": 280.7613525390625,
                    "998": 733.5517578125,
                    "999": 281.0193176269531,
                    "1000": 733.3253173828125,
                    "1001": 279.03216552734375,
                    "1002": 735.8157958984375,
                    "1003": 280.7613525390625,
                    "1004": 733.3253173828125,
                    "1005": 279.03216552734375,
                    "1006": 735.58935546875,
                    "1007": 278.7742004394531,
                    "1008": 735.5233764648438,
                    "1009": 280.81207275390625,
                    "1010": 733.2551879882812,
                    "1011": 281.0304870605469,
                    "1012": 733.0634765625,
                    "1013": 279.0397033691406,
                    "1014": 735.5233764648438,
                    "1015": 280.81207275390625,
                    "1016": 733.0634765625,
                    "1017": 279.0397033691406,
                    "1018": 735.3316650390625,
                    "1019": 278.8212890625,
                    "1020": 735.2301025390625,
                    "1021": 280.8576965332031,
                    "1022": 732.9584350585938,
                    "1023": 281.0364685058594,
                    "1024": 732.801513671875,
                    "1025": 279.0426330566406,
                    "1026": 735.2301025390625,
                    "1027": 280.8576965332031,
                    "1028": 732.801513671875,
                    "1029": 279.0426330566406,
                    "1030": 735.0731811523438,
                    "1031": 278.8638610839844,
                    "1032": 734.9360961914062,
                    "1033": 280.898193359375,
                    "1034": 732.66162109375,
                    "1035": 281.03729248046875,
                    "1036": 732.53955078125,
                    "1037": 279.041015625,
                    "1038": 734.9360961914062,
                    "1039": 280.898193359375,
                    "1040": 732.53955078125,
                    "1041": 279.041015625,
                    "1042": 734.81396484375,
                    "1043": 278.90191650390625,
                    "1044": 734.6414184570312,
                    "1045": 280.93353271484375,
                    "1046": 732.3648681640625,
                    "1047": 281.0329284667969,
                    "1048": 732.2776489257812,
                    "1049": 279.03485107421875,
                    "1050": 734.6414184570312,
                    "1051": 280.93353271484375,
                    "1052": 732.2776489257812,
                    "1053": 279.03485107421875,
                    "1054": 734.5541381835938,
                    "1055": 278.9354553222656,
                    "1056": 734.3461303710938,
                    "1057": 280.9637451171875,
                    "1058": 732.0682373046875,
                    "1059": 281.0234069824219,
                    "1060": 732.015869140625,
                    "1061": 279.0240783691406,
                    "1062": 734.3461303710938,
                    "1063": 280.9637451171875,
                    "1064": 732.015869140625,
                    "1065": 279.0240783691406,
                    "1066": 734.2938232421875,
                    "1067": 278.9644470214844,
                    "1068": 734.0504150390625,
                    "1069": 280.9888000488281,
                    "1070": 731.7718505859375,
                    "1071": 281.0086975097656,
                    "1072": 731.75439453125,
                    "1073": 279.0087585449219,
                    "1074": 734.0504150390625,
                    "1075": 280.9888000488281,
                    "1076": 731.75439453125,
                    "1077": 279.0087585449219,
                    "1078": 734.032958984375,
                    "1079": 278.9888916015625,
                    "1080": 733.7542724609375,
                    "1081": 281.0086975097656,
                    "1082": 731.4757080078125,
                    "1083": 280.9888000488281,
                    "1084": 731.4931640625,
                    "1085": 278.9888916015625,
                    "1086": 733.7542724609375,
                    "1087": 281.0086975097656,
                    "1088": 731.4931640625,
                    "1089": 278.9888916015625,
                    "1090": 733.771728515625,
                    "1091": 279.0087585449219,
                    "1092": 733.4578857421875,
                    "1093": 281.0234069824219,
                    "1094": 731.1799926757812,
                    "1095": 280.9637451171875,
                    "1096": 731.2322998046875,
                    "1097": 278.9644470214844,
                    "1098": 733.4578857421875,
                    "1099": 281.0234069824219,
                    "1100": 731.2322998046875,
                    "1101": 278.9644470214844,
                    "1102": 733.5101928710938,
                    "1103": 279.0240783691406,
                    "1104": 733.1612548828125,
                    "1105": 281.0329284667969,
                    "1106": 730.8847045898438,
                    "1107": 280.93353271484375,
                    "1108": 730.971923828125,
                    "1109": 278.9354553222656,
                    "1110": 733.1612548828125,
                    "1111": 281.0329284667969,
                    "1112": 730.971923828125,
                    "1113": 278.9354553222656,
                    "1114": 733.2484741210938,
                    "1115": 279.03485107421875,
                    "1116": 732.8644409179688,
                    "1117": 281.03729248046875,
                    "1118": 730.5900268554688,
                    "1119": 280.898193359375,
                    "1120": 730.712158203125,
                    "1121": 278.90191650390625,
                    "1122": 732.8644409179688,
                    "1123": 281.03729248046875,
                    "1124": 730.712158203125,
                    "1125": 278.90191650390625,
                    "1126": 732.986572265625,
                    "1127": 279.041015625,
                    "1128": 732.5676879882812,
                    "1129": 281.0364685058594,
                    "1130": 730.2960205078125,
                    "1131": 280.8576965332031,
                    "1132": 730.4529418945312,
                    "1133": 278.8638610839844,
                    "1134": 732.5676879882812,
                    "1135": 281.0364685058594,
                    "1136": 730.4529418945312,
                    "1137": 278.8638610839844,
                    "1138": 732.724609375,
                    "1139": 279.0426330566406,
                    "1140": 732.2709350585938,
                    "1141": 281.0304870605469,
                    "1142": 730.0027465820312,
                    "1143": 280.81207275390625,
                    "1144": 730.1944580078125,
                    "1145": 278.8212890625,
                    "1146": 732.2709350585938,
                    "1147": 281.0304870605469,
                    "1148": 730.1944580078125,
                    "1149": 278.8212890625,
                    "1150": 732.462646484375,
                    "1151": 279.0397033691406,
                    "1152": 731.974365234375,
                    "1153": 281.0193176269531,
                    "1154": 729.7103271484375,
                    "1155": 280.7613525390625,
                    "1156": 729.9367065429688,
                    "1157": 278.7742004394531,
                    "1158": 731.974365234375,
                    "1159": 281.0193176269531,
                    "1160": 729.9367065429688,
                    "1161": 278.7742004394531,
                    "1162": 732.2007446289062,
                    "1163": 279.03216552734375,
                    "1164": 731.6780395507812,
                    "1165": 281.0029602050781,
                    "1166": 729.4188232421875,
                    "1167": 280.7055358886719,
                    "1168": 729.6798706054688,
                    "1169": 278.7226257324219,
                    "1170": 731.6780395507812,
                    "1171": 281.0029602050781,
                    "1172": 729.6798706054688,
                    "1173": 278.7226257324219,
                    "1174": 731.9390869140625,
                    "1175": 279.0200500488281,
                    "1176": 731.3820190429688,
                    "1177": 280.9814147949219,
                    "1178": 729.1283569335938,
                    "1179": 280.6446228027344,
                    "1180": 729.4239501953125,
                    "1181": 278.6665954589844,
                    "1182": 731.3820190429688,
                    "1183": 280.9814147949219,
                    "1184": 729.4239501953125,
                    "1185": 278.6665954589844,
                    "1186": 731.6776123046875,
                    "1187": 279.0033874511719,
                    "1188": 731.08642578125,
                    "1189": 280.9547424316406,
                    "1190": 728.8389892578125,
                    "1191": 280.5786437988281,
                    "1192": 729.1690673828125,
                    "1193": 278.6060791015625,
                    "1194": 731.08642578125,
                    "1195": 280.9547424316406,
                    "1196": 729.1690673828125,
                    "1197": 278.6060791015625,
                    "1198": 731.41650390625,
                    "1199": 278.982177734375,
                    "1200": 730.7913208007812,
                    "1201": 280.92291259765625,
                    "1202": 728.55078125,
                    "1203": 280.5076599121094,
                    "1204": 728.915283203125,
                    "1205": 278.5411376953125,
                    "1206": 730.7913208007812,
                    "1207": 280.92291259765625,
                    "1208": 728.915283203125,
                    "1209": 278.5411376953125,
                    "1210": 731.1558227539062,
                    "1211": 278.9563903808594,
                    "1212": 730.4968872070312,
                    "1213": 280.88592529296875,
                    "1214": 728.263916015625,
                    "1215": 280.431640625,
                    "1216": 728.6626586914062,
                    "1217": 278.4717712402344,
                    "1218": 730.4968872070312,
                    "1219": 280.88592529296875,
                    "1220": 728.6626586914062,
                    "1221": 278.4717712402344,
                    "1222": 730.8955688476562,
                    "1223": 278.92608642578125,
                    "1224": 730.2030639648438,
                    "1225": 280.84381103515625,
                    "1226": 727.9783935546875,
                    "1227": 280.3506164550781,
                    "1228": 728.4112548828125,
                    "1229": 278.39801025390625,
                    "1230": 730.2030639648438,
                    "1231": 280.84381103515625,
                    "1232": 728.4112548828125,
                    "1233": 278.39801025390625,
                    "1234": 730.6359252929688,
                    "1235": 278.8912048339844,
                    "1236": 729.9100341796875,
                    "1237": 280.79656982421875,
                    "1238": 727.6943359375,
                    "1239": 280.2646179199219,
                    "1240": 728.1612548828125,
                    "1241": 278.31988525390625,
                    "1242": 729.9100341796875,
                    "1243": 280.79656982421875,
                    "1244": 728.1612548828125,
                    "1245": 278.31988525390625,
                    "1246": 730.376953125,
                    "1247": 278.8518371582031,
                    "1248": 729.617919921875,
                    "1249": 280.7442321777344,
                    "1250": 727.4118041992188,
                    "1251": 280.1736755371094,
                    "1252": 727.91259765625,
                    "1253": 278.2373962402344,
                    "1254": 729.617919921875,
                    "1255": 280.7442321777344,
                    "1256": 727.91259765625,
                    "1257": 278.2373962402344,
                    "1258": 730.11865234375,
                    "1259": 278.80792236328125,
                    "1260": 729.3267211914062,
                    "1261": 280.6867980957031,
                    "1262": 727.1309204101562,
                    "1263": 280.0778503417969,
                    "1264": 727.6654052734375,
                    "1265": 278.15057373046875,
                    "1266": 729.3267211914062,
                    "1267": 280.6867980957031,
                    "1268": 727.6654052734375,
                    "1269": 278.15057373046875,
                    "1270": 729.8612060546875,
                    "1271": 278.759521484375,
                    "1272": 729.03662109375,
                    "1273": 280.624267578125,
                    "1274": 726.8517456054688,
                    "1275": 279.97711181640625,
                    "1276": 727.4197998046875,
                    "1277": 278.0594482421875,
                    "1278": 729.03662109375,
                    "1279": 280.624267578125,
                    "1280": 727.4197998046875,
                    "1281": 278.0594482421875,
                    "1282": 729.6046142578125,
                    "1283": 278.7066345214844,
                    "1284": 728.7476196289062,
                    "1285": 280.55670166015625,
                    "1286": 726.5744018554688,
                    "1287": 279.8714904785156,
                    "1288": 727.17578125,
                    "1289": 277.9640808105469,
                    "1290": 728.7476196289062,
                    "1291": 280.55670166015625,
                    "1292": 727.17578125,
                    "1293": 277.9640808105469,
                    "1294": 729.3489990234375,
                    "1295": 278.6492919921875,
                    "1296": 728.4598388671875,
                    "1297": 280.484130859375,
                    "1298": 726.2988891601562,
                    "1299": 279.7610778808594,
                    "1300": 726.9335327148438,
                    "1301": 277.86444091796875,
                    "1302": 728.4598388671875,
                    "1303": 280.484130859375,
                    "1304": 726.9335327148438,
                    "1305": 277.86444091796875,
                    "1306": 729.0944213867188,
                    "1307": 278.58746337890625,
                    "1308": 728.17333984375,
                    "1309": 280.4065246582031,
                    "1310": 726.025390625,
                    "1311": 279.6458740234375,
                    "1312": 726.6929931640625,
                    "1313": 277.7605895996094,
                    "1314": 728.17333984375,
                    "1315": 280.4065246582031,
                    "1316": 726.6929931640625,
                    "1317": 277.7605895996094,
                    "1318": 728.8409423828125,
                    "1319": 278.521240234375,
                    "1320": 727.8883056640625,
                    "1321": 280.32391357421875,
                    "1322": 725.75390625,
                    "1323": 279.5259094238281,
                    "1324": 726.454345703125,
                    "1325": 277.6525573730469,
                    "1326": 727.8883056640625,
                    "1327": 280.32391357421875,
                    "1328": 726.454345703125,
                    "1329": 277.6525573730469,
                    "1330": 728.5886840820312,
                    "1331": 278.4505615234375,
                    "1332": 727.604736328125,
                    "1333": 280.2363586425781,
                    "1334": 725.4845581054688,
                    "1335": 279.4012145996094,
                    "1336": 726.2175903320312,
                    "1337": 277.5403747558594,
                    "1338": 727.604736328125,
                    "1339": 280.2363586425781,
                    "1340": 726.2175903320312,
                    "1341": 277.5403747558594,
                    "1342": 728.3377075195312,
                    "1343": 278.3755187988281,
                    "1344": 727.3226928710938,
                    "1345": 280.14385986328125,
                    "1346": 725.2174682617188,
                    "1347": 279.2718505859375,
                    "1348": 725.9828491210938,
                    "1349": 277.4241027832031,
                    "1350": 727.3226928710938,
                    "1351": 280.14385986328125,
                    "1352": 725.9828491210938,
                    "1353": 277.4241027832031,
                    "1354": 728.0880737304688,
                    "1355": 278.2961120605469,
                    "1356": 727.0423583984375,
                    "1357": 280.0464782714844,
                    "1358": 724.95263671875,
                    "1359": 279.1378479003906,
                    "1360": 725.7501220703125,
                    "1361": 277.3037109375,
                    "1362": 727.0423583984375,
                    "1363": 280.0464782714844,
                    "1364": 725.7501220703125,
                    "1365": 277.3037109375,
                    "1366": 727.83984375,
                    "1367": 278.21234130859375,
                    "1368": 726.7637329101562,
                    "1369": 279.9441833496094,
                    "1370": 724.690185546875,
                    "1371": 278.9992370605469,
                    "1372": 725.5195922851562,
                    "1373": 277.1793212890625,
                    "1374": 726.7637329101562,
                    "1375": 279.9441833496094,
                    "1376": 725.5195922851562,
                    "1377": 277.1793212890625,
                    "1378": 727.5931396484375,
                    "1379": 278.124267578125,
                    "1380": 726.4869384765625,
                    "1381": 279.8370666503906,
                    "1382": 724.4302368164062,
                    "1383": 278.8560485839844,
                    "1384": 725.291259765625,
                    "1385": 277.0509033203125,
                    "1386": 726.4869384765625,
                    "1387": 279.8370666503906,
                    "1388": 725.291259765625,
                    "1389": 277.0509033203125,
                    "1390": 727.3479614257812,
                    "1391": 278.0318908691406,
                    "1392": 726.2120971679688,
                    "1393": 279.7251281738281,
                    "1394": 724.1727905273438,
                    "1395": 278.7083740234375,
                    "1396": 725.065185546875,
                    "1397": 276.91851806640625,
                    "1398": 726.2120971679688,
                    "1399": 279.7251281738281,
                    "1400": 725.065185546875,
                    "1401": 276.91851806640625,
                    "1402": 727.1044921875,
                    "1403": 277.93524169921875,
                    "1404": 725.939208984375,
                    "1405": 279.6083984375,
                    "1406": 723.91796875,
                    "1407": 278.55621337890625,
                    "1408": 724.8414916992188,
                    "1409": 276.7821960449219,
                    "1410": 725.939208984375,
                    "1411": 279.6083984375,
                    "1412": 724.8414916992188,
                    "1413": 276.7821960449219,
                    "1414": 726.8626708984375,
                    "1415": 277.8343811035156,
                    "1416": 725.6683959960938,
                    "1417": 279.4869384765625,
                    "1418": 723.6658325195312,
                    "1419": 278.3996276855469,
                    "1420": 724.6201782226562,
                    "1421": 276.6419982910156,
                    "1422": 725.6683959960938,
                    "1423": 279.4869384765625,
                    "1424": 724.6201782226562,
                    "1425": 276.6419982910156,
                    "1426": 726.6227416992188,
                    "1427": 277.72930908203125,
                    "1428": 725.3997802734375,
                    "1429": 279.3607482910156,
                    "1430": 723.41650390625,
                    "1431": 278.2386779785156,
                    "1432": 724.4013671875,
                    "1433": 276.49798583984375,
                    "1434": 725.3997802734375,
                    "1435": 279.3607482910156,
                    "1436": 724.4013671875,
                    "1437": 276.49798583984375,
                    "1438": 726.3845825195312,
                    "1439": 277.62005615234375,
                    "1440": 725.1333618164062,
                    "1441": 279.22991943359375,
                    "1442": 723.1699829101562,
                    "1443": 278.0733947753906,
                    "1444": 724.18505859375,
                    "1445": 276.3501281738281,
                    "1446": 725.1333618164062,
                    "1447": 279.22991943359375,
                    "1448": 724.18505859375,
                    "1449": 276.3501281738281,
                    "1450": 726.1484375,
                    "1451": 277.50665283203125,
                    "1452": 724.8692626953125,
                    "1453": 279.0944519042969,
                    "1454": 722.9263916015625,
                    "1455": 277.9038391113281,
                    "1456": 723.9713745117188,
                    "1457": 276.19854736328125,
                    "1458": 724.8692626953125,
                    "1459": 279.0944519042969,
                    "1460": 723.9713745117188,
                    "1461": 276.19854736328125,
                    "1462": 725.914306640625,
                    "1463": 277.38916015625,
                    "1464": 724.6076049804688,
                    "1465": 278.9543762207031,
                    "1466": 722.685791015625,
                    "1467": 277.73004150390625,
                    "1468": 723.7603759765625,
                    "1469": 276.04327392578125,
                    "1470": 724.6076049804688,
                    "1471": 278.9543762207031,
                    "1472": 723.7603759765625,
                    "1473": 276.04327392578125,
                    "1474": 725.6822509765625,
                    "1475": 277.2676086425781,
                    "1476": 724.3484497070312,
                    "1477": 278.8097839355469,
                    "1478": 722.4483032226562,
                    "1479": 277.5520935058594,
                    "1480": 723.5521850585938,
                    "1481": 275.8843078613281,
                    "1482": 724.3484497070312,
                    "1483": 278.8097839355469,
                    "1484": 723.5521850585938,
                    "1485": 275.8843078613281,
                    "1486": 725.4523315429688,
                    "1487": 277.1419982910156,
                    "1488": 724.091796875,
                    "1489": 278.6606750488281,
                    "1490": 722.2139282226562,
                    "1491": 277.3700256347656,
                    "1492": 723.3467407226562,
                    "1493": 275.7217712402344,
                    "1494": 724.091796875,
                    "1495": 278.6606750488281,
                    "1496": 723.3467407226562,
                    "1497": 275.7217712402344,
                    "1498": 725.224609375,
                    "1499": 277.0124206542969,
                    "1500": 723.8378295898438,
                    "1501": 278.5071105957031,
                    "1502": 721.9827270507812,
                    "1503": 277.1838684082031,
                    "1504": 723.1441650390625,
                    "1505": 275.5556335449219,
                    "1506": 723.8378295898438,
                    "1507": 278.5071105957031,
                    "1508": 723.1441650390625,
                    "1509": 275.5556335449219,
                    "1510": 724.999267578125,
                    "1511": 276.8788757324219,
                    "1512": 723.5866088867188,
                    "1513": 278.3491516113281,
                    "1514": 721.7548217773438,
                    "1515": 276.9937438964844,
                    "1516": 722.9445190429688,
                    "1517": 275.3860168457031,
                    "1518": 723.5866088867188,
                    "1519": 278.3491516113281,
                    "1520": 722.9445190429688,
                    "1521": 275.3860168457031,
                    "1522": 724.7762451171875,
                    "1523": 276.7414245605469,
                    "1524": 723.338134765625,
                    "1525": 278.1867980957031,
                    "1526": 721.5303344726562,
                    "1527": 276.7996520996094,
                    "1528": 722.7478637695312,
                    "1529": 275.2129211425781,
                    "1530": 723.338134765625,
                    "1531": 278.1867980957031,
                    "1532": 722.7478637695312,
                    "1533": 275.2129211425781,
                    "1534": 724.5556640625,
                    "1535": 276.60009765625,
                    "1536": 723.092529296875,
                    "1537": 278.0201721191406,
                    "1538": 721.3092041015625,
                    "1539": 276.6016540527344,
                    "1540": 722.5542602539062,
                    "1541": 275.03643798828125,
                    "1542": 723.092529296875,
                    "1543": 278.0201721191406,
                    "1544": 722.5542602539062,
                    "1545": 275.03643798828125,
                    "1546": 724.3375854492188,
                    "1547": 276.4549560546875,
                    "1548": 722.8499145507812,
                    "1549": 277.8492736816406,
                    "1550": 721.0916137695312,
                    "1551": 276.39984130859375,
                    "1552": 722.36376953125,
                    "1553": 274.8565979003906,
                    "1554": 722.8499145507812,
                    "1555": 277.8492736816406,
                    "1556": 722.36376953125,
                    "1557": 274.8565979003906,
                    "1558": 724.1220703125,
                    "1559": 276.3060302734375,
                    "1560": 722.6102294921875,
                    "1561": 277.6741638183594,
                    "1562": 720.8775024414062,
                    "1563": 276.19427490234375,
                    "1564": 722.1764526367188,
                    "1565": 274.6734619140625,
                    "1566": 722.6102294921875,
                    "1567": 277.6741638183594,
                    "1568": 722.1764526367188,
                    "1569": 274.6734619140625,
                    "1570": 723.9091796875,
                    "1571": 276.1533508300781,
                    "1572": 722.3737182617188,
                    "1573": 277.494873046875,
                    "1574": 720.6671142578125,
                    "1575": 275.9849853515625,
                    "1576": 721.9923095703125,
                    "1577": 274.487060546875,
                    "1578": 722.3737182617188,
                    "1579": 277.494873046875,
                    "1580": 721.9923095703125,
                    "1581": 274.487060546875,
                    "1582": 723.698974609375,
                    "1583": 275.9969787597656,
                    "1584": 722.140380859375,
                    "1585": 277.3115234375,
                    "1586": 720.4603271484375,
                    "1587": 275.7720642089844,
                    "1588": 721.8115234375,
                    "1589": 274.2975158691406,
                    "1590": 722.140380859375,
                    "1591": 277.3115234375,
                    "1592": 721.8115234375,
                    "1593": 274.2975158691406,
                    "1594": 723.4915161132812,
                    "1595": 275.8369445800781,
                    "1596": 721.9102172851562,
                    "1597": 277.12408447265625,
                    "1598": 720.25732421875,
                    "1599": 275.5555725097656,
                    "1600": 721.634033203125,
                    "1601": 274.10479736328125,
                    "1602": 721.9102172851562,
                    "1603": 277.12408447265625,
                    "1604": 721.634033203125,
                    "1605": 274.10479736328125,
                    "1606": 723.2869262695312,
                    "1607": 275.67333984375,
                    "1608": 721.6834106445312,
                    "1609": 276.9327087402344,
                    "1610": 720.05810546875,
                    "1611": 275.3355407714844,
                    "1612": 721.4599609375,
                    "1613": 273.9090576171875,
                    "1614": 721.6834106445312,
                    "1615": 276.9327087402344,
                    "1616": 721.4599609375,
                    "1617": 273.9090576171875,
                    "1618": 723.085205078125,
                    "1619": 275.5061950683594,
                    "1620": 721.4599609375,
                    "1621": 276.73736572265625,
                    "1622": 719.86279296875,
                    "1623": 275.1120910644531,
                    "1624": 721.289306640625,
                    "1625": 273.71026611328125,
                    "1626": 721.4599609375,
                    "1627": 276.73736572265625,
                    "1628": 721.289306640625,
                    "1629": 273.71026611328125,
                    "1630": 722.8864135742188,
                    "1631": 275.3355407714844,
                    "1632": 721.2399291992188,
                    "1633": 276.5381774902344,
                    "1634": 719.67138671875,
                    "1635": 274.88525390625,
                    "1636": 721.1221313476562,
                    "1637": 273.508544921875,
                    "1638": 721.2399291992188,
                    "1639": 276.5381774902344,
                    "1640": 721.1221313476562,
                    "1641": 273.508544921875,
                    "1642": 722.690673828125,
                    "1643": 275.1614685058594,
                    "1644": 721.0234375,
                    "1645": 276.33514404296875,
                    "1646": 719.4839477539062,
                    "1647": 274.6551208496094,
                    "1648": 720.95849609375,
                    "1649": 273.303955078125,
                    "1650": 721.0234375,
                    "1651": 276.33514404296875,
                    "1652": 720.95849609375,
                    "1653": 273.303955078125,
                    "1654": 722.4979858398438,
                    "1655": 274.9839782714844,
                    "1656": 720.8104858398438,
                    "1657": 276.1283874511719,
                    "1658": 719.3005981445312,
                    "1659": 274.4217529296875,
                    "1660": 720.7985229492188,
                    "1661": 273.0965270996094,
                    "1662": 720.8104858398438,
                    "1663": 276.1283874511719,
                    "1664": 720.7985229492188,
                    "1665": 273.0965270996094,
                    "1666": 722.3084106445312,
                    "1667": 274.80316162109375,
                    "1668": 720.6011962890625,
                    "1669": 275.9179382324219,
                    "1670": 719.121337890625,
                    "1671": 274.18524169921875,
                    "1672": 720.6421508789062,
                    "1673": 272.8863220214844,
                    "1674": 720.6011962890625,
                    "1675": 275.9179382324219,
                    "1676": 720.6421508789062,
                    "1677": 272.8863220214844,
                    "1678": 722.1220092773438,
                    "1679": 274.6190490722656,
                    "1680": 720.3956298828125,
                    "1681": 275.7038879394531,
                    "1682": 718.9462280273438,
                    "1683": 273.9455871582031,
                    "1684": 720.4894409179688,
                    "1685": 272.6734313964844,
                    "1686": 720.3956298828125,
                    "1687": 275.7038879394531,
                    "1688": 720.4894409179688,
                    "1689": 272.6734313964844,
                    "1690": 721.9389038085938,
                    "1691": 274.4317321777344,
                    "1692": 720.19384765625,
                    "1693": 275.48626708984375,
                    "1694": 718.7753295898438,
                    "1695": 273.70294189453125,
                    "1696": 720.3405151367188,
                    "1697": 272.4579162597656,
                    "1698": 720.19384765625,
                    "1699": 275.48626708984375,
                    "1700": 720.3405151367188,
                    "1701": 272.4579162597656,
                    "1702": 721.759033203125,
                    "1703": 274.2412414550781,
                    "1704": 719.995849609375,
                    "1705": 275.2651672363281,
                    "1706": 718.608642578125,
                    "1707": 273.4573669433594,
                    "1708": 720.1953735351562,
                    "1709": 272.2398376464844,
                    "1710": 719.995849609375,
                    "1711": 275.2651672363281,
                    "1712": 720.1953735351562,
                    "1713": 272.2398376464844,
                    "1714": 721.5825805664062,
                    "1715": 274.0476379394531,
                    "1716": 719.8017578125,
                    "1717": 275.0406188964844,
                    "1718": 718.4463500976562,
                    "1719": 273.2088928222656,
                    "1720": 720.0540771484375,
                    "1721": 272.0192565917969,
                    "1722": 719.8017578125,
                    "1723": 275.0406188964844,
                    "1724": 720.0540771484375,
                    "1725": 272.0192565917969,
                    "1726": 721.4094848632812,
                    "1727": 273.8509826660156,
                    "1728": 719.6116333007812,
                    "1729": 274.812744140625,
                    "1730": 718.2883911132812,
                    "1731": 272.9576416015625,
                    "1732": 719.9166259765625,
                    "1733": 271.7962341308594,
                    "1734": 719.6116333007812,
                    "1735": 274.812744140625,
                    "1736": 719.9166259765625,
                    "1737": 271.7962341308594,
                    "1738": 721.2398071289062,
                    "1739": 273.6513366699219,
                    "1740": 719.4254760742188,
                    "1741": 274.5815734863281,
                    "1742": 718.1348266601562,
                    "1743": 272.70367431640625,
                    "1744": 719.7830810546875,
                    "1745": 271.57086181640625,
                    "1746": 719.4254760742188,
                    "1747": 274.5815734863281,
                    "1748": 719.7830810546875,
                    "1749": 271.57086181640625,
                    "1750": 721.07373046875,
                    "1751": 273.4487609863281,
                    "1752": 719.243408203125,
                    "1753": 274.3471984863281,
                    "1754": 717.9857177734375,
                    "1755": 272.4470520019531,
                    "1756": 719.6534423828125,
                    "1757": 271.3431701660156,
                    "1758": 719.243408203125,
                    "1759": 274.3471984863281,
                    "1760": 719.6534423828125,
                    "1761": 271.3431701660156,
                    "1762": 720.9111328125,
                    "1763": 273.2433166503906,
                    "1764": 719.0654296875,
                    "1765": 274.10968017578125,
                    "1766": 717.8411254882812,
                    "1767": 272.1878662109375,
                    "1768": 719.5278930664062,
                    "1769": 271.1132507324219,
                    "1770": 719.0654296875,
                    "1771": 274.10968017578125,
                    "1772": 719.5278930664062,
                    "1773": 271.1132507324219,
                    "1774": 720.752197265625,
                    "1775": 273.03509521484375,
                    "1776": 718.8916625976562,
                    "1777": 273.86907958984375,
                    "1778": 717.7010498046875,
                    "1779": 271.92620849609375,
                    "1780": 719.4063110351562,
                    "1781": 270.8811950683594,
                    "1782": 718.8916625976562,
                    "1783": 273.86907958984375,
                    "1784": 719.4063110351562,
                    "1785": 270.8811950683594,
                    "1786": 720.596923828125,
                    "1787": 272.8240966796875,
                    "1788": 718.7221069335938,
                    "1789": 273.62548828125,
                    "1790": 717.5655517578125,
                    "1791": 271.662109375,
                    "1792": 719.288818359375,
                    "1793": 270.64703369140625,
                    "1794": 718.7221069335938,
                    "1795": 273.62548828125,
                    "1796": 719.288818359375,
                    "1797": 270.64703369140625,
                    "1798": 720.4453735351562,
                    "1799": 272.61041259765625,
                    "1800": 718.5568237304688,
                    "1801": 273.3789978027344,
                    "1802": 717.4347534179688,
                    "1803": 271.3957214355469,
                    "1804": 719.1754150390625,
                    "1805": 270.410888671875,
                    "1806": 718.5568237304688,
                    "1807": 273.3789978027344,
                    "1808": 719.1754150390625,
                    "1809": 270.410888671875,
                    "1810": 720.2974853515625,
                    "1811": 272.3941345214844,
                    "1812": 718.3958740234375,
                    "1813": 273.129638671875,
                    "1814": 717.3085327148438,
                    "1815": 271.1270751953125,
                    "1816": 719.066162109375,
                    "1817": 270.1727600097656,
                    "1818": 718.3958740234375,
                    "1819": 273.129638671875,
                    "1820": 719.066162109375,
                    "1821": 270.1727600097656,
                    "1822": 720.1535034179688,
                    "1823": 272.1753234863281,
                    "1824": 718.2392578125,
                    "1825": 272.87750244140625,
                    "1826": 717.1870727539062,
                    "1827": 270.8562927246094,
                    "1828": 718.9611206054688,
                    "1829": 269.93280029296875,
                    "1830": 718.2392578125,
                    "1831": 272.87750244140625,
                    "1832": 718.9611206054688,
                    "1833": 269.93280029296875,
                    "1834": 720.0133056640625,
                    "1835": 271.9540100097656,
                    "1836": 718.0870971679688,
                    "1837": 272.6226806640625,
                    "1838": 717.0703735351562,
                    "1839": 270.5834045410156,
                    "1840": 718.8602294921875,
                    "1841": 269.6910095214844,
                    "1842": 718.0870971679688,
                    "1843": 272.6226806640625,
                    "1844": 718.8602294921875,
                    "1845": 269.6910095214844,
                    "1846": 719.876953125,
                    "1847": 271.73028564453125,
                    "1848": 717.939453125,
                    "1849": 272.365234375,
                    "1850": 716.9584350585938,
                    "1851": 270.30853271484375,
                    "1852": 718.7636108398438,
                    "1853": 269.447509765625,
                    "1854": 717.939453125,
                    "1855": 272.365234375,
                    "1856": 718.7636108398438,
                    "1857": 269.447509765625,
                    "1858": 719.7445678710938,
                    "1859": 271.50421142578125,
                    "1860": 717.7962646484375,
                    "1861": 272.1052551269531,
                    "1862": 716.851318359375,
                    "1863": 270.0317687988281,
                    "1864": 718.6712036132812,
                    "1865": 269.2023620605469,
                    "1866": 717.7962646484375,
                    "1867": 272.1052551269531,
                    "1868": 718.6712036132812,
                    "1869": 269.2023620605469,
                    "1870": 719.6161499023438,
                    "1871": 271.27587890625,
                    "1872": 717.6576538085938,
                    "1873": 271.84283447265625,
                    "1874": 716.7490234375,
                    "1875": 269.7531433105469,
                    "1876": 718.5831298828125,
                    "1877": 268.9556579589844,
                    "1878": 717.6576538085938,
                    "1879": 271.84283447265625,
                    "1880": 718.5831298828125,
                    "1881": 268.9556579589844,
                    "1882": 719.4917602539062,
                    "1883": 271.04534912109375,
                    "1884": 717.5236206054688,
                    "1885": 271.5780029296875,
                    "1886": 716.651611328125,
                    "1887": 269.4727783203125,
                    "1888": 718.4993896484375,
                    "1889": 268.7074279785156,
                    "1890": 717.5236206054688,
                    "1891": 271.5780029296875,
                    "1892": 718.4993896484375,
                    "1893": 268.7074279785156,
                    "1894": 719.3713989257812,
                    "1895": 270.8126525878906,
                    "1896": 717.394287109375,
                    "1897": 271.3109130859375,
                    "1898": 716.5591430664062,
                    "1899": 269.1907653808594,
                    "1900": 718.4199829101562,
                    "1901": 268.457763671875,
                    "1902": 717.394287109375,
                    "1903": 271.3109130859375,
                    "1904": 718.4199829101562,
                    "1905": 268.457763671875,
                    "1906": 719.255126953125,
                    "1907": 270.5779113769531,
                    "1908": 717.2695922851562,
                    "1909": 271.04156494140625,
                    "1910": 716.4715576171875,
                    "1911": 268.9071960449219,
                    "1912": 718.3449096679688,
                    "1913": 268.206787109375,
                    "1914": 717.2695922851562,
                    "1915": 271.04156494140625,
                    "1916": 718.3449096679688,
                    "1917": 268.206787109375,
                    "1918": 719.1429443359375,
                    "1919": 270.3411560058594,
                    "1920": 717.1495971679688,
                    "1921": 270.7701110839844,
                    "1922": 716.3889770507812,
                    "1923": 268.62213134765625,
                    "1924": 718.2742309570312,
                    "1925": 267.9544982910156,
                    "1926": 717.1495971679688,
                    "1927": 270.7701110839844,
                    "1928": 718.2742309570312,
                    "1929": 267.9544982910156,
                    "1930": 719.034912109375,
                    "1931": 270.1025085449219,
                    "1932": 717.034423828125,
                    "1933": 270.49658203125,
                    "1934": 716.3113403320312,
                    "1935": 268.3356628417969,
                    "1936": 718.2080078125,
                    "1937": 267.7010498046875,
                    "1938": 717.034423828125,
                    "1939": 270.49658203125,
                    "1940": 718.2080078125,
                    "1941": 267.7010498046875,
                    "1942": 718.9310302734375,
                    "1943": 269.8619689941406,
                    "1944": 716.9240112304688,
                    "1945": 270.2210998535156,
                    "1946": 716.23876953125,
                    "1947": 268.0478820800781,
                    "1948": 718.1461791992188,
                    "1949": 267.44647216796875,
                    "1950": 716.9240112304688,
                    "1951": 270.2210998535156,
                    "1952": 718.1461791992188,
                    "1953": 267.44647216796875,
                    "1954": 718.8314208984375,
                    "1955": 269.61968994140625,
                    "1956": 716.818359375,
                    "1957": 269.9437255859375,
                    "1958": 716.1712036132812,
                    "1959": 267.7588806152344,
                    "1960": 718.0888671875,
                    "1961": 267.19085693359375,
                    "1962": 716.818359375,
                    "1963": 269.9437255859375,
                    "1964": 718.0888671875,
                    "1965": 267.19085693359375,
                    "1966": 718.7360229492188,
                    "1967": 269.3757019042969,
                    "1968": 716.7176513671875,
                    "1969": 269.66455078125,
                    "1970": 716.1087036132812,
                    "1971": 267.46875,
                    "1972": 718.0359497070312,
                    "1973": 266.93426513671875,
                    "1974": 716.7176513671875,
                    "1975": 269.66455078125,
                    "1976": 718.0359497070312,
                    "1977": 266.93426513671875,
                    "1978": 718.6448974609375,
                    "1979": 269.13006591796875,
                    "1980": 716.621826171875,
                    "1981": 269.3836669921875,
                    "1982": 716.05126953125,
                    "1983": 267.17755126953125,
                    "1984": 717.987548828125,
                    "1985": 266.67681884765625,
                    "1986": 716.621826171875,
                    "1987": 269.3836669921875,
                    "1988": 717.987548828125,
                    "1989": 266.67681884765625,
                    "1990": 718.55810546875,
                    "1991": 268.8829040527344,
                    "1992": 716.5308837890625,
                    "1993": 269.10113525390625,
                    "1994": 715.9989013671875,
                    "1995": 266.88543701171875,
                    "1996": 717.9436645507812,
                    "1997": 266.4185485839844,
                    "1998": 716.5308837890625,
                    "1999": 269.10113525390625,
                    "2000": 717.9436645507812,
                    "2001": 266.4185485839844,
                    "2002": 718.4755859375,
                    "2003": 268.6342468261719,
                    "2004": 716.4448852539062,
                    "2005": 268.81707763671875,
                    "2006": 715.95166015625,
                    "2007": 266.5924072265625,
                    "2008": 717.904296875,
                    "2009": 266.1595458984375,
                    "2010": 716.4448852539062,
                    "2011": 268.81707763671875,
                    "2012": 717.904296875,
                    "2013": 266.1595458984375,
                    "2014": 718.3974609375,
                    "2015": 268.38421630859375,
                    "2016": 716.3638305664062,
                    "2017": 268.53155517578125,
                    "2018": 715.9095458984375,
                    "2019": 266.2986145019531,
                    "2020": 717.869384765625,
                    "2021": 265.89990234375,
                    "2022": 716.3638305664062,
                    "2023": 268.53155517578125,
                    "2024": 717.869384765625,
                    "2025": 265.89990234375,
                    "2026": 718.32373046875,
                    "2027": 268.1328430175781,
                    "2028": 716.287841796875,
                    "2029": 268.2446594238281,
                    "2030": 715.87255859375,
                    "2031": 266.004150390625,
                    "2032": 717.839111328125,
                    "2033": 265.6396789550781,
                    "2034": 716.287841796875,
                    "2035": 268.2446594238281,
                    "2036": 717.839111328125,
                    "2037": 265.6396789550781,
                    "2038": 718.2543334960938,
                    "2039": 267.88018798828125,
                    "2040": 716.2168579101562,
                    "2041": 267.9565124511719,
                    "2042": 715.8407592773438,
                    "2043": 265.7090759277344,
                    "2044": 717.8132934570312,
                    "2045": 265.37896728515625,
                    "2046": 716.2168579101562,
                    "2047": 267.9565124511719,
                    "2048": 717.8132934570312,
                    "2049": 265.37896728515625,
                    "2050": 718.1893920898438,
                    "2051": 267.62640380859375,
                    "2052": 716.15087890625,
                    "2053": 267.6671447753906,
                    "2054": 715.8140258789062,
                    "2055": 265.4134826660156,
                    "2056": 717.7921142578125,
                    "2057": 265.11785888671875,
                    "2058": 716.15087890625,
                    "2059": 267.6671447753906,
                    "2060": 717.7921142578125,
                    "2061": 265.11785888671875,
                    "2062": 718.12890625,
                    "2063": 267.37152099609375,
                    "2064": 716.0899658203125,
                    "2065": 267.37664794921875,
                    "2066": 715.7925415039062,
                    "2067": 265.1174621582031,
                    "2068": 717.7754516601562,
                    "2069": 264.8564147949219,
                    "2070": 716.0899658203125,
                    "2071": 267.37664794921875,
                    "2072": 717.7754516601562,
                    "2073": 264.8564147949219,
                    "2074": 718.0728759765625,
                    "2075": 267.1156005859375,
                    "2076": 716.0341186523438,
                    "2077": 267.0851745605469,
                    "2078": 715.7761840820312,
                    "2079": 264.8211364746094,
                    "2080": 717.7633056640625,
                    "2081": 264.5947265625,
                    "2082": 716.0341186523438,
                    "2083": 267.0851745605469,
                    "2084": 717.7633056640625,
                    "2085": 264.5947265625,
                    "2086": 718.0213012695312,
                    "2087": 266.8587646484375,
                    "2088": 715.9833984375,
                    "2089": 266.792724609375,
                    "2090": 715.7650146484375,
                    "2091": 264.5245361328125,
                    "2092": 717.7557983398438,
                    "2093": 264.3328552246094,
                    "2094": 715.9833984375,
                    "2095": 266.792724609375,
                    "2096": 717.7557983398438,
                    "2097": 264.3328552246094,
                    "2098": 717.9741821289062,
                    "2099": 266.6010437011719,
                    "2100": 715.9378051757812,
                    "2101": 266.4994812011719,
                    "2102": 715.759033203125,
                    "2103": 264.2278137207031,
                    "2104": 717.7528686523438,
                    "2105": 264.0708923339844,
                    "2106": 715.9378051757812,
                    "2107": 266.4994812011719,
                    "2108": 717.7528686523438,
                    "2109": 264.0708923339844,
                    "2110": 717.931640625,
                    "2111": 266.3425598144531,
                    "2112": 715.8972778320312,
                    "2113": 266.2054443359375,
                    "2114": 715.7581787109375,
                    "2115": 263.9310302734375,
                    "2116": 717.7544555664062,
                    "2117": 263.8089294433594,
                    "2118": 715.8972778320312,
                    "2119": 266.2054443359375,
                    "2120": 717.7544555664062,
                    "2121": 263.8089294433594,
                    "2122": 717.8935546875,
                    "2123": 266.0833435058594,
                    "2124": 715.8619384765625,
                    "2125": 265.9107666015625,
                    "2126": 715.7625732421875,
                    "2127": 263.6342468261719,
                    "2128": 717.7606201171875,
                    "2129": 263.5470275878906,
                    "2130": 715.8619384765625,
                    "2131": 265.9107666015625,
                    "2132": 717.7606201171875,
                    "2133": 263.5470275878906,
                    "2134": 717.8600463867188,
                    "2135": 265.82354736328125,
                    "2136": 715.8317260742188,
                    "2137": 265.6155090332031,
                    "2138": 715.7720947265625,
                    "2139": 263.3376159667969,
                    "2140": 717.7714233398438,
                    "2141": 263.2852783203125,
                    "2142": 715.8317260742188,
                    "2143": 265.6155090332031,
                    "2144": 717.7714233398438,
                    "2145": 263.2852783203125,
                    "2146": 717.8310546875,
                    "2147": 265.56317138671875,
                    "2148": 715.8067016601562,
                    "2149": 265.3197937011719,
                    "2150": 715.7868041992188,
                    "2151": 263.04119873046875,
                    "2152": 717.7867431640625,
                    "2153": 263.02374267578125,
                    "2154": 715.8067016601562,
                    "2155": 265.3197937011719,
                    "2156": 717.7867431640625,
                    "2157": 263.02374267578125,
                    "2158": 717.8065795898438,
                    "2159": 265.3023376464844,
                    "2160": 715.7868041992188,
                    "2161": 265.0236511230469,
                    "2162": 715.8067016601562,
                    "2163": 262.74505615234375,
                    "2164": 717.8065795898438,
                    "2165": 262.76251220703125,
                    "2166": 715.7868041992188,
                    "2167": 265.0236511230469,
                    "2168": 717.8065795898438,
                    "2169": 262.76251220703125,
                    "2170": 717.7867431640625,
                    "2171": 265.0411071777344,
                    "2172": 715.7720947265625,
                    "2173": 264.72723388671875,
                    "2174": 715.8317260742188,
                    "2175": 262.4493408203125,
                    "2176": 717.8310546875,
                    "2177": 262.5016784667969,
                    "2178": 715.7720947265625,
                    "2179": 264.72723388671875,
                    "2180": 717.8310546875,
                    "2181": 262.5016784667969,
                    "2182": 717.7714233398438,
                    "2183": 264.77960205078125,
                    "2184": 715.7625732421875,
                    "2185": 264.43060302734375,
                    "2186": 715.8619384765625,
                    "2187": 262.1540832519531,
                    "2188": 717.8600463867188,
                    "2189": 262.2413330078125,
                    "2190": 715.7625732421875,
                    "2191": 264.43060302734375,
                    "2192": 717.8600463867188,
                    "2193": 262.2413330078125,
                    "2194": 717.7606201171875,
                    "2195": 264.517822265625,
                    "2196": 715.7581787109375,
                    "2197": 264.13385009765625,
                    "2198": 715.8972778320312,
                    "2199": 261.8594055175781,
                    "2200": 717.8935546875,
                    "2201": 261.98150634765625,
                    "2202": 715.7581787109375,
                    "2203": 264.13385009765625,
                    "2204": 717.8935546875,
                    "2205": 261.98150634765625,
                    "2206": 717.7544555664062,
                    "2207": 264.25592041015625,
                    "2208": 715.759033203125,
                    "2209": 263.8370361328125,
                    "2210": 715.9378051757812,
                    "2211": 261.5653991699219,
                    "2212": 717.931640625,
                    "2213": 261.7222900390625,
                    "2214": 715.759033203125,
                    "2215": 263.8370361328125,
                    "2216": 717.931640625,
                    "2217": 261.7222900390625,
                    "2218": 717.7528686523438,
                    "2219": 263.99395751953125,
                    "2220": 715.7650146484375,
                    "2221": 263.5403137207031,
                    "2222": 715.9833984375,
                    "2223": 261.2721252441406,
                    "2224": 717.9741821289062,
                    "2225": 261.46380615234375,
                    "2226": 715.7650146484375,
                    "2227": 263.5403137207031,
                    "2228": 717.9741821289062,
                    "2229": 261.46380615234375,
                    "2230": 717.7557983398438,
                    "2231": 263.73199462890625,
                    "2232": 715.7761840820312,
                    "2233": 263.2437438964844,
                    "2234": 716.0341186523438,
                    "2235": 260.9797058105469,
                    "2236": 718.0213012695312,
                    "2237": 261.20611572265625,
                    "2238": 715.7761840820312,
                    "2239": 263.2437438964844,
                    "2240": 718.0213012695312,
                    "2241": 261.20611572265625,
                    "2242": 717.7633056640625,
                    "2243": 263.4701232910156,
                    "2244": 715.7925415039062,
                    "2245": 262.9473876953125,
                    "2246": 716.0899658203125,
                    "2247": 260.6882019042969,
                    "2248": 718.0728759765625,
                    "2249": 260.9492492675781,
                    "2250": 715.7925415039062,
                    "2251": 262.9473876953125,
                    "2252": 718.0728759765625,
                    "2253": 260.9492492675781,
                    "2254": 717.7754516601562,
                    "2255": 263.20843505859375,
                    "2256": 715.8140258789062,
                    "2257": 262.6513671875,
                    "2258": 716.15087890625,
                    "2259": 260.3977355957031,
                    "2260": 718.12890625,
                    "2261": 260.6933288574219,
                    "2262": 715.8140258789062,
                    "2263": 262.6513671875,
                    "2264": 718.12890625,
                    "2265": 260.6933288574219,
                    "2266": 717.7921142578125,
                    "2267": 262.9469909667969,
                    "2268": 715.8407592773438,
                    "2269": 262.35577392578125,
                    "2270": 716.2168579101562,
                    "2271": 260.1083679199219,
                    "2272": 718.1893920898438,
                    "2273": 260.4384460449219,
                    "2274": 715.8407592773438,
                    "2275": 262.35577392578125,
                    "2276": 718.1893920898438,
                    "2277": 260.4384460449219,
                    "2278": 717.8132934570312,
                    "2279": 262.6858825683594,
                    "2280": 715.87255859375,
                    "2281": 262.0606994628906,
                    "2282": 716.287841796875,
                    "2283": 259.8201904296875,
                    "2284": 718.2543334960938,
                    "2285": 260.1846618652344,
                    "2286": 715.87255859375,
                    "2287": 262.0606994628906,
                    "2288": 718.2543334960938,
                    "2289": 260.1846618652344,
                    "2290": 717.839111328125,
                    "2291": 262.4251708984375,
                    "2292": 715.9095458984375,
                    "2293": 261.7662353515625,
                    "2294": 716.3638305664062,
                    "2295": 259.5332946777344,
                    "2296": 718.32373046875,
                    "2297": 259.9320373535156,
                    "2298": 715.9095458984375,
                    "2299": 261.7662353515625,
                    "2300": 718.32373046875,
                    "2301": 259.9320373535156,
                    "2302": 717.869384765625,
                    "2303": 262.16497802734375,
                    "2304": 715.95166015625,
                    "2305": 261.4724426269531,
                    "2306": 716.4448852539062,
                    "2307": 259.2477722167969,
                    "2308": 718.3974609375,
                    "2309": 259.6806335449219,
                    "2310": 715.95166015625,
                    "2311": 261.4724426269531,
                    "2312": 718.3974609375,
                    "2313": 259.6806335449219,
                    "2314": 717.904296875,
                    "2315": 261.9053039550781,
                    "2316": 715.9989013671875,
                    "2317": 261.179443359375,
                    "2318": 716.5308837890625,
                    "2319": 258.9637145996094,
                    "2320": 718.4755859375,
                    "2321": 259.43060302734375,
                    "2322": 715.9989013671875,
                    "2323": 261.179443359375,
                    "2324": 718.4755859375,
                    "2325": 259.43060302734375,
                    "2326": 717.9436645507812,
                    "2327": 261.6463317871094,
                    "2328": 716.05126953125,
                    "2329": 260.8872985839844,
                    "2330": 716.621826171875,
                    "2331": 258.6811828613281,
                    "2332": 718.55810546875,
                    "2333": 259.18194580078125,
                    "2334": 716.05126953125,
                    "2335": 260.8872985839844,
                    "2336": 718.55810546875,
                    "2337": 259.18194580078125,
                    "2338": 717.987548828125,
                    "2339": 261.3880615234375,
                    "2340": 716.1087036132812,
                    "2341": 260.5960998535156,
                    "2342": 716.7176513671875,
                    "2343": 258.4002990722656,
                    "2344": 718.6448974609375,
                    "2345": 258.9347839355469,
                    "2346": 716.1087036132812,
                    "2347": 260.5960998535156,
                    "2348": 718.6448974609375,
                    "2349": 258.9347839355469,
                    "2350": 718.0359497070312,
                    "2351": 261.1305847167969,
                    "2352": 716.1712036132812,
                    "2353": 260.30596923828125,
                    "2354": 716.818359375,
                    "2355": 258.1211242675781,
                    "2356": 718.7360229492188,
                    "2357": 258.68914794921875,
                    "2358": 716.1712036132812,
                    "2359": 260.30596923828125,
                    "2360": 718.7360229492188,
                    "2361": 258.68914794921875,
                    "2362": 718.0888671875,
                    "2363": 260.8739929199219,
                    "2364": 716.23876953125,
                    "2365": 260.0169677734375,
                    "2366": 716.9240112304688,
                    "2367": 257.84375,
                    "2368": 718.8314208984375,
                    "2369": 258.4451599121094,
                    "2370": 716.23876953125,
                    "2371": 260.0169677734375,
                    "2372": 718.8314208984375,
                    "2373": 258.4451599121094,
                    "2374": 718.1461791992188,
                    "2375": 260.6183776855469,
                    "2376": 716.3113403320312,
                    "2377": 259.72918701171875,
                    "2378": 717.034423828125,
                    "2379": 257.5682678222656,
                    "2380": 718.9310302734375,
                    "2381": 258.202880859375,
                    "2382": 716.3113403320312,
                    "2383": 259.72918701171875,
                    "2384": 718.9310302734375,
                    "2385": 258.202880859375,
                    "2386": 718.2080078125,
                    "2387": 260.3638000488281,
                    "2388": 716.3889770507812,
                    "2389": 259.4427185058594,
                    "2390": 717.1495971679688,
                    "2391": 257.29473876953125,
                    "2392": 719.034912109375,
                    "2393": 257.9623718261719,
                    "2394": 716.3889770507812,
                    "2395": 259.4427185058594,
                    "2396": 719.034912109375,
                    "2397": 257.9623718261719,
                    "2398": 718.2742309570312,
                    "2399": 260.1103515625,
                    "2400": 716.4715576171875,
                    "2401": 259.15765380859375,
                    "2402": 717.2695922851562,
                    "2403": 257.0232849121094,
                    "2404": 719.1429443359375,
                    "2405": 257.72369384765625,
                    "2406": 716.4715576171875,
                    "2407": 259.15765380859375,
                    "2408": 719.1429443359375,
                    "2409": 257.72369384765625,
                    "2410": 718.3449096679688,
                    "2411": 259.8580627441406,
                    "2412": 716.5591430664062,
                    "2413": 258.87408447265625,
                    "2414": 717.394287109375,
                    "2415": 256.7539367675781,
                    "2416": 719.255126953125,
                    "2417": 257.4869384765625,
                    "2418": 716.5591430664062,
                    "2419": 258.87408447265625,
                    "2420": 719.255126953125,
                    "2421": 257.4869384765625,
                    "2422": 718.4199829101562,
                    "2423": 259.6070861816406,
                    "2424": 716.651611328125,
                    "2425": 258.5920715332031,
                    "2426": 717.5236206054688,
                    "2427": 256.4868469238281,
                    "2428": 719.3713989257812,
                    "2429": 257.252197265625,
                    "2430": 716.651611328125,
                    "2431": 258.5920715332031,
                    "2432": 719.3713989257812,
                    "2433": 257.252197265625,
                    "2434": 718.4993896484375,
                    "2435": 259.357421875,
                    "2436": 716.7490234375,
                    "2437": 258.31170654296875,
                    "2438": 717.6576538085938,
                    "2439": 256.2220153808594,
                    "2440": 719.4917602539062,
                    "2441": 257.01953125,
                    "2442": 716.7490234375,
                    "2443": 258.31170654296875,
                    "2444": 719.4917602539062,
                    "2445": 257.01953125,
                    "2446": 718.5831298828125,
                    "2447": 259.1092224121094,
                    "2448": 716.851318359375,
                    "2449": 258.0331115722656,
                    "2450": 717.7962646484375,
                    "2451": 255.95957946777344,
                    "2452": 719.6161499023438,
                    "2453": 256.7889709472656,
                    "2454": 716.851318359375,
                    "2455": 258.0331115722656,
                    "2456": 719.6161499023438,
                    "2457": 256.7889709472656,
                    "2458": 718.6712036132812,
                    "2459": 258.86248779296875,
                    "2460": 716.9584350585938,
                    "2461": 257.7563171386719,
                    "2462": 717.939453125,
                    "2463": 255.69960021972656,
                    "2464": 719.7445678710938,
                    "2465": 256.5606384277344,
                    "2466": 716.9584350585938,
                    "2467": 257.7563171386719,
                    "2468": 719.7445678710938,
                    "2469": 256.5606384277344,
                    "2470": 718.7636108398438,
                    "2471": 258.6173400878906,
                    "2472": 717.0703735351562,
                    "2473": 257.4814453125,
                    "2474": 718.0870971679688,
                    "2475": 255.44216918945312,
                    "2476": 719.876953125,
                    "2477": 256.3345642089844,
                    "2478": 717.0703735351562,
                    "2479": 257.4814453125,
                    "2480": 719.876953125,
                    "2481": 256.3345642089844,
                    "2482": 718.8602294921875,
                    "2483": 258.37384033203125,
                    "2484": 717.1870727539062,
                    "2485": 257.20855712890625,
                    "2486": 718.2392578125,
                    "2487": 255.18734741210938,
                    "2488": 720.0133056640625,
                    "2489": 256.11083984375,
                    "2490": 717.1870727539062,
                    "2491": 257.20855712890625,
                    "2492": 720.0133056640625,
                    "2493": 256.11083984375,
                    "2494": 718.9611206054688,
                    "2495": 258.1320495605469,
                    "2496": 717.3085327148438,
                    "2497": 256.9377746582031,
                    "2498": 718.3958740234375,
                    "2499": 254.93521118164062,
                    "2500": 720.1535034179688,
                    "2501": 255.88954162597656,
                    "2502": 717.3085327148438,
                    "2503": 256.9377746582031,
                    "2504": 720.1535034179688,
                    "2505": 255.88954162597656,
                    "2506": 719.066162109375,
                    "2507": 257.89208984375,
                    "2508": 717.4347534179688,
                    "2509": 256.66912841796875,
                    "2510": 718.5568237304688,
                    "2511": 254.6858673095703,
                    "2512": 720.2974853515625,
                    "2513": 255.67071533203125,
                    "2514": 717.4347534179688,
                    "2515": 256.66912841796875,
                    "2516": 720.2974853515625,
                    "2517": 255.67071533203125,
                    "2518": 719.1754150390625,
                    "2519": 257.6539611816406,
                    "2520": 717.5655517578125,
                    "2521": 256.4027404785156,
                    "2522": 718.7221069335938,
                    "2523": 254.43934631347656,
                    "2524": 720.4453735351562,
                    "2525": 255.4544219970703,
                    "2526": 717.5655517578125,
                    "2527": 256.4027404785156,
                    "2528": 720.4453735351562,
                    "2529": 255.4544219970703,
                    "2530": 719.288818359375,
                    "2531": 257.4178161621094,
                    "2532": 717.7010498046875,
                    "2533": 256.138671875,
                    "2534": 718.8916625976562,
                    "2535": 254.19577026367188,
                    "2536": 720.596923828125,
                    "2537": 255.2407684326172,
                    "2538": 717.7010498046875,
                    "2539": 256.138671875,
                    "2540": 720.596923828125,
                    "2541": 255.2407684326172,
                    "2542": 719.4063110351562,
                    "2543": 257.18365478515625,
                    "2544": 717.8411254882812,
                    "2545": 255.8769989013672,
                    "2546": 719.0654296875,
                    "2547": 253.95516967773438,
                    "2548": 720.752197265625,
                    "2549": 255.02976989746094,
                    "2550": 717.8411254882812,
                    "2551": 255.8769989013672,
                    "2552": 720.752197265625,
                    "2553": 255.02976989746094,
                    "2554": 719.5278930664062,
                    "2555": 256.95159912109375,
                    "2556": 717.9857177734375,
                    "2557": 255.61781311035156,
                    "2558": 719.243408203125,
                    "2559": 253.7176513671875,
                    "2560": 720.9111328125,
                    "2561": 254.82151794433594,
                    "2562": 717.9857177734375,
                    "2563": 255.61781311035156,
                    "2564": 720.9111328125,
                    "2565": 254.82151794433594,
                    "2566": 719.6534423828125,
                    "2567": 256.7216796875,
                    "2568": 718.1348266601562,
                    "2569": 255.36119079589844,
                    "2570": 719.4254760742188,
                    "2571": 253.4832763671875,
                    "2572": 721.07373046875,
                    "2573": 254.6160888671875,
                    "2574": 718.1348266601562,
                    "2575": 255.36119079589844,
                    "2576": 721.07373046875,
                    "2577": 254.6160888671875,
                    "2578": 719.7830810546875,
                    "2579": 256.4940185546875,
                    "2580": 718.2883911132812,
                    "2581": 255.1072235107422,
                    "2582": 719.6116333007812,
                    "2583": 253.25210571289062,
                    "2584": 721.2398071289062,
                    "2585": 254.41351318359375,
                    "2586": 718.2883911132812,
                    "2587": 255.1072235107422,
                    "2588": 721.2398071289062,
                    "2589": 254.41351318359375,
                    "2590": 719.9166259765625,
                    "2591": 256.26861572265625,
                    "2592": 718.4463500976562,
                    "2593": 254.85595703125,
                    "2594": 719.8017578125,
                    "2595": 253.0242156982422,
                    "2596": 721.4094848632812,
                    "2597": 254.2138671875,
                    "2598": 718.4463500976562,
                    "2599": 254.85595703125,
                    "2600": 721.4094848632812,
                    "2601": 254.2138671875,
                    "2602": 720.0540771484375,
                    "2603": 256.04559326171875,
                    "2604": 718.608642578125,
                    "2605": 254.6074981689453,
                    "2606": 719.995849609375,
                    "2607": 252.79969787597656,
                    "2608": 721.5825805664062,
                    "2609": 254.0172119140625,
                    "2610": 718.608642578125,
                    "2611": 254.6074981689453,
                    "2612": 721.5825805664062,
                    "2613": 254.0172119140625,
                    "2614": 720.1953735351562,
                    "2615": 255.82501220703125,
                    "2616": 718.7753295898438,
                    "2617": 254.36190795898438,
                    "2618": 720.19384765625,
                    "2619": 252.57858276367188,
                    "2620": 721.759033203125,
                    "2621": 253.8236083984375,
                    "2622": 718.7753295898438,
                    "2623": 254.36190795898438,
                    "2624": 721.759033203125,
                    "2625": 253.8236083984375,
                    "2626": 720.3405151367188,
                    "2627": 255.60693359375,
                    "2628": 718.9462280273438,
                    "2629": 254.11924743652344,
                    "2630": 720.3956298828125,
                    "2631": 252.3609619140625,
                    "2632": 721.9389038085938,
                    "2633": 253.63311767578125,
                    "2634": 718.9462280273438,
                    "2635": 254.11924743652344,
                    "2636": 721.9389038085938,
                    "2637": 253.63311767578125,
                    "2638": 720.4894409179688,
                    "2639": 255.39141845703125,
                    "2640": 719.121337890625,
                    "2641": 253.87962341308594,
                    "2642": 720.6011962890625,
                    "2643": 252.1468963623047,
                    "2644": 722.1220092773438,
                    "2645": 253.44580078125,
                    "2646": 719.121337890625,
                    "2647": 253.87962341308594,
                    "2648": 722.1220092773438,
                    "2649": 253.44580078125,
                    "2650": 720.6421508789062,
                    "2651": 255.17852783203125,
                    "2652": 719.3005981445312,
                    "2653": 253.64309692382812,
                    "2654": 720.8104858398438,
                    "2655": 251.93646240234375,
                    "2656": 722.3084106445312,
                    "2657": 253.26170349121094,
                    "2658": 719.3005981445312,
                    "2659": 253.64309692382812,
                    "2660": 722.3084106445312,
                    "2661": 253.26170349121094,
                    "2662": 720.7985229492188,
                    "2663": 254.9683380126953,
                    "2664": 719.4839477539062,
                    "2665": 253.40972900390625,
                    "2666": 721.0234375,
                    "2667": 251.72970581054688,
                    "2668": 722.4979858398438,
                    "2669": 253.0808868408203,
                    "2670": 719.4839477539062,
                    "2671": 253.40972900390625,
                    "2672": 722.4979858398438,
                    "2673": 253.0808868408203,
                    "2674": 720.95849609375,
                    "2675": 254.7609100341797,
                    "2676": 719.67138671875,
                    "2677": 253.17959594726562,
                    "2678": 721.2399291992188,
                    "2679": 251.5266876220703,
                    "2680": 722.690673828125,
                    "2681": 252.9033966064453,
                    "2682": 719.67138671875,
                    "2683": 253.17959594726562,
                    "2684": 722.690673828125,
                    "2685": 252.9033966064453,
                    "2686": 721.1221313476562,
                    "2687": 254.55630493164062,
                    "2688": 719.86279296875,
                    "2689": 252.9527587890625,
                    "2690": 721.4599609375,
                    "2691": 251.32748413085938,
                    "2692": 722.8864135742188,
                    "2693": 252.72930908203125,
                    "2694": 719.86279296875,
                    "2695": 252.9527587890625,
                    "2696": 722.8864135742188,
                    "2697": 252.72930908203125,
                    "2698": 721.289306640625,
                    "2699": 254.35458374023438,
                    "2700": 720.05810546875,
                    "2701": 252.72930908203125,
                    "2702": 721.6834106445312,
                    "2703": 251.1321563720703,
                    "2704": 723.085205078125,
                    "2705": 252.55865478515625,
                    "2706": 720.05810546875,
                    "2707": 252.72930908203125,
                    "2708": 723.085205078125,
                    "2709": 252.55865478515625,
                    "2710": 721.4599609375,
                    "2711": 254.1558074951172,
                    "2712": 720.25732421875,
                    "2713": 252.50929260253906,
                    "2714": 721.9102172851562,
                    "2715": 250.9407501220703,
                    "2716": 723.2869262695312,
                    "2717": 252.39151000976562,
                    "2718": 720.25732421875,
                    "2719": 252.50929260253906,
                    "2720": 723.2869262695312,
                    "2721": 252.39151000976562,
                    "2722": 721.634033203125,
                    "2723": 253.96005249023438,
                    "2724": 720.4603271484375,
                    "2725": 252.2928009033203,
                    "2726": 722.140380859375,
                    "2727": 250.7533416748047,
                    "2728": 723.4915161132812,
                    "2729": 252.22789001464844,
                    "2730": 720.4603271484375,
                    "2731": 252.2928009033203,
                    "2732": 723.4915161132812,
                    "2733": 252.22789001464844,
                    "2734": 721.8115234375,
                    "2735": 253.76734924316406,
                    "2736": 720.6671142578125,
                    "2737": 252.0798797607422,
                    "2738": 722.3737182617188,
                    "2739": 250.56997680664062,
                    "2740": 723.698974609375,
                    "2741": 252.06788635253906,
                    "2742": 720.6671142578125,
                    "2743": 252.0798797607422,
                    "2744": 723.698974609375,
                    "2745": 252.06788635253906,
                    "2746": 721.9923095703125,
                    "2747": 253.57778930664062,
                    "2748": 720.8775024414062,
                    "2749": 251.87059020996094,
                    "2750": 722.6102294921875,
                    "2751": 250.3907012939453,
                    "2752": 723.9091796875,
                    "2753": 251.91151428222656,
                    "2754": 720.8775024414062,
                    "2755": 251.87059020996094,
                    "2756": 723.9091796875,
                    "2757": 251.91151428222656,
                    "2758": 722.1764526367188,
                    "2759": 253.3914031982422,
                    "2760": 721.0916137695312,
                    "2761": 251.66500854492188,
                    "2762": 722.8499145507812,
                    "2763": 250.21559143066406,
                    "2764": 724.1220703125,
                    "2765": 251.7588348388672,
                    "2766": 721.0916137695312,
                    "2767": 251.66500854492188,
                    "2768": 724.1220703125,
                    "2769": 251.7588348388672,
                    "2770": 722.36376953125,
                    "2771": 253.20826721191406,
                    "2772": 721.3092041015625,
                    "2773": 251.46319580078125,
                    "2774": 723.092529296875,
                    "2775": 250.04469299316406,
                    "2776": 724.3375854492188,
                    "2777": 251.6099090576172,
                    "2778": 721.3092041015625,
                    "2779": 251.46319580078125,
                    "2780": 724.3375854492188,
                    "2781": 251.6099090576172,
                    "2782": 722.5542602539062,
                    "2783": 253.02841186523438,
                    "2784": 721.5303344726562,
                    "2785": 251.2652130126953,
                    "2786": 723.338134765625,
                    "2787": 249.87803649902344,
                    "2788": 724.5556640625,
                    "2789": 251.46475219726562,
                    "2790": 721.5303344726562,
                    "2791": 251.2652130126953,
                    "2792": 724.5556640625,
                    "2793": 251.46475219726562,
                    "2794": 722.7478637695312,
                    "2795": 252.8519287109375,
                    "2796": 721.7548217773438,
                    "2797": 251.0711212158203,
                    "2798": 723.5866088867188,
                    "2799": 249.71571350097656,
                    "2800": 724.7762451171875,
                    "2801": 251.32342529296875,
                    "2802": 721.7548217773438,
                    "2803": 251.0711212158203,
                    "2804": 724.7762451171875,
                    "2805": 251.32342529296875,
                    "2806": 722.9445190429688,
                    "2807": 252.6788330078125,
                    "2808": 721.9827270507812,
                    "2809": 250.8809814453125,
                    "2810": 723.8378295898438,
                    "2811": 249.5577392578125,
                    "2812": 724.999267578125,
                    "2813": 251.18597412109375,
                    "2814": 721.9827270507812,
                    "2815": 250.8809814453125,
                    "2816": 724.999267578125,
                    "2817": 251.18597412109375,
                    "2818": 723.1441650390625,
                    "2819": 252.5092010498047,
                    "2820": 722.2139282226562,
                    "2821": 250.69483947753906,
                    "2822": 724.091796875,
                    "2823": 249.4041748046875,
                    "2824": 725.224609375,
                    "2825": 251.05242919921875,
                    "2826": 722.2139282226562,
                    "2827": 250.69483947753906,
                    "2828": 725.224609375,
                    "2829": 251.05242919921875,
                    "2830": 723.3467407226562,
                    "2831": 252.3430938720703,
                    "2832": 722.4483032226562,
                    "2833": 250.51275634765625,
                    "2834": 724.3484497070312,
                    "2835": 249.25506591796875,
                    "2836": 725.4523315429688,
                    "2837": 250.92283630371094,
                    "2838": 722.4483032226562,
                    "2839": 250.51275634765625,
                    "2840": 725.4523315429688,
                    "2841": 250.92283630371094,
                    "2842": 723.5521850585938,
                    "2843": 252.18052673339844,
                    "2844": 722.685791015625,
                    "2845": 250.33480834960938,
                    "2846": 724.6076049804688,
                    "2847": 249.1104736328125,
                    "2848": 725.6822509765625,
                    "2849": 250.79725646972656,
                    "2850": 722.685791015625,
                    "2851": 250.33480834960938,
                    "2852": 725.6822509765625,
                    "2853": 250.79725646972656,
                    "2854": 723.7603759765625,
                    "2855": 252.02159118652344,
                    "2856": 722.9263916015625,
                    "2857": 250.1610107421875,
                    "2858": 724.8692626953125,
                    "2859": 248.9704132080078,
                    "2860": 725.914306640625,
                    "2861": 250.67568969726562,
                    "2862": 722.9263916015625,
                    "2863": 250.1610107421875,
                    "2864": 725.914306640625,
                    "2865": 250.67568969726562,
                    "2866": 723.9713745117188,
                    "2867": 251.86630249023438,
                    "2868": 723.1699829101562,
                    "2869": 249.991455078125,
                    "2870": 725.1333618164062,
                    "2871": 248.83493041992188,
                    "2872": 726.1484375,
                    "2873": 250.55819702148438,
                    "2874": 723.1699829101562,
                    "2875": 249.991455078125,
                    "2876": 726.1484375,
                    "2877": 250.55819702148438,
                    "2878": 724.18505859375,
                    "2879": 251.71470642089844,
                    "2880": 723.41650390625,
                    "2881": 249.826171875,
                    "2882": 725.3997802734375,
                    "2883": 248.7041015625,
                    "2884": 726.3845825195312,
                    "2885": 250.44480895996094,
                    "2886": 723.41650390625,
                    "2887": 249.826171875,
                    "2888": 726.3845825195312,
                    "2889": 250.44480895996094,
                    "2890": 724.4013671875,
                    "2891": 251.56687927246094,
                    "2892": 723.6658325195312,
                    "2893": 249.66522216796875,
                    "2894": 725.6683959960938,
                    "2895": 248.5779266357422,
                    "2896": 726.6227416992188,
                    "2897": 250.33555603027344,
                    "2898": 723.6658325195312,
                    "2899": 249.66522216796875,
                    "2900": 726.6227416992188,
                    "2901": 250.33555603027344,
                    "2902": 724.6201782226562,
                    "2903": 251.4228515625,
                    "2904": 723.91796875,
                    "2905": 249.50863647460938,
                    "2906": 725.939208984375,
                    "2907": 248.45645141601562,
                    "2908": 726.8626708984375,
                    "2909": 250.23048400878906,
                    "2910": 723.91796875,
                    "2911": 249.50863647460938,
                    "2912": 726.8626708984375,
                    "2913": 250.23048400878906,
                    "2914": 724.8414916992188,
                    "2915": 251.28265380859375,
                    "2916": 724.1727905273438,
                    "2917": 249.35647583007812,
                    "2918": 726.2120971679688,
                    "2919": 248.33973693847656,
                    "2920": 727.1044921875,
                    "2921": 250.12960815429688,
                    "2922": 724.1727905273438,
                    "2923": 249.35647583007812,
                    "2924": 727.1044921875,
                    "2925": 250.12960815429688,
                    "2926": 725.065185546875,
                    "2927": 251.14634704589844,
                    "2928": 724.4302368164062,
                    "2929": 249.20880126953125,
                    "2930": 726.4869384765625,
                    "2931": 248.22779846191406,
                    "2932": 727.3479614257812,
                    "2933": 250.032958984375,
                    "2934": 724.4302368164062,
                    "2935": 249.20880126953125,
                    "2936": 727.3479614257812,
                    "2937": 250.032958984375,
                    "2938": 725.291259765625,
                    "2939": 251.0139617919922,
                    "2940": 724.690185546875,
                    "2941": 249.0656280517578,
                    "2942": 726.7637329101562,
                    "2943": 248.12066650390625,
                    "2944": 727.5931396484375,
                    "2945": 249.9405975341797,
                    "2946": 724.690185546875,
                    "2947": 249.0656280517578,
                    "2948": 727.5931396484375,
                    "2949": 249.9405975341797,
                    "2950": 725.5195922851562,
                    "2951": 250.8855438232422,
                    "2952": 724.95263671875,
                    "2953": 248.92701721191406,
                    "2954": 727.0423583984375,
                    "2955": 248.0183868408203,
                    "2956": 727.83984375,
                    "2957": 249.85250854492188,
                    "2958": 724.95263671875,
                    "2959": 248.92701721191406,
                    "2960": 727.83984375,
                    "2961": 249.85250854492188,
                    "2962": 725.7501220703125,
                    "2963": 250.76113891601562,
                    "2964": 725.2174682617188,
                    "2965": 248.79299926757812,
                    "2966": 727.3226928710938,
                    "2967": 247.92098999023438,
                    "2968": 728.0880737304688,
                    "2969": 249.7687530517578,
                    "2970": 725.2174682617188,
                    "2971": 248.79299926757812,
                    "2972": 728.0880737304688,
                    "2973": 249.7687530517578,
                    "2974": 725.9828491210938,
                    "2975": 250.64076232910156,
                    "2976": 725.4845581054688,
                    "2977": 248.66363525390625,
                    "2978": 727.604736328125,
                    "2979": 247.8284912109375,
                    "2980": 728.3377075195312,
                    "2981": 249.6893310546875,
                    "2982": 725.4845581054688,
                    "2983": 248.66363525390625,
                    "2984": 728.3377075195312,
                    "2985": 249.6893310546875,
                    "2986": 726.2175903320312,
                    "2987": 250.52447509765625,
                    "2988": 725.75390625,
                    "2989": 248.53895568847656,
                    "2990": 727.8883056640625,
                    "2991": 247.74093627929688,
                    "2992": 728.5886840820312,
                    "2993": 249.61428833007812,
                    "2994": 725.75390625,
                    "2995": 248.53895568847656,
                    "2996": 728.5886840820312,
                    "2997": 249.61428833007812,
                    "2998": 726.454345703125,
                    "2999": 250.41229248046875,
                    "3000": 726.025390625,
                    "3001": 248.41897583007812,
                    "3002": 728.17333984375,
                    "3003": 247.65834045410156,
                    "3004": 728.8409423828125,
                    "3005": 249.5436248779297,
                    "3006": 726.025390625,
                    "3007": 248.41897583007812,
                    "3008": 728.8409423828125,
                    "3009": 249.5436248779297,
                    "3010": 726.6929931640625,
                    "3011": 250.30426025390625,
                    "3012": 726.2988891601562,
                    "3013": 248.30377197265625,
                    "3014": 728.4598388671875,
                    "3015": 247.5807342529297,
                    "3016": 729.0944213867188,
                    "3017": 249.47738647460938,
                    "3018": 726.2988891601562,
                    "3019": 248.30377197265625,
                    "3020": 729.0944213867188,
                    "3021": 249.47738647460938,
                    "3022": 726.9335327148438,
                    "3023": 250.20042419433594,
                    "3024": 726.5744018554688,
                    "3025": 248.193359375,
                    "3026": 728.7476196289062,
                    "3027": 247.5081329345703,
                    "3028": 729.3489990234375,
                    "3029": 249.4155731201172,
                    "3030": 726.5744018554688,
                    "3031": 248.193359375,
                    "3032": 729.3489990234375,
                    "3033": 249.4155731201172,
                    "3034": 727.17578125,
                    "3035": 250.1007843017578,
                    "3036": 726.8517456054688,
                    "3037": 248.08775329589844,
                    "3038": 729.03662109375,
                    "3039": 247.44058227539062,
                    "3040": 729.6046142578125,
                    "3041": 249.35821533203125,
                    "3042": 726.8517456054688,
                    "3043": 248.08775329589844,
                    "3044": 729.6046142578125,
                    "3045": 249.35821533203125,
                    "3046": 727.4197998046875,
                    "3047": 250.00540161132812,
                    "3048": 727.1309204101562,
                    "3049": 247.9870147705078,
                    "3050": 729.3267211914062,
                    "3051": 247.37806701660156,
                    "3052": 729.8612060546875,
                    "3053": 249.30532836914062,
                    "3054": 727.1309204101562,
                    "3055": 247.9870147705078,
                    "3056": 729.8612060546875,
                    "3057": 249.30532836914062,
                    "3058": 727.6654052734375,
                    "3059": 249.91427612304688,
                    "3060": 727.4118041992188,
                    "3061": 247.89117431640625,
                    "3062": 729.617919921875,
                    "3063": 247.3206329345703,
                    "3064": 730.11865234375,
                    "3065": 249.25692749023438,
                    "3066": 727.4118041992188,
                    "3067": 247.89117431640625,
                    "3068": 730.11865234375,
                    "3069": 249.25692749023438,
                    "3070": 727.91259765625,
                    "3071": 249.8274688720703,
                    "3072": 727.6943359375,
                    "3073": 247.80023193359375,
                    "3074": 729.9100341796875,
                    "3075": 247.26828002929688,
                    "3076": 730.376953125,
                    "3077": 249.21302795410156,
                    "3078": 727.6943359375,
                    "3079": 247.80023193359375,
                    "3080": 730.376953125,
                    "3081": 249.21302795410156,
                    "3082": 728.1612548828125,
                    "3083": 249.74497985839844,
                    "3084": 727.9783935546875,
                    "3085": 247.71424865722656,
                    "3086": 730.2030639648438,
                    "3087": 247.22105407714844,
                    "3088": 730.6359252929688,
                    "3089": 249.17364501953125,
                    "3090": 727.9783935546875,
                    "3091": 247.71424865722656,
                    "3092": 730.6359252929688,
                    "3093": 249.17364501953125,
                    "3094": 728.4112548828125,
                    "3095": 249.66683959960938,
                    "3096": 728.263916015625,
                    "3097": 247.6332244873047,
                    "3098": 730.4968872070312,
                    "3099": 247.17892456054688,
                    "3100": 730.8955688476562,
                    "3101": 249.13877868652344,
                    "3102": 728.263916015625,
                    "3103": 247.6332244873047,
                    "3104": 730.8955688476562,
                    "3105": 249.13877868652344,
                    "3106": 728.6626586914062,
                    "3107": 249.59307861328125,
                    "3108": 728.55078125,
                    "3109": 247.5572052001953,
                    "3110": 730.7913208007812,
                    "3111": 247.14195251464844,
                    "3112": 731.1558227539062,
                    "3113": 249.10845947265625,
                    "3114": 728.55078125,
                    "3115": 247.5572052001953,
                    "3116": 731.1558227539062,
                    "3117": 249.10845947265625,
                    "3118": 728.915283203125,
                    "3119": 249.52371215820312,
                    "3120": 728.8389892578125,
                    "3121": 247.4862060546875,
                    "3122": 731.08642578125,
                    "3123": 247.110107421875,
                    "3124": 731.41650390625,
                    "3125": 249.0826873779297,
                    "3126": 728.8389892578125,
                    "3127": 247.4862060546875,
                    "3128": 731.41650390625,
                    "3129": 249.0826873779297,
                    "3130": 729.1690673828125,
                    "3131": 249.45877075195312,
                    "3132": 729.1283569335938,
                    "3133": 247.4202423095703,
                    "3134": 731.3820190429688,
                    "3135": 247.0834197998047,
                    "3136": 731.6776123046875,
                    "3137": 249.06146240234375,
                    "3138": 729.1283569335938,
                    "3139": 247.4202423095703,
                    "3140": 731.6776123046875,
                    "3141": 249.06146240234375,
                    "3142": 729.4239501953125,
                    "3143": 249.3982696533203,
                    "3144": 729.4188232421875,
                    "3145": 247.3593292236328,
                    "3146": 731.6780395507812,
                    "3147": 247.06190490722656,
                    "3148": 731.9390869140625,
                    "3149": 249.0447998046875,
                    "3150": 729.4188232421875,
                    "3151": 247.3593292236328,
                    "3152": 731.9390869140625,
                    "3153": 249.0447998046875,
                    "3154": 729.6798706054688,
                    "3155": 249.34222412109375,
                    "3156": 729.7103271484375,
                    "3157": 247.3035125732422,
                    "3158": 731.974365234375,
                    "3159": 247.04554748535156,
                    "3160": 732.2007446289062,
                    "3161": 249.03269958496094,
                    "3162": 729.7103271484375,
                    "3163": 247.3035125732422,
                    "3164": 732.2007446289062,
                    "3165": 249.03269958496094,
                    "3166": 729.9367065429688,
                    "3167": 249.2906494140625,
                    "3168": 730.0027465820312,
                    "3169": 247.25277709960938,
                    "3170": 732.2709350585938,
                    "3171": 247.0343780517578,
                    "3172": 732.462646484375,
                    "3173": 249.02516174316406,
                    "3174": 730.0027465820312,
                    "3175": 247.25277709960938,
                    "3176": 732.462646484375,
                    "3177": 249.02516174316406,
                    "3178": 730.1944580078125,
                    "3179": 249.2435760498047,
                    "3180": 730.2960205078125,
                    "3181": 247.2071533203125,
                    "3182": 732.5676879882812,
                    "3183": 247.02838134765625,
                    "3184": 732.724609375,
                    "3185": 249.02220153808594,
                    "3186": 730.2960205078125,
                    "3187": 247.2071533203125,
                    "3188": 732.724609375,
                    "3189": 249.02220153808594,
                    "3190": 730.4529418945312,
                    "3191": 249.20098876953125,
                    "3192": 730.5900268554688,
                    "3193": 247.1666717529297,
                    "3194": 732.8644409179688,
                    "3195": 247.02755737304688,
                    "3196": 732.986572265625,
                    "3197": 249.02381896972656,
                    "3198": 730.5900268554688,
                    "3199": 247.1666717529297,
                    "3200": 732.986572265625,
                    "3201": 249.02381896972656,
                    "3202": 730.712158203125,
                    "3203": 249.16293334960938,
                    "3204": 730.8847045898438,
                    "3205": 247.1313018798828,
                    "3206": 733.1612548828125,
                    "3207": 247.03192138671875,
                    "3208": 733.2484741210938,
                    "3209": 249.03001403808594,
                    "3210": 730.8847045898438,
                    "3211": 247.1313018798828,
                    "3212": 733.2484741210938,
                    "3213": 249.03001403808594,
                    "3214": 730.971923828125,
                    "3215": 249.12940979003906,
                    "3216": 731.1799926757812,
                    "3217": 247.10110473632812,
                    "3218": 733.4578857421875,
                    "3219": 247.0414581298828,
                    "3220": 733.5101928710938,
                    "3221": 249.040771484375,
                    "3222": 731.1799926757812,
                    "3223": 247.10110473632812,
                    "3224": 733.5101928710938,
                    "3225": 249.040771484375,
                    "3226": 731.2322998046875,
                    "3227": 249.1004180908203,
                    "3228": 731.4757080078125,
                    "3229": 247.0760498046875,
                    "3230": 733.7542724609375,
                    "3231": 247.05616760253906,
                    "3232": 733.771728515625,
                    "3233": 249.05609130859375,
                    "3234": 731.4757080078125,
                    "3235": 247.0760498046875,
                    "3236": 733.771728515625,
                    "3237": 249.05609130859375,
                    "3238": 731.4931640625,
                    "3239": 249.0759735107422,
                    "3240": 731.7718505859375,
                    "3241": 247.05616760253906,
                    "3242": 734.0504150390625,
                    "3243": 247.0760498046875,
                    "3244": 734.032958984375,
                    "3245": 249.0759735107422,
                    "3246": 731.7718505859375,
                    "3247": 247.05616760253906,
                    "3248": 734.032958984375,
                    "3249": 249.0759735107422,
                    "3250": 731.75439453125,
                    "3251": 249.05609130859375,
                    "3252": 732.0682373046875,
                    "3253": 247.0414581298828,
                    "3254": 734.3461303710938,
                    "3255": 247.10110473632812,
                    "3256": 734.2938232421875,
                    "3257": 249.1004180908203,
                    "3258": 732.0682373046875,
                    "3259": 247.0414581298828,
                    "3260": 734.2938232421875,
                    "3261": 249.1004180908203,
                    "3262": 732.015869140625,
                    "3263": 249.040771484375,
                    "3264": 732.3648681640625,
                    "3265": 247.03192138671875,
                    "3266": 734.6414184570312,
                    "3267": 247.1313018798828,
                    "3268": 734.5541381835938,
                    "3269": 249.12940979003906,
                    "3270": 732.3648681640625,
                    "3271": 247.03192138671875,
                    "3272": 734.5541381835938,
                    "3273": 249.12940979003906,
                    "3274": 732.2776489257812,
                    "3275": 249.03001403808594,
                    "3276": 732.66162109375,
                    "3277": 247.02755737304688,
                    "3278": 734.9360961914062,
                    "3279": 247.1666717529297,
                    "3280": 734.81396484375,
                    "3281": 249.16293334960938,
                    "3282": 732.66162109375,
                    "3283": 247.02755737304688,
                    "3284": 734.81396484375,
                    "3285": 249.16293334960938,
                    "3286": 732.53955078125,
                    "3287": 249.02381896972656,
                    "3288": 732.9584350585938,
                    "3289": 247.02838134765625,
                    "3290": 735.2301025390625,
                    "3291": 247.2071533203125,
                    "3292": 735.0731811523438,
                    "3293": 249.20098876953125,
                    "3294": 732.9584350585938,
                    "3295": 247.02838134765625,
                    "3296": 735.0731811523438,
                    "3297": 249.20098876953125,
                    "3298": 732.801513671875,
                    "3299": 249.02220153808594,
                    "3300": 733.2551879882812,
                    "3301": 247.0343780517578,
                    "3302": 735.5233764648438,
                    "3303": 247.25277709960938,
                    "3304": 735.3316650390625,
                    "3305": 249.2435760498047,
                    "3306": 733.2551879882812,
                    "3307": 247.0343780517578,
                    "3308": 735.3316650390625,
                    "3309": 249.2435760498047,
                    "3310": 733.0634765625,
                    "3311": 249.02516174316406,
                    "3312": 733.5517578125,
                    "3313": 247.04554748535156,
                    "3314": 735.8157958984375,
                    "3315": 247.3035125732422,
                    "3316": 735.58935546875,
                    "3317": 249.2906494140625,
                    "3318": 733.5517578125,
                    "3319": 247.04554748535156,
                    "3320": 735.58935546875,
                    "3321": 249.2906494140625,
                    "3322": 733.3253173828125,
                    "3323": 249.03269958496094,
                    "3324": 733.8480834960938,
                    "3325": 247.06190490722656,
                    "3326": 736.1072998046875,
                    "3327": 247.3593292236328,
                    "3328": 735.8462524414062,
                    "3329": 249.34222412109375,
                    "3330": 733.8480834960938,
                    "3331": 247.06190490722656,
                    "3332": 735.8462524414062,
                    "3333": 249.34222412109375,
                    "3334": 733.5870361328125,
                    "3335": 249.0447998046875,
                    "3336": 734.1441040039062,
                    "3337": 247.0834197998047,
                    "3338": 736.3977661132812,
                    "3339": 247.4202423095703,
                    "3340": 736.1021118164062,
                    "3341": 249.3982696533203,
                    "3342": 734.1441040039062,
                    "3343": 247.0834197998047,
                    "3344": 736.1021118164062,
                    "3345": 249.3982696533203,
                    "3346": 733.8485107421875,
                    "3347": 249.06146240234375,
                    "3348": 734.439697265625,
                    "3349": 247.110107421875,
                    "3350": 736.6871337890625,
                    "3351": 247.4862060546875,
                    "3352": 736.3570556640625,
                    "3353": 249.45877075195312,
                    "3354": 734.439697265625,
                    "3355": 247.110107421875,
                    "3356": 736.3570556640625,
                    "3357": 249.45877075195312,
                    "3358": 734.109619140625,
                    "3359": 249.0826873779297,
                    "3360": 734.7348022460938,
                    "3361": 247.14195251464844,
                    "3362": 736.9752807617188,
                    "3363": 247.5572052001953,
                    "3364": 736.61083984375,
                    "3365": 249.52371215820312,
                    "3366": 734.7348022460938,
                    "3367": 247.14195251464844,
                    "3368": 736.61083984375,
                    "3369": 249.52371215820312,
                    "3370": 734.3703002929688,
                    "3371": 249.10845947265625,
                    "3372": 735.0292358398438,
                    "3373": 247.17892456054688,
                    "3374": 737.26220703125,
                    "3375": 247.6332244873047,
                    "3376": 736.8634643554688,
                    "3377": 249.59307861328125,
                    "3378": 735.0292358398438,
                    "3379": 247.17892456054688,
                    "3380": 736.8634643554688,
                    "3381": 249.59307861328125,
                    "3382": 734.6304931640625,
                    "3383": 249.13877868652344,
                    "3384": 735.3230590820312,
                    "3385": 247.22105407714844,
                    "3386": 737.5477294921875,
                    "3387": 247.71424865722656,
                    "3388": 737.1148071289062,
                    "3389": 249.66683959960938,
                    "3390": 735.3230590820312,
                    "3391": 247.22105407714844,
                    "3392": 737.1148071289062,
                    "3393": 249.66683959960938,
                    "3394": 734.89013671875,
                    "3395": 249.17364501953125,
                    "3396": 735.6160278320312,
                    "3397": 247.26828002929688,
                    "3398": 737.831787109375,
                    "3399": 247.80023193359375,
                    "3400": 737.3648681640625,
                    "3401": 249.74497985839844,
                    "3402": 735.6160278320312,
                    "3403": 247.26828002929688,
                    "3404": 737.3648681640625,
                    "3405": 249.74497985839844,
                    "3406": 735.149169921875,
                    "3407": 249.21302795410156,
                    "3408": 735.908203125,
                    "3409": 247.3206329345703,
                    "3410": 738.1143188476562,
                    "3411": 247.89117431640625,
                    "3412": 737.613525390625,
                    "3413": 249.8274688720703,
                    "3414": 735.908203125,
                    "3415": 247.3206329345703,
                    "3416": 737.613525390625,
                    "3417": 249.8274688720703,
                    "3418": 735.4074096679688,
                    "3419": 249.25692749023438,
                    "3420": 736.1994018554688,
                    "3421": 247.37806701660156,
                    "3422": 738.3952026367188,
                    "3423": 247.9870147705078,
                    "3424": 737.8607177734375,
                    "3425": 249.91427612304688,
                    "3426": 736.1994018554688,
                    "3427": 247.37806701660156,
                    "3428": 737.8607177734375,
                    "3429": 249.91427612304688,
                    "3430": 735.6649169921875,
                    "3431": 249.30532836914062,
                    "3432": 736.489501953125,
                    "3433": 247.44058227539062,
                    "3434": 738.6743774414062,
                    "3435": 248.08775329589844,
                    "3436": 738.1063232421875,
                    "3437": 250.00540161132812,
                    "3438": 736.489501953125,
                    "3439": 247.44058227539062,
                    "3440": 738.1063232421875,
                    "3441": 250.00540161132812,
                    "3442": 735.9215087890625,
                    "3443": 249.35821533203125,
                    "3444": 736.7785034179688,
                    "3445": 247.5081329345703,
                    "3446": 738.9517211914062,
                    "3447": 248.193359375,
                    "3448": 738.350341796875,
                    "3449": 250.1007843017578,
                    "3450": 736.7785034179688,
                    "3451": 247.5081329345703,
                    "3452": 738.350341796875,
                    "3453": 250.1007843017578,
                    "3454": 736.1771240234375,
                    "3455": 249.4155731201172,
                    "3456": 737.0662841796875,
                    "3457": 247.5807342529297,
                    "3458": 739.2272338867188,
                    "3459": 248.30377197265625,
                    "3460": 738.5925903320312,
                    "3461": 250.20042419433594,
                    "3462": 737.0662841796875,
                    "3463": 247.5807342529297,
                    "3464": 738.5925903320312,
                    "3465": 250.20042419433594,
                    "3466": 736.4317016601562,
                    "3467": 249.47738647460938,
                    "3468": 737.352783203125,
                    "3469": 247.65834045410156,
                    "3470": 739.500732421875,
                    "3471": 248.41897583007812,
                    "3472": 738.8331298828125,
                    "3473": 250.30426025390625,
                    "3474": 737.352783203125,
                    "3475": 247.65834045410156,
                    "3476": 738.8331298828125,
                    "3477": 250.30426025390625,
                    "3478": 736.6851196289062,
                    "3479": 249.5436248779297,
                    "3480": 737.6378173828125,
                    "3481": 247.74093627929688,
                    "3482": 739.772216796875,
                    "3483": 248.53895568847656,
                    "3484": 739.07177734375,
                    "3485": 250.41229248046875,
                    "3486": 737.6378173828125,
                    "3487": 247.74093627929688,
                    "3488": 739.07177734375,
                    "3489": 250.41229248046875,
                    "3490": 736.9374389648438,
                    "3491": 249.61428833007812,
                    "3492": 737.92138671875,
                    "3493": 247.8284912109375,
                    "3494": 740.04150390625,
                    "3495": 248.66363525390625,
                    "3496": 739.3085327148438,
                    "3497": 250.52447509765625,
                    "3498": 737.92138671875,
                    "3499": 247.8284912109375,
                    "3500": 739.3085327148438,
                    "3501": 250.52447509765625,
                    "3502": 737.1884155273438,
                    "3503": 249.6893310546875,
                    "3504": 738.2034301757812,
                    "3505": 247.92098999023438,
                    "3506": 740.3086547851562,
                    "3507": 248.79299926757812,
                    "3508": 739.5432739257812,
                    "3509": 250.64076232910156,
                    "3510": 738.2034301757812,
                    "3511": 247.92098999023438,
                    "3512": 739.5432739257812,
                    "3513": 250.64076232910156,
                    "3514": 737.4380493164062,
                    "3515": 249.7687530517578,
                    "3516": 738.4837646484375,
                    "3517": 248.0183868408203,
                    "3518": 740.573486328125,
                    "3519": 248.92701721191406,
                    "3520": 739.7759399414062,
                    "3521": 250.76113891601562,
                    "3522": 738.4837646484375,
                    "3523": 248.0183868408203,
                    "3524": 739.7759399414062,
                    "3525": 250.76113891601562,
                    "3526": 737.686279296875,
                    "3527": 249.85250854492188,
                    "3528": 738.7623901367188,
                    "3529": 248.12066650390625,
                    "3530": 740.8358764648438,
                    "3531": 249.0656280517578,
                    "3532": 740.0065307617188,
                    "3533": 250.8855438232422,
                    "3534": 738.7623901367188,
                    "3535": 248.12066650390625,
                    "3536": 740.0065307617188,
                    "3537": 250.8855438232422,
                    "3538": 737.9329833984375,
                    "3539": 249.9405975341797,
                    "3540": 739.0391845703125,
                    "3541": 248.22779846191406,
                    "3542": 741.0958862304688,
                    "3543": 249.20880126953125,
                    "3544": 740.23486328125,
                    "3545": 251.0139617919922,
                    "3546": 739.0391845703125,
                    "3547": 248.22779846191406,
                    "3548": 740.23486328125,
                    "3549": 251.0139617919922,
                    "3550": 738.1781616210938,
                    "3551": 250.032958984375,
                    "3552": 739.3140258789062,
                    "3553": 248.33973693847656,
                    "3554": 741.3533325195312,
                    "3555": 249.35647583007812,
                    "3556": 740.4609375,
                    "3557": 251.14634704589844,
                    "3558": 739.3140258789062,
                    "3559": 248.33973693847656,
                    "3560": 740.4609375,
                    "3561": 251.14634704589844,
                    "3562": 738.421630859375,
                    "3563": 250.12960815429688,
                    "3564": 739.5869140625,
                    "3565": 248.45645141601562,
                    "3566": 741.608154296875,
                    "3567": 249.50863647460938,
                    "3568": 740.6846313476562,
                    "3569": 251.28265380859375,
                    "3570": 739.5869140625,
                    "3571": 248.45645141601562,
                    "3572": 740.6846313476562,
                    "3573": 251.28265380859375,
                    "3574": 738.6634521484375,
                    "3575": 250.23048400878906,
                    "3576": 739.8577270507812,
                    "3577": 248.5779266357422,
                    "3578": 741.8602905273438,
                    "3579": 249.66522216796875,
                    "3580": 740.9059448242188,
                    "3581": 251.4228515625,
                    "3582": 739.8577270507812,
                    "3583": 248.5779266357422,
                    "3584": 740.9059448242188,
                    "3585": 251.4228515625,
                    "3586": 738.9033813476562,
                    "3587": 250.33555603027344,
                    "3588": 740.1263427734375,
                    "3589": 248.7041015625,
                    "3590": 742.109619140625,
                    "3591": 249.826171875,
                    "3592": 741.124755859375,
                    "3593": 251.56687927246094,
                    "3594": 740.1263427734375,
                    "3595": 248.7041015625,
                    "3596": 741.124755859375,
                    "3597": 251.56687927246094,
                    "3598": 739.1415405273438,
                    "3599": 250.44480895996094,
                    "3600": 740.3927612304688,
                    "3601": 248.83493041992188,
                    "3602": 742.3561401367188,
                    "3603": 249.991455078125,
                    "3604": 741.341064453125,
                    "3605": 251.71470642089844,
                    "3606": 740.3927612304688,
                    "3607": 248.83493041992188,
                    "3608": 741.341064453125,
                    "3609": 251.71470642089844,
                    "3610": 739.377685546875,
                    "3611": 250.55819702148438,
                    "3612": 740.6567993164062,
                    "3613": 248.9704132080078,
                    "3614": 742.5997314453125,
                    "3615": 250.1610107421875,
                    "3616": 741.5547485351562,
                    "3617": 251.86630249023438,
                    "3618": 740.6567993164062,
                    "3619": 248.9704132080078,
                    "3620": 741.5547485351562,
                    "3621": 251.86630249023438,
                    "3622": 739.61181640625,
                    "3623": 250.67568969726562,
                    "3624": 740.9185180664062,
                    "3625": 249.1104736328125,
                    "3626": 742.84033203125,
                    "3627": 250.33480834960938,
                    "3628": 741.7656860351562,
                    "3629": 252.02159118652344,
                    "3630": 740.9185180664062,
                    "3631": 249.1104736328125,
                    "3632": 741.7656860351562,
                    "3633": 252.02159118652344,
                    "3634": 739.8438720703125,
                    "3635": 250.79725646972656,
                    "3636": 741.1776733398438,
                    "3637": 249.25506591796875,
                    "3638": 743.0778198242188,
                    "3639": 250.51275634765625,
                    "3640": 741.9739379882812,
                    "3641": 252.18052673339844,
                    "3642": 741.1776733398438,
                    "3643": 249.25506591796875,
                    "3644": 741.9739379882812,
                    "3645": 252.18052673339844,
                    "3646": 740.0737915039062,
                    "3647": 250.92283630371094,
                    "3648": 741.4342651367188,
                    "3649": 249.4041748046875,
                    "3650": 743.3121948242188,
                    "3651": 250.69483947753906,
                    "3652": 742.1793823242188,
                    "3653": 252.3430938720703,
                    "3654": 741.4342651367188,
                    "3655": 249.4041748046875,
                    "3656": 742.1793823242188,
                    "3657": 252.3430938720703,
                    "3658": 740.3014526367188,
                    "3659": 251.05242919921875,
                    "3660": 741.6882934570312,
                    "3661": 249.5577392578125,
                    "3662": 743.5433959960938,
                    "3663": 250.8809814453125,
                    "3664": 742.3819580078125,
                    "3665": 252.5092010498047,
                    "3666": 741.6882934570312,
                    "3667": 249.5577392578125,
                    "3668": 742.3819580078125,
                    "3669": 252.5092010498047,
                    "3670": 740.52685546875,
                    "3671": 251.18597412109375,
                    "3672": 741.9395141601562,
                    "3673": 249.71571350097656,
                    "3674": 743.771240234375,
                    "3675": 251.0711212158203,
                    "3676": 742.5816040039062,
                    "3677": 252.6788330078125,
                    "3678": 741.9395141601562,
                    "3679": 249.71571350097656,
                    "3680": 742.5816040039062,
                    "3681": 252.6788330078125,
                    "3682": 740.7498779296875,
                    "3683": 251.32342529296875,
                    "3684": 742.18798828125,
                    "3685": 249.87803649902344,
                    "3686": 743.9957885742188,
                    "3687": 251.2652130126953,
                    "3688": 742.7782592773438,
                    "3689": 252.8519287109375,
                    "3690": 742.18798828125,
                    "3691": 249.87803649902344,
                    "3692": 742.7782592773438,
                    "3693": 252.8519287109375,
                    "3694": 740.970458984375,
                    "3695": 251.46475219726562,
                    "3696": 742.43359375,
                    "3697": 250.04469299316406,
                    "3698": 744.2169189453125,
                    "3699": 251.46319580078125,
                    "3700": 742.9718627929688,
                    "3701": 253.02841186523438,
                    "3702": 742.43359375,
                    "3703": 250.04469299316406,
                    "3704": 742.9718627929688,
                    "3705": 253.02841186523438,
                    "3706": 741.1885375976562,
                    "3707": 251.6099090576172,
                    "3708": 742.6762084960938,
                    "3709": 250.21559143066406,
                    "3710": 744.4345092773438,
                    "3711": 251.66500854492188,
                    "3712": 743.162353515625,
                    "3713": 253.20826721191406,
                    "3714": 742.6762084960938,
                    "3715": 250.21559143066406,
                    "3716": 743.162353515625,
                    "3717": 253.20826721191406,
                    "3718": 741.404052734375,
                    "3719": 251.7588348388672,
                    "3720": 742.9158325195312,
                    "3721": 250.3907012939453,
                    "3722": 744.6485595703125,
                    "3723": 251.87059020996094,
                    "3724": 743.3496704101562,
                    "3725": 253.3914031982422,
                    "3726": 742.9158325195312,
                    "3727": 250.3907012939453,
                    "3728": 743.3496704101562,
                    "3729": 253.3914031982422,
                    "3730": 741.616943359375,
                    "3731": 251.91151428222656,
                    "3732": 743.1524047851562,
                    "3733": 250.56997680664062,
                    "3734": 744.8590087890625,
                    "3735": 252.0798797607422,
                    "3736": 743.5338134765625,
                    "3737": 253.57778930664062,
                    "3738": 743.1524047851562,
                    "3739": 250.56997680664062,
                    "3740": 743.5338134765625,
                    "3741": 253.57778930664062,
                    "3742": 741.8271484375,
                    "3743": 252.06788635253906,
                    "3744": 743.3857421875,
                    "3745": 250.7533416748047,
                    "3746": 745.0657958984375,
                    "3747": 252.2928009033203,
                    "3748": 743.714599609375,
                    "3749": 253.76734924316406,
                    "3750": 743.3857421875,
                    "3751": 250.7533416748047,
                    "3752": 743.714599609375,
                    "3753": 253.76734924316406,
                    "3754": 742.0346069335938,
                    "3755": 252.22789001464844,
                    "3756": 743.6159057617188,
                    "3757": 250.9407501220703,
                    "3758": 745.268798828125,
                    "3759": 252.50929260253906,
                    "3760": 743.89208984375,
                    "3761": 253.96005249023438,
                    "3762": 743.6159057617188,
                    "3763": 250.9407501220703,
                    "3764": 743.89208984375,
                    "3765": 253.96005249023438,
                    "3766": 742.2391967773438,
                    "3767": 252.39151000976562,
                    "3768": 743.8427124023438,
                    "3769": 251.1321563720703,
                    "3770": 745.468017578125,
                    "3771": 252.72930908203125,
                    "3772": 744.066162109375,
                    "3773": 254.1558074951172,
                    "3774": 743.8427124023438,
                    "3775": 251.1321563720703,
                    "3776": 744.066162109375,
                    "3777": 254.1558074951172,
                    "3778": 742.44091796875,
                    "3779": 252.55865478515625,
                    "3780": 744.066162109375,
                    "3781": 251.32748413085938,
                    "3782": 745.663330078125,
                    "3783": 252.9527587890625,
                    "3784": 744.23681640625,
                    "3785": 254.35458374023438,
                    "3786": 744.066162109375,
                    "3787": 251.32748413085938,
                    "3788": 744.23681640625,
                    "3789": 254.35458374023438,
                    "3790": 742.6396484375,
                    "3791": 252.72930908203125,
                    "3792": 744.2861938476562,
                    "3793": 251.5266876220703,
                    "3794": 745.854736328125,
                    "3795": 253.17959594726562,
                    "3796": 744.4039916992188,
                    "3797": 254.55630493164062,
                    "3798": 744.2861938476562,
                    "3799": 251.5266876220703,
                    "3800": 744.4039916992188,
                    "3801": 254.55630493164062,
                    "3802": 742.83544921875,
                    "3803": 252.9033966064453,
                    "3804": 744.502685546875,
                    "3805": 251.72970581054688,
                    "3806": 746.0421142578125,
                    "3807": 253.40972900390625,
                    "3808": 744.5675659179688,
                    "3809": 254.7609100341797,
                    "3810": 744.502685546875,
                    "3811": 251.72970581054688,
                    "3812": 744.5675659179688,
                    "3813": 254.7609100341797,
                    "3814": 743.0281372070312,
                    "3815": 253.0808868408203,
                    "3816": 744.7156372070312,
                    "3817": 251.93646240234375,
                    "3818": 746.2255249023438,
                    "3819": 253.64309692382812,
                    "3820": 744.7276000976562,
                    "3821": 254.9683380126953,
                    "3822": 744.7156372070312,
                    "3823": 251.93646240234375,
                    "3824": 744.7276000976562,
                    "3825": 254.9683380126953,
                    "3826": 743.2177124023438,
                    "3827": 253.26170349121094,
                    "3828": 744.9248657226562,
                    "3829": 252.1468963623047,
                    "3830": 746.40478515625,
                    "3831": 253.87962341308594,
                    "3832": 744.8839721679688,
                    "3833": 255.17852783203125,
                    "3834": 744.9248657226562,
                    "3835": 252.1468963623047,
                    "3836": 744.8839721679688,
                    "3837": 255.17852783203125,
                    "3838": 743.404052734375,
                    "3839": 253.44580078125,
                    "3840": 745.1304931640625,
                    "3841": 252.3609619140625,
                    "3842": 746.5798950195312,
                    "3843": 254.11924743652344,
                    "3844": 745.03662109375,
                    "3845": 255.39141845703125,
                    "3846": 745.1304931640625,
                    "3847": 252.3609619140625,
                    "3848": 745.03662109375,
                    "3849": 255.39141845703125,
                    "3850": 743.5872192382812,
                    "3851": 253.63311767578125,
                    "3852": 745.332275390625,
                    "3853": 252.57858276367188,
                    "3854": 746.7507934570312,
                    "3855": 254.36190795898438,
                    "3856": 745.1856079101562,
                    "3857": 255.60693359375,
                    "3858": 745.332275390625,
                    "3859": 252.57858276367188,
                    "3860": 745.1856079101562,
                    "3861": 255.60693359375,
                    "3862": 743.76708984375,
                    "3863": 253.8236083984375,
                    "3864": 745.5302734375,
                    "3865": 252.79969787597656,
                    "3866": 746.9174194335938,
                    "3867": 254.6074981689453,
                    "3868": 745.3307495117188,
                    "3869": 255.82501220703125,
                    "3870": 745.5302734375,
                    "3871": 252.79969787597656,
                    "3872": 745.3307495117188,
                    "3873": 255.82501220703125,
                    "3874": 743.9435424804688,
                    "3875": 254.0172119140625,
                    "3876": 745.724365234375,
                    "3877": 253.0242156982422,
                    "3878": 747.0797729492188,
                    "3879": 254.85595703125,
                    "3880": 745.4720458984375,
                    "3881": 256.04559326171875,
                    "3882": 745.724365234375,
                    "3883": 253.0242156982422,
                    "3884": 745.4720458984375,
                    "3885": 256.04559326171875,
                    "3886": 744.1166381835938,
                    "3887": 254.2138671875,
                    "3888": 745.9144897460938,
                    "3889": 253.25210571289062,
                    "3890": 747.2377319335938,
                    "3891": 255.1072235107422,
                    "3892": 745.6094970703125,
                    "3893": 256.26861572265625,
                    "3894": 745.9144897460938,
                    "3895": 253.25210571289062,
                    "3896": 745.6094970703125,
                    "3897": 256.26861572265625,
                    "3898": 744.2862548828125,
                    "3899": 254.41351318359375,
                    "3900": 746.1006469726562,
                    "3901": 253.4832763671875,
                    "3902": 747.3912963867188,
                    "3903": 255.36119079589844,
                    "3904": 745.7430419921875,
                    "3905": 256.4940185546875,
                    "3906": 746.1006469726562,
                    "3907": 253.4832763671875,
                    "3908": 745.7430419921875,
                    "3909": 256.4940185546875,
                    "3910": 744.452392578125,
                    "3911": 254.6160888671875,
                    "3912": 746.28271484375,
                    "3913": 253.7176513671875,
                    "3914": 747.5404052734375,
                    "3915": 255.61781311035156,
                    "3916": 745.8726196289062,
                    "3917": 256.7216796875,
                    "3918": 746.28271484375,
                    "3919": 253.7176513671875,
                    "3920": 745.8726196289062,
                    "3921": 256.7216796875,
                    "3922": 744.6149291992188,
                    "3923": 254.82151794433594,
                    "3924": 746.460693359375,
                    "3925": 253.95516967773438,
                    "3926": 747.6849975585938,
                    "3927": 255.8769989013672,
                    "3928": 745.9982299804688,
                    "3929": 256.95159912109375,
                    "3930": 746.460693359375,
                    "3931": 253.95516967773438,
                    "3932": 745.9982299804688,
                    "3933": 256.95159912109375,
                    "3934": 744.77392578125,
                    "3935": 255.02976989746094,
                    "3936": 746.6344604492188,
                    "3937": 254.19577026367188,
                    "3938": 747.8250732421875,
                    "3939": 256.138671875,
                    "3940": 746.1198120117188,
                    "3941": 257.18365478515625,
                    "3942": 746.6344604492188,
                    "3943": 254.19577026367188,
                    "3944": 746.1198120117188,
                    "3945": 257.18365478515625,
                    "3946": 744.92919921875,
                    "3947": 255.2407684326172,
                    "3948": 746.8040161132812,
                    "3949": 254.43934631347656,
                    "3950": 747.9605712890625,
                    "3951": 256.4027404785156,
                    "3952": 746.2373046875,
                    "3953": 257.4178161621094,
                    "3954": 746.8040161132812,
                    "3955": 254.43934631347656,
                    "3956": 746.2373046875,
                    "3957": 257.4178161621094,
                    "3958": 745.0807495117188,
                    "3959": 255.4544219970703,
                    "3960": 746.9692993164062,
                    "3961": 254.6858673095703,
                    "3962": 748.0913696289062,
                    "3963": 256.66912841796875,
                    "3964": 746.3507080078125,
                    "3965": 257.6539611816406,
                    "3966": 746.9692993164062,
                    "3967": 254.6858673095703,
                    "3968": 746.3507080078125,
                    "3969": 257.6539611816406,
                    "3970": 745.2285766601562,
                    "3971": 255.67071533203125,
                    "3972": 747.1302490234375,
                    "3973": 254.93521118164062,
                    "3974": 748.2175903320312,
                    "3975": 256.9377746582031,
                    "3976": 746.4598999023438,
                    "3977": 257.89208984375,
                    "3978": 747.1302490234375,
                    "3979": 254.93521118164062,
                    "3980": 746.4598999023438,
                    "3981": 257.89208984375,
                    "3982": 745.3726196289062,
                    "3983": 255.88954162597656,
                    "3984": 747.286865234375,
                    "3985": 255.18734741210938,
                    "3986": 748.3390502929688,
                    "3987": 257.20855712890625,
                    "3988": 746.5650024414062,
                    "3989": 258.1320495605469,
                    "3990": 747.286865234375,
                    "3991": 255.18734741210938,
                    "3992": 746.5650024414062,
                    "3993": 258.1320495605469,
                    "3994": 745.5128173828125,
                    "3995": 256.11083984375,
                    "3996": 747.4390258789062,
                    "3997": 255.44216918945312,
                    "3998": 748.4557495117188,
                    "3999": 257.4814453125,
                    "4000": 746.6658935546875,
                    "4001": 258.37384033203125,
                    "4002": 747.4390258789062,
                    "4003": 255.44216918945312,
                    "4004": 746.6658935546875,
                    "4005": 258.37384033203125,
                    "4006": 745.6491088867188,
                    "4007": 256.3345642089844,
                    "4008": 747.586669921875,
                    "4009": 255.69960021972656,
                    "4010": 748.5676879882812,
                    "4011": 257.7563171386719,
                    "4012": 746.7625122070312,
                    "4013": 258.6173400878906,
                    "4014": 747.586669921875,
                    "4015": 255.69960021972656,
                    "4016": 746.7625122070312,
                    "4017": 258.6173400878906,
                    "4018": 745.781494140625,
                    "4019": 256.5606384277344,
                    "4020": 747.7298583984375,
                    "4021": 255.95957946777344,
                    "4022": 748.6748046875,
                    "4023": 258.0331115722656,
                    "4024": 746.8549194335938,
                    "4025": 258.86248779296875,
                    "4026": 747.7298583984375,
                    "4027": 255.95957946777344,
                    "4028": 746.8549194335938,
                    "4029": 258.86248779296875,
                    "4030": 745.909912109375,
                    "4031": 256.7889709472656,
                    "4032": 747.8684692382812,
                    "4033": 256.2220153808594,
                    "4034": 748.777099609375,
                    "4035": 258.31170654296875,
                    "4036": 746.9429931640625,
                    "4037": 259.1092224121094,
                    "4038": 747.8684692382812,
                    "4039": 256.2220153808594,
                    "4040": 746.9429931640625,
                    "4041": 259.1092224121094,
                    "4042": 746.0343627929688,
                    "4043": 257.01953125,
                    "4044": 748.0025024414062,
                    "4045": 256.4868469238281,
                    "4046": 748.87451171875,
                    "4047": 258.5920715332031,
                    "4048": 747.0267333984375,
                    "4049": 259.357421875,
                    "4050": 748.0025024414062,
                    "4051": 256.4868469238281,
                    "4052": 747.0267333984375,
                    "4053": 259.357421875,
                    "4054": 746.1547241210938,
                    "4055": 257.252197265625,
                    "4056": 748.1318359375,
                    "4057": 256.7539367675781,
                    "4058": 748.9669799804688,
                    "4059": 258.87408447265625,
                    "4060": 747.1061401367188,
                    "4061": 259.6070861816406,
                    "4062": 748.1318359375,
                    "4063": 256.7539367675781,
                    "4064": 747.1061401367188,
                    "4065": 259.6070861816406,
                    "4066": 746.27099609375,
                    "4067": 257.4869384765625,
                    "4068": 748.2565307617188,
                    "4069": 257.0232849121094,
                    "4070": 749.0545654296875,
                    "4071": 259.15765380859375,
                    "4072": 747.1812133789062,
                    "4073": 259.8580627441406,
                    "4074": 748.2565307617188,
                    "4075": 257.0232849121094,
                    "4076": 747.1812133789062,
                    "4077": 259.8580627441406,
                    "4078": 746.3831787109375,
                    "4079": 257.72369384765625,
                    "4080": 748.3765258789062,
                    "4081": 257.29473876953125,
                    "4082": 749.1371459960938,
                    "4083": 259.4427185058594,
                    "4084": 747.2518310546875,
                    "4085": 260.1103515625,
                    "4086": 748.3765258789062,
                    "4087": 257.29473876953125,
                    "4088": 747.2518310546875,
                    "4089": 260.1103515625,
                    "4090": 746.4912109375,
                    "4091": 257.9623718261719,
                    "4092": 748.49169921875,
                    "4093": 257.5682678222656,
                    "4094": 749.2147216796875,
                    "4095": 259.72918701171875,
                    "4096": 747.318115234375,
                    "4097": 260.3638000488281,
                    "4098": 748.49169921875,
                    "4099": 257.5682678222656,
                    "4100": 747.318115234375,
                    "4101": 260.3638000488281,
                    "4102": 746.5950927734375,
                    "4103": 258.202880859375,
                    "4104": 748.6021118164062,
                    "4105": 257.84375,
                    "4106": 749.287353515625,
                    "4107": 260.0169677734375,
                    "4108": 747.3798828125,
                    "4109": 260.6183776855469,
                    "4110": 748.6021118164062,
                    "4111": 257.84375,
                    "4112": 747.3798828125,
                    "4113": 260.6183776855469,
                    "4114": 746.6947021484375,
                    "4115": 258.4451599121094,
                    "4116": 748.7077026367188,
                    "4117": 258.1211242675781,
                    "4118": 749.3549194335938,
                    "4119": 260.30596923828125,
                    "4120": 747.437255859375,
                    "4121": 260.8739929199219,
                    "4122": 748.7077026367188,
                    "4123": 258.1211242675781,
                    "4124": 747.437255859375,
                    "4125": 260.8739929199219,
                    "4126": 746.7901000976562,
                    "4127": 258.68914794921875,
                    "4128": 748.8084716796875,
                    "4129": 258.4002990722656,
                    "4130": 749.4174194335938,
                    "4131": 260.5960998535156,
                    "4132": 747.4901733398438,
                    "4133": 261.1305847167969,
                    "4134": 748.8084716796875,
                    "4135": 258.4002990722656,
                    "4136": 747.4901733398438,
                    "4137": 261.1305847167969,
                    "4138": 746.8812255859375,
                    "4139": 258.9347839355469,
                    "4140": 748.904296875,
                    "4141": 258.6811828613281,
                    "4142": 749.474853515625,
                    "4143": 260.8872985839844,
                    "4144": 747.53857421875,
                    "4145": 261.3880615234375,
                    "4146": 748.904296875,
                    "4147": 258.6811828613281,
                    "4148": 747.53857421875,
                    "4149": 261.3880615234375,
                    "4150": 746.968017578125,
                    "4151": 259.18194580078125,
                    "4152": 748.9952392578125,
                    "4153": 258.9637145996094,
                    "4154": 749.5272216796875,
                    "4155": 261.179443359375,
                    "4156": 747.5824584960938,
                    "4157": 261.6463317871094,
                    "4158": 748.9952392578125,
                    "4159": 258.9637145996094,
                    "4160": 747.5824584960938,
                    "4161": 261.6463317871094,
                    "4162": 747.050537109375,
                    "4163": 259.43060302734375,
                    "4164": 749.0812377929688,
                    "4165": 259.2477722167969,
                    "4166": 749.574462890625,
                    "4167": 261.4724426269531,
                    "4168": 747.621826171875,
                    "4169": 261.9053039550781,
                    "4170": 749.0812377929688,
                    "4171": 259.2477722167969,
                    "4172": 747.621826171875,
                    "4173": 261.9053039550781,
                    "4174": 747.128662109375,
                    "4175": 259.6806335449219,
                    "4176": 749.1622314453125,
                    "4177": 259.5332946777344,
                    "4178": 749.6165771484375,
                    "4179": 261.7662353515625,
                    "4180": 747.6566772460938,
                    "4181": 262.16497802734375,
                    "4182": 749.1622314453125,
                    "4183": 259.5332946777344,
                    "4184": 747.6566772460938,
                    "4185": 262.16497802734375,
                    "4186": 747.202392578125,
                    "4187": 259.9320373535156,
                    "4188": 749.23828125,
                    "4189": 259.8201904296875,
                    "4190": 749.653564453125,
                    "4191": 262.0606994628906,
                    "4192": 747.68701171875,
                    "4193": 262.4251708984375,
                    "4194": 749.23828125,
                    "4195": 259.8201904296875,
                    "4196": 747.68701171875,
                    "4197": 262.4251708984375,
                    "4198": 747.2717895507812,
                    "4199": 260.1846618652344,
                    "4200": 749.3092651367188,
                    "4201": 260.1083679199219,
                    "4202": 749.6853637695312,
                    "4203": 262.35577392578125,
                    "4204": 747.7128295898438,
                    "4205": 262.6858825683594,
                    "4206": 749.3092651367188,
                    "4207": 260.1083679199219,
                    "4208": 747.7128295898438,
                    "4209": 262.6858825683594,
                    "4210": 747.3367309570312,
                    "4211": 260.4384460449219,
                    "4212": 749.375244140625,
                    "4213": 260.3977355957031,
                    "4214": 749.7120361328125,
                    "4215": 262.6513671875,
                    "4216": 747.7340087890625,
                    "4217": 262.9469909667969,
                    "4218": 749.375244140625,
                    "4219": 260.3977355957031,
                    "4220": 747.7340087890625,
                    "4221": 262.9469909667969,
                    "4222": 747.397216796875,
                    "4223": 260.6933288574219,
                    "4224": 749.4361572265625,
                    "4225": 260.6882019042969,
                    "4226": 749.7335815429688,
                    "4227": 262.9473876953125,
                    "4228": 747.7506713867188,
                    "4229": 263.20843505859375,
                    "4230": 749.4361572265625,
                    "4231": 260.6882019042969,
                    "4232": 747.7506713867188,
                    "4233": 263.20843505859375,
                    "4234": 747.4532470703125,
                    "4235": 260.9492492675781,
                    "4236": 749.4920043945312,
                    "4237": 260.9797058105469,
                    "4238": 749.7499389648438,
                    "4239": 263.2437438964844,
                    "4240": 747.7628173828125,
                    "4241": 263.4701232910156,
                    "4242": 749.4920043945312,
                    "4243": 260.9797058105469,
                    "4244": 747.7628173828125,
                    "4245": 263.4701232910156,
                    "4246": 747.5048217773438,
                    "4247": 261.20611572265625,
                    "4248": 749.542724609375,
                    "4249": 261.2721252441406,
                    "4250": 749.7611083984375,
                    "4251": 263.5403137207031,
                    "4252": 747.7703247070312,
                    "4253": 263.73199462890625,
                    "4254": 749.542724609375,
                    "4255": 261.2721252441406,
                    "4256": 747.7703247070312,
                    "4257": 263.73199462890625,
                    "4258": 747.5519409179688,
                    "4259": 261.46380615234375,
                    "4260": 749.5883178710938,
                    "4261": 261.5653991699219,
                    "4262": 749.76708984375,
                    "4263": 263.8370361328125,
                    "4264": 747.7732543945312,
                    "4265": 263.99395751953125,
                    "4266": 749.5883178710938,
                    "4267": 261.5653991699219,
                    "4268": 747.7732543945312,
                    "4269": 263.99395751953125,
                    "4270": 747.594482421875,
                    "4271": 261.7222900390625,
                    "4272": 749.6288452148438,
                    "4273": 261.8594055175781,
                    "4274": 749.7679443359375,
                    "4275": 264.13385009765625,
                    "4276": 747.7716674804688,
                    "4277": 264.25592041015625,
                    "4278": 749.6288452148438,
                    "4279": 261.8594055175781,
                    "4280": 747.7716674804688,
                    "4281": 264.25592041015625,
                    "4282": 747.632568359375,
                    "4283": 261.98150634765625,
                    "4284": 749.6641845703125,
                    "4285": 262.1540832519531,
                    "4286": 749.7635498046875,
                    "4287": 264.43060302734375,
                    "4288": 747.7655029296875,
                    "4289": 264.517822265625,
                    "4290": 749.6641845703125,
                    "4291": 262.1540832519531,
                    "4292": 747.7655029296875,
                    "4293": 264.517822265625,
                    "4294": 747.6660766601562,
                    "4295": 262.2413330078125,
                    "4296": 749.6943969726562,
                    "4297": 262.4493408203125,
                    "4298": 749.7540283203125,
                    "4299": 264.72723388671875,
                    "4300": 747.7546997070312,
                    "4301": 264.77960205078125,
                    "4302": 749.6943969726562,
                    "4303": 262.4493408203125,
                    "4304": 747.7546997070312,
                    "4305": 264.77960205078125,
                    "4306": 747.695068359375,
                    "4307": 262.5016784667969,
                    "4308": 749.7194213867188,
                    "4309": 262.74505615234375,
                    "4310": 749.7393188476562,
                    "4311": 265.0236511230469,
                    "4312": 747.7393798828125,
                    "4313": 265.0411071777344,
                    "4314": 749.7194213867188,
                    "4315": 262.74505615234375,
                    "4316": 747.7393798828125,
                    "4317": 265.0411071777344,
                    "4318": 747.719482421875,
                    "4319": 262.76251220703125
                },
                "_radius": 15.967572654919366,
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "_thickness": 2
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10603",
            "desc": "Заслонка (дроссель-клапан) вентиляционная",
            "size": "",
            "kms": "0.1",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 0.1,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 716.7954840947152,
                    "y": 264.03242734508063
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 748.7306294045538,
                    "y": 264.03242734508063
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 665.8407592773438,
            "1": 195.69589233398438,
            "2": 801.099609375,
            "3": 330.9547424316406,
            "4": 799.6853637695312,
            "5": 332.36895751953125,
            "6": 665.8407592773438,
            "7": 195.69589233398438,
            "8": 799.6853637695312,
            "9": 332.36895751953125,
            "10": 664.426513671875,
            "11": 197.110107421875,
            "12": 749.7393188476562,
            "13": 263.04119873046875,
            "14": 749.7194213867188,
            "15": 265.3197937011719,
            "16": 747.719482421875,
            "17": 265.3023376464844,
            "18": 749.7393188476562,
            "19": 263.04119873046875,
            "20": 747.719482421875,
            "21": 265.3023376464844,
            "22": 747.7393798828125,
            "23": 263.02374267578125,
            "24": 749.7540283203125,
            "25": 263.3376159667969,
            "26": 749.6943969726562,
            "27": 265.6155090332031,
            "28": 747.695068359375,
            "29": 265.56317138671875,
            "30": 749.7540283203125,
            "31": 263.3376159667969,
            "32": 747.695068359375,
            "33": 265.56317138671875,
            "34": 747.7546997070312,
            "35": 263.2852783203125,
            "36": 749.7635498046875,
            "37": 263.6342468261719,
            "38": 749.6641845703125,
            "39": 265.9107666015625,
            "40": 747.6660766601562,
            "41": 265.82354736328125,
            "42": 749.7635498046875,
            "43": 263.6342468261719,
            "44": 747.6660766601562,
            "45": 265.82354736328125,
            "46": 747.7655029296875,
            "47": 263.5470275878906,
            "48": 749.7679443359375,
            "49": 263.9310302734375,
            "50": 749.6288452148438,
            "51": 266.2054443359375,
            "52": 747.632568359375,
            "53": 266.0833435058594,
            "54": 749.7679443359375,
            "55": 263.9310302734375,
            "56": 747.632568359375,
            "57": 266.0833435058594,
            "58": 747.7716674804688,
            "59": 263.8089294433594,
            "60": 749.76708984375,
            "61": 264.2278137207031,
            "62": 749.5883178710938,
            "63": 266.4994812011719,
            "64": 747.594482421875,
            "65": 266.3425598144531,
            "66": 749.76708984375,
            "67": 264.2278137207031,
            "68": 747.594482421875,
            "69": 266.3425598144531,
            "70": 747.7732543945312,
            "71": 264.0708923339844,
            "72": 749.7611083984375,
            "73": 264.5245361328125,
            "74": 749.542724609375,
            "75": 266.792724609375,
            "76": 747.5519409179688,
            "77": 266.6010437011719,
            "78": 749.7611083984375,
            "79": 264.5245361328125,
            "80": 747.5519409179688,
            "81": 266.6010437011719,
            "82": 747.7703247070312,
            "83": 264.3328552246094,
            "84": 749.7499389648438,
            "85": 264.8211364746094,
            "86": 749.4920043945312,
            "87": 267.0851745605469,
            "88": 747.5048217773438,
            "89": 266.8587646484375,
            "90": 749.7499389648438,
            "91": 264.8211364746094,
            "92": 747.5048217773438,
            "93": 266.8587646484375,
            "94": 747.7628173828125,
            "95": 264.5947265625,
            "96": 749.7335815429688,
            "97": 265.1174621582031,
            "98": 749.4361572265625,
            "99": 267.37664794921875,
            "100": 747.4532470703125,
            "101": 267.1156005859375,
            "102": 749.7335815429688,
            "103": 265.1174621582031,
            "104": 747.4532470703125,
            "105": 267.1156005859375,
            "106": 747.7506713867188,
            "107": 264.8564147949219,
            "108": 749.7120361328125,
            "109": 265.4134826660156,
            "110": 749.375244140625,
            "111": 267.6671447753906,
            "112": 747.397216796875,
            "113": 267.37152099609375,
            "114": 749.7120361328125,
            "115": 265.4134826660156,
            "116": 747.397216796875,
            "117": 267.37152099609375,
            "118": 747.7340087890625,
            "119": 265.11785888671875,
            "120": 749.6853637695312,
            "121": 265.7090759277344,
            "122": 749.3092651367188,
            "123": 267.9565124511719,
            "124": 747.3367309570312,
            "125": 267.62640380859375,
            "126": 749.6853637695312,
            "127": 265.7090759277344,
            "128": 747.3367309570312,
            "129": 267.62640380859375,
            "130": 747.7128295898438,
            "131": 265.37896728515625,
            "132": 749.653564453125,
            "133": 266.004150390625,
            "134": 749.23828125,
            "135": 268.2446594238281,
            "136": 747.2717895507812,
            "137": 267.88018798828125,
            "138": 749.653564453125,
            "139": 266.004150390625,
            "140": 747.2717895507812,
            "141": 267.88018798828125,
            "142": 747.68701171875,
            "143": 265.6396789550781,
            "144": 749.6165771484375,
            "145": 266.2986145019531,
            "146": 749.1622314453125,
            "147": 268.53155517578125,
            "148": 747.202392578125,
            "149": 268.1328430175781,
            "150": 749.6165771484375,
            "151": 266.2986145019531,
            "152": 747.202392578125,
            "153": 268.1328430175781,
            "154": 747.6566772460938,
            "155": 265.89990234375,
            "156": 749.574462890625,
            "157": 266.5924072265625,
            "158": 749.0812377929688,
            "159": 268.81707763671875,
            "160": 747.128662109375,
            "161": 268.38421630859375,
            "162": 749.574462890625,
            "163": 266.5924072265625,
            "164": 747.128662109375,
            "165": 268.38421630859375,
            "166": 747.621826171875,
            "167": 266.1595458984375,
            "168": 749.5272216796875,
            "169": 266.88543701171875,
            "170": 748.9952392578125,
            "171": 269.10113525390625,
            "172": 747.050537109375,
            "173": 268.6342468261719,
            "174": 749.5272216796875,
            "175": 266.88543701171875,
            "176": 747.050537109375,
            "177": 268.6342468261719,
            "178": 747.5824584960938,
            "179": 266.4185485839844,
            "180": 749.474853515625,
            "181": 267.17755126953125,
            "182": 748.904296875,
            "183": 269.3836669921875,
            "184": 746.968017578125,
            "185": 268.8829040527344,
            "186": 749.474853515625,
            "187": 267.17755126953125,
            "188": 746.968017578125,
            "189": 268.8829040527344,
            "190": 747.53857421875,
            "191": 266.67681884765625,
            "192": 749.4174194335938,
            "193": 267.46875,
            "194": 748.8084716796875,
            "195": 269.66455078125,
            "196": 746.8812255859375,
            "197": 269.13006591796875,
            "198": 749.4174194335938,
            "199": 267.46875,
            "200": 746.8812255859375,
            "201": 269.13006591796875,
            "202": 747.4901733398438,
            "203": 266.93426513671875,
            "204": 749.3549194335938,
            "205": 267.7588806152344,
            "206": 748.7077026367188,
            "207": 269.9437255859375,
            "208": 746.7901000976562,
            "209": 269.3757019042969,
            "210": 749.3549194335938,
            "211": 267.7588806152344,
            "212": 746.7901000976562,
            "213": 269.3757019042969,
            "214": 747.437255859375,
            "215": 267.19085693359375,
            "216": 749.287353515625,
            "217": 268.0478820800781,
            "218": 748.6021118164062,
            "219": 270.2210998535156,
            "220": 746.6947021484375,
            "221": 269.61968994140625,
            "222": 749.287353515625,
            "223": 268.0478820800781,
            "224": 746.6947021484375,
            "225": 269.61968994140625,
            "226": 747.3798828125,
            "227": 267.44647216796875,
            "228": 749.2147216796875,
            "229": 268.3356628417969,
            "230": 748.49169921875,
            "231": 270.49658203125,
            "232": 746.5950927734375,
            "233": 269.8619689941406,
            "234": 749.2147216796875,
            "235": 268.3356628417969,
            "236": 746.5950927734375,
            "237": 269.8619689941406,
            "238": 747.318115234375,
            "239": 267.7010498046875,
            "240": 749.1371459960938,
            "241": 268.62213134765625,
            "242": 748.3765258789062,
            "243": 270.7701110839844,
            "244": 746.4912109375,
            "245": 270.1025085449219,
            "246": 749.1371459960938,
            "247": 268.62213134765625,
            "248": 746.4912109375,
            "249": 270.1025085449219,
            "250": 747.2518310546875,
            "251": 267.9544982910156,
            "252": 749.0545654296875,
            "253": 268.9071960449219,
            "254": 748.2565307617188,
            "255": 271.04156494140625,
            "256": 746.3831787109375,
            "257": 270.3411560058594,
            "258": 749.0545654296875,
            "259": 268.9071960449219,
            "260": 746.3831787109375,
            "261": 270.3411560058594,
            "262": 747.1812133789062,
            "263": 268.206787109375,
            "264": 748.9669799804688,
            "265": 269.1907653808594,
            "266": 748.1318359375,
            "267": 271.3109130859375,
            "268": 746.27099609375,
            "269": 270.5779113769531,
            "270": 748.9669799804688,
            "271": 269.1907653808594,
            "272": 746.27099609375,
            "273": 270.5779113769531,
            "274": 747.1061401367188,
            "275": 268.457763671875,
            "276": 748.87451171875,
            "277": 269.4727783203125,
            "278": 748.0025024414062,
            "279": 271.5780029296875,
            "280": 746.1547241210938,
            "281": 270.8126525878906,
            "282": 748.87451171875,
            "283": 269.4727783203125,
            "284": 746.1547241210938,
            "285": 270.8126525878906,
            "286": 747.0267333984375,
            "287": 268.7074279785156,
            "288": 748.777099609375,
            "289": 269.7531433105469,
            "290": 747.8684692382812,
            "291": 271.84283447265625,
            "292": 746.0343627929688,
            "293": 271.04534912109375,
            "294": 748.777099609375,
            "295": 269.7531433105469,
            "296": 746.0343627929688,
            "297": 271.04534912109375,
            "298": 746.9429931640625,
            "299": 268.9556579589844,
            "300": 748.6748046875,
            "301": 270.0317687988281,
            "302": 747.7298583984375,
            "303": 272.1052551269531,
            "304": 745.909912109375,
            "305": 271.27587890625,
            "306": 748.6748046875,
            "307": 270.0317687988281,
            "308": 745.909912109375,
            "309": 271.27587890625,
            "310": 746.8549194335938,
            "311": 269.2023620605469,
            "312": 748.5676879882812,
            "313": 270.30853271484375,
            "314": 747.586669921875,
            "315": 272.365234375,
            "316": 745.781494140625,
            "317": 271.50421142578125,
            "318": 748.5676879882812,
            "319": 270.30853271484375,
            "320": 745.781494140625,
            "321": 271.50421142578125,
            "322": 746.7625122070312,
            "323": 269.447509765625,
            "324": 748.4557495117188,
            "325": 270.5834045410156,
            "326": 747.4390258789062,
            "327": 272.6226806640625,
            "328": 745.6491088867188,
            "329": 271.73028564453125,
            "330": 748.4557495117188,
            "331": 270.5834045410156,
            "332": 745.6491088867188,
            "333": 271.73028564453125,
            "334": 746.6658935546875,
            "335": 269.6910095214844,
            "336": 748.3390502929688,
            "337": 270.8562927246094,
            "338": 747.286865234375,
            "339": 272.87750244140625,
            "340": 745.5128173828125,
            "341": 271.9540100097656,
            "342": 748.3390502929688,
            "343": 270.8562927246094,
            "344": 745.5128173828125,
            "345": 271.9540100097656,
            "346": 746.5650024414062,
            "347": 269.93280029296875,
            "348": 748.2175903320312,
            "349": 271.1270751953125,
            "350": 747.1302490234375,
            "351": 273.129638671875,
            "352": 745.3726196289062,
            "353": 272.1753234863281,
            "354": 748.2175903320312,
            "355": 271.1270751953125,
            "356": 745.3726196289062,
            "357": 272.1753234863281,
            "358": 746.4598999023438,
            "359": 270.1727600097656,
            "360": 748.0913696289062,
            "361": 271.3957214355469,
            "362": 746.9692993164062,
            "363": 273.3789978027344,
            "364": 745.2285766601562,
            "365": 272.3941345214844,
            "366": 748.0913696289062,
            "367": 271.3957214355469,
            "368": 745.2285766601562,
            "369": 272.3941345214844,
            "370": 746.3507080078125,
            "371": 270.410888671875,
            "372": 747.9605712890625,
            "373": 271.662109375,
            "374": 746.8040161132812,
            "375": 273.62548828125,
            "376": 745.0807495117188,
            "377": 272.61041259765625,
            "378": 747.9605712890625,
            "379": 271.662109375,
            "380": 745.0807495117188,
            "381": 272.61041259765625,
            "382": 746.2373046875,
            "383": 270.64703369140625,
            "384": 747.8250732421875,
            "385": 271.92620849609375,
            "386": 746.6344604492188,
            "387": 273.86907958984375,
            "388": 744.92919921875,
            "389": 272.8240966796875,
            "390": 747.8250732421875,
            "391": 271.92620849609375,
            "392": 744.92919921875,
            "393": 272.8240966796875,
            "394": 746.1198120117188,
            "395": 270.8811950683594,
            "396": 747.6849975585938,
            "397": 272.1878662109375,
            "398": 746.460693359375,
            "399": 274.10968017578125,
            "400": 744.77392578125,
            "401": 273.03509521484375,
            "402": 747.6849975585938,
            "403": 272.1878662109375,
            "404": 744.77392578125,
            "405": 273.03509521484375,
            "406": 745.9982299804688,
            "407": 271.1132507324219,
            "408": 747.5404052734375,
            "409": 272.4470520019531,
            "410": 746.28271484375,
            "411": 274.3471984863281,
            "412": 744.6149291992188,
            "413": 273.2433166503906,
            "414": 747.5404052734375,
            "415": 272.4470520019531,
            "416": 744.6149291992188,
            "417": 273.2433166503906,
            "418": 745.8726196289062,
            "419": 271.3431701660156,
            "420": 747.3912963867188,
            "421": 272.70367431640625,
            "422": 746.1006469726562,
            "423": 274.5815734863281,
            "424": 744.452392578125,
            "425": 273.4487609863281,
            "426": 747.3912963867188,
            "427": 272.70367431640625,
            "428": 744.452392578125,
            "429": 273.4487609863281,
            "430": 745.7430419921875,
            "431": 271.57086181640625,
            "432": 747.2377319335938,
            "433": 272.9576416015625,
            "434": 745.9144897460938,
            "435": 274.812744140625,
            "436": 744.2862548828125,
            "437": 273.6513366699219,
            "438": 747.2377319335938,
            "439": 272.9576416015625,
            "440": 744.2862548828125,
            "441": 273.6513366699219,
            "442": 745.6094970703125,
            "443": 271.7962341308594,
            "444": 747.0797729492188,
            "445": 273.2088928222656,
            "446": 745.724365234375,
            "447": 275.0406188964844,
            "448": 744.1166381835938,
            "449": 273.8509826660156,
            "450": 747.0797729492188,
            "451": 273.2088928222656,
            "452": 744.1166381835938,
            "453": 273.8509826660156,
            "454": 745.4720458984375,
            "455": 272.0192565917969,
            "456": 746.9174194335938,
            "457": 273.4573669433594,
            "458": 745.5302734375,
            "459": 275.2651672363281,
            "460": 743.9435424804688,
            "461": 274.0476379394531,
            "462": 746.9174194335938,
            "463": 273.4573669433594,
            "464": 743.9435424804688,
            "465": 274.0476379394531,
            "466": 745.3307495117188,
            "467": 272.2398376464844,
            "468": 746.7507934570312,
            "469": 273.70294189453125,
            "470": 745.332275390625,
            "471": 275.48626708984375,
            "472": 743.76708984375,
            "473": 274.2412414550781,
            "474": 746.7507934570312,
            "475": 273.70294189453125,
            "476": 743.76708984375,
            "477": 274.2412414550781,
            "478": 745.1856079101562,
            "479": 272.4579162597656,
            "480": 746.5798950195312,
            "481": 273.9455871582031,
            "482": 745.1304931640625,
            "483": 275.7038879394531,
            "484": 743.5872192382812,
            "485": 274.4317321777344,
            "486": 746.5798950195312,
            "487": 273.9455871582031,
            "488": 743.5872192382812,
            "489": 274.4317321777344,
            "490": 745.03662109375,
            "491": 272.6734313964844,
            "492": 746.40478515625,
            "493": 274.18524169921875,
            "494": 744.9248657226562,
            "495": 275.9179382324219,
            "496": 743.404052734375,
            "497": 274.6190490722656,
            "498": 746.40478515625,
            "499": 274.18524169921875,
            "500": 743.404052734375,
            "501": 274.6190490722656,
            "502": 744.8839721679688,
            "503": 272.8863220214844,
            "504": 746.2255249023438,
            "505": 274.4217529296875,
            "506": 744.7156372070312,
            "507": 276.1283874511719,
            "508": 743.2177124023438,
            "509": 274.80316162109375,
            "510": 746.2255249023438,
            "511": 274.4217529296875,
            "512": 743.2177124023438,
            "513": 274.80316162109375,
            "514": 744.7276000976562,
            "515": 273.0965270996094,
            "516": 746.0421142578125,
            "517": 274.6551208496094,
            "518": 744.502685546875,
            "519": 276.33514404296875,
            "520": 743.0281372070312,
            "521": 274.9839782714844,
            "522": 746.0421142578125,
            "523": 274.6551208496094,
            "524": 743.0281372070312,
            "525": 274.9839782714844,
            "526": 744.5675659179688,
            "527": 273.303955078125,
            "528": 745.854736328125,
            "529": 274.88525390625,
            "530": 744.2861938476562,
            "531": 276.5381774902344,
            "532": 742.83544921875,
            "533": 275.1614685058594,
            "534": 745.854736328125,
            "535": 274.88525390625,
            "536": 742.83544921875,
            "537": 275.1614685058594,
            "538": 744.4039916992188,
            "539": 273.508544921875,
            "540": 745.663330078125,
            "541": 275.1120910644531,
            "542": 744.066162109375,
            "543": 276.73736572265625,
            "544": 742.6396484375,
            "545": 275.3355407714844,
            "546": 745.663330078125,
            "547": 275.1120910644531,
            "548": 742.6396484375,
            "549": 275.3355407714844,
            "550": 744.23681640625,
            "551": 273.71026611328125,
            "552": 745.468017578125,
            "553": 275.3355407714844,
            "554": 743.8427124023438,
            "555": 276.9327087402344,
            "556": 742.44091796875,
            "557": 275.5061950683594,
            "558": 745.468017578125,
            "559": 275.3355407714844,
            "560": 742.44091796875,
            "561": 275.5061950683594,
            "562": 744.066162109375,
            "563": 273.9090576171875,
            "564": 745.268798828125,
            "565": 275.5555725097656,
            "566": 743.6159057617188,
            "567": 277.12408447265625,
            "568": 742.2391967773438,
            "569": 275.67333984375,
            "570": 745.268798828125,
            "571": 275.5555725097656,
            "572": 742.2391967773438,
            "573": 275.67333984375,
            "574": 743.89208984375,
            "575": 274.10479736328125,
            "576": 745.0657958984375,
            "577": 275.7720642089844,
            "578": 743.3857421875,
            "579": 277.3115234375,
            "580": 742.0346069335938,
            "581": 275.8369445800781,
            "582": 745.0657958984375,
            "583": 275.7720642089844,
            "584": 742.0346069335938,
            "585": 275.8369445800781,
            "586": 743.714599609375,
            "587": 274.2975158691406,
            "588": 744.8590087890625,
            "589": 275.9849853515625,
            "590": 743.1524047851562,
            "591": 277.494873046875,
            "592": 741.8271484375,
            "593": 275.9969787597656,
            "594": 744.8590087890625,
            "595": 275.9849853515625,
            "596": 741.8271484375,
            "597": 275.9969787597656,
            "598": 743.5338134765625,
            "599": 274.487060546875,
            "600": 744.6485595703125,
            "601": 276.19427490234375,
            "602": 742.9158325195312,
            "603": 277.6741638183594,
            "604": 741.616943359375,
            "605": 276.1533508300781,
            "606": 744.6485595703125,
            "607": 276.19427490234375,
            "608": 741.616943359375,
            "609": 276.1533508300781,
            "610": 743.3496704101562,
            "611": 274.6734619140625,
            "612": 744.4345092773438,
            "613": 276.39984130859375,
            "614": 742.6762084960938,
            "615": 277.8492736816406,
            "616": 741.404052734375,
            "617": 276.3060302734375,
            "618": 744.4345092773438,
            "619": 276.39984130859375,
            "620": 741.404052734375,
            "621": 276.3060302734375,
            "622": 743.162353515625,
            "623": 274.8565979003906,
            "624": 744.2169189453125,
            "625": 276.6016540527344,
            "626": 742.43359375,
            "627": 278.0201721191406,
            "628": 741.1885375976562,
            "629": 276.4549560546875,
            "630": 744.2169189453125,
            "631": 276.6016540527344,
            "632": 741.1885375976562,
            "633": 276.4549560546875,
            "634": 742.9718627929688,
            "635": 275.03643798828125,
            "636": 743.9957885742188,
            "637": 276.7996520996094,
            "638": 742.18798828125,
            "639": 278.1867980957031,
            "640": 740.970458984375,
            "641": 276.60009765625,
            "642": 743.9957885742188,
            "643": 276.7996520996094,
            "644": 740.970458984375,
            "645": 276.60009765625,
            "646": 742.7782592773438,
            "647": 275.2129211425781,
            "648": 743.771240234375,
            "649": 276.9937438964844,
            "650": 741.9395141601562,
            "651": 278.3491516113281,
            "652": 740.7498779296875,
            "653": 276.7414245605469,
            "654": 743.771240234375,
            "655": 276.9937438964844,
            "656": 740.7498779296875,
            "657": 276.7414245605469,
            "658": 742.5816040039062,
            "659": 275.3860168457031,
            "660": 743.5433959960938,
            "661": 277.1838684082031,
            "662": 741.6882934570312,
            "663": 278.5071105957031,
            "664": 740.52685546875,
            "665": 276.8788757324219,
            "666": 743.5433959960938,
            "667": 277.1838684082031,
            "668": 740.52685546875,
            "669": 276.8788757324219,
            "670": 742.3819580078125,
            "671": 275.5556335449219,
            "672": 743.3121948242188,
            "673": 277.3700256347656,
            "674": 741.4342651367188,
            "675": 278.6606750488281,
            "676": 740.3014526367188,
            "677": 277.0124206542969,
            "678": 743.3121948242188,
            "679": 277.3700256347656,
            "680": 740.3014526367188,
            "681": 277.0124206542969,
            "682": 742.1793823242188,
            "683": 275.7217712402344,
            "684": 743.0778198242188,
            "685": 277.5520935058594,
            "686": 741.1776733398438,
            "687": 278.8097839355469,
            "688": 740.0737915039062,
            "689": 277.1419982910156,
            "690": 743.0778198242188,
            "691": 277.5520935058594,
            "692": 740.0737915039062,
            "693": 277.1419982910156,
            "694": 741.9739379882812,
            "695": 275.8843078613281,
            "696": 742.84033203125,
            "697": 277.73004150390625,
            "698": 740.9185180664062,
            "699": 278.9543762207031,
            "700": 739.8438720703125,
            "701": 277.2676086425781,
            "702": 742.84033203125,
            "703": 277.73004150390625,
            "704": 739.8438720703125,
            "705": 277.2676086425781,
            "706": 741.7656860351562,
            "707": 276.04327392578125,
            "708": 742.5997314453125,
            "709": 277.9038391113281,
            "710": 740.6567993164062,
            "711": 279.0944519042969,
            "712": 739.61181640625,
            "713": 277.38916015625,
            "714": 742.5997314453125,
            "715": 277.9038391113281,
            "716": 739.61181640625,
            "717": 277.38916015625,
            "718": 741.5547485351562,
            "719": 276.19854736328125,
            "720": 742.3561401367188,
            "721": 278.0733947753906,
            "722": 740.3927612304688,
            "723": 279.22991943359375,
            "724": 739.377685546875,
            "725": 277.50665283203125,
            "726": 742.3561401367188,
            "727": 278.0733947753906,
            "728": 739.377685546875,
            "729": 277.50665283203125,
            "730": 741.341064453125,
            "731": 276.3501281738281,
            "732": 742.109619140625,
            "733": 278.2386779785156,
            "734": 740.1263427734375,
            "735": 279.3607482910156,
            "736": 739.1415405273438,
            "737": 277.62005615234375,
            "738": 742.109619140625,
            "739": 278.2386779785156,
            "740": 739.1415405273438,
            "741": 277.62005615234375,
            "742": 741.124755859375,
            "743": 276.49798583984375,
            "744": 741.8602905273438,
            "745": 278.3996276855469,
            "746": 739.8577270507812,
            "747": 279.4869384765625,
            "748": 738.9033813476562,
            "749": 277.72930908203125,
            "750": 741.8602905273438,
            "751": 278.3996276855469,
            "752": 738.9033813476562,
            "753": 277.72930908203125,
            "754": 740.9059448242188,
            "755": 276.6419982910156,
            "756": 741.608154296875,
            "757": 278.55621337890625,
            "758": 739.5869140625,
            "759": 279.6083984375,
            "760": 738.6634521484375,
            "761": 277.8343811035156,
            "762": 741.608154296875,
            "763": 278.55621337890625,
            "764": 738.6634521484375,
            "765": 277.8343811035156,
            "766": 740.6846313476562,
            "767": 276.7821960449219,
            "768": 741.3533325195312,
            "769": 278.7083740234375,
            "770": 739.3140258789062,
            "771": 279.7251281738281,
            "772": 738.421630859375,
            "773": 277.93524169921875,
            "774": 741.3533325195312,
            "775": 278.7083740234375,
            "776": 738.421630859375,
            "777": 277.93524169921875,
            "778": 740.4609375,
            "779": 276.91851806640625,
            "780": 741.0958862304688,
            "781": 278.8560485839844,
            "782": 739.0391845703125,
            "783": 279.8370666503906,
            "784": 738.1781616210938,
            "785": 278.0318908691406,
            "786": 741.0958862304688,
            "787": 278.8560485839844,
            "788": 738.1781616210938,
            "789": 278.0318908691406,
            "790": 740.23486328125,
            "791": 277.0509033203125,
            "792": 740.8358764648438,
            "793": 278.9992370605469,
            "794": 738.7623901367188,
            "795": 279.9441833496094,
            "796": 737.9329833984375,
            "797": 278.124267578125,
            "798": 740.8358764648438,
            "799": 278.9992370605469,
            "800": 737.9329833984375,
            "801": 278.124267578125,
            "802": 740.0065307617188,
            "803": 277.1793212890625,
            "804": 740.573486328125,
            "805": 279.1378479003906,
            "806": 738.4837646484375,
            "807": 280.0464782714844,
            "808": 737.686279296875,
            "809": 278.21234130859375,
            "810": 740.573486328125,
            "811": 279.1378479003906,
            "812": 737.686279296875,
            "813": 278.21234130859375,
            "814": 739.7759399414062,
            "815": 277.3037109375,
            "816": 740.3086547851562,
            "817": 279.2718505859375,
            "818": 738.2034301757812,
            "819": 280.14385986328125,
            "820": 737.4380493164062,
            "821": 278.2961120605469,
            "822": 740.3086547851562,
            "823": 279.2718505859375,
            "824": 737.4380493164062,
            "825": 278.2961120605469,
            "826": 739.5432739257812,
            "827": 277.4241027832031,
            "828": 740.04150390625,
            "829": 279.4012145996094,
            "830": 737.92138671875,
            "831": 280.2363586425781,
            "832": 737.1884155273438,
            "833": 278.3755187988281,
            "834": 740.04150390625,
            "835": 279.4012145996094,
            "836": 737.1884155273438,
            "837": 278.3755187988281,
            "838": 739.3085327148438,
            "839": 277.5403747558594,
            "840": 739.772216796875,
            "841": 279.5259094238281,
            "842": 737.6378173828125,
            "843": 280.32391357421875,
            "844": 736.9374389648438,
            "845": 278.4505615234375,
            "846": 739.772216796875,
            "847": 279.5259094238281,
            "848": 736.9374389648438,
            "849": 278.4505615234375,
            "850": 739.07177734375,
            "851": 277.6525573730469,
            "852": 739.500732421875,
            "853": 279.6458740234375,
            "854": 737.352783203125,
            "855": 280.4065246582031,
            "856": 736.6851196289062,
            "857": 278.521240234375,
            "858": 739.500732421875,
            "859": 279.6458740234375,
            "860": 736.6851196289062,
            "861": 278.521240234375,
            "862": 738.8331298828125,
            "863": 277.7605895996094,
            "864": 739.2272338867188,
            "865": 279.7610778808594,
            "866": 737.0662841796875,
            "867": 280.484130859375,
            "868": 736.4317016601562,
            "869": 278.58746337890625,
            "870": 739.2272338867188,
            "871": 279.7610778808594,
            "872": 736.4317016601562,
            "873": 278.58746337890625,
            "874": 738.5925903320312,
            "875": 277.86444091796875,
            "876": 738.9517211914062,
            "877": 279.8714904785156,
            "878": 736.7785034179688,
            "879": 280.55670166015625,
            "880": 736.1771240234375,
            "881": 278.6492919921875,
            "882": 738.9517211914062,
            "883": 279.8714904785156,
            "884": 736.1771240234375,
            "885": 278.6492919921875,
            "886": 738.350341796875,
            "887": 277.9640808105469,
            "888": 738.6743774414062,
            "889": 279.97711181640625,
            "890": 736.489501953125,
            "891": 280.624267578125,
            "892": 735.9215087890625,
            "893": 278.7066345214844,
            "894": 738.6743774414062,
            "895": 279.97711181640625,
            "896": 735.9215087890625,
            "897": 278.7066345214844,
            "898": 738.1063232421875,
            "899": 278.0594482421875,
            "900": 738.3952026367188,
            "901": 280.0778503417969,
            "902": 736.1994018554688,
            "903": 280.6867980957031,
            "904": 735.6649169921875,
            "905": 278.759521484375,
            "906": 738.3952026367188,
            "907": 280.0778503417969,
            "908": 735.6649169921875,
            "909": 278.759521484375,
            "910": 737.8607177734375,
            "911": 278.15057373046875,
            "912": 738.1143188476562,
            "913": 280.1736755371094,
            "914": 735.908203125,
            "915": 280.7442321777344,
            "916": 735.4074096679688,
            "917": 278.80792236328125,
            "918": 738.1143188476562,
            "919": 280.1736755371094,
            "920": 735.4074096679688,
            "921": 278.80792236328125,
            "922": 737.613525390625,
            "923": 278.2373962402344,
            "924": 737.831787109375,
            "925": 280.2646179199219,
            "926": 735.6160278320312,
            "927": 280.79656982421875,
            "928": 735.149169921875,
            "929": 278.8518371582031,
            "930": 737.831787109375,
            "931": 280.2646179199219,
            "932": 735.149169921875,
            "933": 278.8518371582031,
            "934": 737.3648681640625,
            "935": 278.31988525390625,
            "936": 737.5477294921875,
            "937": 280.3506164550781,
            "938": 735.3230590820312,
            "939": 280.84381103515625,
            "940": 734.89013671875,
            "941": 278.8912048339844,
            "942": 737.5477294921875,
            "943": 280.3506164550781,
            "944": 734.89013671875,
            "945": 278.8912048339844,
            "946": 737.1148071289062,
            "947": 278.39801025390625,
            "948": 737.26220703125,
            "949": 280.431640625,
            "950": 735.0292358398438,
            "951": 280.88592529296875,
            "952": 734.6304931640625,
            "953": 278.92608642578125,
            "954": 737.26220703125,
            "955": 280.431640625,
            "956": 734.6304931640625,
            "957": 278.92608642578125,
            "958": 736.8634643554688,
            "959": 278.4717712402344,
            "960": 736.9752807617188,
            "961": 280.5076599121094,
            "962": 734.7348022460938,
            "963": 280.92291259765625,
            "964": 734.3703002929688,
            "965": 278.9563903808594,
            "966": 736.9752807617188,
            "967": 280.5076599121094,
            "968": 734.3703002929688,
            "969": 278.9563903808594,
            "970": 736.61083984375,
            "971": 278.5411376953125,
            "972": 736.6871337890625,
            "973": 280.5786437988281,
            "974": 734.439697265625,
            "975": 280.9547424316406,
            "976": 734.109619140625,
            "977": 278.982177734375,
            "978": 736.6871337890625,
            "979": 280.5786437988281,
            "980": 734.109619140625,
            "981": 278.982177734375,
            "982": 736.3570556640625,
            "983": 278.6060791015625,
            "984": 736.3977661132812,
            "985": 280.6446228027344,
            "986": 734.1441040039062,
            "987": 280.9814147949219,
            "988": 733.8485107421875,
            "989": 279.0033874511719,
            "990": 736.3977661132812,
            "991": 280.6446228027344,
            "992": 733.8485107421875,
            "993": 279.0033874511719,
            "994": 736.1021118164062,
            "995": 278.6665954589844,
            "996": 736.1072998046875,
            "997": 280.7055358886719,
            "998": 733.8480834960938,
            "999": 281.0029602050781,
            "1000": 733.5870361328125,
            "1001": 279.0200500488281,
            "1002": 736.1072998046875,
            "1003": 280.7055358886719,
            "1004": 733.5870361328125,
            "1005": 279.0200500488281,
            "1006": 735.8462524414062,
            "1007": 278.7226257324219,
            "1008": 735.8157958984375,
            "1009": 280.7613525390625,
            "1010": 733.5517578125,
            "1011": 281.0193176269531,
            "1012": 733.3253173828125,
            "1013": 279.03216552734375,
            "1014": 735.8157958984375,
            "1015": 280.7613525390625,
            "1016": 733.3253173828125,
            "1017": 279.03216552734375,
            "1018": 735.58935546875,
            "1019": 278.7742004394531,
            "1020": 735.5233764648438,
            "1021": 280.81207275390625,
            "1022": 733.2551879882812,
            "1023": 281.0304870605469,
            "1024": 733.0634765625,
            "1025": 279.0397033691406,
            "1026": 735.5233764648438,
            "1027": 280.81207275390625,
            "1028": 733.0634765625,
            "1029": 279.0397033691406,
            "1030": 735.3316650390625,
            "1031": 278.8212890625,
            "1032": 735.2301025390625,
            "1033": 280.8576965332031,
            "1034": 732.9584350585938,
            "1035": 281.0364685058594,
            "1036": 732.801513671875,
            "1037": 279.0426330566406,
            "1038": 735.2301025390625,
            "1039": 280.8576965332031,
            "1040": 732.801513671875,
            "1041": 279.0426330566406,
            "1042": 735.0731811523438,
            "1043": 278.8638610839844,
            "1044": 734.9360961914062,
            "1045": 280.898193359375,
            "1046": 732.66162109375,
            "1047": 281.03729248046875,
            "1048": 732.53955078125,
            "1049": 279.041015625,
            "1050": 734.9360961914062,
            "1051": 280.898193359375,
            "1052": 732.53955078125,
            "1053": 279.041015625,
            "1054": 734.81396484375,
            "1055": 278.90191650390625,
            "1056": 734.6414184570312,
            "1057": 280.93353271484375,
            "1058": 732.3648681640625,
            "1059": 281.0329284667969,
            "1060": 732.2776489257812,
            "1061": 279.03485107421875,
            "1062": 734.6414184570312,
            "1063": 280.93353271484375,
            "1064": 732.2776489257812,
            "1065": 279.03485107421875,
            "1066": 734.5541381835938,
            "1067": 278.9354553222656,
            "1068": 734.3461303710938,
            "1069": 280.9637451171875,
            "1070": 732.0682373046875,
            "1071": 281.0234069824219,
            "1072": 732.015869140625,
            "1073": 279.0240783691406,
            "1074": 734.3461303710938,
            "1075": 280.9637451171875,
            "1076": 732.015869140625,
            "1077": 279.0240783691406,
            "1078": 734.2938232421875,
            "1079": 278.9644470214844,
            "1080": 734.0504150390625,
            "1081": 280.9888000488281,
            "1082": 731.7718505859375,
            "1083": 281.0086975097656,
            "1084": 731.75439453125,
            "1085": 279.0087585449219,
            "1086": 734.0504150390625,
            "1087": 280.9888000488281,
            "1088": 731.75439453125,
            "1089": 279.0087585449219,
            "1090": 734.032958984375,
            "1091": 278.9888916015625,
            "1092": 733.7542724609375,
            "1093": 281.0086975097656,
            "1094": 731.4757080078125,
            "1095": 280.9888000488281,
            "1096": 731.4931640625,
            "1097": 278.9888916015625,
            "1098": 733.7542724609375,
            "1099": 281.0086975097656,
            "1100": 731.4931640625,
            "1101": 278.9888916015625,
            "1102": 733.771728515625,
            "1103": 279.0087585449219,
            "1104": 733.4578857421875,
            "1105": 281.0234069824219,
            "1106": 731.1799926757812,
            "1107": 280.9637451171875,
            "1108": 731.2322998046875,
            "1109": 278.9644470214844,
            "1110": 733.4578857421875,
            "1111": 281.0234069824219,
            "1112": 731.2322998046875,
            "1113": 278.9644470214844,
            "1114": 733.5101928710938,
            "1115": 279.0240783691406,
            "1116": 733.1612548828125,
            "1117": 281.0329284667969,
            "1118": 730.8847045898438,
            "1119": 280.93353271484375,
            "1120": 730.971923828125,
            "1121": 278.9354553222656,
            "1122": 733.1612548828125,
            "1123": 281.0329284667969,
            "1124": 730.971923828125,
            "1125": 278.9354553222656,
            "1126": 733.2484741210938,
            "1127": 279.03485107421875,
            "1128": 732.8644409179688,
            "1129": 281.03729248046875,
            "1130": 730.5900268554688,
            "1131": 280.898193359375,
            "1132": 730.712158203125,
            "1133": 278.90191650390625,
            "1134": 732.8644409179688,
            "1135": 281.03729248046875,
            "1136": 730.712158203125,
            "1137": 278.90191650390625,
            "1138": 732.986572265625,
            "1139": 279.041015625,
            "1140": 732.5676879882812,
            "1141": 281.0364685058594,
            "1142": 730.2960205078125,
            "1143": 280.8576965332031,
            "1144": 730.4529418945312,
            "1145": 278.8638610839844,
            "1146": 732.5676879882812,
            "1147": 281.0364685058594,
            "1148": 730.4529418945312,
            "1149": 278.8638610839844,
            "1150": 732.724609375,
            "1151": 279.0426330566406,
            "1152": 732.2709350585938,
            "1153": 281.0304870605469,
            "1154": 730.0027465820312,
            "1155": 280.81207275390625,
            "1156": 730.1944580078125,
            "1157": 278.8212890625,
            "1158": 732.2709350585938,
            "1159": 281.0304870605469,
            "1160": 730.1944580078125,
            "1161": 278.8212890625,
            "1162": 732.462646484375,
            "1163": 279.0397033691406,
            "1164": 731.974365234375,
            "1165": 281.0193176269531,
            "1166": 729.7103271484375,
            "1167": 280.7613525390625,
            "1168": 729.9367065429688,
            "1169": 278.7742004394531,
            "1170": 731.974365234375,
            "1171": 281.0193176269531,
            "1172": 729.9367065429688,
            "1173": 278.7742004394531,
            "1174": 732.2007446289062,
            "1175": 279.03216552734375,
            "1176": 731.6780395507812,
            "1177": 281.0029602050781,
            "1178": 729.4188232421875,
            "1179": 280.7055358886719,
            "1180": 729.6798706054688,
            "1181": 278.7226257324219,
            "1182": 731.6780395507812,
            "1183": 281.0029602050781,
            "1184": 729.6798706054688,
            "1185": 278.7226257324219,
            "1186": 731.9390869140625,
            "1187": 279.0200500488281,
            "1188": 731.3820190429688,
            "1189": 280.9814147949219,
            "1190": 729.1283569335938,
            "1191": 280.6446228027344,
            "1192": 729.4239501953125,
            "1193": 278.6665954589844,
            "1194": 731.3820190429688,
            "1195": 280.9814147949219,
            "1196": 729.4239501953125,
            "1197": 278.6665954589844,
            "1198": 731.6776123046875,
            "1199": 279.0033874511719,
            "1200": 731.08642578125,
            "1201": 280.9547424316406,
            "1202": 728.8389892578125,
            "1203": 280.5786437988281,
            "1204": 729.1690673828125,
            "1205": 278.6060791015625,
            "1206": 731.08642578125,
            "1207": 280.9547424316406,
            "1208": 729.1690673828125,
            "1209": 278.6060791015625,
            "1210": 731.41650390625,
            "1211": 278.982177734375,
            "1212": 730.7913208007812,
            "1213": 280.92291259765625,
            "1214": 728.55078125,
            "1215": 280.5076599121094,
            "1216": 728.915283203125,
            "1217": 278.5411376953125,
            "1218": 730.7913208007812,
            "1219": 280.92291259765625,
            "1220": 728.915283203125,
            "1221": 278.5411376953125,
            "1222": 731.1558227539062,
            "1223": 278.9563903808594,
            "1224": 730.4968872070312,
            "1225": 280.88592529296875,
            "1226": 728.263916015625,
            "1227": 280.431640625,
            "1228": 728.6626586914062,
            "1229": 278.4717712402344,
            "1230": 730.4968872070312,
            "1231": 280.88592529296875,
            "1232": 728.6626586914062,
            "1233": 278.4717712402344,
            "1234": 730.8955688476562,
            "1235": 278.92608642578125,
            "1236": 730.2030639648438,
            "1237": 280.84381103515625,
            "1238": 727.9783935546875,
            "1239": 280.3506164550781,
            "1240": 728.4112548828125,
            "1241": 278.39801025390625,
            "1242": 730.2030639648438,
            "1243": 280.84381103515625,
            "1244": 728.4112548828125,
            "1245": 278.39801025390625,
            "1246": 730.6359252929688,
            "1247": 278.8912048339844,
            "1248": 729.9100341796875,
            "1249": 280.79656982421875,
            "1250": 727.6943359375,
            "1251": 280.2646179199219,
            "1252": 728.1612548828125,
            "1253": 278.31988525390625,
            "1254": 729.9100341796875,
            "1255": 280.79656982421875,
            "1256": 728.1612548828125,
            "1257": 278.31988525390625,
            "1258": 730.376953125,
            "1259": 278.8518371582031,
            "1260": 729.617919921875,
            "1261": 280.7442321777344,
            "1262": 727.4118041992188,
            "1263": 280.1736755371094,
            "1264": 727.91259765625,
            "1265": 278.2373962402344,
            "1266": 729.617919921875,
            "1267": 280.7442321777344,
            "1268": 727.91259765625,
            "1269": 278.2373962402344,
            "1270": 730.11865234375,
            "1271": 278.80792236328125,
            "1272": 729.3267211914062,
            "1273": 280.6867980957031,
            "1274": 727.1309204101562,
            "1275": 280.0778503417969,
            "1276": 727.6654052734375,
            "1277": 278.15057373046875,
            "1278": 729.3267211914062,
            "1279": 280.6867980957031,
            "1280": 727.6654052734375,
            "1281": 278.15057373046875,
            "1282": 729.8612060546875,
            "1283": 278.759521484375,
            "1284": 729.03662109375,
            "1285": 280.624267578125,
            "1286": 726.8517456054688,
            "1287": 279.97711181640625,
            "1288": 727.4197998046875,
            "1289": 278.0594482421875,
            "1290": 729.03662109375,
            "1291": 280.624267578125,
            "1292": 727.4197998046875,
            "1293": 278.0594482421875,
            "1294": 729.6046142578125,
            "1295": 278.7066345214844,
            "1296": 728.7476196289062,
            "1297": 280.55670166015625,
            "1298": 726.5744018554688,
            "1299": 279.8714904785156,
            "1300": 727.17578125,
            "1301": 277.9640808105469,
            "1302": 728.7476196289062,
            "1303": 280.55670166015625,
            "1304": 727.17578125,
            "1305": 277.9640808105469,
            "1306": 729.3489990234375,
            "1307": 278.6492919921875,
            "1308": 728.4598388671875,
            "1309": 280.484130859375,
            "1310": 726.2988891601562,
            "1311": 279.7610778808594,
            "1312": 726.9335327148438,
            "1313": 277.86444091796875,
            "1314": 728.4598388671875,
            "1315": 280.484130859375,
            "1316": 726.9335327148438,
            "1317": 277.86444091796875,
            "1318": 729.0944213867188,
            "1319": 278.58746337890625,
            "1320": 728.17333984375,
            "1321": 280.4065246582031,
            "1322": 726.025390625,
            "1323": 279.6458740234375,
            "1324": 726.6929931640625,
            "1325": 277.7605895996094,
            "1326": 728.17333984375,
            "1327": 280.4065246582031,
            "1328": 726.6929931640625,
            "1329": 277.7605895996094,
            "1330": 728.8409423828125,
            "1331": 278.521240234375,
            "1332": 727.8883056640625,
            "1333": 280.32391357421875,
            "1334": 725.75390625,
            "1335": 279.5259094238281,
            "1336": 726.454345703125,
            "1337": 277.6525573730469,
            "1338": 727.8883056640625,
            "1339": 280.32391357421875,
            "1340": 726.454345703125,
            "1341": 277.6525573730469,
            "1342": 728.5886840820312,
            "1343": 278.4505615234375,
            "1344": 727.604736328125,
            "1345": 280.2363586425781,
            "1346": 725.4845581054688,
            "1347": 279.4012145996094,
            "1348": 726.2175903320312,
            "1349": 277.5403747558594,
            "1350": 727.604736328125,
            "1351": 280.2363586425781,
            "1352": 726.2175903320312,
            "1353": 277.5403747558594,
            "1354": 728.3377075195312,
            "1355": 278.3755187988281,
            "1356": 727.3226928710938,
            "1357": 280.14385986328125,
            "1358": 725.2174682617188,
            "1359": 279.2718505859375,
            "1360": 725.9828491210938,
            "1361": 277.4241027832031,
            "1362": 727.3226928710938,
            "1363": 280.14385986328125,
            "1364": 725.9828491210938,
            "1365": 277.4241027832031,
            "1366": 728.0880737304688,
            "1367": 278.2961120605469,
            "1368": 727.0423583984375,
            "1369": 280.0464782714844,
            "1370": 724.95263671875,
            "1371": 279.1378479003906,
            "1372": 725.7501220703125,
            "1373": 277.3037109375,
            "1374": 727.0423583984375,
            "1375": 280.0464782714844,
            "1376": 725.7501220703125,
            "1377": 277.3037109375,
            "1378": 727.83984375,
            "1379": 278.21234130859375,
            "1380": 726.7637329101562,
            "1381": 279.9441833496094,
            "1382": 724.690185546875,
            "1383": 278.9992370605469,
            "1384": 725.5195922851562,
            "1385": 277.1793212890625,
            "1386": 726.7637329101562,
            "1387": 279.9441833496094,
            "1388": 725.5195922851562,
            "1389": 277.1793212890625,
            "1390": 727.5931396484375,
            "1391": 278.124267578125,
            "1392": 726.4869384765625,
            "1393": 279.8370666503906,
            "1394": 724.4302368164062,
            "1395": 278.8560485839844,
            "1396": 725.291259765625,
            "1397": 277.0509033203125,
            "1398": 726.4869384765625,
            "1399": 279.8370666503906,
            "1400": 725.291259765625,
            "1401": 277.0509033203125,
            "1402": 727.3479614257812,
            "1403": 278.0318908691406,
            "1404": 726.2120971679688,
            "1405": 279.7251281738281,
            "1406": 724.1727905273438,
            "1407": 278.7083740234375,
            "1408": 725.065185546875,
            "1409": 276.91851806640625,
            "1410": 726.2120971679688,
            "1411": 279.7251281738281,
            "1412": 725.065185546875,
            "1413": 276.91851806640625,
            "1414": 727.1044921875,
            "1415": 277.93524169921875,
            "1416": 725.939208984375,
            "1417": 279.6083984375,
            "1418": 723.91796875,
            "1419": 278.55621337890625,
            "1420": 724.8414916992188,
            "1421": 276.7821960449219,
            "1422": 725.939208984375,
            "1423": 279.6083984375,
            "1424": 724.8414916992188,
            "1425": 276.7821960449219,
            "1426": 726.8626708984375,
            "1427": 277.8343811035156,
            "1428": 725.6683959960938,
            "1429": 279.4869384765625,
            "1430": 723.6658325195312,
            "1431": 278.3996276855469,
            "1432": 724.6201782226562,
            "1433": 276.6419982910156,
            "1434": 725.6683959960938,
            "1435": 279.4869384765625,
            "1436": 724.6201782226562,
            "1437": 276.6419982910156,
            "1438": 726.6227416992188,
            "1439": 277.72930908203125,
            "1440": 725.3997802734375,
            "1441": 279.3607482910156,
            "1442": 723.41650390625,
            "1443": 278.2386779785156,
            "1444": 724.4013671875,
            "1445": 276.49798583984375,
            "1446": 725.3997802734375,
            "1447": 279.3607482910156,
            "1448": 724.4013671875,
            "1449": 276.49798583984375,
            "1450": 726.3845825195312,
            "1451": 277.62005615234375,
            "1452": 725.1333618164062,
            "1453": 279.22991943359375,
            "1454": 723.1699829101562,
            "1455": 278.0733947753906,
            "1456": 724.18505859375,
            "1457": 276.3501281738281,
            "1458": 725.1333618164062,
            "1459": 279.22991943359375,
            "1460": 724.18505859375,
            "1461": 276.3501281738281,
            "1462": 726.1484375,
            "1463": 277.50665283203125,
            "1464": 724.8692626953125,
            "1465": 279.0944519042969,
            "1466": 722.9263916015625,
            "1467": 277.9038391113281,
            "1468": 723.9713745117188,
            "1469": 276.19854736328125,
            "1470": 724.8692626953125,
            "1471": 279.0944519042969,
            "1472": 723.9713745117188,
            "1473": 276.19854736328125,
            "1474": 725.914306640625,
            "1475": 277.38916015625,
            "1476": 724.6076049804688,
            "1477": 278.9543762207031,
            "1478": 722.685791015625,
            "1479": 277.73004150390625,
            "1480": 723.7603759765625,
            "1481": 276.04327392578125,
            "1482": 724.6076049804688,
            "1483": 278.9543762207031,
            "1484": 723.7603759765625,
            "1485": 276.04327392578125,
            "1486": 725.6822509765625,
            "1487": 277.2676086425781,
            "1488": 724.3484497070312,
            "1489": 278.8097839355469,
            "1490": 722.4483032226562,
            "1491": 277.5520935058594,
            "1492": 723.5521850585938,
            "1493": 275.8843078613281,
            "1494": 724.3484497070312,
            "1495": 278.8097839355469,
            "1496": 723.5521850585938,
            "1497": 275.8843078613281,
            "1498": 725.4523315429688,
            "1499": 277.1419982910156,
            "1500": 724.091796875,
            "1501": 278.6606750488281,
            "1502": 722.2139282226562,
            "1503": 277.3700256347656,
            "1504": 723.3467407226562,
            "1505": 275.7217712402344,
            "1506": 724.091796875,
            "1507": 278.6606750488281,
            "1508": 723.3467407226562,
            "1509": 275.7217712402344,
            "1510": 725.224609375,
            "1511": 277.0124206542969,
            "1512": 723.8378295898438,
            "1513": 278.5071105957031,
            "1514": 721.9827270507812,
            "1515": 277.1838684082031,
            "1516": 723.1441650390625,
            "1517": 275.5556335449219,
            "1518": 723.8378295898438,
            "1519": 278.5071105957031,
            "1520": 723.1441650390625,
            "1521": 275.5556335449219,
            "1522": 724.999267578125,
            "1523": 276.8788757324219,
            "1524": 723.5866088867188,
            "1525": 278.3491516113281,
            "1526": 721.7548217773438,
            "1527": 276.9937438964844,
            "1528": 722.9445190429688,
            "1529": 275.3860168457031,
            "1530": 723.5866088867188,
            "1531": 278.3491516113281,
            "1532": 722.9445190429688,
            "1533": 275.3860168457031,
            "1534": 724.7762451171875,
            "1535": 276.7414245605469,
            "1536": 723.338134765625,
            "1537": 278.1867980957031,
            "1538": 721.5303344726562,
            "1539": 276.7996520996094,
            "1540": 722.7478637695312,
            "1541": 275.2129211425781,
            "1542": 723.338134765625,
            "1543": 278.1867980957031,
            "1544": 722.7478637695312,
            "1545": 275.2129211425781,
            "1546": 724.5556640625,
            "1547": 276.60009765625,
            "1548": 723.092529296875,
            "1549": 278.0201721191406,
            "1550": 721.3092041015625,
            "1551": 276.6016540527344,
            "1552": 722.5542602539062,
            "1553": 275.03643798828125,
            "1554": 723.092529296875,
            "1555": 278.0201721191406,
            "1556": 722.5542602539062,
            "1557": 275.03643798828125,
            "1558": 724.3375854492188,
            "1559": 276.4549560546875,
            "1560": 722.8499145507812,
            "1561": 277.8492736816406,
            "1562": 721.0916137695312,
            "1563": 276.39984130859375,
            "1564": 722.36376953125,
            "1565": 274.8565979003906,
            "1566": 722.8499145507812,
            "1567": 277.8492736816406,
            "1568": 722.36376953125,
            "1569": 274.8565979003906,
            "1570": 724.1220703125,
            "1571": 276.3060302734375,
            "1572": 722.6102294921875,
            "1573": 277.6741638183594,
            "1574": 720.8775024414062,
            "1575": 276.19427490234375,
            "1576": 722.1764526367188,
            "1577": 274.6734619140625,
            "1578": 722.6102294921875,
            "1579": 277.6741638183594,
            "1580": 722.1764526367188,
            "1581": 274.6734619140625,
            "1582": 723.9091796875,
            "1583": 276.1533508300781,
            "1584": 722.3737182617188,
            "1585": 277.494873046875,
            "1586": 720.6671142578125,
            "1587": 275.9849853515625,
            "1588": 721.9923095703125,
            "1589": 274.487060546875,
            "1590": 722.3737182617188,
            "1591": 277.494873046875,
            "1592": 721.9923095703125,
            "1593": 274.487060546875,
            "1594": 723.698974609375,
            "1595": 275.9969787597656,
            "1596": 722.140380859375,
            "1597": 277.3115234375,
            "1598": 720.4603271484375,
            "1599": 275.7720642089844,
            "1600": 721.8115234375,
            "1601": 274.2975158691406,
            "1602": 722.140380859375,
            "1603": 277.3115234375,
            "1604": 721.8115234375,
            "1605": 274.2975158691406,
            "1606": 723.4915161132812,
            "1607": 275.8369445800781,
            "1608": 721.9102172851562,
            "1609": 277.12408447265625,
            "1610": 720.25732421875,
            "1611": 275.5555725097656,
            "1612": 721.634033203125,
            "1613": 274.10479736328125,
            "1614": 721.9102172851562,
            "1615": 277.12408447265625,
            "1616": 721.634033203125,
            "1617": 274.10479736328125,
            "1618": 723.2869262695312,
            "1619": 275.67333984375,
            "1620": 721.6834106445312,
            "1621": 276.9327087402344,
            "1622": 720.05810546875,
            "1623": 275.3355407714844,
            "1624": 721.4599609375,
            "1625": 273.9090576171875,
            "1626": 721.6834106445312,
            "1627": 276.9327087402344,
            "1628": 721.4599609375,
            "1629": 273.9090576171875,
            "1630": 723.085205078125,
            "1631": 275.5061950683594,
            "1632": 721.4599609375,
            "1633": 276.73736572265625,
            "1634": 719.86279296875,
            "1635": 275.1120910644531,
            "1636": 721.289306640625,
            "1637": 273.71026611328125,
            "1638": 721.4599609375,
            "1639": 276.73736572265625,
            "1640": 721.289306640625,
            "1641": 273.71026611328125,
            "1642": 722.8864135742188,
            "1643": 275.3355407714844,
            "1644": 721.2399291992188,
            "1645": 276.5381774902344,
            "1646": 719.67138671875,
            "1647": 274.88525390625,
            "1648": 721.1221313476562,
            "1649": 273.508544921875,
            "1650": 721.2399291992188,
            "1651": 276.5381774902344,
            "1652": 721.1221313476562,
            "1653": 273.508544921875,
            "1654": 722.690673828125,
            "1655": 275.1614685058594,
            "1656": 721.0234375,
            "1657": 276.33514404296875,
            "1658": 719.4839477539062,
            "1659": 274.6551208496094,
            "1660": 720.95849609375,
            "1661": 273.303955078125,
            "1662": 721.0234375,
            "1663": 276.33514404296875,
            "1664": 720.95849609375,
            "1665": 273.303955078125,
            "1666": 722.4979858398438,
            "1667": 274.9839782714844,
            "1668": 720.8104858398438,
            "1669": 276.1283874511719,
            "1670": 719.3005981445312,
            "1671": 274.4217529296875,
            "1672": 720.7985229492188,
            "1673": 273.0965270996094,
            "1674": 720.8104858398438,
            "1675": 276.1283874511719,
            "1676": 720.7985229492188,
            "1677": 273.0965270996094,
            "1678": 722.3084106445312,
            "1679": 274.80316162109375,
            "1680": 720.6011962890625,
            "1681": 275.9179382324219,
            "1682": 719.121337890625,
            "1683": 274.18524169921875,
            "1684": 720.6421508789062,
            "1685": 272.8863220214844,
            "1686": 720.6011962890625,
            "1687": 275.9179382324219,
            "1688": 720.6421508789062,
            "1689": 272.8863220214844,
            "1690": 722.1220092773438,
            "1691": 274.6190490722656,
            "1692": 720.3956298828125,
            "1693": 275.7038879394531,
            "1694": 718.9462280273438,
            "1695": 273.9455871582031,
            "1696": 720.4894409179688,
            "1697": 272.6734313964844,
            "1698": 720.3956298828125,
            "1699": 275.7038879394531,
            "1700": 720.4894409179688,
            "1701": 272.6734313964844,
            "1702": 721.9389038085938,
            "1703": 274.4317321777344,
            "1704": 720.19384765625,
            "1705": 275.48626708984375,
            "1706": 718.7753295898438,
            "1707": 273.70294189453125,
            "1708": 720.3405151367188,
            "1709": 272.4579162597656,
            "1710": 720.19384765625,
            "1711": 275.48626708984375,
            "1712": 720.3405151367188,
            "1713": 272.4579162597656,
            "1714": 721.759033203125,
            "1715": 274.2412414550781,
            "1716": 719.995849609375,
            "1717": 275.2651672363281,
            "1718": 718.608642578125,
            "1719": 273.4573669433594,
            "1720": 720.1953735351562,
            "1721": 272.2398376464844,
            "1722": 719.995849609375,
            "1723": 275.2651672363281,
            "1724": 720.1953735351562,
            "1725": 272.2398376464844,
            "1726": 721.5825805664062,
            "1727": 274.0476379394531,
            "1728": 719.8017578125,
            "1729": 275.0406188964844,
            "1730": 718.4463500976562,
            "1731": 273.2088928222656,
            "1732": 720.0540771484375,
            "1733": 272.0192565917969,
            "1734": 719.8017578125,
            "1735": 275.0406188964844,
            "1736": 720.0540771484375,
            "1737": 272.0192565917969,
            "1738": 721.4094848632812,
            "1739": 273.8509826660156,
            "1740": 719.6116333007812,
            "1741": 274.812744140625,
            "1742": 718.2883911132812,
            "1743": 272.9576416015625,
            "1744": 719.9166259765625,
            "1745": 271.7962341308594,
            "1746": 719.6116333007812,
            "1747": 274.812744140625,
            "1748": 719.9166259765625,
            "1749": 271.7962341308594,
            "1750": 721.2398071289062,
            "1751": 273.6513366699219,
            "1752": 719.4254760742188,
            "1753": 274.5815734863281,
            "1754": 718.1348266601562,
            "1755": 272.70367431640625,
            "1756": 719.7830810546875,
            "1757": 271.57086181640625,
            "1758": 719.4254760742188,
            "1759": 274.5815734863281,
            "1760": 719.7830810546875,
            "1761": 271.57086181640625,
            "1762": 721.07373046875,
            "1763": 273.4487609863281,
            "1764": 719.243408203125,
            "1765": 274.3471984863281,
            "1766": 717.9857177734375,
            "1767": 272.4470520019531,
            "1768": 719.6534423828125,
            "1769": 271.3431701660156,
            "1770": 719.243408203125,
            "1771": 274.3471984863281,
            "1772": 719.6534423828125,
            "1773": 271.3431701660156,
            "1774": 720.9111328125,
            "1775": 273.2433166503906,
            "1776": 719.0654296875,
            "1777": 274.10968017578125,
            "1778": 717.8411254882812,
            "1779": 272.1878662109375,
            "1780": 719.5278930664062,
            "1781": 271.1132507324219,
            "1782": 719.0654296875,
            "1783": 274.10968017578125,
            "1784": 719.5278930664062,
            "1785": 271.1132507324219,
            "1786": 720.752197265625,
            "1787": 273.03509521484375,
            "1788": 718.8916625976562,
            "1789": 273.86907958984375,
            "1790": 717.7010498046875,
            "1791": 271.92620849609375,
            "1792": 719.4063110351562,
            "1793": 270.8811950683594,
            "1794": 718.8916625976562,
            "1795": 273.86907958984375,
            "1796": 719.4063110351562,
            "1797": 270.8811950683594,
            "1798": 720.596923828125,
            "1799": 272.8240966796875,
            "1800": 718.7221069335938,
            "1801": 273.62548828125,
            "1802": 717.5655517578125,
            "1803": 271.662109375,
            "1804": 719.288818359375,
            "1805": 270.64703369140625,
            "1806": 718.7221069335938,
            "1807": 273.62548828125,
            "1808": 719.288818359375,
            "1809": 270.64703369140625,
            "1810": 720.4453735351562,
            "1811": 272.61041259765625,
            "1812": 718.5568237304688,
            "1813": 273.3789978027344,
            "1814": 717.4347534179688,
            "1815": 271.3957214355469,
            "1816": 719.1754150390625,
            "1817": 270.410888671875,
            "1818": 718.5568237304688,
            "1819": 273.3789978027344,
            "1820": 719.1754150390625,
            "1821": 270.410888671875,
            "1822": 720.2974853515625,
            "1823": 272.3941345214844,
            "1824": 718.3958740234375,
            "1825": 273.129638671875,
            "1826": 717.3085327148438,
            "1827": 271.1270751953125,
            "1828": 719.066162109375,
            "1829": 270.1727600097656,
            "1830": 718.3958740234375,
            "1831": 273.129638671875,
            "1832": 719.066162109375,
            "1833": 270.1727600097656,
            "1834": 720.1535034179688,
            "1835": 272.1753234863281,
            "1836": 718.2392578125,
            "1837": 272.87750244140625,
            "1838": 717.1870727539062,
            "1839": 270.8562927246094,
            "1840": 718.9611206054688,
            "1841": 269.93280029296875,
            "1842": 718.2392578125,
            "1843": 272.87750244140625,
            "1844": 718.9611206054688,
            "1845": 269.93280029296875,
            "1846": 720.0133056640625,
            "1847": 271.9540100097656,
            "1848": 718.0870971679688,
            "1849": 272.6226806640625,
            "1850": 717.0703735351562,
            "1851": 270.5834045410156,
            "1852": 718.8602294921875,
            "1853": 269.6910095214844,
            "1854": 718.0870971679688,
            "1855": 272.6226806640625,
            "1856": 718.8602294921875,
            "1857": 269.6910095214844,
            "1858": 719.876953125,
            "1859": 271.73028564453125,
            "1860": 717.939453125,
            "1861": 272.365234375,
            "1862": 716.9584350585938,
            "1863": 270.30853271484375,
            "1864": 718.7636108398438,
            "1865": 269.447509765625,
            "1866": 717.939453125,
            "1867": 272.365234375,
            "1868": 718.7636108398438,
            "1869": 269.447509765625,
            "1870": 719.7445678710938,
            "1871": 271.50421142578125,
            "1872": 717.7962646484375,
            "1873": 272.1052551269531,
            "1874": 716.851318359375,
            "1875": 270.0317687988281,
            "1876": 718.6712036132812,
            "1877": 269.2023620605469,
            "1878": 717.7962646484375,
            "1879": 272.1052551269531,
            "1880": 718.6712036132812,
            "1881": 269.2023620605469,
            "1882": 719.6161499023438,
            "1883": 271.27587890625,
            "1884": 717.6576538085938,
            "1885": 271.84283447265625,
            "1886": 716.7490234375,
            "1887": 269.7531433105469,
            "1888": 718.5831298828125,
            "1889": 268.9556579589844,
            "1890": 717.6576538085938,
            "1891": 271.84283447265625,
            "1892": 718.5831298828125,
            "1893": 268.9556579589844,
            "1894": 719.4917602539062,
            "1895": 271.04534912109375,
            "1896": 717.5236206054688,
            "1897": 271.5780029296875,
            "1898": 716.651611328125,
            "1899": 269.4727783203125,
            "1900": 718.4993896484375,
            "1901": 268.7074279785156,
            "1902": 717.5236206054688,
            "1903": 271.5780029296875,
            "1904": 718.4993896484375,
            "1905": 268.7074279785156,
            "1906": 719.3713989257812,
            "1907": 270.8126525878906,
            "1908": 717.394287109375,
            "1909": 271.3109130859375,
            "1910": 716.5591430664062,
            "1911": 269.1907653808594,
            "1912": 718.4199829101562,
            "1913": 268.457763671875,
            "1914": 717.394287109375,
            "1915": 271.3109130859375,
            "1916": 718.4199829101562,
            "1917": 268.457763671875,
            "1918": 719.255126953125,
            "1919": 270.5779113769531,
            "1920": 717.2695922851562,
            "1921": 271.04156494140625,
            "1922": 716.4715576171875,
            "1923": 268.9071960449219,
            "1924": 718.3449096679688,
            "1925": 268.206787109375,
            "1926": 717.2695922851562,
            "1927": 271.04156494140625,
            "1928": 718.3449096679688,
            "1929": 268.206787109375,
            "1930": 719.1429443359375,
            "1931": 270.3411560058594,
            "1932": 717.1495971679688,
            "1933": 270.7701110839844,
            "1934": 716.3889770507812,
            "1935": 268.62213134765625,
            "1936": 718.2742309570312,
            "1937": 267.9544982910156,
            "1938": 717.1495971679688,
            "1939": 270.7701110839844,
            "1940": 718.2742309570312,
            "1941": 267.9544982910156,
            "1942": 719.034912109375,
            "1943": 270.1025085449219,
            "1944": 717.034423828125,
            "1945": 270.49658203125,
            "1946": 716.3113403320312,
            "1947": 268.3356628417969,
            "1948": 718.2080078125,
            "1949": 267.7010498046875,
            "1950": 717.034423828125,
            "1951": 270.49658203125,
            "1952": 718.2080078125,
            "1953": 267.7010498046875,
            "1954": 718.9310302734375,
            "1955": 269.8619689941406,
            "1956": 716.9240112304688,
            "1957": 270.2210998535156,
            "1958": 716.23876953125,
            "1959": 268.0478820800781,
            "1960": 718.1461791992188,
            "1961": 267.44647216796875,
            "1962": 716.9240112304688,
            "1963": 270.2210998535156,
            "1964": 718.1461791992188,
            "1965": 267.44647216796875,
            "1966": 718.8314208984375,
            "1967": 269.61968994140625,
            "1968": 716.818359375,
            "1969": 269.9437255859375,
            "1970": 716.1712036132812,
            "1971": 267.7588806152344,
            "1972": 718.0888671875,
            "1973": 267.19085693359375,
            "1974": 716.818359375,
            "1975": 269.9437255859375,
            "1976": 718.0888671875,
            "1977": 267.19085693359375,
            "1978": 718.7360229492188,
            "1979": 269.3757019042969,
            "1980": 716.7176513671875,
            "1981": 269.66455078125,
            "1982": 716.1087036132812,
            "1983": 267.46875,
            "1984": 718.0359497070312,
            "1985": 266.93426513671875,
            "1986": 716.7176513671875,
            "1987": 269.66455078125,
            "1988": 718.0359497070312,
            "1989": 266.93426513671875,
            "1990": 718.6448974609375,
            "1991": 269.13006591796875,
            "1992": 716.621826171875,
            "1993": 269.3836669921875,
            "1994": 716.05126953125,
            "1995": 267.17755126953125,
            "1996": 717.987548828125,
            "1997": 266.67681884765625,
            "1998": 716.621826171875,
            "1999": 269.3836669921875,
            "2000": 717.987548828125,
            "2001": 266.67681884765625,
            "2002": 718.55810546875,
            "2003": 268.8829040527344,
            "2004": 716.5308837890625,
            "2005": 269.10113525390625,
            "2006": 715.9989013671875,
            "2007": 266.88543701171875,
            "2008": 717.9436645507812,
            "2009": 266.4185485839844,
            "2010": 716.5308837890625,
            "2011": 269.10113525390625,
            "2012": 717.9436645507812,
            "2013": 266.4185485839844,
            "2014": 718.4755859375,
            "2015": 268.6342468261719,
            "2016": 716.4448852539062,
            "2017": 268.81707763671875,
            "2018": 715.95166015625,
            "2019": 266.5924072265625,
            "2020": 717.904296875,
            "2021": 266.1595458984375,
            "2022": 716.4448852539062,
            "2023": 268.81707763671875,
            "2024": 717.904296875,
            "2025": 266.1595458984375,
            "2026": 718.3974609375,
            "2027": 268.38421630859375,
            "2028": 716.3638305664062,
            "2029": 268.53155517578125,
            "2030": 715.9095458984375,
            "2031": 266.2986145019531,
            "2032": 717.869384765625,
            "2033": 265.89990234375,
            "2034": 716.3638305664062,
            "2035": 268.53155517578125,
            "2036": 717.869384765625,
            "2037": 265.89990234375,
            "2038": 718.32373046875,
            "2039": 268.1328430175781,
            "2040": 716.287841796875,
            "2041": 268.2446594238281,
            "2042": 715.87255859375,
            "2043": 266.004150390625,
            "2044": 717.839111328125,
            "2045": 265.6396789550781,
            "2046": 716.287841796875,
            "2047": 268.2446594238281,
            "2048": 717.839111328125,
            "2049": 265.6396789550781,
            "2050": 718.2543334960938,
            "2051": 267.88018798828125,
            "2052": 716.2168579101562,
            "2053": 267.9565124511719,
            "2054": 715.8407592773438,
            "2055": 265.7090759277344,
            "2056": 717.8132934570312,
            "2057": 265.37896728515625,
            "2058": 716.2168579101562,
            "2059": 267.9565124511719,
            "2060": 717.8132934570312,
            "2061": 265.37896728515625,
            "2062": 718.1893920898438,
            "2063": 267.62640380859375,
            "2064": 716.15087890625,
            "2065": 267.6671447753906,
            "2066": 715.8140258789062,
            "2067": 265.4134826660156,
            "2068": 717.7921142578125,
            "2069": 265.11785888671875,
            "2070": 716.15087890625,
            "2071": 267.6671447753906,
            "2072": 717.7921142578125,
            "2073": 265.11785888671875,
            "2074": 718.12890625,
            "2075": 267.37152099609375,
            "2076": 716.0899658203125,
            "2077": 267.37664794921875,
            "2078": 715.7925415039062,
            "2079": 265.1174621582031,
            "2080": 717.7754516601562,
            "2081": 264.8564147949219,
            "2082": 716.0899658203125,
            "2083": 267.37664794921875,
            "2084": 717.7754516601562,
            "2085": 264.8564147949219,
            "2086": 718.0728759765625,
            "2087": 267.1156005859375,
            "2088": 716.0341186523438,
            "2089": 267.0851745605469,
            "2090": 715.7761840820312,
            "2091": 264.8211364746094,
            "2092": 717.7633056640625,
            "2093": 264.5947265625,
            "2094": 716.0341186523438,
            "2095": 267.0851745605469,
            "2096": 717.7633056640625,
            "2097": 264.5947265625,
            "2098": 718.0213012695312,
            "2099": 266.8587646484375,
            "2100": 715.9833984375,
            "2101": 266.792724609375,
            "2102": 715.7650146484375,
            "2103": 264.5245361328125,
            "2104": 717.7557983398438,
            "2105": 264.3328552246094,
            "2106": 715.9833984375,
            "2107": 266.792724609375,
            "2108": 717.7557983398438,
            "2109": 264.3328552246094,
            "2110": 717.9741821289062,
            "2111": 266.6010437011719,
            "2112": 715.9378051757812,
            "2113": 266.4994812011719,
            "2114": 715.759033203125,
            "2115": 264.2278137207031,
            "2116": 717.7528686523438,
            "2117": 264.0708923339844,
            "2118": 715.9378051757812,
            "2119": 266.4994812011719,
            "2120": 717.7528686523438,
            "2121": 264.0708923339844,
            "2122": 717.931640625,
            "2123": 266.3425598144531,
            "2124": 715.8972778320312,
            "2125": 266.2054443359375,
            "2126": 715.7581787109375,
            "2127": 263.9310302734375,
            "2128": 717.7544555664062,
            "2129": 263.8089294433594,
            "2130": 715.8972778320312,
            "2131": 266.2054443359375,
            "2132": 717.7544555664062,
            "2133": 263.8089294433594,
            "2134": 717.8935546875,
            "2135": 266.0833435058594,
            "2136": 715.8619384765625,
            "2137": 265.9107666015625,
            "2138": 715.7625732421875,
            "2139": 263.6342468261719,
            "2140": 717.7606201171875,
            "2141": 263.5470275878906,
            "2142": 715.8619384765625,
            "2143": 265.9107666015625,
            "2144": 717.7606201171875,
            "2145": 263.5470275878906,
            "2146": 717.8600463867188,
            "2147": 265.82354736328125,
            "2148": 715.8317260742188,
            "2149": 265.6155090332031,
            "2150": 715.7720947265625,
            "2151": 263.3376159667969,
            "2152": 717.7714233398438,
            "2153": 263.2852783203125,
            "2154": 715.8317260742188,
            "2155": 265.6155090332031,
            "2156": 717.7714233398438,
            "2157": 263.2852783203125,
            "2158": 717.8310546875,
            "2159": 265.56317138671875,
            "2160": 715.8067016601562,
            "2161": 265.3197937011719,
            "2162": 715.7868041992188,
            "2163": 263.04119873046875,
            "2164": 717.7867431640625,
            "2165": 263.02374267578125,
            "2166": 715.8067016601562,
            "2167": 265.3197937011719,
            "2168": 717.7867431640625,
            "2169": 263.02374267578125,
            "2170": 717.8065795898438,
            "2171": 265.3023376464844,
            "2172": 715.7868041992188,
            "2173": 265.0236511230469,
            "2174": 715.8067016601562,
            "2175": 262.74505615234375,
            "2176": 717.8065795898438,
            "2177": 262.76251220703125,
            "2178": 715.7868041992188,
            "2179": 265.0236511230469,
            "2180": 717.8065795898438,
            "2181": 262.76251220703125,
            "2182": 717.7867431640625,
            "2183": 265.0411071777344,
            "2184": 715.7720947265625,
            "2185": 264.72723388671875,
            "2186": 715.8317260742188,
            "2187": 262.4493408203125,
            "2188": 717.8310546875,
            "2189": 262.5016784667969,
            "2190": 715.7720947265625,
            "2191": 264.72723388671875,
            "2192": 717.8310546875,
            "2193": 262.5016784667969,
            "2194": 717.7714233398438,
            "2195": 264.77960205078125,
            "2196": 715.7625732421875,
            "2197": 264.43060302734375,
            "2198": 715.8619384765625,
            "2199": 262.1540832519531,
            "2200": 717.8600463867188,
            "2201": 262.2413330078125,
            "2202": 715.7625732421875,
            "2203": 264.43060302734375,
            "2204": 717.8600463867188,
            "2205": 262.2413330078125,
            "2206": 717.7606201171875,
            "2207": 264.517822265625,
            "2208": 715.7581787109375,
            "2209": 264.13385009765625,
            "2210": 715.8972778320312,
            "2211": 261.8594055175781,
            "2212": 717.8935546875,
            "2213": 261.98150634765625,
            "2214": 715.7581787109375,
            "2215": 264.13385009765625,
            "2216": 717.8935546875,
            "2217": 261.98150634765625,
            "2218": 717.7544555664062,
            "2219": 264.25592041015625,
            "2220": 715.759033203125,
            "2221": 263.8370361328125,
            "2222": 715.9378051757812,
            "2223": 261.5653991699219,
            "2224": 717.931640625,
            "2225": 261.7222900390625,
            "2226": 715.759033203125,
            "2227": 263.8370361328125,
            "2228": 717.931640625,
            "2229": 261.7222900390625,
            "2230": 717.7528686523438,
            "2231": 263.99395751953125,
            "2232": 715.7650146484375,
            "2233": 263.5403137207031,
            "2234": 715.9833984375,
            "2235": 261.2721252441406,
            "2236": 717.9741821289062,
            "2237": 261.46380615234375,
            "2238": 715.7650146484375,
            "2239": 263.5403137207031,
            "2240": 717.9741821289062,
            "2241": 261.46380615234375,
            "2242": 717.7557983398438,
            "2243": 263.73199462890625,
            "2244": 715.7761840820312,
            "2245": 263.2437438964844,
            "2246": 716.0341186523438,
            "2247": 260.9797058105469,
            "2248": 718.0213012695312,
            "2249": 261.20611572265625,
            "2250": 715.7761840820312,
            "2251": 263.2437438964844,
            "2252": 718.0213012695312,
            "2253": 261.20611572265625,
            "2254": 717.7633056640625,
            "2255": 263.4701232910156,
            "2256": 715.7925415039062,
            "2257": 262.9473876953125,
            "2258": 716.0899658203125,
            "2259": 260.6882019042969,
            "2260": 718.0728759765625,
            "2261": 260.9492492675781,
            "2262": 715.7925415039062,
            "2263": 262.9473876953125,
            "2264": 718.0728759765625,
            "2265": 260.9492492675781,
            "2266": 717.7754516601562,
            "2267": 263.20843505859375,
            "2268": 715.8140258789062,
            "2269": 262.6513671875,
            "2270": 716.15087890625,
            "2271": 260.3977355957031,
            "2272": 718.12890625,
            "2273": 260.6933288574219,
            "2274": 715.8140258789062,
            "2275": 262.6513671875,
            "2276": 718.12890625,
            "2277": 260.6933288574219,
            "2278": 717.7921142578125,
            "2279": 262.9469909667969,
            "2280": 715.8407592773438,
            "2281": 262.35577392578125,
            "2282": 716.2168579101562,
            "2283": 260.1083679199219,
            "2284": 718.1893920898438,
            "2285": 260.4384460449219,
            "2286": 715.8407592773438,
            "2287": 262.35577392578125,
            "2288": 718.1893920898438,
            "2289": 260.4384460449219,
            "2290": 717.8132934570312,
            "2291": 262.6858825683594,
            "2292": 715.87255859375,
            "2293": 262.0606994628906,
            "2294": 716.287841796875,
            "2295": 259.8201904296875,
            "2296": 718.2543334960938,
            "2297": 260.1846618652344,
            "2298": 715.87255859375,
            "2299": 262.0606994628906,
            "2300": 718.2543334960938,
            "2301": 260.1846618652344,
            "2302": 717.839111328125,
            "2303": 262.4251708984375,
            "2304": 715.9095458984375,
            "2305": 261.7662353515625,
            "2306": 716.3638305664062,
            "2307": 259.5332946777344,
            "2308": 718.32373046875,
            "2309": 259.9320373535156,
            "2310": 715.9095458984375,
            "2311": 261.7662353515625,
            "2312": 718.32373046875,
            "2313": 259.9320373535156,
            "2314": 717.869384765625,
            "2315": 262.16497802734375,
            "2316": 715.95166015625,
            "2317": 261.4724426269531,
            "2318": 716.4448852539062,
            "2319": 259.2477722167969,
            "2320": 718.3974609375,
            "2321": 259.6806335449219,
            "2322": 715.95166015625,
            "2323": 261.4724426269531,
            "2324": 718.3974609375,
            "2325": 259.6806335449219,
            "2326": 717.904296875,
            "2327": 261.9053039550781,
            "2328": 715.9989013671875,
            "2329": 261.179443359375,
            "2330": 716.5308837890625,
            "2331": 258.9637145996094,
            "2332": 718.4755859375,
            "2333": 259.43060302734375,
            "2334": 715.9989013671875,
            "2335": 261.179443359375,
            "2336": 718.4755859375,
            "2337": 259.43060302734375,
            "2338": 717.9436645507812,
            "2339": 261.6463317871094,
            "2340": 716.05126953125,
            "2341": 260.8872985839844,
            "2342": 716.621826171875,
            "2343": 258.6811828613281,
            "2344": 718.55810546875,
            "2345": 259.18194580078125,
            "2346": 716.05126953125,
            "2347": 260.8872985839844,
            "2348": 718.55810546875,
            "2349": 259.18194580078125,
            "2350": 717.987548828125,
            "2351": 261.3880615234375,
            "2352": 716.1087036132812,
            "2353": 260.5960998535156,
            "2354": 716.7176513671875,
            "2355": 258.4002990722656,
            "2356": 718.6448974609375,
            "2357": 258.9347839355469,
            "2358": 716.1087036132812,
            "2359": 260.5960998535156,
            "2360": 718.6448974609375,
            "2361": 258.9347839355469,
            "2362": 718.0359497070312,
            "2363": 261.1305847167969,
            "2364": 716.1712036132812,
            "2365": 260.30596923828125,
            "2366": 716.818359375,
            "2367": 258.1211242675781,
            "2368": 718.7360229492188,
            "2369": 258.68914794921875,
            "2370": 716.1712036132812,
            "2371": 260.30596923828125,
            "2372": 718.7360229492188,
            "2373": 258.68914794921875,
            "2374": 718.0888671875,
            "2375": 260.8739929199219,
            "2376": 716.23876953125,
            "2377": 260.0169677734375,
            "2378": 716.9240112304688,
            "2379": 257.84375,
            "2380": 718.8314208984375,
            "2381": 258.4451599121094,
            "2382": 716.23876953125,
            "2383": 260.0169677734375,
            "2384": 718.8314208984375,
            "2385": 258.4451599121094,
            "2386": 718.1461791992188,
            "2387": 260.6183776855469,
            "2388": 716.3113403320312,
            "2389": 259.72918701171875,
            "2390": 717.034423828125,
            "2391": 257.5682678222656,
            "2392": 718.9310302734375,
            "2393": 258.202880859375,
            "2394": 716.3113403320312,
            "2395": 259.72918701171875,
            "2396": 718.9310302734375,
            "2397": 258.202880859375,
            "2398": 718.2080078125,
            "2399": 260.3638000488281,
            "2400": 716.3889770507812,
            "2401": 259.4427185058594,
            "2402": 717.1495971679688,
            "2403": 257.29473876953125,
            "2404": 719.034912109375,
            "2405": 257.9623718261719,
            "2406": 716.3889770507812,
            "2407": 259.4427185058594,
            "2408": 719.034912109375,
            "2409": 257.9623718261719,
            "2410": 718.2742309570312,
            "2411": 260.1103515625,
            "2412": 716.4715576171875,
            "2413": 259.15765380859375,
            "2414": 717.2695922851562,
            "2415": 257.0232849121094,
            "2416": 719.1429443359375,
            "2417": 257.72369384765625,
            "2418": 716.4715576171875,
            "2419": 259.15765380859375,
            "2420": 719.1429443359375,
            "2421": 257.72369384765625,
            "2422": 718.3449096679688,
            "2423": 259.8580627441406,
            "2424": 716.5591430664062,
            "2425": 258.87408447265625,
            "2426": 717.394287109375,
            "2427": 256.7539367675781,
            "2428": 719.255126953125,
            "2429": 257.4869384765625,
            "2430": 716.5591430664062,
            "2431": 258.87408447265625,
            "2432": 719.255126953125,
            "2433": 257.4869384765625,
            "2434": 718.4199829101562,
            "2435": 259.6070861816406,
            "2436": 716.651611328125,
            "2437": 258.5920715332031,
            "2438": 717.5236206054688,
            "2439": 256.4868469238281,
            "2440": 719.3713989257812,
            "2441": 257.252197265625,
            "2442": 716.651611328125,
            "2443": 258.5920715332031,
            "2444": 719.3713989257812,
            "2445": 257.252197265625,
            "2446": 718.4993896484375,
            "2447": 259.357421875,
            "2448": 716.7490234375,
            "2449": 258.31170654296875,
            "2450": 717.6576538085938,
            "2451": 256.2220153808594,
            "2452": 719.4917602539062,
            "2453": 257.01953125,
            "2454": 716.7490234375,
            "2455": 258.31170654296875,
            "2456": 719.4917602539062,
            "2457": 257.01953125,
            "2458": 718.5831298828125,
            "2459": 259.1092224121094,
            "2460": 716.851318359375,
            "2461": 258.0331115722656,
            "2462": 717.7962646484375,
            "2463": 255.95957946777344,
            "2464": 719.6161499023438,
            "2465": 256.7889709472656,
            "2466": 716.851318359375,
            "2467": 258.0331115722656,
            "2468": 719.6161499023438,
            "2469": 256.7889709472656,
            "2470": 718.6712036132812,
            "2471": 258.86248779296875,
            "2472": 716.9584350585938,
            "2473": 257.7563171386719,
            "2474": 717.939453125,
            "2475": 255.69960021972656,
            "2476": 719.7445678710938,
            "2477": 256.5606384277344,
            "2478": 716.9584350585938,
            "2479": 257.7563171386719,
            "2480": 719.7445678710938,
            "2481": 256.5606384277344,
            "2482": 718.7636108398438,
            "2483": 258.6173400878906,
            "2484": 717.0703735351562,
            "2485": 257.4814453125,
            "2486": 718.0870971679688,
            "2487": 255.44216918945312,
            "2488": 719.876953125,
            "2489": 256.3345642089844,
            "2490": 717.0703735351562,
            "2491": 257.4814453125,
            "2492": 719.876953125,
            "2493": 256.3345642089844,
            "2494": 718.8602294921875,
            "2495": 258.37384033203125,
            "2496": 717.1870727539062,
            "2497": 257.20855712890625,
            "2498": 718.2392578125,
            "2499": 255.18734741210938,
            "2500": 720.0133056640625,
            "2501": 256.11083984375,
            "2502": 717.1870727539062,
            "2503": 257.20855712890625,
            "2504": 720.0133056640625,
            "2505": 256.11083984375,
            "2506": 718.9611206054688,
            "2507": 258.1320495605469,
            "2508": 717.3085327148438,
            "2509": 256.9377746582031,
            "2510": 718.3958740234375,
            "2511": 254.93521118164062,
            "2512": 720.1535034179688,
            "2513": 255.88954162597656,
            "2514": 717.3085327148438,
            "2515": 256.9377746582031,
            "2516": 720.1535034179688,
            "2517": 255.88954162597656,
            "2518": 719.066162109375,
            "2519": 257.89208984375,
            "2520": 717.4347534179688,
            "2521": 256.66912841796875,
            "2522": 718.5568237304688,
            "2523": 254.6858673095703,
            "2524": 720.2974853515625,
            "2525": 255.67071533203125,
            "2526": 717.4347534179688,
            "2527": 256.66912841796875,
            "2528": 720.2974853515625,
            "2529": 255.67071533203125,
            "2530": 719.1754150390625,
            "2531": 257.6539611816406,
            "2532": 717.5655517578125,
            "2533": 256.4027404785156,
            "2534": 718.7221069335938,
            "2535": 254.43934631347656,
            "2536": 720.4453735351562,
            "2537": 255.4544219970703,
            "2538": 717.5655517578125,
            "2539": 256.4027404785156,
            "2540": 720.4453735351562,
            "2541": 255.4544219970703,
            "2542": 719.288818359375,
            "2543": 257.4178161621094,
            "2544": 717.7010498046875,
            "2545": 256.138671875,
            "2546": 718.8916625976562,
            "2547": 254.19577026367188,
            "2548": 720.596923828125,
            "2549": 255.2407684326172,
            "2550": 717.7010498046875,
            "2551": 256.138671875,
            "2552": 720.596923828125,
            "2553": 255.2407684326172,
            "2554": 719.4063110351562,
            "2555": 257.18365478515625,
            "2556": 717.8411254882812,
            "2557": 255.8769989013672,
            "2558": 719.0654296875,
            "2559": 253.95516967773438,
            "2560": 720.752197265625,
            "2561": 255.02976989746094,
            "2562": 717.8411254882812,
            "2563": 255.8769989013672,
            "2564": 720.752197265625,
            "2565": 255.02976989746094,
            "2566": 719.5278930664062,
            "2567": 256.95159912109375,
            "2568": 717.9857177734375,
            "2569": 255.61781311035156,
            "2570": 719.243408203125,
            "2571": 253.7176513671875,
            "2572": 720.9111328125,
            "2573": 254.82151794433594,
            "2574": 717.9857177734375,
            "2575": 255.61781311035156,
            "2576": 720.9111328125,
            "2577": 254.82151794433594,
            "2578": 719.6534423828125,
            "2579": 256.7216796875,
            "2580": 718.1348266601562,
            "2581": 255.36119079589844,
            "2582": 719.4254760742188,
            "2583": 253.4832763671875,
            "2584": 721.07373046875,
            "2585": 254.6160888671875,
            "2586": 718.1348266601562,
            "2587": 255.36119079589844,
            "2588": 721.07373046875,
            "2589": 254.6160888671875,
            "2590": 719.7830810546875,
            "2591": 256.4940185546875,
            "2592": 718.2883911132812,
            "2593": 255.1072235107422,
            "2594": 719.6116333007812,
            "2595": 253.25210571289062,
            "2596": 721.2398071289062,
            "2597": 254.41351318359375,
            "2598": 718.2883911132812,
            "2599": 255.1072235107422,
            "2600": 721.2398071289062,
            "2601": 254.41351318359375,
            "2602": 719.9166259765625,
            "2603": 256.26861572265625,
            "2604": 718.4463500976562,
            "2605": 254.85595703125,
            "2606": 719.8017578125,
            "2607": 253.0242156982422,
            "2608": 721.4094848632812,
            "2609": 254.2138671875,
            "2610": 718.4463500976562,
            "2611": 254.85595703125,
            "2612": 721.4094848632812,
            "2613": 254.2138671875,
            "2614": 720.0540771484375,
            "2615": 256.04559326171875,
            "2616": 718.608642578125,
            "2617": 254.6074981689453,
            "2618": 719.995849609375,
            "2619": 252.79969787597656,
            "2620": 721.5825805664062,
            "2621": 254.0172119140625,
            "2622": 718.608642578125,
            "2623": 254.6074981689453,
            "2624": 721.5825805664062,
            "2625": 254.0172119140625,
            "2626": 720.1953735351562,
            "2627": 255.82501220703125,
            "2628": 718.7753295898438,
            "2629": 254.36190795898438,
            "2630": 720.19384765625,
            "2631": 252.57858276367188,
            "2632": 721.759033203125,
            "2633": 253.8236083984375,
            "2634": 718.7753295898438,
            "2635": 254.36190795898438,
            "2636": 721.759033203125,
            "2637": 253.8236083984375,
            "2638": 720.3405151367188,
            "2639": 255.60693359375,
            "2640": 718.9462280273438,
            "2641": 254.11924743652344,
            "2642": 720.3956298828125,
            "2643": 252.3609619140625,
            "2644": 721.9389038085938,
            "2645": 253.63311767578125,
            "2646": 718.9462280273438,
            "2647": 254.11924743652344,
            "2648": 721.9389038085938,
            "2649": 253.63311767578125,
            "2650": 720.4894409179688,
            "2651": 255.39141845703125,
            "2652": 719.121337890625,
            "2653": 253.87962341308594,
            "2654": 720.6011962890625,
            "2655": 252.1468963623047,
            "2656": 722.1220092773438,
            "2657": 253.44580078125,
            "2658": 719.121337890625,
            "2659": 253.87962341308594,
            "2660": 722.1220092773438,
            "2661": 253.44580078125,
            "2662": 720.6421508789062,
            "2663": 255.17852783203125,
            "2664": 719.3005981445312,
            "2665": 253.64309692382812,
            "2666": 720.8104858398438,
            "2667": 251.93646240234375,
            "2668": 722.3084106445312,
            "2669": 253.26170349121094,
            "2670": 719.3005981445312,
            "2671": 253.64309692382812,
            "2672": 722.3084106445312,
            "2673": 253.26170349121094,
            "2674": 720.7985229492188,
            "2675": 254.9683380126953,
            "2676": 719.4839477539062,
            "2677": 253.40972900390625,
            "2678": 721.0234375,
            "2679": 251.72970581054688,
            "2680": 722.4979858398438,
            "2681": 253.0808868408203,
            "2682": 719.4839477539062,
            "2683": 253.40972900390625,
            "2684": 722.4979858398438,
            "2685": 253.0808868408203,
            "2686": 720.95849609375,
            "2687": 254.7609100341797,
            "2688": 719.67138671875,
            "2689": 253.17959594726562,
            "2690": 721.2399291992188,
            "2691": 251.5266876220703,
            "2692": 722.690673828125,
            "2693": 252.9033966064453,
            "2694": 719.67138671875,
            "2695": 253.17959594726562,
            "2696": 722.690673828125,
            "2697": 252.9033966064453,
            "2698": 721.1221313476562,
            "2699": 254.55630493164062,
            "2700": 719.86279296875,
            "2701": 252.9527587890625,
            "2702": 721.4599609375,
            "2703": 251.32748413085938,
            "2704": 722.8864135742188,
            "2705": 252.72930908203125,
            "2706": 719.86279296875,
            "2707": 252.9527587890625,
            "2708": 722.8864135742188,
            "2709": 252.72930908203125,
            "2710": 721.289306640625,
            "2711": 254.35458374023438,
            "2712": 720.05810546875,
            "2713": 252.72930908203125,
            "2714": 721.6834106445312,
            "2715": 251.1321563720703,
            "2716": 723.085205078125,
            "2717": 252.55865478515625,
            "2718": 720.05810546875,
            "2719": 252.72930908203125,
            "2720": 723.085205078125,
            "2721": 252.55865478515625,
            "2722": 721.4599609375,
            "2723": 254.1558074951172,
            "2724": 720.25732421875,
            "2725": 252.50929260253906,
            "2726": 721.9102172851562,
            "2727": 250.9407501220703,
            "2728": 723.2869262695312,
            "2729": 252.39151000976562,
            "2730": 720.25732421875,
            "2731": 252.50929260253906,
            "2732": 723.2869262695312,
            "2733": 252.39151000976562,
            "2734": 721.634033203125,
            "2735": 253.96005249023438,
            "2736": 720.4603271484375,
            "2737": 252.2928009033203,
            "2738": 722.140380859375,
            "2739": 250.7533416748047,
            "2740": 723.4915161132812,
            "2741": 252.22789001464844,
            "2742": 720.4603271484375,
            "2743": 252.2928009033203,
            "2744": 723.4915161132812,
            "2745": 252.22789001464844,
            "2746": 721.8115234375,
            "2747": 253.76734924316406,
            "2748": 720.6671142578125,
            "2749": 252.0798797607422,
            "2750": 722.3737182617188,
            "2751": 250.56997680664062,
            "2752": 723.698974609375,
            "2753": 252.06788635253906,
            "2754": 720.6671142578125,
            "2755": 252.0798797607422,
            "2756": 723.698974609375,
            "2757": 252.06788635253906,
            "2758": 721.9923095703125,
            "2759": 253.57778930664062,
            "2760": 720.8775024414062,
            "2761": 251.87059020996094,
            "2762": 722.6102294921875,
            "2763": 250.3907012939453,
            "2764": 723.9091796875,
            "2765": 251.91151428222656,
            "2766": 720.8775024414062,
            "2767": 251.87059020996094,
            "2768": 723.9091796875,
            "2769": 251.91151428222656,
            "2770": 722.1764526367188,
            "2771": 253.3914031982422,
            "2772": 721.0916137695312,
            "2773": 251.66500854492188,
            "2774": 722.8499145507812,
            "2775": 250.21559143066406,
            "2776": 724.1220703125,
            "2777": 251.7588348388672,
            "2778": 721.0916137695312,
            "2779": 251.66500854492188,
            "2780": 724.1220703125,
            "2781": 251.7588348388672,
            "2782": 722.36376953125,
            "2783": 253.20826721191406,
            "2784": 721.3092041015625,
            "2785": 251.46319580078125,
            "2786": 723.092529296875,
            "2787": 250.04469299316406,
            "2788": 724.3375854492188,
            "2789": 251.6099090576172,
            "2790": 721.3092041015625,
            "2791": 251.46319580078125,
            "2792": 724.3375854492188,
            "2793": 251.6099090576172,
            "2794": 722.5542602539062,
            "2795": 253.02841186523438,
            "2796": 721.5303344726562,
            "2797": 251.2652130126953,
            "2798": 723.338134765625,
            "2799": 249.87803649902344,
            "2800": 724.5556640625,
            "2801": 251.46475219726562,
            "2802": 721.5303344726562,
            "2803": 251.2652130126953,
            "2804": 724.5556640625,
            "2805": 251.46475219726562,
            "2806": 722.7478637695312,
            "2807": 252.8519287109375,
            "2808": 721.7548217773438,
            "2809": 251.0711212158203,
            "2810": 723.5866088867188,
            "2811": 249.71571350097656,
            "2812": 724.7762451171875,
            "2813": 251.32342529296875,
            "2814": 721.7548217773438,
            "2815": 251.0711212158203,
            "2816": 724.7762451171875,
            "2817": 251.32342529296875,
            "2818": 722.9445190429688,
            "2819": 252.6788330078125,
            "2820": 721.9827270507812,
            "2821": 250.8809814453125,
            "2822": 723.8378295898438,
            "2823": 249.5577392578125,
            "2824": 724.999267578125,
            "2825": 251.18597412109375,
            "2826": 721.9827270507812,
            "2827": 250.8809814453125,
            "2828": 724.999267578125,
            "2829": 251.18597412109375,
            "2830": 723.1441650390625,
            "2831": 252.5092010498047,
            "2832": 722.2139282226562,
            "2833": 250.69483947753906,
            "2834": 724.091796875,
            "2835": 249.4041748046875,
            "2836": 725.224609375,
            "2837": 251.05242919921875,
            "2838": 722.2139282226562,
            "2839": 250.69483947753906,
            "2840": 725.224609375,
            "2841": 251.05242919921875,
            "2842": 723.3467407226562,
            "2843": 252.3430938720703,
            "2844": 722.4483032226562,
            "2845": 250.51275634765625,
            "2846": 724.3484497070312,
            "2847": 249.25506591796875,
            "2848": 725.4523315429688,
            "2849": 250.92283630371094,
            "2850": 722.4483032226562,
            "2851": 250.51275634765625,
            "2852": 725.4523315429688,
            "2853": 250.92283630371094,
            "2854": 723.5521850585938,
            "2855": 252.18052673339844,
            "2856": 722.685791015625,
            "2857": 250.33480834960938,
            "2858": 724.6076049804688,
            "2859": 249.1104736328125,
            "2860": 725.6822509765625,
            "2861": 250.79725646972656,
            "2862": 722.685791015625,
            "2863": 250.33480834960938,
            "2864": 725.6822509765625,
            "2865": 250.79725646972656,
            "2866": 723.7603759765625,
            "2867": 252.02159118652344,
            "2868": 722.9263916015625,
            "2869": 250.1610107421875,
            "2870": 724.8692626953125,
            "2871": 248.9704132080078,
            "2872": 725.914306640625,
            "2873": 250.67568969726562,
            "2874": 722.9263916015625,
            "2875": 250.1610107421875,
            "2876": 725.914306640625,
            "2877": 250.67568969726562,
            "2878": 723.9713745117188,
            "2879": 251.86630249023438,
            "2880": 723.1699829101562,
            "2881": 249.991455078125,
            "2882": 725.1333618164062,
            "2883": 248.83493041992188,
            "2884": 726.1484375,
            "2885": 250.55819702148438,
            "2886": 723.1699829101562,
            "2887": 249.991455078125,
            "2888": 726.1484375,
            "2889": 250.55819702148438,
            "2890": 724.18505859375,
            "2891": 251.71470642089844,
            "2892": 723.41650390625,
            "2893": 249.826171875,
            "2894": 725.3997802734375,
            "2895": 248.7041015625,
            "2896": 726.3845825195312,
            "2897": 250.44480895996094,
            "2898": 723.41650390625,
            "2899": 249.826171875,
            "2900": 726.3845825195312,
            "2901": 250.44480895996094,
            "2902": 724.4013671875,
            "2903": 251.56687927246094,
            "2904": 723.6658325195312,
            "2905": 249.66522216796875,
            "2906": 725.6683959960938,
            "2907": 248.5779266357422,
            "2908": 726.6227416992188,
            "2909": 250.33555603027344,
            "2910": 723.6658325195312,
            "2911": 249.66522216796875,
            "2912": 726.6227416992188,
            "2913": 250.33555603027344,
            "2914": 724.6201782226562,
            "2915": 251.4228515625,
            "2916": 723.91796875,
            "2917": 249.50863647460938,
            "2918": 725.939208984375,
            "2919": 248.45645141601562,
            "2920": 726.8626708984375,
            "2921": 250.23048400878906,
            "2922": 723.91796875,
            "2923": 249.50863647460938,
            "2924": 726.8626708984375,
            "2925": 250.23048400878906,
            "2926": 724.8414916992188,
            "2927": 251.28265380859375,
            "2928": 724.1727905273438,
            "2929": 249.35647583007812,
            "2930": 726.2120971679688,
            "2931": 248.33973693847656,
            "2932": 727.1044921875,
            "2933": 250.12960815429688,
            "2934": 724.1727905273438,
            "2935": 249.35647583007812,
            "2936": 727.1044921875,
            "2937": 250.12960815429688,
            "2938": 725.065185546875,
            "2939": 251.14634704589844,
            "2940": 724.4302368164062,
            "2941": 249.20880126953125,
            "2942": 726.4869384765625,
            "2943": 248.22779846191406,
            "2944": 727.3479614257812,
            "2945": 250.032958984375,
            "2946": 724.4302368164062,
            "2947": 249.20880126953125,
            "2948": 727.3479614257812,
            "2949": 250.032958984375,
            "2950": 725.291259765625,
            "2951": 251.0139617919922,
            "2952": 724.690185546875,
            "2953": 249.0656280517578,
            "2954": 726.7637329101562,
            "2955": 248.12066650390625,
            "2956": 727.5931396484375,
            "2957": 249.9405975341797,
            "2958": 724.690185546875,
            "2959": 249.0656280517578,
            "2960": 727.5931396484375,
            "2961": 249.9405975341797,
            "2962": 725.5195922851562,
            "2963": 250.8855438232422,
            "2964": 724.95263671875,
            "2965": 248.92701721191406,
            "2966": 727.0423583984375,
            "2967": 248.0183868408203,
            "2968": 727.83984375,
            "2969": 249.85250854492188,
            "2970": 724.95263671875,
            "2971": 248.92701721191406,
            "2972": 727.83984375,
            "2973": 249.85250854492188,
            "2974": 725.7501220703125,
            "2975": 250.76113891601562,
            "2976": 725.2174682617188,
            "2977": 248.79299926757812,
            "2978": 727.3226928710938,
            "2979": 247.92098999023438,
            "2980": 728.0880737304688,
            "2981": 249.7687530517578,
            "2982": 725.2174682617188,
            "2983": 248.79299926757812,
            "2984": 728.0880737304688,
            "2985": 249.7687530517578,
            "2986": 725.9828491210938,
            "2987": 250.64076232910156,
            "2988": 725.4845581054688,
            "2989": 248.66363525390625,
            "2990": 727.604736328125,
            "2991": 247.8284912109375,
            "2992": 728.3377075195312,
            "2993": 249.6893310546875,
            "2994": 725.4845581054688,
            "2995": 248.66363525390625,
            "2996": 728.3377075195312,
            "2997": 249.6893310546875,
            "2998": 726.2175903320312,
            "2999": 250.52447509765625,
            "3000": 725.75390625,
            "3001": 248.53895568847656,
            "3002": 727.8883056640625,
            "3003": 247.74093627929688,
            "3004": 728.5886840820312,
            "3005": 249.61428833007812,
            "3006": 725.75390625,
            "3007": 248.53895568847656,
            "3008": 728.5886840820312,
            "3009": 249.61428833007812,
            "3010": 726.454345703125,
            "3011": 250.41229248046875,
            "3012": 726.025390625,
            "3013": 248.41897583007812,
            "3014": 728.17333984375,
            "3015": 247.65834045410156,
            "3016": 728.8409423828125,
            "3017": 249.5436248779297,
            "3018": 726.025390625,
            "3019": 248.41897583007812,
            "3020": 728.8409423828125,
            "3021": 249.5436248779297,
            "3022": 726.6929931640625,
            "3023": 250.30426025390625,
            "3024": 726.2988891601562,
            "3025": 248.30377197265625,
            "3026": 728.4598388671875,
            "3027": 247.5807342529297,
            "3028": 729.0944213867188,
            "3029": 249.47738647460938,
            "3030": 726.2988891601562,
            "3031": 248.30377197265625,
            "3032": 729.0944213867188,
            "3033": 249.47738647460938,
            "3034": 726.9335327148438,
            "3035": 250.20042419433594,
            "3036": 726.5744018554688,
            "3037": 248.193359375,
            "3038": 728.7476196289062,
            "3039": 247.5081329345703,
            "3040": 729.3489990234375,
            "3041": 249.4155731201172,
            "3042": 726.5744018554688,
            "3043": 248.193359375,
            "3044": 729.3489990234375,
            "3045": 249.4155731201172,
            "3046": 727.17578125,
            "3047": 250.1007843017578,
            "3048": 726.8517456054688,
            "3049": 248.08775329589844,
            "3050": 729.03662109375,
            "3051": 247.44058227539062,
            "3052": 729.6046142578125,
            "3053": 249.35821533203125,
            "3054": 726.8517456054688,
            "3055": 248.08775329589844,
            "3056": 729.6046142578125,
            "3057": 249.35821533203125,
            "3058": 727.4197998046875,
            "3059": 250.00540161132812,
            "3060": 727.1309204101562,
            "3061": 247.9870147705078,
            "3062": 729.3267211914062,
            "3063": 247.37806701660156,
            "3064": 729.8612060546875,
            "3065": 249.30532836914062,
            "3066": 727.1309204101562,
            "3067": 247.9870147705078,
            "3068": 729.8612060546875,
            "3069": 249.30532836914062,
            "3070": 727.6654052734375,
            "3071": 249.91427612304688,
            "3072": 727.4118041992188,
            "3073": 247.89117431640625,
            "3074": 729.617919921875,
            "3075": 247.3206329345703,
            "3076": 730.11865234375,
            "3077": 249.25692749023438,
            "3078": 727.4118041992188,
            "3079": 247.89117431640625,
            "3080": 730.11865234375,
            "3081": 249.25692749023438,
            "3082": 727.91259765625,
            "3083": 249.8274688720703,
            "3084": 727.6943359375,
            "3085": 247.80023193359375,
            "3086": 729.9100341796875,
            "3087": 247.26828002929688,
            "3088": 730.376953125,
            "3089": 249.21302795410156,
            "3090": 727.6943359375,
            "3091": 247.80023193359375,
            "3092": 730.376953125,
            "3093": 249.21302795410156,
            "3094": 728.1612548828125,
            "3095": 249.74497985839844,
            "3096": 727.9783935546875,
            "3097": 247.71424865722656,
            "3098": 730.2030639648438,
            "3099": 247.22105407714844,
            "3100": 730.6359252929688,
            "3101": 249.17364501953125,
            "3102": 727.9783935546875,
            "3103": 247.71424865722656,
            "3104": 730.6359252929688,
            "3105": 249.17364501953125,
            "3106": 728.4112548828125,
            "3107": 249.66683959960938,
            "3108": 728.263916015625,
            "3109": 247.6332244873047,
            "3110": 730.4968872070312,
            "3111": 247.17892456054688,
            "3112": 730.8955688476562,
            "3113": 249.13877868652344,
            "3114": 728.263916015625,
            "3115": 247.6332244873047,
            "3116": 730.8955688476562,
            "3117": 249.13877868652344,
            "3118": 728.6626586914062,
            "3119": 249.59307861328125,
            "3120": 728.55078125,
            "3121": 247.5572052001953,
            "3122": 730.7913208007812,
            "3123": 247.14195251464844,
            "3124": 731.1558227539062,
            "3125": 249.10845947265625,
            "3126": 728.55078125,
            "3127": 247.5572052001953,
            "3128": 731.1558227539062,
            "3129": 249.10845947265625,
            "3130": 728.915283203125,
            "3131": 249.52371215820312,
            "3132": 728.8389892578125,
            "3133": 247.4862060546875,
            "3134": 731.08642578125,
            "3135": 247.110107421875,
            "3136": 731.41650390625,
            "3137": 249.0826873779297,
            "3138": 728.8389892578125,
            "3139": 247.4862060546875,
            "3140": 731.41650390625,
            "3141": 249.0826873779297,
            "3142": 729.1690673828125,
            "3143": 249.45877075195312,
            "3144": 729.1283569335938,
            "3145": 247.4202423095703,
            "3146": 731.3820190429688,
            "3147": 247.0834197998047,
            "3148": 731.6776123046875,
            "3149": 249.06146240234375,
            "3150": 729.1283569335938,
            "3151": 247.4202423095703,
            "3152": 731.6776123046875,
            "3153": 249.06146240234375,
            "3154": 729.4239501953125,
            "3155": 249.3982696533203,
            "3156": 729.4188232421875,
            "3157": 247.3593292236328,
            "3158": 731.6780395507812,
            "3159": 247.06190490722656,
            "3160": 731.9390869140625,
            "3161": 249.0447998046875,
            "3162": 729.4188232421875,
            "3163": 247.3593292236328,
            "3164": 731.9390869140625,
            "3165": 249.0447998046875,
            "3166": 729.6798706054688,
            "3167": 249.34222412109375,
            "3168": 729.7103271484375,
            "3169": 247.3035125732422,
            "3170": 731.974365234375,
            "3171": 247.04554748535156,
            "3172": 732.2007446289062,
            "3173": 249.03269958496094,
            "3174": 729.7103271484375,
            "3175": 247.3035125732422,
            "3176": 732.2007446289062,
            "3177": 249.03269958496094,
            "3178": 729.9367065429688,
            "3179": 249.2906494140625,
            "3180": 730.0027465820312,
            "3181": 247.25277709960938,
            "3182": 732.2709350585938,
            "3183": 247.0343780517578,
            "3184": 732.462646484375,
            "3185": 249.02516174316406,
            "3186": 730.0027465820312,
            "3187": 247.25277709960938,
            "3188": 732.462646484375,
            "3189": 249.02516174316406,
            "3190": 730.1944580078125,
            "3191": 249.2435760498047,
            "3192": 730.2960205078125,
            "3193": 247.2071533203125,
            "3194": 732.5676879882812,
            "3195": 247.02838134765625,
            "3196": 732.724609375,
            "3197": 249.02220153808594,
            "3198": 730.2960205078125,
            "3199": 247.2071533203125,
            "3200": 732.724609375,
            "3201": 249.02220153808594,
            "3202": 730.4529418945312,
            "3203": 249.20098876953125,
            "3204": 730.5900268554688,
            "3205": 247.1666717529297,
            "3206": 732.8644409179688,
            "3207": 247.02755737304688,
            "3208": 732.986572265625,
            "3209": 249.02381896972656,
            "3210": 730.5900268554688,
            "3211": 247.1666717529297,
            "3212": 732.986572265625,
            "3213": 249.02381896972656,
            "3214": 730.712158203125,
            "3215": 249.16293334960938,
            "3216": 730.8847045898438,
            "3217": 247.1313018798828,
            "3218": 733.1612548828125,
            "3219": 247.03192138671875,
            "3220": 733.2484741210938,
            "3221": 249.03001403808594,
            "3222": 730.8847045898438,
            "3223": 247.1313018798828,
            "3224": 733.2484741210938,
            "3225": 249.03001403808594,
            "3226": 730.971923828125,
            "3227": 249.12940979003906,
            "3228": 731.1799926757812,
            "3229": 247.10110473632812,
            "3230": 733.4578857421875,
            "3231": 247.0414581298828,
            "3232": 733.5101928710938,
            "3233": 249.040771484375,
            "3234": 731.1799926757812,
            "3235": 247.10110473632812,
            "3236": 733.5101928710938,
            "3237": 249.040771484375,
            "3238": 731.2322998046875,
            "3239": 249.1004180908203,
            "3240": 731.4757080078125,
            "3241": 247.0760498046875,
            "3242": 733.7542724609375,
            "3243": 247.05616760253906,
            "3244": 733.771728515625,
            "3245": 249.05609130859375,
            "3246": 731.4757080078125,
            "3247": 247.0760498046875,
            "3248": 733.771728515625,
            "3249": 249.05609130859375,
            "3250": 731.4931640625,
            "3251": 249.0759735107422,
            "3252": 731.7718505859375,
            "3253": 247.05616760253906,
            "3254": 734.0504150390625,
            "3255": 247.0760498046875,
            "3256": 734.032958984375,
            "3257": 249.0759735107422,
            "3258": 731.7718505859375,
            "3259": 247.05616760253906,
            "3260": 734.032958984375,
            "3261": 249.0759735107422,
            "3262": 731.75439453125,
            "3263": 249.05609130859375,
            "3264": 732.0682373046875,
            "3265": 247.0414581298828,
            "3266": 734.3461303710938,
            "3267": 247.10110473632812,
            "3268": 734.2938232421875,
            "3269": 249.1004180908203,
            "3270": 732.0682373046875,
            "3271": 247.0414581298828,
            "3272": 734.2938232421875,
            "3273": 249.1004180908203,
            "3274": 732.015869140625,
            "3275": 249.040771484375,
            "3276": 732.3648681640625,
            "3277": 247.03192138671875,
            "3278": 734.6414184570312,
            "3279": 247.1313018798828,
            "3280": 734.5541381835938,
            "3281": 249.12940979003906,
            "3282": 732.3648681640625,
            "3283": 247.03192138671875,
            "3284": 734.5541381835938,
            "3285": 249.12940979003906,
            "3286": 732.2776489257812,
            "3287": 249.03001403808594,
            "3288": 732.66162109375,
            "3289": 247.02755737304688,
            "3290": 734.9360961914062,
            "3291": 247.1666717529297,
            "3292": 734.81396484375,
            "3293": 249.16293334960938,
            "3294": 732.66162109375,
            "3295": 247.02755737304688,
            "3296": 734.81396484375,
            "3297": 249.16293334960938,
            "3298": 732.53955078125,
            "3299": 249.02381896972656,
            "3300": 732.9584350585938,
            "3301": 247.02838134765625,
            "3302": 735.2301025390625,
            "3303": 247.2071533203125,
            "3304": 735.0731811523438,
            "3305": 249.20098876953125,
            "3306": 732.9584350585938,
            "3307": 247.02838134765625,
            "3308": 735.0731811523438,
            "3309": 249.20098876953125,
            "3310": 732.801513671875,
            "3311": 249.02220153808594,
            "3312": 733.2551879882812,
            "3313": 247.0343780517578,
            "3314": 735.5233764648438,
            "3315": 247.25277709960938,
            "3316": 735.3316650390625,
            "3317": 249.2435760498047,
            "3318": 733.2551879882812,
            "3319": 247.0343780517578,
            "3320": 735.3316650390625,
            "3321": 249.2435760498047,
            "3322": 733.0634765625,
            "3323": 249.02516174316406,
            "3324": 733.5517578125,
            "3325": 247.04554748535156,
            "3326": 735.8157958984375,
            "3327": 247.3035125732422,
            "3328": 735.58935546875,
            "3329": 249.2906494140625,
            "3330": 733.5517578125,
            "3331": 247.04554748535156,
            "3332": 735.58935546875,
            "3333": 249.2906494140625,
            "3334": 733.3253173828125,
            "3335": 249.03269958496094,
            "3336": 733.8480834960938,
            "3337": 247.06190490722656,
            "3338": 736.1072998046875,
            "3339": 247.3593292236328,
            "3340": 735.8462524414062,
            "3341": 249.34222412109375,
            "3342": 733.8480834960938,
            "3343": 247.06190490722656,
            "3344": 735.8462524414062,
            "3345": 249.34222412109375,
            "3346": 733.5870361328125,
            "3347": 249.0447998046875,
            "3348": 734.1441040039062,
            "3349": 247.0834197998047,
            "3350": 736.3977661132812,
            "3351": 247.4202423095703,
            "3352": 736.1021118164062,
            "3353": 249.3982696533203,
            "3354": 734.1441040039062,
            "3355": 247.0834197998047,
            "3356": 736.1021118164062,
            "3357": 249.3982696533203,
            "3358": 733.8485107421875,
            "3359": 249.06146240234375,
            "3360": 734.439697265625,
            "3361": 247.110107421875,
            "3362": 736.6871337890625,
            "3363": 247.4862060546875,
            "3364": 736.3570556640625,
            "3365": 249.45877075195312,
            "3366": 734.439697265625,
            "3367": 247.110107421875,
            "3368": 736.3570556640625,
            "3369": 249.45877075195312,
            "3370": 734.109619140625,
            "3371": 249.0826873779297,
            "3372": 734.7348022460938,
            "3373": 247.14195251464844,
            "3374": 736.9752807617188,
            "3375": 247.5572052001953,
            "3376": 736.61083984375,
            "3377": 249.52371215820312,
            "3378": 734.7348022460938,
            "3379": 247.14195251464844,
            "3380": 736.61083984375,
            "3381": 249.52371215820312,
            "3382": 734.3703002929688,
            "3383": 249.10845947265625,
            "3384": 735.0292358398438,
            "3385": 247.17892456054688,
            "3386": 737.26220703125,
            "3387": 247.6332244873047,
            "3388": 736.8634643554688,
            "3389": 249.59307861328125,
            "3390": 735.0292358398438,
            "3391": 247.17892456054688,
            "3392": 736.8634643554688,
            "3393": 249.59307861328125,
            "3394": 734.6304931640625,
            "3395": 249.13877868652344,
            "3396": 735.3230590820312,
            "3397": 247.22105407714844,
            "3398": 737.5477294921875,
            "3399": 247.71424865722656,
            "3400": 737.1148071289062,
            "3401": 249.66683959960938,
            "3402": 735.3230590820312,
            "3403": 247.22105407714844,
            "3404": 737.1148071289062,
            "3405": 249.66683959960938,
            "3406": 734.89013671875,
            "3407": 249.17364501953125,
            "3408": 735.6160278320312,
            "3409": 247.26828002929688,
            "3410": 737.831787109375,
            "3411": 247.80023193359375,
            "3412": 737.3648681640625,
            "3413": 249.74497985839844,
            "3414": 735.6160278320312,
            "3415": 247.26828002929688,
            "3416": 737.3648681640625,
            "3417": 249.74497985839844,
            "3418": 735.149169921875,
            "3419": 249.21302795410156,
            "3420": 735.908203125,
            "3421": 247.3206329345703,
            "3422": 738.1143188476562,
            "3423": 247.89117431640625,
            "3424": 737.613525390625,
            "3425": 249.8274688720703,
            "3426": 735.908203125,
            "3427": 247.3206329345703,
            "3428": 737.613525390625,
            "3429": 249.8274688720703,
            "3430": 735.4074096679688,
            "3431": 249.25692749023438,
            "3432": 736.1994018554688,
            "3433": 247.37806701660156,
            "3434": 738.3952026367188,
            "3435": 247.9870147705078,
            "3436": 737.8607177734375,
            "3437": 249.91427612304688,
            "3438": 736.1994018554688,
            "3439": 247.37806701660156,
            "3440": 737.8607177734375,
            "3441": 249.91427612304688,
            "3442": 735.6649169921875,
            "3443": 249.30532836914062,
            "3444": 736.489501953125,
            "3445": 247.44058227539062,
            "3446": 738.6743774414062,
            "3447": 248.08775329589844,
            "3448": 738.1063232421875,
            "3449": 250.00540161132812,
            "3450": 736.489501953125,
            "3451": 247.44058227539062,
            "3452": 738.1063232421875,
            "3453": 250.00540161132812,
            "3454": 735.9215087890625,
            "3455": 249.35821533203125,
            "3456": 736.7785034179688,
            "3457": 247.5081329345703,
            "3458": 738.9517211914062,
            "3459": 248.193359375,
            "3460": 738.350341796875,
            "3461": 250.1007843017578,
            "3462": 736.7785034179688,
            "3463": 247.5081329345703,
            "3464": 738.350341796875,
            "3465": 250.1007843017578,
            "3466": 736.1771240234375,
            "3467": 249.4155731201172,
            "3468": 737.0662841796875,
            "3469": 247.5807342529297,
            "3470": 739.2272338867188,
            "3471": 248.30377197265625,
            "3472": 738.5925903320312,
            "3473": 250.20042419433594,
            "3474": 737.0662841796875,
            "3475": 247.5807342529297,
            "3476": 738.5925903320312,
            "3477": 250.20042419433594,
            "3478": 736.4317016601562,
            "3479": 249.47738647460938,
            "3480": 737.352783203125,
            "3481": 247.65834045410156,
            "3482": 739.500732421875,
            "3483": 248.41897583007812,
            "3484": 738.8331298828125,
            "3485": 250.30426025390625,
            "3486": 737.352783203125,
            "3487": 247.65834045410156,
            "3488": 738.8331298828125,
            "3489": 250.30426025390625,
            "3490": 736.6851196289062,
            "3491": 249.5436248779297,
            "3492": 737.6378173828125,
            "3493": 247.74093627929688,
            "3494": 739.772216796875,
            "3495": 248.53895568847656,
            "3496": 739.07177734375,
            "3497": 250.41229248046875,
            "3498": 737.6378173828125,
            "3499": 247.74093627929688,
            "3500": 739.07177734375,
            "3501": 250.41229248046875,
            "3502": 736.9374389648438,
            "3503": 249.61428833007812,
            "3504": 737.92138671875,
            "3505": 247.8284912109375,
            "3506": 740.04150390625,
            "3507": 248.66363525390625,
            "3508": 739.3085327148438,
            "3509": 250.52447509765625,
            "3510": 737.92138671875,
            "3511": 247.8284912109375,
            "3512": 739.3085327148438,
            "3513": 250.52447509765625,
            "3514": 737.1884155273438,
            "3515": 249.6893310546875,
            "3516": 738.2034301757812,
            "3517": 247.92098999023438,
            "3518": 740.3086547851562,
            "3519": 248.79299926757812,
            "3520": 739.5432739257812,
            "3521": 250.64076232910156,
            "3522": 738.2034301757812,
            "3523": 247.92098999023438,
            "3524": 739.5432739257812,
            "3525": 250.64076232910156,
            "3526": 737.4380493164062,
            "3527": 249.7687530517578,
            "3528": 738.4837646484375,
            "3529": 248.0183868408203,
            "3530": 740.573486328125,
            "3531": 248.92701721191406,
            "3532": 739.7759399414062,
            "3533": 250.76113891601562,
            "3534": 738.4837646484375,
            "3535": 248.0183868408203,
            "3536": 739.7759399414062,
            "3537": 250.76113891601562,
            "3538": 737.686279296875,
            "3539": 249.85250854492188,
            "3540": 738.7623901367188,
            "3541": 248.12066650390625,
            "3542": 740.8358764648438,
            "3543": 249.0656280517578,
            "3544": 740.0065307617188,
            "3545": 250.8855438232422,
            "3546": 738.7623901367188,
            "3547": 248.12066650390625,
            "3548": 740.0065307617188,
            "3549": 250.8855438232422,
            "3550": 737.9329833984375,
            "3551": 249.9405975341797,
            "3552": 739.0391845703125,
            "3553": 248.22779846191406,
            "3554": 741.0958862304688,
            "3555": 249.20880126953125,
            "3556": 740.23486328125,
            "3557": 251.0139617919922,
            "3558": 739.0391845703125,
            "3559": 248.22779846191406,
            "3560": 740.23486328125,
            "3561": 251.0139617919922,
            "3562": 738.1781616210938,
            "3563": 250.032958984375,
            "3564": 739.3140258789062,
            "3565": 248.33973693847656,
            "3566": 741.3533325195312,
            "3567": 249.35647583007812,
            "3568": 740.4609375,
            "3569": 251.14634704589844,
            "3570": 739.3140258789062,
            "3571": 248.33973693847656,
            "3572": 740.4609375,
            "3573": 251.14634704589844,
            "3574": 738.421630859375,
            "3575": 250.12960815429688,
            "3576": 739.5869140625,
            "3577": 248.45645141601562,
            "3578": 741.608154296875,
            "3579": 249.50863647460938,
            "3580": 740.6846313476562,
            "3581": 251.28265380859375,
            "3582": 739.5869140625,
            "3583": 248.45645141601562,
            "3584": 740.6846313476562,
            "3585": 251.28265380859375,
            "3586": 738.6634521484375,
            "3587": 250.23048400878906,
            "3588": 739.8577270507812,
            "3589": 248.5779266357422,
            "3590": 741.8602905273438,
            "3591": 249.66522216796875,
            "3592": 740.9059448242188,
            "3593": 251.4228515625,
            "3594": 739.8577270507812,
            "3595": 248.5779266357422,
            "3596": 740.9059448242188,
            "3597": 251.4228515625,
            "3598": 738.9033813476562,
            "3599": 250.33555603027344,
            "3600": 740.1263427734375,
            "3601": 248.7041015625,
            "3602": 742.109619140625,
            "3603": 249.826171875,
            "3604": 741.124755859375,
            "3605": 251.56687927246094,
            "3606": 740.1263427734375,
            "3607": 248.7041015625,
            "3608": 741.124755859375,
            "3609": 251.56687927246094,
            "3610": 739.1415405273438,
            "3611": 250.44480895996094,
            "3612": 740.3927612304688,
            "3613": 248.83493041992188,
            "3614": 742.3561401367188,
            "3615": 249.991455078125,
            "3616": 741.341064453125,
            "3617": 251.71470642089844,
            "3618": 740.3927612304688,
            "3619": 248.83493041992188,
            "3620": 741.341064453125,
            "3621": 251.71470642089844,
            "3622": 739.377685546875,
            "3623": 250.55819702148438,
            "3624": 740.6567993164062,
            "3625": 248.9704132080078,
            "3626": 742.5997314453125,
            "3627": 250.1610107421875,
            "3628": 741.5547485351562,
            "3629": 251.86630249023438,
            "3630": 740.6567993164062,
            "3631": 248.9704132080078,
            "3632": 741.5547485351562,
            "3633": 251.86630249023438,
            "3634": 739.61181640625,
            "3635": 250.67568969726562,
            "3636": 740.9185180664062,
            "3637": 249.1104736328125,
            "3638": 742.84033203125,
            "3639": 250.33480834960938,
            "3640": 741.7656860351562,
            "3641": 252.02159118652344,
            "3642": 740.9185180664062,
            "3643": 249.1104736328125,
            "3644": 741.7656860351562,
            "3645": 252.02159118652344,
            "3646": 739.8438720703125,
            "3647": 250.79725646972656,
            "3648": 741.1776733398438,
            "3649": 249.25506591796875,
            "3650": 743.0778198242188,
            "3651": 250.51275634765625,
            "3652": 741.9739379882812,
            "3653": 252.18052673339844,
            "3654": 741.1776733398438,
            "3655": 249.25506591796875,
            "3656": 741.9739379882812,
            "3657": 252.18052673339844,
            "3658": 740.0737915039062,
            "3659": 250.92283630371094,
            "3660": 741.4342651367188,
            "3661": 249.4041748046875,
            "3662": 743.3121948242188,
            "3663": 250.69483947753906,
            "3664": 742.1793823242188,
            "3665": 252.3430938720703,
            "3666": 741.4342651367188,
            "3667": 249.4041748046875,
            "3668": 742.1793823242188,
            "3669": 252.3430938720703,
            "3670": 740.3014526367188,
            "3671": 251.05242919921875,
            "3672": 741.6882934570312,
            "3673": 249.5577392578125,
            "3674": 743.5433959960938,
            "3675": 250.8809814453125,
            "3676": 742.3819580078125,
            "3677": 252.5092010498047,
            "3678": 741.6882934570312,
            "3679": 249.5577392578125,
            "3680": 742.3819580078125,
            "3681": 252.5092010498047,
            "3682": 740.52685546875,
            "3683": 251.18597412109375,
            "3684": 741.9395141601562,
            "3685": 249.71571350097656,
            "3686": 743.771240234375,
            "3687": 251.0711212158203,
            "3688": 742.5816040039062,
            "3689": 252.6788330078125,
            "3690": 741.9395141601562,
            "3691": 249.71571350097656,
            "3692": 742.5816040039062,
            "3693": 252.6788330078125,
            "3694": 740.7498779296875,
            "3695": 251.32342529296875,
            "3696": 742.18798828125,
            "3697": 249.87803649902344,
            "3698": 743.9957885742188,
            "3699": 251.2652130126953,
            "3700": 742.7782592773438,
            "3701": 252.8519287109375,
            "3702": 742.18798828125,
            "3703": 249.87803649902344,
            "3704": 742.7782592773438,
            "3705": 252.8519287109375,
            "3706": 740.970458984375,
            "3707": 251.46475219726562,
            "3708": 742.43359375,
            "3709": 250.04469299316406,
            "3710": 744.2169189453125,
            "3711": 251.46319580078125,
            "3712": 742.9718627929688,
            "3713": 253.02841186523438,
            "3714": 742.43359375,
            "3715": 250.04469299316406,
            "3716": 742.9718627929688,
            "3717": 253.02841186523438,
            "3718": 741.1885375976562,
            "3719": 251.6099090576172,
            "3720": 742.6762084960938,
            "3721": 250.21559143066406,
            "3722": 744.4345092773438,
            "3723": 251.66500854492188,
            "3724": 743.162353515625,
            "3725": 253.20826721191406,
            "3726": 742.6762084960938,
            "3727": 250.21559143066406,
            "3728": 743.162353515625,
            "3729": 253.20826721191406,
            "3730": 741.404052734375,
            "3731": 251.7588348388672,
            "3732": 742.9158325195312,
            "3733": 250.3907012939453,
            "3734": 744.6485595703125,
            "3735": 251.87059020996094,
            "3736": 743.3496704101562,
            "3737": 253.3914031982422,
            "3738": 742.9158325195312,
            "3739": 250.3907012939453,
            "3740": 743.3496704101562,
            "3741": 253.3914031982422,
            "3742": 741.616943359375,
            "3743": 251.91151428222656,
            "3744": 743.1524047851562,
            "3745": 250.56997680664062,
            "3746": 744.8590087890625,
            "3747": 252.0798797607422,
            "3748": 743.5338134765625,
            "3749": 253.57778930664062,
            "3750": 743.1524047851562,
            "3751": 250.56997680664062,
            "3752": 743.5338134765625,
            "3753": 253.57778930664062,
            "3754": 741.8271484375,
            "3755": 252.06788635253906,
            "3756": 743.3857421875,
            "3757": 250.7533416748047,
            "3758": 745.0657958984375,
            "3759": 252.2928009033203,
            "3760": 743.714599609375,
            "3761": 253.76734924316406,
            "3762": 743.3857421875,
            "3763": 250.7533416748047,
            "3764": 743.714599609375,
            "3765": 253.76734924316406,
            "3766": 742.0346069335938,
            "3767": 252.22789001464844,
            "3768": 743.6159057617188,
            "3769": 250.9407501220703,
            "3770": 745.268798828125,
            "3771": 252.50929260253906,
            "3772": 743.89208984375,
            "3773": 253.96005249023438,
            "3774": 743.6159057617188,
            "3775": 250.9407501220703,
            "3776": 743.89208984375,
            "3777": 253.96005249023438,
            "3778": 742.2391967773438,
            "3779": 252.39151000976562,
            "3780": 743.8427124023438,
            "3781": 251.1321563720703,
            "3782": 745.468017578125,
            "3783": 252.72930908203125,
            "3784": 744.066162109375,
            "3785": 254.1558074951172,
            "3786": 743.8427124023438,
            "3787": 251.1321563720703,
            "3788": 744.066162109375,
            "3789": 254.1558074951172,
            "3790": 742.44091796875,
            "3791": 252.55865478515625,
            "3792": 744.066162109375,
            "3793": 251.32748413085938,
            "3794": 745.663330078125,
            "3795": 252.9527587890625,
            "3796": 744.23681640625,
            "3797": 254.35458374023438,
            "3798": 744.066162109375,
            "3799": 251.32748413085938,
            "3800": 744.23681640625,
            "3801": 254.35458374023438,
            "3802": 742.6396484375,
            "3803": 252.72930908203125,
            "3804": 744.2861938476562,
            "3805": 251.5266876220703,
            "3806": 745.854736328125,
            "3807": 253.17959594726562,
            "3808": 744.4039916992188,
            "3809": 254.55630493164062,
            "3810": 744.2861938476562,
            "3811": 251.5266876220703,
            "3812": 744.4039916992188,
            "3813": 254.55630493164062,
            "3814": 742.83544921875,
            "3815": 252.9033966064453,
            "3816": 744.502685546875,
            "3817": 251.72970581054688,
            "3818": 746.0421142578125,
            "3819": 253.40972900390625,
            "3820": 744.5675659179688,
            "3821": 254.7609100341797,
            "3822": 744.502685546875,
            "3823": 251.72970581054688,
            "3824": 744.5675659179688,
            "3825": 254.7609100341797,
            "3826": 743.0281372070312,
            "3827": 253.0808868408203,
            "3828": 744.7156372070312,
            "3829": 251.93646240234375,
            "3830": 746.2255249023438,
            "3831": 253.64309692382812,
            "3832": 744.7276000976562,
            "3833": 254.9683380126953,
            "3834": 744.7156372070312,
            "3835": 251.93646240234375,
            "3836": 744.7276000976562,
            "3837": 254.9683380126953,
            "3838": 743.2177124023438,
            "3839": 253.26170349121094,
            "3840": 744.9248657226562,
            "3841": 252.1468963623047,
            "3842": 746.40478515625,
            "3843": 253.87962341308594,
            "3844": 744.8839721679688,
            "3845": 255.17852783203125,
            "3846": 744.9248657226562,
            "3847": 252.1468963623047,
            "3848": 744.8839721679688,
            "3849": 255.17852783203125,
            "3850": 743.404052734375,
            "3851": 253.44580078125,
            "3852": 745.1304931640625,
            "3853": 252.3609619140625,
            "3854": 746.5798950195312,
            "3855": 254.11924743652344,
            "3856": 745.03662109375,
            "3857": 255.39141845703125,
            "3858": 745.1304931640625,
            "3859": 252.3609619140625,
            "3860": 745.03662109375,
            "3861": 255.39141845703125,
            "3862": 743.5872192382812,
            "3863": 253.63311767578125,
            "3864": 745.332275390625,
            "3865": 252.57858276367188,
            "3866": 746.7507934570312,
            "3867": 254.36190795898438,
            "3868": 745.1856079101562,
            "3869": 255.60693359375,
            "3870": 745.332275390625,
            "3871": 252.57858276367188,
            "3872": 745.1856079101562,
            "3873": 255.60693359375,
            "3874": 743.76708984375,
            "3875": 253.8236083984375,
            "3876": 745.5302734375,
            "3877": 252.79969787597656,
            "3878": 746.9174194335938,
            "3879": 254.6074981689453,
            "3880": 745.3307495117188,
            "3881": 255.82501220703125,
            "3882": 745.5302734375,
            "3883": 252.79969787597656,
            "3884": 745.3307495117188,
            "3885": 255.82501220703125,
            "3886": 743.9435424804688,
            "3887": 254.0172119140625,
            "3888": 745.724365234375,
            "3889": 253.0242156982422,
            "3890": 747.0797729492188,
            "3891": 254.85595703125,
            "3892": 745.4720458984375,
            "3893": 256.04559326171875,
            "3894": 745.724365234375,
            "3895": 253.0242156982422,
            "3896": 745.4720458984375,
            "3897": 256.04559326171875,
            "3898": 744.1166381835938,
            "3899": 254.2138671875,
            "3900": 745.9144897460938,
            "3901": 253.25210571289062,
            "3902": 747.2377319335938,
            "3903": 255.1072235107422,
            "3904": 745.6094970703125,
            "3905": 256.26861572265625,
            "3906": 745.9144897460938,
            "3907": 253.25210571289062,
            "3908": 745.6094970703125,
            "3909": 256.26861572265625,
            "3910": 744.2862548828125,
            "3911": 254.41351318359375,
            "3912": 746.1006469726562,
            "3913": 253.4832763671875,
            "3914": 747.3912963867188,
            "3915": 255.36119079589844,
            "3916": 745.7430419921875,
            "3917": 256.4940185546875,
            "3918": 746.1006469726562,
            "3919": 253.4832763671875,
            "3920": 745.7430419921875,
            "3921": 256.4940185546875,
            "3922": 744.452392578125,
            "3923": 254.6160888671875,
            "3924": 746.28271484375,
            "3925": 253.7176513671875,
            "3926": 747.5404052734375,
            "3927": 255.61781311035156,
            "3928": 745.8726196289062,
            "3929": 256.7216796875,
            "3930": 746.28271484375,
            "3931": 253.7176513671875,
            "3932": 745.8726196289062,
            "3933": 256.7216796875,
            "3934": 744.6149291992188,
            "3935": 254.82151794433594,
            "3936": 746.460693359375,
            "3937": 253.95516967773438,
            "3938": 747.6849975585938,
            "3939": 255.8769989013672,
            "3940": 745.9982299804688,
            "3941": 256.95159912109375,
            "3942": 746.460693359375,
            "3943": 253.95516967773438,
            "3944": 745.9982299804688,
            "3945": 256.95159912109375,
            "3946": 744.77392578125,
            "3947": 255.02976989746094,
            "3948": 746.6344604492188,
            "3949": 254.19577026367188,
            "3950": 747.8250732421875,
            "3951": 256.138671875,
            "3952": 746.1198120117188,
            "3953": 257.18365478515625,
            "3954": 746.6344604492188,
            "3955": 254.19577026367188,
            "3956": 746.1198120117188,
            "3957": 257.18365478515625,
            "3958": 744.92919921875,
            "3959": 255.2407684326172,
            "3960": 746.8040161132812,
            "3961": 254.43934631347656,
            "3962": 747.9605712890625,
            "3963": 256.4027404785156,
            "3964": 746.2373046875,
            "3965": 257.4178161621094,
            "3966": 746.8040161132812,
            "3967": 254.43934631347656,
            "3968": 746.2373046875,
            "3969": 257.4178161621094,
            "3970": 745.0807495117188,
            "3971": 255.4544219970703,
            "3972": 746.9692993164062,
            "3973": 254.6858673095703,
            "3974": 748.0913696289062,
            "3975": 256.66912841796875,
            "3976": 746.3507080078125,
            "3977": 257.6539611816406,
            "3978": 746.9692993164062,
            "3979": 254.6858673095703,
            "3980": 746.3507080078125,
            "3981": 257.6539611816406,
            "3982": 745.2285766601562,
            "3983": 255.67071533203125,
            "3984": 747.1302490234375,
            "3985": 254.93521118164062,
            "3986": 748.2175903320312,
            "3987": 256.9377746582031,
            "3988": 746.4598999023438,
            "3989": 257.89208984375,
            "3990": 747.1302490234375,
            "3991": 254.93521118164062,
            "3992": 746.4598999023438,
            "3993": 257.89208984375,
            "3994": 745.3726196289062,
            "3995": 255.88954162597656,
            "3996": 747.286865234375,
            "3997": 255.18734741210938,
            "3998": 748.3390502929688,
            "3999": 257.20855712890625,
            "4000": 746.5650024414062,
            "4001": 258.1320495605469,
            "4002": 747.286865234375,
            "4003": 255.18734741210938,
            "4004": 746.5650024414062,
            "4005": 258.1320495605469,
            "4006": 745.5128173828125,
            "4007": 256.11083984375,
            "4008": 747.4390258789062,
            "4009": 255.44216918945312,
            "4010": 748.4557495117188,
            "4011": 257.4814453125,
            "4012": 746.6658935546875,
            "4013": 258.37384033203125,
            "4014": 747.4390258789062,
            "4015": 255.44216918945312,
            "4016": 746.6658935546875,
            "4017": 258.37384033203125,
            "4018": 745.6491088867188,
            "4019": 256.3345642089844,
            "4020": 747.586669921875,
            "4021": 255.69960021972656,
            "4022": 748.5676879882812,
            "4023": 257.7563171386719,
            "4024": 746.7625122070312,
            "4025": 258.6173400878906,
            "4026": 747.586669921875,
            "4027": 255.69960021972656,
            "4028": 746.7625122070312,
            "4029": 258.6173400878906,
            "4030": 745.781494140625,
            "4031": 256.5606384277344,
            "4032": 747.7298583984375,
            "4033": 255.95957946777344,
            "4034": 748.6748046875,
            "4035": 258.0331115722656,
            "4036": 746.8549194335938,
            "4037": 258.86248779296875,
            "4038": 747.7298583984375,
            "4039": 255.95957946777344,
            "4040": 746.8549194335938,
            "4041": 258.86248779296875,
            "4042": 745.909912109375,
            "4043": 256.7889709472656,
            "4044": 747.8684692382812,
            "4045": 256.2220153808594,
            "4046": 748.777099609375,
            "4047": 258.31170654296875,
            "4048": 746.9429931640625,
            "4049": 259.1092224121094,
            "4050": 747.8684692382812,
            "4051": 256.2220153808594,
            "4052": 746.9429931640625,
            "4053": 259.1092224121094,
            "4054": 746.0343627929688,
            "4055": 257.01953125,
            "4056": 748.0025024414062,
            "4057": 256.4868469238281,
            "4058": 748.87451171875,
            "4059": 258.5920715332031,
            "4060": 747.0267333984375,
            "4061": 259.357421875,
            "4062": 748.0025024414062,
            "4063": 256.4868469238281,
            "4064": 747.0267333984375,
            "4065": 259.357421875,
            "4066": 746.1547241210938,
            "4067": 257.252197265625,
            "4068": 748.1318359375,
            "4069": 256.7539367675781,
            "4070": 748.9669799804688,
            "4071": 258.87408447265625,
            "4072": 747.1061401367188,
            "4073": 259.6070861816406,
            "4074": 748.1318359375,
            "4075": 256.7539367675781,
            "4076": 747.1061401367188,
            "4077": 259.6070861816406,
            "4078": 746.27099609375,
            "4079": 257.4869384765625,
            "4080": 748.2565307617188,
            "4081": 257.0232849121094,
            "4082": 749.0545654296875,
            "4083": 259.15765380859375,
            "4084": 747.1812133789062,
            "4085": 259.8580627441406,
            "4086": 748.2565307617188,
            "4087": 257.0232849121094,
            "4088": 747.1812133789062,
            "4089": 259.8580627441406,
            "4090": 746.3831787109375,
            "4091": 257.72369384765625,
            "4092": 748.3765258789062,
            "4093": 257.29473876953125,
            "4094": 749.1371459960938,
            "4095": 259.4427185058594,
            "4096": 747.2518310546875,
            "4097": 260.1103515625,
            "4098": 748.3765258789062,
            "4099": 257.29473876953125,
            "4100": 747.2518310546875,
            "4101": 260.1103515625,
            "4102": 746.4912109375,
            "4103": 257.9623718261719,
            "4104": 748.49169921875,
            "4105": 257.5682678222656,
            "4106": 749.2147216796875,
            "4107": 259.72918701171875,
            "4108": 747.318115234375,
            "4109": 260.3638000488281,
            "4110": 748.49169921875,
            "4111": 257.5682678222656,
            "4112": 747.318115234375,
            "4113": 260.3638000488281,
            "4114": 746.5950927734375,
            "4115": 258.202880859375,
            "4116": 748.6021118164062,
            "4117": 257.84375,
            "4118": 749.287353515625,
            "4119": 260.0169677734375,
            "4120": 747.3798828125,
            "4121": 260.6183776855469,
            "4122": 748.6021118164062,
            "4123": 257.84375,
            "4124": 747.3798828125,
            "4125": 260.6183776855469,
            "4126": 746.6947021484375,
            "4127": 258.4451599121094,
            "4128": 748.7077026367188,
            "4129": 258.1211242675781,
            "4130": 749.3549194335938,
            "4131": 260.30596923828125,
            "4132": 747.437255859375,
            "4133": 260.8739929199219,
            "4134": 748.7077026367188,
            "4135": 258.1211242675781,
            "4136": 747.437255859375,
            "4137": 260.8739929199219,
            "4138": 746.7901000976562,
            "4139": 258.68914794921875,
            "4140": 748.8084716796875,
            "4141": 258.4002990722656,
            "4142": 749.4174194335938,
            "4143": 260.5960998535156,
            "4144": 747.4901733398438,
            "4145": 261.1305847167969,
            "4146": 748.8084716796875,
            "4147": 258.4002990722656,
            "4148": 747.4901733398438,
            "4149": 261.1305847167969,
            "4150": 746.8812255859375,
            "4151": 258.9347839355469,
            "4152": 748.904296875,
            "4153": 258.6811828613281,
            "4154": 749.474853515625,
            "4155": 260.8872985839844,
            "4156": 747.53857421875,
            "4157": 261.3880615234375,
            "4158": 748.904296875,
            "4159": 258.6811828613281,
            "4160": 747.53857421875,
            "4161": 261.3880615234375,
            "4162": 746.968017578125,
            "4163": 259.18194580078125,
            "4164": 748.9952392578125,
            "4165": 258.9637145996094,
            "4166": 749.5272216796875,
            "4167": 261.179443359375,
            "4168": 747.5824584960938,
            "4169": 261.6463317871094,
            "4170": 748.9952392578125,
            "4171": 258.9637145996094,
            "4172": 747.5824584960938,
            "4173": 261.6463317871094,
            "4174": 747.050537109375,
            "4175": 259.43060302734375,
            "4176": 749.0812377929688,
            "4177": 259.2477722167969,
            "4178": 749.574462890625,
            "4179": 261.4724426269531,
            "4180": 747.621826171875,
            "4181": 261.9053039550781,
            "4182": 749.0812377929688,
            "4183": 259.2477722167969,
            "4184": 747.621826171875,
            "4185": 261.9053039550781,
            "4186": 747.128662109375,
            "4187": 259.6806335449219,
            "4188": 749.1622314453125,
            "4189": 259.5332946777344,
            "4190": 749.6165771484375,
            "4191": 261.7662353515625,
            "4192": 747.6566772460938,
            "4193": 262.16497802734375,
            "4194": 749.1622314453125,
            "4195": 259.5332946777344,
            "4196": 747.6566772460938,
            "4197": 262.16497802734375,
            "4198": 747.202392578125,
            "4199": 259.9320373535156,
            "4200": 749.23828125,
            "4201": 259.8201904296875,
            "4202": 749.653564453125,
            "4203": 262.0606994628906,
            "4204": 747.68701171875,
            "4205": 262.4251708984375,
            "4206": 749.23828125,
            "4207": 259.8201904296875,
            "4208": 747.68701171875,
            "4209": 262.4251708984375,
            "4210": 747.2717895507812,
            "4211": 260.1846618652344,
            "4212": 749.3092651367188,
            "4213": 260.1083679199219,
            "4214": 749.6853637695312,
            "4215": 262.35577392578125,
            "4216": 747.7128295898438,
            "4217": 262.6858825683594,
            "4218": 749.3092651367188,
            "4219": 260.1083679199219,
            "4220": 747.7128295898438,
            "4221": 262.6858825683594,
            "4222": 747.3367309570312,
            "4223": 260.4384460449219,
            "4224": 749.375244140625,
            "4225": 260.3977355957031,
            "4226": 749.7120361328125,
            "4227": 262.6513671875,
            "4228": 747.7340087890625,
            "4229": 262.9469909667969,
            "4230": 749.375244140625,
            "4231": 260.3977355957031,
            "4232": 747.7340087890625,
            "4233": 262.9469909667969,
            "4234": 747.397216796875,
            "4235": 260.6933288574219,
            "4236": 749.4361572265625,
            "4237": 260.6882019042969,
            "4238": 749.7335815429688,
            "4239": 262.9473876953125,
            "4240": 747.7506713867188,
            "4241": 263.20843505859375,
            "4242": 749.4361572265625,
            "4243": 260.6882019042969,
            "4244": 747.7506713867188,
            "4245": 263.20843505859375,
            "4246": 747.4532470703125,
            "4247": 260.9492492675781,
            "4248": 749.4920043945312,
            "4249": 260.9797058105469,
            "4250": 749.7499389648438,
            "4251": 263.2437438964844,
            "4252": 747.7628173828125,
            "4253": 263.4701232910156,
            "4254": 749.4920043945312,
            "4255": 260.9797058105469,
            "4256": 747.7628173828125,
            "4257": 263.4701232910156,
            "4258": 747.5048217773438,
            "4259": 261.20611572265625,
            "4260": 749.542724609375,
            "4261": 261.2721252441406,
            "4262": 749.7611083984375,
            "4263": 263.5403137207031,
            "4264": 747.7703247070312,
            "4265": 263.73199462890625,
            "4266": 749.542724609375,
            "4267": 261.2721252441406,
            "4268": 747.7703247070312,
            "4269": 263.73199462890625,
            "4270": 747.5519409179688,
            "4271": 261.46380615234375,
            "4272": 749.5883178710938,
            "4273": 261.5653991699219,
            "4274": 749.76708984375,
            "4275": 263.8370361328125,
            "4276": 747.7732543945312,
            "4277": 263.99395751953125,
            "4278": 749.5883178710938,
            "4279": 261.5653991699219,
            "4280": 747.7732543945312,
            "4281": 263.99395751953125,
            "4282": 747.594482421875,
            "4283": 261.7222900390625,
            "4284": 749.6288452148438,
            "4285": 261.8594055175781,
            "4286": 749.7679443359375,
            "4287": 264.13385009765625,
            "4288": 747.7716674804688,
            "4289": 264.25592041015625,
            "4290": 749.6288452148438,
            "4291": 261.8594055175781,
            "4292": 747.7716674804688,
            "4293": 264.25592041015625,
            "4294": 747.632568359375,
            "4295": 261.98150634765625,
            "4296": 749.6641845703125,
            "4297": 262.1540832519531,
            "4298": 749.7635498046875,
            "4299": 264.43060302734375,
            "4300": 747.7655029296875,
            "4301": 264.517822265625,
            "4302": 749.6641845703125,
            "4303": 262.1540832519531,
            "4304": 747.7655029296875,
            "4305": 264.517822265625,
            "4306": 747.6660766601562,
            "4307": 262.2413330078125,
            "4308": 749.6943969726562,
            "4309": 262.4493408203125,
            "4310": 749.7540283203125,
            "4311": 264.72723388671875,
            "4312": 747.7546997070312,
            "4313": 264.77960205078125,
            "4314": 749.6943969726562,
            "4315": 262.4493408203125,
            "4316": 747.7546997070312,
            "4317": 264.77960205078125,
            "4318": 747.695068359375,
            "4319": 262.5016784667969,
            "4320": 749.7194213867188,
            "4321": 262.74505615234375,
            "4322": 749.7393188476562,
            "4323": 265.0236511230469,
            "4324": 747.7393798828125,
            "4325": 265.0411071777344,
            "4326": 749.7194213867188,
            "4327": 262.74505615234375,
            "4328": 747.7393798828125,
            "4329": 265.0411071777344,
            "4330": 747.719482421875,
            "4331": 262.76251220703125
        },
        "zlc": 0.13525882811602638,
        "id": "3576801a-b201-4569-9ac0-1bfea881d8f8"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "c02ab8d4-b82b-482d-8f2c-f6109df91094",
            "ownerSide": null
        },
        "_id": "c02ab8d4-b82b-482d-8f2c-f6109df91094",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 565.4001161492,
                "y": 146.6579610208
            },
            "_p2": {
                "x": 731.0756913133,
                "y": 146.6579610208
            },
            "_p3": {
                "x": 731.0756913133,
                "y": 458.009096347
            },
            "_p4": {
                "x": 565.4001161492,
                "y": 458.009096347
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 627.87913348185,
                        "y": 261.61598596585
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "89554be8-7b19-4fd6-a71b-be66cd77b9a9",
                    "ownerSide": 0
                },
                "_id": "89554be8-7b19-4fd6-a71b-be66cd77b9a9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 680.3581459544,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 164
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 680.3581459544,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 689,
                        "y": 298
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 704.0961786807012,
                        "y": 64.43728027869854
                    },
                    "_p2": {
                        "x": 544.2009815112012,
                        "y": 384.2276746173985
                    },
                    "_p3": {
                        "x": 553.1452534211987,
                        "y": 388.6998105724015
                    },
                    "_p4": {
                        "x": 713.0404505906987,
                        "y": 68.90941623370146
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 680.3581459544,
                    "y": 156.6579610208
                },
                "_end": {
                    "x": 575.4001210093,
                    "y": 366.5740109109
                },
                "mid": {
                    "x": 627.87913348185,
                    "y": 261.61598596585
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "89554be8-7b19-4fd6-a71b-be66cd77b9a9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 708.5683146357,
                        "y": 66.6733482562
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "89554be8-7b19-4fd6-a71b-be66cd77b9a9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 502.6221776943,
                        "y": 478.5656221386
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "1a1c1277-c0f2-4302-8d66-6d8e73be486b",
                "net": {
                    "type": null,
                    "_diameterMil": null,
                    "_flowRateCmh": null,
                    "velocity": 0,
                    "dp": 0,
                    "localResistances": [],
                    "kms": null,
                    "kvs": null,
                    "_realLenMet": 1.1180345541803267
                },
                "len": 234.69327856127276
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 616.1176555179,
                        "y": 448.009096347
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "041ac699-40f8-42e0-9d80-190b6f66df00",
                    "ownerSide": null
                },
                "_id": "041ac699-40f8-42e0-9d80-190b6f66df00",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756864532,
                        "y": 238.0930344766
                    },
                    "_mouse": {
                        "x": 624,
                        "y": 247
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756864532,
                        "y": 238.0930344766
                    },
                    "_mouse": {
                        "x": 720,
                        "y": 264
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 750.1471142470012,
                        "y": 202.59007364999852
                    },
                    "_p2": {
                        "x": 590.2519075409012,
                        "y": 522.3804870618986
                    },
                    "_p3": {
                        "x": 599.1961794508987,
                        "y": 526.8526230169015
                    },
                    "_p4": {
                        "x": 759.0913861569987,
                        "y": 207.06220960500147
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 721.0756864532,
                    "y": 238.0930344766
                },
                "_end": {
                    "x": 616.1176555179,
                    "y": 448.009096347
                },
                "mid": {
                    "x": 668.59667098555,
                    "y": 343.0510654118
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "041ac699-40f8-42e0-9d80-190b6f66df00",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 800.6701804373,
                        "y": 112.724281157
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "041ac699-40f8-42e0-9d80-190b6f66df00",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 594.7240434959,
                        "y": 524.6165550394
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "c767078d-be3e-47b0-9a71-c192bee27b8f",
                "net": {
                    "type": null,
                    "_diameterMil": null,
                    "_flowRateCmh": null,
                    "velocity": 0,
                    "dp": 0,
                    "localResistances": [],
                    "kms": null,
                    "kvs": null,
                    "_realLenMet": 1.1180345541803267
                },
                "len": 234.69329195567778
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 721.0756845675,
                        "y": 156.6579610208
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "6b5fd76e-2926-4153-a821-aea1645a0bfe",
                    "ownerSide": 0
                },
                "_id": "6b5fd76e-2926-4153-a821-aea1645a0bfe",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 575.4001161492,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 164
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756845675,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 720,
                        "y": 264
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 548.6731105951,
                        "y": 94.6988147066
                    },
                    "_p2": {
                        "x": 754.6192475364,
                        "y": 94.6988147066
                    },
                    "_p3": {
                        "x": 754.6192475364,
                        "y": 84.6988147066
                    },
                    "_p4": {
                        "x": 548.6731105951,
                        "y": 84.6988147066
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 575.4001161492,
                    "y": 156.6579610208
                },
                "_end": {
                    "x": 721.0756845675,
                    "y": 156.6579610208
                },
                "mid": {
                    "x": 648.2379003583501,
                    "y": 156.6579610208
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "410c9241-501b-4ee2-aea1-25708457eb4f",
                    "ownerId": "6b5fd76e-2926-4153-a821-aea1645a0bfe",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 548.6731105951,
                        "y": 89.6988147066
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "c6a3142b-6599-4c1a-a9ea-0b58a62ec99a",
                    "ownerId": "6b5fd76e-2926-4153-a821-aea1645a0bfe",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 754.6192475364,
                        "y": 89.6988147066
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "0cc9d2b8-a472-448b-b378-25eafcab24d3",
                "saved": {
                    "0": 548.673095703125,
                    "1": 88.69881439208984,
                    "2": 754.6192626953125,
                    "3": 88.69881439208984,
                    "4": 754.6192626953125,
                    "5": 90.69881439208984,
                    "6": 548.673095703125,
                    "7": 88.69881439208984,
                    "8": 754.6192626953125,
                    "9": 90.69881439208984,
                    "10": 548.673095703125,
                    "11": 90.69881439208984
                },
                "len": 145.67556841830003
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 721.0756879404,
                        "y": 302.3335286839
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "abc9e19f-7158-400d-9c25-990915889b75",
                    "ownerSide": 1
                },
                "_id": "abc9e19f-7158-400d-9c25-990915889b75",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756845675,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 164
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756845675,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 720,
                        "y": 264
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 716.0756845675,
                        "y": 156.65796113656754
                    },
                    "_p2": {
                        "x": 716.0756913133,
                        "y": 448.00909646276756
                    },
                    "_p3": {
                        "x": 726.0756913133,
                        "y": 448.0090962312325
                    },
                    "_p4": {
                        "x": 726.0756845675,
                        "y": 156.65796090503247
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 721.0756845675,
                    "y": 156.6579610208
                },
                "_end": {
                    "x": 721.0756913133,
                    "y": 448.009096347
                },
                "mid": {
                    "x": 721.0756879404,
                    "y": 302.3335286839
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "5eb2c17d-b519-40eb-b360-6cc32af2c67b",
                    "ownerId": "abc9e19f-7158-400d-9c25-990915889b75",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 754.6192475364,
                        "y": 89.6988147066
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "bc717909-84b1-4ac5-a382-afc7af172f0a",
                    "ownerId": "abc9e19f-7158-400d-9c25-990915889b75",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 754.6192570731,
                        "y": 501.5910864531
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "0cc9d2b8-a472-448b-b378-25eafcab24d3",
                "saved": {
                    "0": 755.6192626953125,
                    "1": 89.69881439208984,
                    "2": 755.6192626953125,
                    "3": 501.5910949707031,
                    "4": 753.6192626953125,
                    "5": 501.5910949707031,
                    "6": 755.6192626953125,
                    "7": 89.69881439208984,
                    "8": 753.6192626953125,
                    "9": 501.5910949707031,
                    "10": 753.6192626953125,
                    "11": 89.69881439208984
                },
                "len": 291.3511353262001
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 575.400122895,
                        "y": 448.009096347
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "c7173515-4ebc-4917-a4fb-c9408c5112d4",
                    "ownerSide": 1
                },
                "_id": "c7173515-4ebc-4917-a4fb-c9408c5112d4",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 721.0756913133,
                        "y": 448.009096347
                    },
                    "_mouse": {
                        "x": 720,
                        "y": 264
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 754.6192570731,
                        "y": 496.5910864531
                    },
                    "_p2": {
                        "x": 548.6731201318,
                        "y": 496.5910864531
                    },
                    "_p3": {
                        "x": 548.6731201318,
                        "y": 506.5910864531
                    },
                    "_p4": {
                        "x": 754.6192570731,
                        "y": 506.5910864531
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 721.0756913133,
                    "y": 448.009096347
                },
                "_end": {
                    "x": 575.400122895,
                    "y": 448.009096347
                },
                "mid": {
                    "x": 648.23790710415,
                    "y": 448.009096347
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "5b40838c-b70a-4aa0-8b2e-9bcdf7a764eb",
                    "ownerId": "c7173515-4ebc-4917-a4fb-c9408c5112d4",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 754.6192570731,
                        "y": 501.5910864531
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "5d7e73fd-3dda-4d65-850c-969e10d0e30b",
                    "ownerId": "c7173515-4ebc-4917-a4fb-c9408c5112d4",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 548.6731201318,
                        "y": 501.5910864531
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "0cc9d2b8-a472-448b-b378-25eafcab24d3",
                "saved": {
                    "0": 754.6192626953125,
                    "1": 502.5910949707031,
                    "2": 548.673095703125,
                    "3": 502.5910949707031,
                    "4": 548.673095703125,
                    "5": 500.5910949707031,
                    "6": 754.6192626953125,
                    "7": 502.5910949707031,
                    "8": 548.673095703125,
                    "9": 500.5910949707031,
                    "10": 754.6192626953125,
                    "11": 500.5910949707031
                },
                "len": 145.67556841830003
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 575.4001195221,
                        "y": 302.3335286839
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ae4e388e-df81-4b17-acd3-8e2f3cdb3094",
                    "ownerSide": 1
                },
                "_id": "ae4e388e-df81-4b17-acd3-8e2f3cdb3094",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 575.4001161492,
                        "y": 156.6579610208
                    },
                    "_mouse": {
                        "x": 664,
                        "y": 164
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 575.400122895,
                        "y": 448.009096347
                    },
                    "_mouse": {
                        "x": 574,
                        "y": 313
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 580.400122895,
                        "y": 448.0090962312325
                    },
                    "_p2": {
                        "x": 580.4001161492,
                        "y": 156.65796090503247
                    },
                    "_p3": {
                        "x": 570.4001161492,
                        "y": 156.65796113656754
                    },
                    "_p4": {
                        "x": 570.400122895,
                        "y": 448.00909646276756
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 575.400122895,
                    "y": 448.009096347
                },
                "_end": {
                    "x": 575.4001161492,
                    "y": 156.6579610208
                },
                "mid": {
                    "x": 575.4001195221,
                    "y": 302.3335286839
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "9f643321-195f-42be-a794-8db6b54217a1",
                    "ownerId": "ae4e388e-df81-4b17-acd3-8e2f3cdb3094",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 548.6731201318,
                        "y": 501.5910864531
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "64a7345e-9d5c-4c6c-b07c-098bd953f71f",
                    "ownerId": "ae4e388e-df81-4b17-acd3-8e2f3cdb3094",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 548.6731105951,
                        "y": 89.6988147066
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "0cc9d2b8-a472-448b-b378-25eafcab24d3",
                "saved": {
                    "0": 547.673095703125,
                    "1": 501.5910949707031,
                    "2": 547.673095703125,
                    "3": 89.69881439208984,
                    "4": 549.673095703125,
                    "5": 89.69881439208984,
                    "6": 547.673095703125,
                    "7": 501.5910949707031,
                    "8": 549.673095703125,
                    "9": 89.69881439208984,
                    "10": 549.673095703125,
                    "11": 501.5910949707031
                },
                "len": 291.3511353262001
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10605",
            "desc": "Клапан обратный",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 575.4001195221,
                    "y": 302.3335286839
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 721.0756879404,
                    "y": 302.3335286839
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 681.2525634765625,
            "1": 157.1051788330078,
            "2": 576.2945556640625,
            "3": 367.0212097167969,
            "4": 574.5056762695312,
            "5": 366.1268005371094,
            "6": 681.2525634765625,
            "7": 157.1051788330078,
            "8": 574.5056762695312,
            "9": 366.1268005371094,
            "10": 679.4637451171875,
            "11": 156.21075439453125,
            "12": 721.9700927734375,
            "13": 238.54025268554688,
            "14": 617.0120849609375,
            "15": 448.456298828125,
            "16": 615.2232055664062,
            "17": 447.5618896484375,
            "18": 721.9700927734375,
            "19": 238.54025268554688,
            "20": 615.2232055664062,
            "21": 447.5618896484375,
            "22": 720.1812744140625,
            "23": 237.6458282470703,
            "24": 575.400146484375,
            "25": 155.657958984375,
            "26": 721.07568359375,
            "27": 155.657958984375,
            "28": 721.07568359375,
            "29": 157.657958984375,
            "30": 575.400146484375,
            "31": 155.657958984375,
            "32": 721.07568359375,
            "33": 157.657958984375,
            "34": 575.400146484375,
            "35": 157.657958984375,
            "36": 722.07568359375,
            "37": 156.657958984375,
            "38": 722.07568359375,
            "39": 448.00909423828125,
            "40": 720.07568359375,
            "41": 448.00909423828125,
            "42": 722.07568359375,
            "43": 156.657958984375,
            "44": 720.07568359375,
            "45": 448.00909423828125,
            "46": 720.07568359375,
            "47": 156.657958984375,
            "48": 721.07568359375,
            "49": 449.00909423828125,
            "50": 575.400146484375,
            "51": 449.00909423828125,
            "52": 575.400146484375,
            "53": 447.00909423828125,
            "54": 721.07568359375,
            "55": 449.00909423828125,
            "56": 575.400146484375,
            "57": 447.00909423828125,
            "58": 721.07568359375,
            "59": 447.00909423828125,
            "60": 574.400146484375,
            "61": 448.00909423828125,
            "62": 574.400146484375,
            "63": 156.657958984375,
            "64": 576.400146484375,
            "65": 156.657958984375,
            "66": 574.400146484375,
            "67": 448.00909423828125,
            "68": 576.400146484375,
            "69": 156.657958984375,
            "70": 576.400146484375,
            "71": 448.00909423828125
        },
        "zlc": 0.29135101685454795,
        "id": "c02ab8d4-b82b-482d-8f2c-f6109df91094"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "a1346ecf-8d3c-447c-be58-91dff3538372",
            "ownerSide": null
        },
        "_id": "a1346ecf-8d3c-447c-be58-91dff3538372",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 634.8196419488721,
                "y": 133.3244323699
            },
            "_p2": {
                "x": 800.4951503761461,
                "y": 133.3244323699
            },
            "_p3": {
                "x": 800.4951503761461,
                "y": 444.6754492244479
            },
            "_p4": {
                "x": 634.8196419488721,
                "y": 444.6754492244479
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 790.4951503761461,
                        "y": 288.99994079717396
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "16871249-df4d-4901-9a7c-8e273d03e282",
                    "ownerSide": null
                },
                "_id": "16871249-df4d-4901-9a7c-8e273d03e282",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 790.4951503761461,
                        "y": 288.99994079717396
                    },
                    "_mouse": {
                        "x": 780,
                        "y": 287
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 644.8196419488721,
                        "y": 288.99994079717396
                    },
                    "_mouse": {
                        "x": 647,
                        "y": 299
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 634.8196419488721,
                        "y": 133.3244323699
                    },
                    "_p2": {
                        "x": 800.4951503761461,
                        "y": 133.3244323699
                    },
                    "_p3": {
                        "x": 800.4951503761461,
                        "y": 444.6754492244479
                    },
                    "_p4": {
                        "x": 634.8196419488721,
                        "y": 444.6754492244479
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "rectangle",
                "_p1": {
                    "x": 644.8196419488721,
                    "y": 143.32443236989997
                },
                "_p2": {
                    "x": 790.4951503761461,
                    "y": 143.32443236989997
                },
                "_p3": {
                    "x": 790.4951503761461,
                    "y": 434.67544922444785
                },
                "_p4": {
                    "x": 644.8196419488721,
                    "y": 434.67544922444785
                },
                "_width": 145.67550842727397,
                "_height": 291.35101685454794,
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "_thickness": 2,
                "m1": {
                    "x": 717.657396162509,
                    "y": 143.32443236989997
                },
                "m2": {
                    "x": 790.4951503761461,
                    "y": 288.9999407971739
                },
                "m3": {
                    "x": 717.657396162509,
                    "y": 434.67544922444785
                },
                "m4": {
                    "x": 644.8196419488721,
                    "y": 288.9999407971739
                },
                "saved": {
                    "0": 643.8196411132812,
                    "1": 142.32443237304688,
                    "2": 791.4951782226562,
                    "3": 142.32443237304688,
                    "4": 791.4951782226562,
                    "5": 144.32443237304688,
                    "6": 643.8196411132812,
                    "7": 142.32443237304688,
                    "8": 791.4951782226562,
                    "9": 144.32443237304688,
                    "10": 643.8196411132812,
                    "11": 144.32443237304688,
                    "12": 791.4951782226562,
                    "13": 142.32443237304688,
                    "14": 791.4951782226562,
                    "15": 435.6754455566406,
                    "16": 789.4951782226562,
                    "17": 435.6754455566406,
                    "18": 791.4951782226562,
                    "19": 142.32443237304688,
                    "20": 789.4951782226562,
                    "21": 435.6754455566406,
                    "22": 789.4951782226562,
                    "23": 142.32443237304688,
                    "24": 791.4951782226562,
                    "25": 435.6754455566406,
                    "26": 643.8196411132812,
                    "27": 435.6754455566406,
                    "28": 643.8196411132812,
                    "29": 433.6754455566406,
                    "30": 791.4951782226562,
                    "31": 435.6754455566406,
                    "32": 643.8196411132812,
                    "33": 433.6754455566406,
                    "34": 791.4951782226562,
                    "35": 433.6754455566406,
                    "36": 643.8196411132812,
                    "37": 435.6754455566406,
                    "38": 643.8196411132812,
                    "39": 142.32443237304688,
                    "40": 645.8196411132812,
                    "41": 142.32443237304688,
                    "42": 643.8196411132812,
                    "43": 435.6754455566406,
                    "44": 645.8196411132812,
                    "45": 142.32443237304688,
                    "46": 645.8196411132812,
                    "47": 435.6754455566406
                },
                "center": {
                    "x": 717.657396162509,
                    "y": 288.9999407971739
                }
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 717.6573961624999,
                        "y": 288.99994079715
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "4ad2c37a-acf6-4883-8f3d-414024b13675",
                    "ownerSide": 1
                },
                "_id": "4ad2c37a-acf6-4883-8f3d-414024b13675",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 790.4951503761,
                        "y": 143.3244323699
                    },
                    "_mouse": {
                        "x": 784,
                        "y": 287
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 649.2917779038999,
                        "y": 436.9115172018992
                    },
                    "_p2": {
                        "x": 794.9672863310999,
                        "y": 145.56050034739917
                    },
                    "_p3": {
                        "x": 786.0230144211001,
                        "y": 141.08836439240082
                    },
                    "_p4": {
                        "x": 640.3475059939001,
                        "y": 432.4393812469008
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 644.8196419489,
                    "y": 434.6754492244
                },
                "_end": {
                    "x": 790.4951503761,
                    "y": 143.3244323699
                },
                "mid": {
                    "x": 717.6573961624999,
                    "y": 288.99994079715
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "4ad2c37a-acf6-4883-8f3d-414024b13675",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 644.8196419489,
                        "y": 434.6754492244
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "4ad2c37a-acf6-4883-8f3d-414024b13675",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 790.4951503761,
                        "y": 143.3244323699
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 643.9252319335938,
                    "1": 434.2282409667969,
                    "2": 789.6007080078125,
                    "3": 142.87721252441406,
                    "4": 791.3895874023438,
                    "5": 143.7716522216797,
                    "6": 643.9252319335938,
                    "7": 434.2282409667969,
                    "8": 791.3895874023438,
                    "9": 143.7716522216797,
                    "10": 645.7140502929688,
                    "11": 435.1226501464844
                },
                "len": 325.7403395001522
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10606",
            "desc": "Клапан дымоудаления",
            "size": "",
            "kms": "0.25",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 0.25,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 644.8196419488721,
                    "y": 288.99994079717396
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 790.4951503761461,
                    "y": 288.99994079717396
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 643.8196411132812,
            "1": 142.32443237304688,
            "2": 791.4951782226562,
            "3": 142.32443237304688,
            "4": 791.4951782226562,
            "5": 144.32443237304688,
            "6": 643.8196411132812,
            "7": 142.32443237304688,
            "8": 791.4951782226562,
            "9": 144.32443237304688,
            "10": 643.8196411132812,
            "11": 144.32443237304688,
            "12": 791.4951782226562,
            "13": 142.32443237304688,
            "14": 791.4951782226562,
            "15": 435.6754455566406,
            "16": 789.4951782226562,
            "17": 435.6754455566406,
            "18": 791.4951782226562,
            "19": 142.32443237304688,
            "20": 789.4951782226562,
            "21": 435.6754455566406,
            "22": 789.4951782226562,
            "23": 142.32443237304688,
            "24": 791.4951782226562,
            "25": 435.6754455566406,
            "26": 643.8196411132812,
            "27": 435.6754455566406,
            "28": 643.8196411132812,
            "29": 433.6754455566406,
            "30": 791.4951782226562,
            "31": 435.6754455566406,
            "32": 643.8196411132812,
            "33": 433.6754455566406,
            "34": 791.4951782226562,
            "35": 433.6754455566406,
            "36": 643.8196411132812,
            "37": 435.6754455566406,
            "38": 643.8196411132812,
            "39": 142.32443237304688,
            "40": 645.8196411132812,
            "41": 142.32443237304688,
            "42": 643.8196411132812,
            "43": 435.6754455566406,
            "44": 645.8196411132812,
            "45": 142.32443237304688,
            "46": 645.8196411132812,
            "47": 435.6754455566406,
            "48": 643.9252319335938,
            "49": 434.2282409667969,
            "50": 789.6007080078125,
            "51": 142.87721252441406,
            "52": 791.3895874023438,
            "53": 143.7716522216797,
            "54": 643.9252319335938,
            "55": 434.2282409667969,
            "56": 791.3895874023438,
            "57": 143.7716522216797,
            "58": 645.7140502929688,
            "59": 435.1226501464844
        },
        "zlc": 0.29135101685454795,
        "id": "a1346ecf-8d3c-447c-be58-91dff3538372"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "34a6aa30-3a21-485c-93ac-a499e49fc93d",
            "ownerSide": null
        },
        "_id": "34a6aa30-3a21-485c-93ac-a499e49fc93d",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 573.0000009536743,
                "y": 127.99999675154686
            },
            "_p2": {
                "x": 738.6755093809483,
                "y": 127.99999675154686
            },
            "_p3": {
                "x": 738.6755093809483,
                "y": 439.3510136060948
            },
            "_p4": {
                "x": 573.0000009536743,
                "y": 439.3510136060948
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 728.6755093809483,
                        "y": 283.6755051788208
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "f6deb4ac-c31f-473a-bff0-f14cdc866e12",
                    "ownerSide": null
                },
                "_id": "f6deb4ac-c31f-473a-bff0-f14cdc866e12",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 655.8377551673113,
                        "y": 137.99999675154686
                    },
                    "_mouse": {
                        "x": 753,
                        "y": 128
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 728.6755093809483,
                        "y": 283.6755051788208
                    },
                    "_mouse": {
                        "x": 736,
                        "y": 77
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 594,
                        "y": 210
                    },
                    "_p2": {
                        "x": 759.6755084272739,
                        "y": 210
                    },
                    "_p3": {
                        "x": 759.6755084272739,
                        "y": 521.3510168545479
                    },
                    "_p4": {
                        "x": 594,
                        "y": 521.3510168545479
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "rectangle",
                "_p1": {
                    "x": 583.0000009536743,
                    "y": 137.99999675154686
                },
                "_p2": {
                    "x": 728.6755093809483,
                    "y": 137.99999675154686
                },
                "_p3": {
                    "x": 728.6755093809483,
                    "y": 429.3510136060948
                },
                "_p4": {
                    "x": 583.0000009536743,
                    "y": 429.3510136060948
                },
                "_width": 145.67550842727397,
                "_height": 291.35101685454794,
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "_thickness": 2,
                "m1": {
                    "x": 655.8377551673113,
                    "y": 137.99999675154686
                },
                "m2": {
                    "x": 728.6755093809483,
                    "y": 283.6755051788208
                },
                "m3": {
                    "x": 655.8377551673113,
                    "y": 429.3510136060948
                },
                "m4": {
                    "x": 583.0000009536743,
                    "y": 283.6755051788208
                },
                "saved": {
                    "0": 582,
                    "1": 137,
                    "2": 729.675537109375,
                    "3": 137,
                    "4": 729.675537109375,
                    "5": 139,
                    "6": 582,
                    "7": 137,
                    "8": 729.675537109375,
                    "9": 139,
                    "10": 582,
                    "11": 139,
                    "12": 729.675537109375,
                    "13": 137,
                    "14": 729.675537109375,
                    "15": 430.35101318359375,
                    "16": 727.675537109375,
                    "17": 430.35101318359375,
                    "18": 729.675537109375,
                    "19": 137,
                    "20": 727.675537109375,
                    "21": 430.35101318359375,
                    "22": 727.675537109375,
                    "23": 137,
                    "24": 729.675537109375,
                    "25": 430.35101318359375,
                    "26": 582,
                    "27": 430.35101318359375,
                    "28": 582,
                    "29": 428.35101318359375,
                    "30": 729.675537109375,
                    "31": 430.35101318359375,
                    "32": 582,
                    "33": 428.35101318359375,
                    "34": 729.675537109375,
                    "35": 428.35101318359375,
                    "36": 582,
                    "37": 430.35101318359375,
                    "38": 582,
                    "39": 137,
                    "40": 584,
                    "41": 137,
                    "42": 582,
                    "43": 430.35101318359375,
                    "44": 584,
                    "45": 137,
                    "46": 584,
                    "47": 430.35101318359375
                },
                "center": {
                    "x": 655.8377551673113,
                    "y": 283.6755051788208
                }
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10607",
            "desc": "Клапан дымоудаления",
            "size": "",
            "kms": "",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": null,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 583.0000009536743,
                    "y": 283.6755051788208
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 728.6755093809483,
                    "y": 283.6755051788208
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 582,
            "1": 137,
            "2": 729.675537109375,
            "3": 137,
            "4": 729.675537109375,
            "5": 139,
            "6": 582,
            "7": 137,
            "8": 729.675537109375,
            "9": 139,
            "10": 582,
            "11": 139,
            "12": 729.675537109375,
            "13": 137,
            "14": 729.675537109375,
            "15": 430.35101318359375,
            "16": 727.675537109375,
            "17": 430.35101318359375,
            "18": 729.675537109375,
            "19": 137,
            "20": 727.675537109375,
            "21": 430.35101318359375,
            "22": 727.675537109375,
            "23": 137,
            "24": 729.675537109375,
            "25": 430.35101318359375,
            "26": 582,
            "27": 430.35101318359375,
            "28": 582,
            "29": 428.35101318359375,
            "30": 729.675537109375,
            "31": 430.35101318359375,
            "32": 582,
            "33": 428.35101318359375,
            "34": 729.675537109375,
            "35": 428.35101318359375,
            "36": 582,
            "37": 430.35101318359375,
            "38": 582,
            "39": 137,
            "40": 584,
            "41": 137,
            "42": 582,
            "43": 430.35101318359375,
            "44": 584,
            "45": 137,
            "46": 584,
            "47": 430.35101318359375
        },
        "zlc": 0.29135101685454795,
        "id": "34a6aa30-3a21-485c-93ac-a499e49fc93d"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "31564ebe-6c0a-4274-82d6-c9706e373fbc",
            "ownerSide": null
        },
        "_id": "31564ebe-6c0a-4274-82d6-c9706e373fbc",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 852.1967440594,
                "y": 230.5119270492
            },
            "_p2": {
                "x": 912.84553139,
                "y": 230.5119270492
            },
            "_p3": {
                "x": 912.84553139,
                "y": 331.8095017105
            },
            "_p4": {
                "x": 852.1967440594,
                "y": 331.8095017105
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 862.1967440594,
                        "y": 281.16071437985
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "49c05623-711b-450d-b584-fe0a140d7bd9",
                    "ownerSide": 1
                },
                "_id": "49c05623-711b-450d-b584-fe0a140d7bd9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 862.1967440594,
                        "y": 240.5119270492
                    },
                    "_mouse": {
                        "x": 876,
                        "y": 232
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 862.1967440594,
                        "y": 240.5119270492
                    },
                    "_mouse": {
                        "x": 854,
                        "y": 193
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 857.1967440594,
                        "y": 240.5119270492
                    },
                    "_p2": {
                        "x": 857.1967440594,
                        "y": 321.8095017105
                    },
                    "_p3": {
                        "x": 867.1967440594,
                        "y": 321.8095017105
                    },
                    "_p4": {
                        "x": 867.1967440594,
                        "y": 240.5119270492
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 862.1967440594,
                    "y": 240.5119270492
                },
                "_end": {
                    "x": 862.1967440594,
                    "y": 321.8095017105
                },
                "mid": {
                    "x": 862.1967440594,
                    "y": 281.16071437985
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "49c05623-711b-450d-b584-fe0a140d7bd9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 927,
                        "y": 158
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "49c05623-711b-450d-b584-fe0a140d7bd9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 927,
                        "y": 213.5273325681
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "net": {
                    "type": null,
                    "_diameterMil": null,
                    "_flowRateCmh": null,
                    "velocity": 0,
                    "dp": 0,
                    "localResistances": [],
                    "kms": null,
                    "kvs": null,
                    "_realLenMet": 0.8000000000001655
                },
                "saved": {
                    "0": 928,
                    "1": 158,
                    "2": 928,
                    "3": 213.52732849121094,
                    "4": 926,
                    "5": 213.52732849121094,
                    "6": 928,
                    "7": 158,
                    "8": 926,
                    "9": 213.52732849121094,
                    "10": 926,
                    "11": 158
                },
                "len": 81.29757466129999
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 882.5211377247,
                        "y": 260.8363207145
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "94c0f09f-0135-4041-989e-72ace28e9117",
                    "ownerSide": 0
                },
                "_id": "94c0f09f-0135-4041-989e-72ace28e9117",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 902.84553139,
                        "y": 240.5119270492
                    },
                    "_mouse": {
                        "x": 876,
                        "y": 232
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "_mouse": {
                        "x": 854,
                        "y": 193
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 865.7322779653327,
                        "y": 284.6962482857328
                    },
                    "_p2": {
                        "x": 906.3810652959328,
                        "y": 244.04746095513275
                    },
                    "_p3": {
                        "x": 899.3099974840673,
                        "y": 236.97639314326727
                    },
                    "_p4": {
                        "x": 858.6612101534672,
                        "y": 277.62518047386726
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 862.1967440594,
                    "y": 281.1607143798
                },
                "_end": {
                    "x": 902.84553139,
                    "y": 240.5119270492
                },
                "mid": {
                    "x": 882.5211377247,
                    "y": 260.8363207145
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "af64849e-b537-48ec-8989-8178f1b4d860",
                    "ownerId": "94c0f09f-0135-4041-989e-72ace28e9117",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "a53195ad-d60b-4c5b-a49c-a0b2e5e8404b",
                    "ownerId": "94c0f09f-0135-4041-989e-72ace28e9117",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 902.84553139,
                        "y": 240.5119270492
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "d3c468ac-00d3-46ef-8145-9941bbc3b74f",
                "saved": {
                    "0": 861.4896240234375,
                    "1": 280.45361328125,
                    "2": 902.138427734375,
                    "3": 239.80482482910156,
                    "4": 903.5526123046875,
                    "5": 241.2190399169922,
                    "6": 861.4896240234375,
                    "7": 280.45361328125,
                    "8": 903.5526123046875,
                    "9": 241.2190399169922,
                    "10": 862.9038696289062,
                    "11": 281.8678283691406
                },
                "len": 57.4860663369542
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 902.84553139,
                        "y": 321.8095017105
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "c8c2fdf2-dc4a-4b82-91f8-5aa7cf8294c9",
                    "ownerSide": 1
                },
                "_id": "c8c2fdf2-dc4a-4b82-91f8-5aa7cf8294c9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 902.84553139,
                        "y": 240.5119270492
                    },
                    "_mouse": {
                        "x": 876,
                        "y": 232
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 0,
                        "y": 0
                    },
                    "_mouse": null,
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 897.84553139,
                        "y": 240.5119270492
                    },
                    "_p2": {
                        "x": 897.84553139,
                        "y": 321.8095017105
                    },
                    "_p3": {
                        "x": 907.84553139,
                        "y": 321.8095017105
                    },
                    "_p4": {
                        "x": 907.84553139,
                        "y": 240.5119270492
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 902.84553139,
                    "y": 240.5119270492
                },
                "_end": {
                    "x": 902.84553139,
                    "y": 321.8095017105
                },
                "mid": {
                    "x": 902.84553139,
                    "y": 281.16071437985
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "a53195ad-d60b-4c5b-a49c-a0b2e5e8404b",
                    "ownerId": "c8c2fdf2-dc4a-4b82-91f8-5aa7cf8294c9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 902.84553139,
                        "y": 240.5119270492
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "34b77f72-20d3-4a72-a340-7ce74cd47cec",
                    "ownerId": "c8c2fdf2-dc4a-4b82-91f8-5aa7cf8294c9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 902.84553139,
                        "y": 321.8095017105
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "d3c468ac-00d3-46ef-8145-9941bbc3b74f",
                "saved": {
                    "0": 903.8455200195312,
                    "1": 240.51193237304688,
                    "2": 903.8455200195312,
                    "3": 321.80950927734375,
                    "4": 901.8455200195312,
                    "5": 321.80950927734375,
                    "6": 903.8455200195312,
                    "7": 240.51193237304688,
                    "8": 901.8455200195312,
                    "9": 321.80950927734375,
                    "10": 901.8455200195312,
                    "11": 240.51193237304688
                },
                "len": 81.29757466129999
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "addffb14-98d8-4c9d-a4f2-5b36642b6415",
                    "ownerSide": 1
                },
                "_id": "addffb14-98d8-4c9d-a4f2-5b36642b6415",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "_mouse": {
                        "x": 852,
                        "y": 282
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "_mouse": {
                        "x": 854,
                        "y": 193
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 902.84553139,
                    "y": 321.8095017105
                },
                "_end": {
                    "x": 862.1967440594,
                    "y": 281.1607143798
                },
                "mid": {
                    "x": 882.5211377247,
                    "y": 301.48510804515
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "34b77f72-20d3-4a72-a340-7ce74cd47cec",
                    "ownerId": "addffb14-98d8-4c9d-a4f2-5b36642b6415",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 902.84553139,
                        "y": 321.8095017105
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "af64849e-b537-48ec-8989-8178f1b4d860",
                    "ownerId": "addffb14-98d8-4c9d-a4f2-5b36642b6415",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 862.1967440594,
                        "y": 281.1607143798
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "d3c468ac-00d3-46ef-8145-9941bbc3b74f",
                "saved": {
                    "0": 902.138427734375,
                    "1": 322.5166015625,
                    "2": 861.4896240234375,
                    "3": 281.8678283691406,
                    "4": 862.9038696289062,
                    "5": 280.45361328125,
                    "6": 902.138427734375,
                    "7": 322.5166015625,
                    "8": 862.9038696289062,
                    "9": 280.45361328125,
                    "10": 903.5526123046875,
                    "11": 321.1023864746094
                },
                "len": 57.48606633702488
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "вытяжная решётка",
            "desc": "",
            "size": "",
            "kms": "4",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 4,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 862.1967440594,
                    "y": 281.16071437985
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 863.1967163085938,
            "1": 240.51193237304688,
            "2": 863.1967163085938,
            "3": 321.80950927734375,
            "4": 861.1967163085938,
            "5": 321.80950927734375,
            "6": 863.1967163085938,
            "7": 240.51193237304688,
            "8": 861.1967163085938,
            "9": 321.80950927734375,
            "10": 861.1967163085938,
            "11": 240.51193237304688,
            "12": 861.4896240234375,
            "13": 280.45361328125,
            "14": 902.138427734375,
            "15": 239.80482482910156,
            "16": 903.5526123046875,
            "17": 241.2190399169922,
            "18": 861.4896240234375,
            "19": 280.45361328125,
            "20": 903.5526123046875,
            "21": 241.2190399169922,
            "22": 862.9038696289062,
            "23": 281.8678283691406,
            "24": 903.8455200195312,
            "25": 240.51193237304688,
            "26": 903.8455200195312,
            "27": 321.80950927734375,
            "28": 901.8455200195312,
            "29": 321.80950927734375,
            "30": 903.8455200195312,
            "31": 240.51193237304688,
            "32": 901.8455200195312,
            "33": 321.80950927734375,
            "34": 901.8455200195312,
            "35": 240.51193237304688,
            "36": 902.138427734375,
            "37": 322.5166015625,
            "38": 861.4896240234375,
            "39": 281.8678283691406,
            "40": 862.9038696289062,
            "41": 280.45361328125,
            "42": 902.138427734375,
            "43": 322.5166015625,
            "44": 862.9038696289062,
            "45": 280.45361328125,
            "46": 903.5526123046875,
            "47": 321.1023864746094
        },
        "zlc": 0.10162195951617306,
        "id": "31564ebe-6c0a-4274-82d6-c9706e373fbc"
    },
    {
        "aspectRatio": 0.49765625,
        "isSelected": true,
        "isinArea": true,
        "edit": null,
        "move_mat": null,
        "grip": {
            "aspectRatio": 0.49765625,
            "_center": {
                "x": 0,
                "y": 0
            },
            "width": 10,
            "height": 10,
            "type": "m_grip",
            "color": [
                0,
                1,
                0,
                1
            ],
            "ownerId": "eb118d45-e1f7-463d-ba9d-2dbdd4631282",
            "ownerSide": null
        },
        "_id": "eb118d45-e1f7-463d-ba9d-2dbdd4631282",
        "tripH": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_triph",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "tripV": {
            "aspectRatio": 0.49765625,
            "_start": {
                "x": 0,
                "y": 0
            },
            "_mouse": null,
            "type": "m_tripv",
            "color": [
                0,
                1,
                0,
                0.4
            ]
        },
        "selectBoundary": {
            "type": "selectBoundary",
            "aspectRatio": 0.49765625,
            "_p1": {
                "x": 534.4831473804,
                "y": 260.2542193649
            },
            "_p2": {
                "x": 871.1929580601,
                "y": 260.2542193649
            },
            "_p3": {
                "x": 871.1929580601,
                "y": 406.9381436367
            },
            "_p4": {
                "x": 534.4831473804,
                "y": 406.9381436367
            },
            "color": [
                0.75,
                0.75,
                0.75,
                1
            ]
        },
        "hidden": false,
        "rtype": "без типа",
        "type": "block",
        "shapes": [
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 544.4831473804,
                        "y": 333.59618150079996
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "071aa379-6ec0-41f1-886a-e0eedfcfffad",
                    "ownerSide": 0
                },
                "_id": "071aa379-6ec0-41f1-886a-e0eedfcfffad",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 544.4831473804,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 544.4831473804,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 554,
                        "y": 311
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 539.4831473804,
                        "y": 270.2542193649
                    },
                    "_p2": {
                        "x": 539.4831473804,
                        "y": 396.9381436367
                    },
                    "_p3": {
                        "x": 549.4831473804,
                        "y": 396.9381436367
                    },
                    "_p4": {
                        "x": 549.4831473804,
                        "y": 270.2542193649
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 544.4831473804,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 544.4831473804,
                    "y": 396.9381436367
                },
                "mid": {
                    "x": 544.4831473804,
                    "y": 333.59618150079996
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "a0bfc58a-658c-4022-a639-808b90ae3f66",
                    "ownerId": "071aa379-6ec0-41f1-886a-e0eedfcfffad",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 499,
                        "y": 188
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "08201ada-de27-447a-b46d-740dc9818fb6",
                    "ownerId": "071aa379-6ec0-41f1-886a-e0eedfcfffad",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 499,
                        "y": 231.0976310052
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "c8fb4b87-2fbb-47c4-b3b5-5144c3c3f7a5",
                "saved": {
                    "0": 500,
                    "1": 188,
                    "2": 500,
                    "3": 231.09762573242188,
                    "4": 498,
                    "5": 231.09762573242188,
                    "6": 500,
                    "7": 188,
                    "8": 498,
                    "9": 231.09762573242188,
                    "10": 498,
                    "11": 188
                },
                "len": 119.86811095933307
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 861.1929580601,
                        "y": 396.9381436367
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "7abff4b9-72f3-4838-b082-100491a149af",
                    "ownerSide": 1
                },
                "_id": "7abff4b9-72f3-4838-b082-100491a149af",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 544.4831473804,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 861.1929580601,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 855,
                        "y": 620
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 544.4831473804,
                        "y": 401.9381436367
                    },
                    "_p2": {
                        "x": 861.1929580601,
                        "y": 401.9381436367
                    },
                    "_p3": {
                        "x": 861.1929580601,
                        "y": 391.9381436367
                    },
                    "_p4": {
                        "x": 544.4831473804,
                        "y": 391.9381436367
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 544.4831473804,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 861.1929580601,
                    "y": 396.9381436367
                },
                "mid": {
                    "x": 702.8380527202501,
                    "y": 396.9381436367
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "7abff4b9-72f3-4838-b082-100491a149af",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 499,
                        "y": 231.0976310052
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "f66cd5c3-ccd9-4443-b6c7-709323094577",
                    "ownerId": "7abff4b9-72f3-4838-b082-100491a149af",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 606.7440775129,
                        "y": 231.0976310052
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "c8fb4b87-2fbb-47c4-b3b5-5144c3c3f7a5",
                "saved": {
                    "0": 499,
                    "1": 230.09762573242188,
                    "2": 606.7440795898438,
                    "3": 230.09762573242188,
                    "4": 606.7440795898438,
                    "5": 232.09762573242188,
                    "6": 499,
                    "7": 230.09762573242188,
                    "8": 606.7440795898438,
                    "9": 232.09762573242188,
                    "10": 499,
                    "11": 232.09762573242188
                },
                "len": 296.68706007626974
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 861.1929580601,
                        "y": 396.9381436367
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "ada10319-3974-4588-9b83-ce47ee00d49a",
                    "ownerSide": 1
                },
                "_id": "ada10319-3974-4588-9b83-ce47ee00d49a",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 861.1929580601,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 861.1929580601,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 855,
                        "y": 620
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 1,
                    "_p1": {
                        "x": 0,
                        "y": 0
                    },
                    "_p2": {
                        "x": 0,
                        "y": 0
                    },
                    "_p3": {
                        "x": 0,
                        "y": 0
                    },
                    "_p4": {
                        "x": 0,
                        "y": 0
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 861.1929580601,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 861.1929580601,
                    "y": 270.2542193649
                },
                "mid": {
                    "x": 861.1929580601,
                    "y": 333.59618150079996
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "ada10319-3974-4588-9b83-ce47ee00d49a",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 606.7440775129,
                        "y": 231.0976310052
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "a7e4e75f-08ec-4669-b191-7e95be2abd66",
                    "ownerId": "ada10319-3974-4588-9b83-ce47ee00d49a",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 606.7440775129,
                        "y": 188
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "c8fb4b87-2fbb-47c4-b3b5-5144c3c3f7a5",
                "saved": {
                    "0": 605.7440795898438,
                    "1": 231.09762573242188,
                    "2": 605.7440795898438,
                    "3": 188,
                    "4": 607.7440795898438,
                    "5": 188,
                    "6": 605.7440795898438,
                    "7": 231.09762573242188,
                    "8": 607.7440795898438,
                    "9": 188,
                    "10": 607.7440795898438,
                    "11": 231.09762573242188
                },
                "len": 123.94005362516423
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 861.1929580601,
                        "y": 270.2542193649
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "de951b59-0a9f-420a-8c24-5e2310ebae9e",
                    "ownerSide": 1
                },
                "_id": "de951b59-0a9f-420a-8c24-5e2310ebae9e",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 861.1929580601,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 968,
                        "y": 280
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 861.1929580601,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 855,
                        "y": 620
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 828.6798382196,
                        "y": 197.8836161064
                    },
                    "_p2": {
                        "x": 490.53267998,
                        "y": 197.8836161064
                    },
                    "_p3": {
                        "x": 490.53267998,
                        "y": 207.8836161064
                    },
                    "_p4": {
                        "x": 828.6798382196,
                        "y": 207.8836161064
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 861.1929580601,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 544.4831473804,
                    "y": 270.2542193649
                },
                "mid": {
                    "x": 702.8380527202501,
                    "y": 270.2542193649
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": "a7e4e75f-08ec-4669-b191-7e95be2abd66",
                    "ownerId": "de951b59-0a9f-420a-8c24-5e2310ebae9e",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 606.7440775129,
                        "y": 188
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": "a0bfc58a-658c-4022-a639-808b90ae3f66",
                    "ownerId": "de951b59-0a9f-420a-8c24-5e2310ebae9e",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 499,
                        "y": 188
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": "c8fb4b87-2fbb-47c4-b3b5-5144c3c3f7a5",
                "saved": {
                    "0": 606.7440795898438,
                    "1": 189,
                    "2": 499,
                    "3": 189,
                    "4": 499,
                    "5": 187,
                    "6": 606.7440795898438,
                    "7": 189,
                    "8": 499,
                    "9": 187,
                    "10": 606.7440795898438,
                    "11": 187
                },
                "len": 308.057682913628
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 576.1541202105,
                        "y": 270.2542193649
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "e75a9d87-090b-4183-aa12-bd9d0cb2b5e2",
                    "ownerSide": 1
                },
                "_id": "e75a9d87-090b-4183-aa12-bd9d0cb2b5e2",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 576.1541202105,
                        "y": 333.5961815007
                    },
                    "_mouse": {
                        "x": 967,
                        "y": 342
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 576.1541202105,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 578,
                        "y": 283
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 482.1423020162,
                        "y": 202.9915444872
                    },
                    "_p2": {
                        "x": 482.1423020162,
                        "y": 324.3125009093
                    },
                    "_p3": {
                        "x": 492.1423020162,
                        "y": 324.3125009093
                    },
                    "_p4": {
                        "x": 492.1423020162,
                        "y": 202.9915444872
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 576.1541202105,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 576.1541202105,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 576.1541202105,
                    "y": 301.9252004328
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "e75a9d87-090b-4183-aa12-bd9d0cb2b5e2",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 524.347387009,
                        "y": 202.8836161064
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "e75a9d87-090b-4183-aa12-bd9d0cb2b5e2",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 524.347387009,
                        "y": 256.9871473528
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 525.347412109375,
                    "1": 202.8836212158203,
                    "2": 525.347412109375,
                    "3": 256.9871520996094,
                    "4": 523.347412109375,
                    "5": 256.9871520996094,
                    "6": 525.347412109375,
                    "7": 202.8836212158203,
                    "8": 523.347412109375,
                    "9": 256.9871520996094,
                    "10": 523.347412109375,
                    "11": 202.8836212158203
                },
                "len": 62.24080229746461
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 797.8509689461,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "46a76fcd-bab1-412f-b485-da8c677189a0",
                    "ownerSide": 1
                },
                "_id": "46a76fcd-bab1-412f-b485-da8c677189a0",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 797.8509689461,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 797.8509689461,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 807,
                        "y": 254
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 1022.9215795479,
                        "y": 506.2940144296
                    },
                    "_p2": {
                        "x": 1022.9215795479,
                        "y": 384.9730580076
                    },
                    "_p3": {
                        "x": 1012.9215795479,
                        "y": 384.9730580076
                    },
                    "_p4": {
                        "x": 1012.9215795479,
                        "y": 506.2940144296
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 797.8509689461,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 797.8509689461,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 797.8509689461,
                    "y": 365.2671625687
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "46a76fcd-bab1-412f-b485-da8c677189a0",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 558.162094038,
                        "y": 338.1424794024
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "46a76fcd-bab1-412f-b485-da8c677189a0",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 558.162094038,
                        "y": 284.038948156
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 557.162109375,
                    "1": 338.1424865722656,
                    "2": 557.162109375,
                    "3": 284.0389404296875,
                    "4": 559.162109375,
                    "5": 284.0389404296875,
                    "6": 557.162109375,
                    "7": 338.1424865722656,
                    "8": 559.162109375,
                    "9": 284.0389404296875,
                    "10": 559.162109375,
                    "11": 338.1424865722656
                },
                "len": 66.28628252961919
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 829.5219417767,
                        "y": 270.2542193649
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "b32e575f-ba04-47f2-99d8-268a902c89cb",
                    "ownerSide": 1
                },
                "_id": "b32e575f-ba04-47f2-99d8-268a902c89cb",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 829.5219417767,
                        "y": 333.5961815007
                    },
                    "_mouse": {
                        "x": 967,
                        "y": 342
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 829.5219417767,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 838,
                        "y": 633
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 1088.7471773123,
                        "y": 202.9915444872
                    },
                    "_p2": {
                        "x": 1088.7471773123,
                        "y": 324.3125009093
                    },
                    "_p3": {
                        "x": 1098.7471773123,
                        "y": 324.3125009093
                    },
                    "_p4": {
                        "x": 1098.7471773123,
                        "y": 202.9915444872
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 829.5219417767,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 829.5219417767,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 829.5219417767,
                    "y": 301.9252004328
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "b32e575f-ba04-47f2-99d8-268a902c89cb",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 591.976801067,
                        "y": 202.8836161064
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "b32e575f-ba04-47f2-99d8-268a902c89cb",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 591.976801067,
                        "y": 256.9871473528
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "saved": {
                    "0": 592.976806640625,
                    "1": 202.8836212158203,
                    "2": 592.976806640625,
                    "3": 256.9871520996094,
                    "4": 590.976806640625,
                    "5": 256.9871520996094,
                    "6": 592.976806640625,
                    "7": 202.8836212158203,
                    "8": 590.976806640625,
                    "9": 256.9871520996094,
                    "10": 590.976806640625,
                    "11": 202.8836212158203
                },
                "len": 64.32011226132623
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 607.8250930418,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "e8b925dc-0838-4f1f-9569-b734e32796e4",
                    "ownerSide": 1
                },
                "_id": "e8b925dc-0838-4f1f-9569-b734e32796e4",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 607.8250930418,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 607.8250930418,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 613,
                        "y": 258
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 567.9678997816,
                        "y": 506.2940144296
                    },
                    "_p2": {
                        "x": 567.9678997816,
                        "y": 354.6427794584
                    },
                    "_p3": {
                        "x": 557.9678997816,
                        "y": 354.6427794584
                    },
                    "_p4": {
                        "x": 557.9678997816,
                        "y": 506.2940144296
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 607.8250930418,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 607.8250930418,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 607.8250930418,
                    "y": 365.2671625687
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "e8b925dc-0838-4f1f-9569-b734e32796e4",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 558.162094038,
                        "y": 338.1424794024
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "e8b925dc-0838-4f1f-9569-b734e32796e4",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 558.162094038,
                        "y": 284.038948156
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 64.78041149515563
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 639.4960658719,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "50269840-dcfc-4927-9cf9-0ee28648d299",
                    "ownerSide": 1
                },
                "_id": "50269840-dcfc-4927-9cf9-0ee28648d299",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 639.4960658719,
                        "y": 333.5961815007
                    },
                    "_mouse": {
                        "x": 967,
                        "y": 342
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 639.4960658719,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 648,
                        "y": 251
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 633.7934975444,
                        "y": 202.9915444872
                    },
                    "_p2": {
                        "x": 633.7934975444,
                        "y": 324.3125009093
                    },
                    "_p3": {
                        "x": 643.7934975444,
                        "y": 324.3125009093
                    },
                    "_p4": {
                        "x": 643.7934975444,
                        "y": 202.9915444872
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 639.4960658719,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 639.4960658719,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 639.4960658719,
                    "y": 301.9252004328
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "50269840-dcfc-4927-9cf9-0ee28648d299",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 591.976801067,
                        "y": 202.8836161064
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "50269840-dcfc-4927-9cf9-0ee28648d299",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 591.976801067,
                        "y": 256.9871473528
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 61.969598635673265
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 671.1670382782,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "0abc6a00-0974-4ccb-b0d0-ef1e6d46e4ef",
                    "ownerSide": 1
                },
                "_id": "0abc6a00-0974-4ccb-b0d0-ef1e6d46e4ef",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 671.1670382782,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 671.1670382782,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 673,
                        "y": 249
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 719.6190942925,
                        "y": 506.2940144296
                    },
                    "_p2": {
                        "x": 719.6190942925,
                        "y": 384.9730580076
                    },
                    "_p3": {
                        "x": 709.6190942925,
                        "y": 384.9730580076
                    },
                    "_p4": {
                        "x": 709.6190942925,
                        "y": 506.2940144296
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 671.1670382782,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 671.1670382782,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 671.1670382782,
                    "y": 365.2671625687
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "0abc6a00-0974-4ccb-b0d0-ef1e6d46e4ef",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 625.7915076427,
                        "y": 338.1424794024
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "0abc6a00-0974-4ccb-b0d0-ef1e6d46e4ef",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 625.7915076427,
                        "y": 284.038948156
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 64.77633909808021
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 702.8380527201,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "14cba903-240f-4488-98fb-7307f818b2f9",
                    "ownerSide": 1
                },
                "_id": "14cba903-240f-4488-98fb-7307f818b2f9",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 702.8380527201,
                        "y": 333.5961815007
                    },
                    "_mouse": {
                        "x": 967,
                        "y": 342
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 702.8380111084,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 712,
                        "y": 249
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 785.4446920554,
                        "y": 202.9915444872
                    },
                    "_p2": {
                        "x": 785.4446920554,
                        "y": 324.3125009093
                    },
                    "_p3": {
                        "x": 795.4446920554,
                        "y": 324.3125009093
                    },
                    "_p4": {
                        "x": 795.4446920554,
                        "y": 202.9915444872
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 702.8380111084,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 702.8380527201,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 702.83803191425,
                    "y": 301.9252004328
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "14cba903-240f-4488-98fb-7307f818b2f9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 659.6062146717,
                        "y": 202.8836161064
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "14cba903-240f-4488-98fb-7307f818b2f9",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 659.6062146717,
                        "y": 256.9871473528
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 62.23232138821094
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 734.5090237093,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "2f640db8-fdfc-48e3-b38c-79b6b3013a33",
                    "ownerSide": 1
                },
                "_id": "2f640db8-fdfc-48e3-b38c-79b6b3013a33",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 734.5090237093,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 1097,
                        "y": 394
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 734.5090237093,
                        "y": 396.9381436367
                    },
                    "_mouse": {
                        "x": 744,
                        "y": 134
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 871.2703850361,
                        "y": 506.2940144296
                    },
                    "_p2": {
                        "x": 871.2703850361,
                        "y": 384.9730580076
                    },
                    "_p3": {
                        "x": 861.2703850361,
                        "y": 384.9730580076
                    },
                    "_p4": {
                        "x": 861.2703850361,
                        "y": 506.2940144296
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 734.5090237093,
                    "y": 396.9381436367
                },
                "_end": {
                    "x": 734.5090237093,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 734.5090237093,
                    "y": 365.2671625687
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "2f640db8-fdfc-48e3-b38c-79b6b3013a33",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 693.4209641628,
                        "y": 338.1424794024
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "2f640db8-fdfc-48e3-b38c-79b6b3013a33",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 693.4209641628,
                        "y": 284.038948156
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 65.28218731644253
            },
            {
                "aspectRatio": 1,
                "isSelected": true,
                "isinArea": true,
                "edit": null,
                "move_mat": null,
                "grip": {
                    "aspectRatio": 1,
                    "_center": {
                        "x": 766.17999654,
                        "y": 333.5961815007
                    },
                    "width": 10,
                    "height": 10,
                    "type": "m_grip",
                    "color": [
                        0,
                        1,
                        0,
                        1
                    ],
                    "ownerId": "e62db0f2-a40a-4008-8b74-a93196ba6c24",
                    "ownerSide": 1
                },
                "_id": "e62db0f2-a40a-4008-8b74-a93196ba6c24",
                "tripH": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 766.17999654,
                        "y": 333.5961815007
                    },
                    "_mouse": {
                        "x": 967,
                        "y": 342
                    },
                    "type": "m_triph",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "tripV": {
                    "aspectRatio": 1,
                    "_start": {
                        "x": 766.17999654,
                        "y": 270.2542193649
                    },
                    "_mouse": {
                        "x": 769,
                        "y": 249
                    },
                    "type": "m_tripv",
                    "color": [
                        0,
                        1,
                        0,
                        0.4
                    ]
                },
                "selectBoundary": {
                    "type": "selectBoundary",
                    "aspectRatio": 0.49765625,
                    "_p1": {
                        "x": 937.0959828004,
                        "y": 202.9915444872
                    },
                    "_p2": {
                        "x": 937.0959828004,
                        "y": 324.3125009093
                    },
                    "_p3": {
                        "x": 947.0959828004,
                        "y": 324.3125009093
                    },
                    "_p4": {
                        "x": 947.0959828004,
                        "y": 202.9915444872
                    },
                    "color": [
                        0.75,
                        0.75,
                        0.75,
                        1
                    ]
                },
                "hidden": false,
                "type": "line",
                "_start": {
                    "x": 766.17999654,
                    "y": 270.2542193649
                },
                "_end": {
                    "x": 766.17999654,
                    "y": 333.5961815007
                },
                "mid": {
                    "x": 766.17999654,
                    "y": 301.9252004328
                },
                "color": [
                    0.1,
                    0.1,
                    0.1,
                    1
                ],
                "thickness": 2,
                "startJ": {
                    "id": null,
                    "ownerId": "e62db0f2-a40a-4008-8b74-a93196ba6c24",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 727.2356711918,
                        "y": 202.8836161064
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "endJ": {
                    "id": null,
                    "ownerId": "e62db0f2-a40a-4008-8b74-a93196ba6c24",
                    "type": "join",
                    "color": [
                        1,
                        0,
                        1,
                        1
                    ],
                    "active": false,
                    "adjacents": [],
                    "route": [],
                    "center": {
                        "x": 727.2356711918,
                        "y": 256.9871473528
                    },
                    "radius": 5,
                    "angleDeg": null
                },
                "routeId": null,
                "len": 63.02230447629554
            }
        ],
        "color": [
            0.1,
            0.1,
            0.1,
            1
        ],
        "thickness": 2,
        "data": {
            "code": "10613",
            "desc": "Шумоглушитель",
            "size": "",
            "kms": "0.5",
            "kvs": "",
            "flowDirections": {
                "start": "UNKNOWN",
                "end": "UNKNOWN",
                "mid": null
            },
            "isTerminal": {
                "start": false,
                "end": false,
                "mid": null
            },
            "pressure": {
                "start": 100,
                "end": 80,
                "mid": null
            }
        },
        "net": {
            "type": "block",
            "_flowRateCmh": null,
            "velocity": 0,
            "dp": 0,
            "localResistances": [],
            "kms": 0.5,
            "kvs": null
        },
        "cpoints": [
            {
                "point": {
                    "x": 544.4831473804,
                    "y": 333.59618150079996
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            },
            {
                "point": {
                    "x": 861.1929580601,
                    "y": 333.59618150079996
                },
                "color": [
                    0.5,
                    0.5,
                    1,
                    1
                ],
                "radius": 7.5,
                "thickness": 1,
                "type": "cpoint",
                "isDisplayed": true
            }
        ],
        "saved": {
            "0": 545.483154296875,
            "1": 270.25421142578125,
            "2": 545.483154296875,
            "3": 396.9381408691406,
            "4": 543.483154296875,
            "5": 396.9381408691406,
            "6": 545.483154296875,
            "7": 270.25421142578125,
            "8": 543.483154296875,
            "9": 396.9381408691406,
            "10": 543.483154296875,
            "11": 270.25421142578125,
            "12": 544.483154296875,
            "13": 395.9381408691406,
            "14": 861.1929321289062,
            "15": 395.9381408691406,
            "16": 861.1929321289062,
            "17": 397.9381408691406,
            "18": 544.483154296875,
            "19": 395.9381408691406,
            "20": 861.1929321289062,
            "21": 397.9381408691406,
            "22": 544.483154296875,
            "23": 397.9381408691406,
            "24": 860.1929321289062,
            "25": 396.9381408691406,
            "26": 860.1929321289062,
            "27": 270.25421142578125,
            "28": 862.1929321289062,
            "29": 270.25421142578125,
            "30": 860.1929321289062,
            "31": 396.9381408691406,
            "32": 862.1929321289062,
            "33": 270.25421142578125,
            "34": 862.1929321289062,
            "35": 396.9381408691406,
            "36": 861.1929321289062,
            "37": 271.25421142578125,
            "38": 544.483154296875,
            "39": 271.25421142578125,
            "40": 544.483154296875,
            "41": 269.25421142578125,
            "42": 861.1929321289062,
            "43": 271.25421142578125,
            "44": 544.483154296875,
            "45": 269.25421142578125,
            "46": 861.1929321289062,
            "47": 269.25421142578125,
            "48": 577.1541137695312,
            "49": 270.25421142578125,
            "50": 577.1541137695312,
            "51": 333.59619140625,
            "52": 575.1541137695312,
            "53": 333.59619140625,
            "54": 577.1541137695312,
            "55": 270.25421142578125,
            "56": 575.1541137695312,
            "57": 333.59619140625,
            "58": 575.1541137695312,
            "59": 270.25421142578125,
            "60": 796.8509521484375,
            "61": 396.9381408691406,
            "62": 796.8509521484375,
            "63": 333.59619140625,
            "64": 798.8509521484375,
            "65": 333.59619140625,
            "66": 796.8509521484375,
            "67": 396.9381408691406,
            "68": 798.8509521484375,
            "69": 333.59619140625,
            "70": 798.8509521484375,
            "71": 396.9381408691406,
            "72": 830.5219116210938,
            "73": 270.25421142578125,
            "74": 830.5219116210938,
            "75": 333.59619140625,
            "76": 828.5219116210938,
            "77": 333.59619140625,
            "78": 830.5219116210938,
            "79": 270.25421142578125,
            "80": 828.5219116210938,
            "81": 333.59619140625,
            "82": 828.5219116210938,
            "83": 270.25421142578125,
            "84": 606.8250732421875,
            "85": 396.9381408691406,
            "86": 606.8250732421875,
            "87": 333.59619140625,
            "88": 608.8250732421875,
            "89": 333.59619140625,
            "90": 606.8250732421875,
            "91": 396.9381408691406,
            "92": 608.8250732421875,
            "93": 333.59619140625,
            "94": 608.8250732421875,
            "95": 396.9381408691406,
            "96": 640.49609375,
            "97": 270.25421142578125,
            "98": 640.49609375,
            "99": 333.59619140625,
            "100": 638.49609375,
            "101": 333.59619140625,
            "102": 640.49609375,
            "103": 270.25421142578125,
            "104": 638.49609375,
            "105": 333.59619140625,
            "106": 638.49609375,
            "107": 270.25421142578125,
            "108": 670.1670532226562,
            "109": 396.9381408691406,
            "110": 670.1670532226562,
            "111": 333.59619140625,
            "112": 672.1670532226562,
            "113": 333.59619140625,
            "114": 670.1670532226562,
            "115": 396.9381408691406,
            "116": 672.1670532226562,
            "117": 333.59619140625,
            "118": 672.1670532226562,
            "119": 396.9381408691406,
            "120": 703.8380126953125,
            "121": 270.25421142578125,
            "122": 703.8380737304688,
            "123": 333.59619140625,
            "124": 701.8380737304688,
            "125": 333.59619140625,
            "126": 703.8380126953125,
            "127": 270.25421142578125,
            "128": 701.8380737304688,
            "129": 333.59619140625,
            "130": 701.8380126953125,
            "131": 270.25421142578125,
            "132": 733.509033203125,
            "133": 396.9381408691406,
            "134": 733.509033203125,
            "135": 333.59619140625,
            "136": 735.509033203125,
            "137": 333.59619140625,
            "138": 733.509033203125,
            "139": 396.9381408691406,
            "140": 735.509033203125,
            "141": 333.59619140625,
            "142": 735.509033203125,
            "143": 396.9381408691406,
            "144": 767.1799926757812,
            "145": 270.25421142578125,
            "146": 767.1799926757812,
            "147": 333.59619140625,
            "148": 765.1799926757812,
            "149": 333.59619140625,
            "150": 767.1799926757812,
            "151": 270.25421142578125,
            "152": 765.1799926757812,
            "153": 333.59619140625,
            "154": 765.1799926757812,
            "155": 270.25421142578125
        },
        "zlc": 0.1266838983394346,
        "id": "eb118d45-e1f7-463d-ba9d-2dbdd4631282"
    }
]